
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree4b6"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree4b6"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hrfRP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $cb21442f1e4cb90f$export$2e2bcd8739ae039);

var $aFdsA = parcelRequire("aFdsA");

var $1Ps55 = parcelRequire("1Ps55");

var $8puGV = parcelRequire("8puGV");

var $8xhTr = parcelRequire("8xhTr");

var $h3Eu6 = parcelRequire("h3Eu6");

var $9n8Xf = parcelRequire("9n8Xf");

var $kNEh8 = parcelRequire("kNEh8");

var $lv1Tt = parcelRequire("lv1Tt");

var $epTtS = parcelRequire("epTtS");

var $gQK5r = parcelRequire("gQK5r");
var $cb21442f1e4cb90f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $cb21442f1e4cb90f$var$defaultOptions = {
    waveColor: '#999',
    progressColor: '#555',
    cursorWidth: 1,
    minPxPerSec: 0,
    fillParent: true,
    interact: true,
    dragToSeek: false,
    autoScroll: true,
    autoCenter: true,
    sampleRate: 8000
};
class $cb21442f1e4cb90f$var$WaveSurfer extends (0, $h3Eu6.default) {
    /** Create a new WaveSurfer instance */ static create(options) {
        return new $cb21442f1e4cb90f$var$WaveSurfer(options);
    }
    /** Get the reactive state for advanced use cases */ getState() {
        return this.wavesurferState;
    }
    /** Get the renderer instance for plugin access to reactive streams */ getRenderer() {
        return this.renderer;
    }
    /** Create a new WaveSurfer instance */ constructor(options){
        const media = options.media || (options.backend === 'WebAudio' ? new (0, $lv1Tt.default)() : undefined);
        super({
            media: media,
            mediaControls: options.mediaControls,
            autoplay: options.autoplay,
            playbackRate: options.audioRate
        });
        this.plugins = [];
        this.decodedData = null;
        this.stopAtPosition = null;
        this.subscriptions = [];
        this.mediaSubscriptions = [];
        this.abortController = null;
        this._isDestroyed = false;
        this._loadVersion = 0;
        this.reactiveCleanups = [];
        this.options = Object.assign({}, $cb21442f1e4cb90f$var$defaultOptions, options);
        // Initialize reactive state
        // Pass Player signals to compose them into WaveSurferState
        const { state: state, actions: actions } = (0, $epTtS.createWaveSurferState)({
            isPlaying: this.isPlayingSignal,
            currentTime: this.currentTimeSignal,
            duration: this.durationSignal,
            volume: this.volumeSignal,
            playbackRate: this.playbackRateSignal,
            isSeeking: this.seekingSignal
        });
        this.wavesurferState = state;
        this.wavesurferActions = actions;
        this.timer = new (0, $kNEh8.default)();
        const audioElement = media ? undefined : this.getMediaElement();
        this.renderer = new (0, $9n8Xf.default)(this.options, audioElement);
        this.initPlayerEvents();
        this.initRendererEvents();
        this.initTimerEvents();
        this.initReactiveState();
        this.initPlugins();
        // Read the initial URL before load has been called
        const initialUrl = this.options.url || this.getSrc() || '';
        // Init and load async to allow external events to be registered
        Promise.resolve().then(()=>{
            this.emit('init');
            // Load audio if URL or an external media with an src is passed,
            // of render w/o audio if pre-decoded peaks and duration are provided
            const { peaks: peaks, duration: duration } = this.options;
            if (initialUrl || peaks && duration) // Swallow async errors because they cannot be caught from a constructor call.
            // Subscribe to the wavesurfer's error event to handle them.
            this.load(initialUrl, peaks, duration).catch(()=>{
            // Error already emitted by load()
            });
        });
    }
    updateProgress(currentTime = this.getCurrentTime()) {
        this.renderer.renderProgress(currentTime / this.getDuration(), this.isPlaying());
        return currentTime;
    }
    initTimerEvents() {
        // The timer fires every 16ms for a smooth progress animation
        this.subscriptions.push(this.timer.on('tick', ()=>{
            if (!this.isSeeking()) {
                const currentTime = this.updateProgress();
                this.emit('timeupdate', currentTime);
                this.emit('audioprocess', currentTime);
                // Pause audio when it reaches the stopAtPosition
                if (this.stopAtPosition != null && this.isPlaying() && currentTime >= this.stopAtPosition) {
                    // The timer may overshoot the stop position, so clamp the time back to it
                    const stopAt = this.stopAtPosition;
                    this.pause();
                    this.setTime(stopAt);
                }
            }
        }));
    }
    initReactiveState() {
        // Bridge reactive state to EventEmitter for backwards compatibility
        this.reactiveCleanups.push((0, $gQK5r.setupStateEventEmission)(this.wavesurferState, {
            emit: this.emit.bind(this)
        }));
    }
    initPlayerEvents() {
        if (this.isPlaying()) {
            this.emit('play');
            this.timer.start();
        }
        this.mediaSubscriptions.push(this.onMediaEvent('timeupdate', ()=>{
            const currentTime = this.updateProgress();
            this.emit('timeupdate', currentTime);
        }), this.onMediaEvent('play', ()=>{
            this.emit('play');
            this.timer.start();
        }), this.onMediaEvent('pause', ()=>{
            this.emit('pause');
            this.timer.stop();
            this.stopAtPosition = null;
        }), this.onMediaEvent('emptied', ()=>{
            this.timer.stop();
            this.stopAtPosition = null;
        }), this.onMediaEvent('ended', ()=>{
            this.emit('timeupdate', this.getDuration());
            this.emit('finish');
            this.stopAtPosition = null;
        }), this.onMediaEvent('seeking', ()=>{
            this.emit('seeking', this.getCurrentTime());
        }), this.onMediaEvent('error', ()=>{
            var _a;
            this.emit('error', (_a = this.getMediaElement().error) !== null && _a !== void 0 ? _a : new Error('Media error'));
            this.stopAtPosition = null;
        }));
    }
    initRendererEvents() {
        this.subscriptions.push(// Seek on click
        this.renderer.on('click', (relativeX, relativeY)=>{
            if (this.options.interact) {
                this.seekTo(relativeX);
                this.emit('interaction', relativeX * this.getDuration());
                this.emit('click', relativeX, relativeY);
            }
        }), // Double click
        this.renderer.on('dblclick', (relativeX, relativeY)=>{
            this.emit('dblclick', relativeX, relativeY);
        }), // Scroll
        this.renderer.on('scroll', (startX, endX, scrollLeft, scrollRight)=>{
            const duration = this.getDuration();
            this.emit('scroll', startX * duration, endX * duration, scrollLeft, scrollRight);
        }), // Redraw
        this.renderer.on('render', ()=>{
            this.emit('redraw');
        }), // RedrawComplete
        this.renderer.on('rendered', ()=>{
            this.emit('redrawcomplete');
        }), // DragStart
        this.renderer.on('dragstart', (relativeX)=>{
            this.emit('dragstart', relativeX);
        }), // DragEnd
        this.renderer.on('dragend', (relativeX)=>{
            this.emit('dragend', relativeX);
        }), // Resize
        this.renderer.on('resize', ()=>{
            this.emit('resize');
        }));
        // Drag
        {
            let debounce;
            const unsubscribeDrag = this.renderer.on('drag', (relativeX)=>{
                var _a;
                if (!this.options.interact) return;
                // Update the visual position
                this.renderer.renderProgress(relativeX);
                // Set the audio position with a debounce
                clearTimeout(debounce);
                let debounceTime = 0;
                const dragToSeek = this.options.dragToSeek;
                if (this.isPlaying()) debounceTime = 0;
                else if (dragToSeek === true) debounceTime = 200;
                else if (dragToSeek && typeof dragToSeek === 'object') debounceTime = (_a = dragToSeek.debounceTime) !== null && _a !== void 0 ? _a : 200;
                debounce = setTimeout(()=>{
                    this.seekTo(relativeX);
                }, debounceTime);
                this.emit('interaction', relativeX * this.getDuration());
                this.emit('drag', relativeX);
            });
            // Clear debounce timeout on destroy
            this.subscriptions.push(()=>{
                clearTimeout(debounce);
                unsubscribeDrag();
            });
        }
    }
    initPlugins() {
        var _a;
        if (!((_a = this.options.plugins) === null || _a === void 0 ? void 0 : _a.length)) return;
        this.options.plugins.forEach((plugin)=>{
            this.registerPlugin(plugin);
        });
    }
    unsubscribePlayerEvents() {
        this.mediaSubscriptions.forEach((unsubscribe)=>unsubscribe());
        this.mediaSubscriptions = [];
    }
    /** Set new wavesurfer options and re-render it */ setOptions(options) {
        this.options = Object.assign({}, this.options, options);
        if (options.duration && !options.peaks) this.decodedData = (0, $1Ps55.default).createBuffer(this.exportPeaks(), options.duration);
        if (options.peaks && options.duration) // Create new decoded data buffer from peaks and duration
        this.decodedData = (0, $1Ps55.default).createBuffer(options.peaks, options.duration);
        this.renderer.setOptions(this.options);
        if (options.audioRate) this.setPlaybackRate(options.audioRate);
        if (options.mediaControls != null) this.getMediaElement().controls = options.mediaControls;
    }
    /** Register a wavesurfer.js plugin */ registerPlugin(plugin) {
        // Check if the plugin is already registered
        if (this.plugins.includes(plugin)) return plugin;
        plugin._init(this);
        this.plugins.push(plugin);
        // Unregister plugin on destroy
        const unsubscribe = plugin.once('destroy', ()=>{
            this.plugins = this.plugins.filter((p)=>p !== plugin);
            this.subscriptions = this.subscriptions.filter((fn)=>fn !== unsubscribe);
        });
        this.subscriptions.push(unsubscribe);
        return plugin;
    }
    /** Unregister a wavesurfer.js plugin */ unregisterPlugin(plugin) {
        this.plugins = this.plugins.filter((p)=>p !== plugin);
        plugin.destroy();
    }
    /** For plugins only: get the waveform wrapper div */ getWrapper() {
        return this.renderer.getWrapper();
    }
    /** For plugins only: get the scroll container client width */ getWidth() {
        return this.renderer.getWidth();
    }
    /** Get the current scroll position in pixels */ getScroll() {
        return this.renderer.getScroll();
    }
    /** Set the current scroll position in pixels */ setScroll(pixels) {
        return this.renderer.setScroll(pixels);
    }
    /** Move the start of the viewing window to a specific time in the audio (in seconds) */ setScrollTime(time) {
        const percentage = time / this.getDuration();
        this.renderer.setScrollPercentage(percentage);
    }
    /** Get all registered plugins */ getActivePlugins() {
        return this.plugins;
    }
    loadAudio(url, blob, channelData, duration) {
        return $cb21442f1e4cb90f$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            // Re-entrancy guard: assign a version to this load call
            // If a newer load starts while this one is in-flight, this one will bail out
            const loadVersion = ++this._loadVersion;
            // Reusing an instance after destroy() is a supported behavior (see issue #3637
            // and cypress/e2e/abort.cy.js "load url after destroyed should emit ready").
            // Reset the destroyed flag so the instance can be reloaded. Stale in-flight
            // loads from before destroy() are still cancelled by the loadVersion guard
            // below, so this reset does not weaken the post-await bail-out checks.
            this._isDestroyed = false;
            this.emit('load', url);
            if (!this.options.media && this.isPlaying()) this.pause();
            this.decodedData = null;
            this.stopAtPosition = null;
            // Abort any ongoing fetch before starting a new one
            (_a = this.abortController) === null || _a === void 0 || _a.abort();
            this.abortController = null;
            // Fetch the entire audio as a blob if pre-decoded data is not provided
            if (!blob && !channelData) {
                const fetchParams = this.options.fetchParams || {};
                if (window.AbortController && !fetchParams.signal) {
                    this.abortController = new AbortController();
                    fetchParams.signal = this.abortController.signal;
                }
                const onProgress = (percentage)=>this.emit('loading', percentage);
                blob = yield (0, $8xhTr.default).fetchBlob(url, onProgress, fetchParams);
                // Guard: bail if destroyed or a newer load started
                if (this._isDestroyed || loadVersion !== this._loadVersion) return;
                const overriddenMimeType = this.options.blobMimeType;
                if (overriddenMimeType) blob = new Blob([
                    blob
                ], {
                    type: overriddenMimeType
                });
            }
            // Guard: bail if destroyed or a newer load started
            if (this._isDestroyed || loadVersion !== this._loadVersion) return;
            // Set the mediaelement source
            this.setSrc(url, blob);
            // Wait for the audio duration
            const audioDuration = yield new Promise((resolve)=>{
                const staticDuration = duration || this.getDuration();
                if (staticDuration) resolve(staticDuration);
                else this.mediaSubscriptions.push(this.onMediaEvent('loadedmetadata', ()=>resolve(this.getDuration()), {
                    once: true
                }));
            });
            // Guard: bail if destroyed or a newer load started
            if (this._isDestroyed || loadVersion !== this._loadVersion) return;
            // Set the duration if the player is a WebAudioPlayer without a URL
            if (!url && !blob) {
                const media = this.getMediaElement();
                if (media instanceof (0, $lv1Tt.default)) media.duration = audioDuration;
            }
            // Decode the audio data or use user-provided peaks
            if (channelData) this.decodedData = (0, $1Ps55.default).createBuffer(channelData, audioDuration || 0);
            else if (blob) {
                const arrayBuffer = yield blob.arrayBuffer();
                // Guard: bail if destroyed or a newer load started
                if (this._isDestroyed || loadVersion !== this._loadVersion) return;
                this.decodedData = yield (0, $1Ps55.default).decode(arrayBuffer, this.options.sampleRate);
            }
            // Guard: bail if destroyed or a newer load started
            if (this._isDestroyed || loadVersion !== this._loadVersion) return;
            if (this.decodedData) {
                this.emit('decode', this.getDuration());
                this.renderer.render(this.decodedData);
            }
            this.emit('ready', this.getDuration());
        });
    }
    /** Load an audio file by URL, with optional pre-decoded audio data */ load(url, channelData, duration) {
        return $cb21442f1e4cb90f$var$__awaiter(this, void 0, void 0, function*() {
            try {
                return yield this.loadAudio(url, undefined, channelData, duration);
            } catch (err) {
                this.emit('error', err);
                throw err;
            }
        });
    }
    /** Load an audio blob */ loadBlob(blob, channelData, duration) {
        return $cb21442f1e4cb90f$var$__awaiter(this, void 0, void 0, function*() {
            try {
                return yield this.loadAudio('', blob, channelData, duration);
            } catch (err) {
                this.emit('error', err);
                throw err;
            }
        });
    }
    /** Zoom the waveform by a given pixels-per-second factor */ zoom(minPxPerSec) {
        if (!this.decodedData) throw new Error('No audio loaded');
        this.renderer.zoom(minPxPerSec);
        this.emit('zoom', minPxPerSec);
    }
    /** Get the decoded audio data */ getDecodedData() {
        return this.decodedData;
    }
    /** Get decoded peaks */ exportPeaks({ channels: channels = 2, maxLength: maxLength = 8000, precision: precision = 10000 } = {}) {
        if (!this.decodedData) throw new Error('The audio has not been decoded yet');
        const maxChannels = Math.min(channels, this.decodedData.numberOfChannels);
        const peaks = [];
        for(let i = 0; i < maxChannels; i++){
            const channel = this.decodedData.getChannelData(i);
            const data = [];
            const sampleSize = channel.length / maxLength;
            for(let j = 0; j < maxLength; j++){
                const sample = channel.slice(Math.floor(j * sampleSize), Math.ceil((j + 1) * sampleSize));
                let max = 0;
                for(let x = 0; x < sample.length; x++){
                    const n = sample[x];
                    if (Math.abs(n) > Math.abs(max)) max = n;
                }
                data.push(Math.round(max * precision) / precision);
            }
            peaks.push(data);
        }
        return peaks;
    }
    /** Get the duration of the audio in seconds */ getDuration() {
        let duration = super.getDuration() || 0;
        // Fall back to the decoded data duration if the media duration is incorrect
        if ((duration === 0 || duration === Infinity) && this.decodedData) duration = this.decodedData.duration;
        return duration;
    }
    /** Toggle if the waveform should react to clicks */ toggleInteraction(isInteractive) {
        this.options.interact = isInteractive;
    }
    /** Jump to a specific time in the audio (in seconds) */ setTime(time) {
        this.stopAtPosition = null;
        super.setTime(time);
        this.updateProgress(time);
        this.emit('timeupdate', time);
    }
    /** Seek to a ratio of audio as [0..1] (0 = beginning, 1 = end) */ seekTo(progress) {
        const time = this.getDuration() * progress;
        this.setTime(time);
    }
    /** Start playing the audio */ play(start, end) {
        const _super = Object.create(null, {
            play: {
                get: ()=>super.play
            }
        });
        return $cb21442f1e4cb90f$var$__awaiter(this, void 0, void 0, function*() {
            if (start != null) this.setTime(start);
            const playResult = yield _super.play.call(this);
            if (end != null) {
                if (this.media instanceof (0, $lv1Tt.default)) this.media.stopAt(end);
                else this.stopAtPosition = end;
            }
            return playResult;
        });
    }
    /** Play or pause the audio */ playPause() {
        return $cb21442f1e4cb90f$var$__awaiter(this, void 0, void 0, function*() {
            return this.isPlaying() ? this.pause() : this.play();
        });
    }
    /** Stop the audio and go to the beginning */ stop() {
        this.pause();
        this.setTime(0);
    }
    /** Skip N or -N seconds from the current position */ skip(seconds) {
        this.setTime(this.getCurrentTime() + seconds);
    }
    /** Empty the waveform */ empty() {
        this.load('', [
            [
                0
            ]
        ], 0.001);
    }
    /** Set HTML media element */ setMediaElement(element) {
        this.unsubscribePlayerEvents();
        super.setMediaElement(element);
        this.initPlayerEvents();
    }
    exportImage() {
        return $cb21442f1e4cb90f$var$__awaiter(this, arguments, void 0, function*(format = 'image/png', quality = 1, type = 'dataURL') {
            return this.renderer.exportImage(format, quality, type);
        });
    }
    /** Unmount wavesurfer */ destroy() {
        var _a;
        this._isDestroyed = true;
        this.emit('destroy');
        (_a = this.abortController) === null || _a === void 0 || _a.abort();
        this.plugins.forEach((plugin)=>plugin.destroy());
        this.subscriptions.forEach((unsubscribe)=>unsubscribe());
        this.unsubscribePlayerEvents();
        this.reactiveCleanups.forEach((cleanup)=>cleanup());
        this.reactiveCleanups = [];
        this.timer.destroy();
        this.renderer.destroy();
        super.destroy();
    }
}
$cb21442f1e4cb90f$var$WaveSurfer.BasePlugin = (0, $aFdsA.default);
$cb21442f1e4cb90f$var$WaveSurfer.dom = $8puGV;
var $cb21442f1e4cb90f$export$2e2bcd8739ae039 = $cb21442f1e4cb90f$var$WaveSurfer;

});
parcelRegister("aFdsA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c382c9e3763f4ed$export$2e2bcd8739ae039);

var $6s4Q9 = parcelRequire("6s4Q9");
class $7c382c9e3763f4ed$export$af2591e7a96958a7 extends (0, $6s4Q9.default) {
    /** Create a plugin instance */ constructor(options){
        super();
        this.subscriptions = [];
        this.isDestroyed = false;
        this.options = options;
    }
    /** Called after this.wavesurfer is available */ onInit() {
        return;
    }
    /** Do not call directly, only called by WavesSurfer internally */ _init(wavesurfer) {
        // Reset state if plugin was previously destroyed
        if (this.isDestroyed) {
            this.subscriptions = [];
            this.isDestroyed = false;
        }
        this.wavesurfer = wavesurfer;
        this.onInit();
    }
    /** Destroy the plugin and unsubscribe from all events */ destroy() {
        this.emit('destroy');
        this.subscriptions.forEach((unsubscribe)=>unsubscribe());
        this.subscriptions = [];
        this.isDestroyed = true;
        this.wavesurfer = undefined;
    }
}
var $7c382c9e3763f4ed$export$2e2bcd8739ae039 = $7c382c9e3763f4ed$export$af2591e7a96958a7;

});
parcelRegister("6s4Q9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b291cc2f5744988$export$2e2bcd8739ae039);
/** A simple event emitter that can be used to listen to and emit events. */ class $4b291cc2f5744988$var$EventEmitter {
    constructor(){
        this.listeners = {};
    }
    /** Subscribe to an event. Returns an unsubscribe function. */ on(event, listener, options) {
        if (!this.listeners[event]) this.listeners[event] = new Set();
        if (options === null || options === void 0 ? void 0 : options.once) {
            // Create a wrapper that removes itself after being called once
            const onceWrapper = (...args)=>{
                this.un(event, onceWrapper);
                listener(...args);
            };
            this.listeners[event].add(onceWrapper);
            return ()=>this.un(event, onceWrapper);
        }
        this.listeners[event].add(listener);
        return ()=>this.un(event, listener);
    }
    /** Unsubscribe from an event */ un(event, listener) {
        var _a;
        (_a = this.listeners[event]) === null || _a === void 0 || _a.delete(listener);
    }
    /** Subscribe to an event only once */ once(event, listener) {
        return this.on(event, listener, {
            once: true
        });
    }
    /** Clear all events */ unAll() {
        this.listeners = {};
    }
    /** Emit an event */ emit(eventName, ...args) {
        if (this.listeners[eventName]) this.listeners[eventName].forEach((listener)=>listener(...args));
    }
}
var $4b291cc2f5744988$export$2e2bcd8739ae039 = $4b291cc2f5744988$var$EventEmitter;

});


parcelRegister("1Ps55", function(module, exports) {

$parcel$export(module.exports, "default", () => $1550562b2153aba3$export$2e2bcd8739ae039);
var $1550562b2153aba3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/** Decode an array buffer into an audio buffer */ function $1550562b2153aba3$var$decode(audioData, sampleRate) {
    return $1550562b2153aba3$var$__awaiter(this, void 0, void 0, function*() {
        const audioCtx = new AudioContext({
            sampleRate: sampleRate
        });
        try {
            return yield audioCtx.decodeAudioData(audioData);
        } finally{
            // Ensure AudioContext is always closed, even on synchronous errors
            if (audioCtx.state !== 'closed') yield audioCtx.close().catch(()=>undefined);
        }
    });
}
/** Normalize peaks to -1..1 */ function $1550562b2153aba3$var$normalize(channelData) {
    const firstChannel = channelData[0];
    if (firstChannel.some((n)=>n > 1 || n < -1)) {
        const length = firstChannel.length;
        let max = 0;
        for(let i = 0; i < length; i++){
            const absN = Math.abs(firstChannel[i]);
            if (absN > max) max = absN;
        }
        for (const channel of channelData)for(let i = 0; i < length; i++)channel[i] /= max;
    }
    return channelData;
}
/** Create an audio buffer from pre-decoded audio data */ function $1550562b2153aba3$var$createBuffer(channelData, duration) {
    // Validate inputs
    if (!channelData || channelData.length === 0) throw new Error('channelData must be a non-empty array');
    if (duration <= 0) throw new Error('duration must be greater than 0');
    // If a single array of numbers is passed, make it an array of arrays
    if (typeof channelData[0] === 'number') channelData = [
        channelData
    ];
    // Validate channel data after conversion
    if (!channelData[0] || channelData[0].length === 0) throw new Error('channelData must contain non-empty channel arrays');
    // Normalize to -1..1
    $1550562b2153aba3$var$normalize(channelData);
    // Convert to Float32Array for consistency
    const float32Channels = channelData.map((channel)=>channel instanceof Float32Array ? channel : Float32Array.from(channel));
    return {
        duration: duration,
        length: float32Channels[0].length,
        sampleRate: float32Channels[0].length / duration,
        numberOfChannels: float32Channels.length,
        getChannelData: (i)=>{
            const channel = float32Channels[i];
            if (!channel) throw new Error(`Channel ${i} not found`);
            return channel;
        },
        copyFromChannel: AudioBuffer.prototype.copyFromChannel,
        copyToChannel: AudioBuffer.prototype.copyToChannel
    };
}
const $1550562b2153aba3$var$Decoder = {
    decode: $1550562b2153aba3$var$decode,
    createBuffer: $1550562b2153aba3$var$createBuffer
};
var $1550562b2153aba3$export$2e2bcd8739ae039 = $1550562b2153aba3$var$Decoder;

});

parcelRegister("8puGV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "createElement", () => $61f8772b0f31b483$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "isHTMLElement", () => $61f8772b0f31b483$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "default", () => $61f8772b0f31b483$export$2e2bcd8739ae039);
function $61f8772b0f31b483$var$renderNode(tagName, content) {
    const element = content.xmlns ? document.createElementNS(content.xmlns, tagName) : document.createElement(tagName);
    for (const [key, value] of Object.entries(content)){
        if (key === 'children' && value) for (const [childTag, childValue] of Object.entries(value)){
            if (childValue instanceof Node) element.appendChild(childValue);
            else if (typeof childValue === 'string') element.appendChild(document.createTextNode(childValue));
            else element.appendChild($61f8772b0f31b483$var$renderNode(childTag, childValue));
        }
        else if (key === 'style') Object.assign(element.style, value);
        else if (key === 'textContent') element.textContent = value;
        else element.setAttribute(key, value.toString());
    }
    return element;
}
function $61f8772b0f31b483$export$c8a8987d4410bf2d(tagName, content, container) {
    const el = $61f8772b0f31b483$var$renderNode(tagName, content || {});
    container === null || container === void 0 || container.appendChild(el);
    return el;
}
function $61f8772b0f31b483$export$1b3bfaa9684536aa(value) {
    if (value instanceof HTMLElement) return true;
    return typeof value === 'object' && value !== null && value.nodeType === Node.ELEMENT_NODE && typeof value.style === 'object';
}
var $61f8772b0f31b483$export$2e2bcd8739ae039 = $61f8772b0f31b483$export$c8a8987d4410bf2d;

});

parcelRegister("8xhTr", function(module, exports) {

$parcel$export(module.exports, "default", () => $636f48ff5e91bbd4$export$2e2bcd8739ae039);
var $636f48ff5e91bbd4$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $636f48ff5e91bbd4$var$watchProgress(response, progressCallback, signal) {
    return $636f48ff5e91bbd4$var$__awaiter(this, void 0, void 0, function*() {
        var _a;
        if (!response.body || !response.headers) return;
        const reader = response.body.getReader();
        const contentLength = Number(response.headers.get('Content-Length')) || 0;
        let receivedLength = 0;
        // Abort the reader when the signal fires
        const onAbort = ()=>{
            reader.cancel();
        };
        if (signal) {
            if (signal.aborted) {
                reader.cancel();
                return;
            }
            signal.addEventListener('abort', onAbort, {
                once: true
            });
        }
        // Use iteration instead of recursion to avoid stack issues
        try {
            while(true){
                const data = yield reader.read();
                if (data.done) break;
                receivedLength += ((_a = data.value) === null || _a === void 0 ? void 0 : _a.length) || 0;
                // Only report progress if Content-Length is available and non-zero
                if (contentLength > 0) {
                    const percentage = Math.round(receivedLength / contentLength * 100);
                    progressCallback(percentage);
                }
            }
        } catch (err) {
            // Ignore abort errors from reader cancellation
            if (err instanceof DOMException && err.name === 'AbortError') return;
            // Ignore other errors because we can only handle the main response
            console.warn('Progress tracking error:', err);
        } finally{
            // Remove the abort listener to prevent leaks
            if (signal) signal.removeEventListener('abort', onAbort);
        }
    });
}
function $636f48ff5e91bbd4$var$fetchBlob(url, progressCallback, requestInit) {
    return $636f48ff5e91bbd4$var$__awaiter(this, void 0, void 0, function*() {
        var _a;
        // Fetch the resource
        const response = yield fetch(url, requestInit);
        if (response.status >= 400) throw new Error(`Failed to fetch ${url}: ${response.status} (${response.statusText})`);
        // Read the data to track progress
        // Pass the abort signal so the progress reader can be cancelled
        $636f48ff5e91bbd4$var$watchProgress(response.clone(), progressCallback, (_a = requestInit === null || requestInit === void 0 ? void 0 : requestInit.signal) !== null && _a !== void 0 ? _a : undefined);
        return response.blob();
    });
}
const $636f48ff5e91bbd4$var$Fetcher = {
    fetchBlob: $636f48ff5e91bbd4$var$fetchBlob
};
var $636f48ff5e91bbd4$export$2e2bcd8739ae039 = $636f48ff5e91bbd4$var$Fetcher;

});

parcelRegister("h3Eu6", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6b21edb7e0dc8a9$export$2e2bcd8739ae039);

var $6s4Q9 = parcelRequire("6s4Q9");

var $8Wo0q = parcelRequire("8Wo0q");
var $c6b21edb7e0dc8a9$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $c6b21edb7e0dc8a9$var$Player extends (0, $6s4Q9.default) {
    // Expose reactive state as writable signals
    // These are writable to allow WaveSurfer to compose them into centralized state
    get isPlayingSignal() {
        return this._isPlaying;
    }
    get currentTimeSignal() {
        return this._currentTime;
    }
    get durationSignal() {
        return this._duration;
    }
    get volumeSignal() {
        return this._volume;
    }
    get mutedSignal() {
        return this._muted;
    }
    get playbackRateSignal() {
        return this._playbackRate;
    }
    get seekingSignal() {
        return this._seeking;
    }
    constructor(options){
        super();
        this.isExternalMedia = false;
        this._ownBlobUrl = null;
        this.reactiveMediaEventCleanups = [];
        if (options.media) {
            this.media = options.media;
            this.isExternalMedia = true;
        } else this.media = document.createElement('audio');
        // Initialize reactive state
        this._isPlaying = (0, $8Wo0q.signal)(false);
        this._currentTime = (0, $8Wo0q.signal)(0);
        this._duration = (0, $8Wo0q.signal)(0);
        this._volume = (0, $8Wo0q.signal)(this.media.volume);
        this._muted = (0, $8Wo0q.signal)(this.media.muted);
        this._playbackRate = (0, $8Wo0q.signal)(this.media.playbackRate || 1);
        this._seeking = (0, $8Wo0q.signal)(false);
        // Setup reactive media event handlers
        this.setupReactiveMediaEvents();
        // Controls
        if (options.mediaControls) this.media.controls = true;
        // Autoplay
        if (options.autoplay) this.media.autoplay = true;
        // Speed
        if (options.playbackRate != null) this.onMediaEvent('canplay', ()=>{
            if (options.playbackRate != null) this.media.playbackRate = options.playbackRate;
        }, {
            once: true
        });
    }
    /**
     * Setup reactive media event handlers that update signals
     * This bridges the imperative HTMLMediaElement API to reactive state
     */ setupReactiveMediaEvents() {
        // Playing state
        this.reactiveMediaEventCleanups.push(this.onMediaEvent('play', ()=>{
            this._isPlaying.set(true);
        }));
        this.reactiveMediaEventCleanups.push(this.onMediaEvent('pause', ()=>{
            this._isPlaying.set(false);
        }));
        this.reactiveMediaEventCleanups.push(this.onMediaEvent('ended', ()=>{
            this._isPlaying.set(false);
        }));
        // Time tracking
        this.reactiveMediaEventCleanups.push(this.onMediaEvent('timeupdate', ()=>{
            this._currentTime.set(this.media.currentTime);
        }));
        this.reactiveMediaEventCleanups.push(this.onMediaEvent('durationchange', ()=>{
            this._duration.set(this.media.duration || 0);
        }));
        this.reactiveMediaEventCleanups.push(this.onMediaEvent('loadedmetadata', ()=>{
            this._duration.set(this.media.duration || 0);
        }));
        // Seeking state
        this.reactiveMediaEventCleanups.push(this.onMediaEvent('seeking', ()=>{
            this._seeking.set(true);
        }));
        this.reactiveMediaEventCleanups.push(this.onMediaEvent('seeked', ()=>{
            this._seeking.set(false);
        }));
        // Volume and muted
        this.reactiveMediaEventCleanups.push(this.onMediaEvent('volumechange', ()=>{
            this._volume.set(this.media.volume);
            this._muted.set(this.media.muted);
        }));
        // Playback rate
        this.reactiveMediaEventCleanups.push(this.onMediaEvent('ratechange', ()=>{
            this._playbackRate.set(this.media.playbackRate);
        }));
    }
    onMediaEvent(event, callback, options) {
        this.media.addEventListener(event, callback, options);
        return ()=>this.media.removeEventListener(event, callback, options);
    }
    getSrc() {
        return this.media.currentSrc || this.media.src || '';
    }
    revokeSrc() {
        // Only revoke blob URLs that we created (not ones owned by external callers)
        if (this._ownBlobUrl) {
            URL.revokeObjectURL(this._ownBlobUrl);
            this._ownBlobUrl = null;
        }
    }
    canPlayType(type) {
        return this.media.canPlayType(type) !== '';
    }
    setSrc(url, blob) {
        const prevSrc = this.getSrc();
        if (url && prevSrc === url) return; // no need to change the source
        this.revokeSrc();
        const newSrc = blob instanceof Blob && (this.canPlayType(blob.type) || !url) ? URL.createObjectURL(blob) : url;
        // Track blob URLs we created so we can revoke them on destroy
        if (newSrc !== url) this._ownBlobUrl = newSrc;
        // Reset the media element, otherwise it keeps the previous source
        if (prevSrc) this.media.removeAttribute('src');
        if (newSrc || url) try {
            this.media.src = newSrc;
        } catch (_a) {
            this.media.src = url;
        }
    }
    destroy() {
        // Cleanup reactive media event listeners
        this.reactiveMediaEventCleanups.forEach((cleanup)=>cleanup());
        this.reactiveMediaEventCleanups = [];
        // Revoke blob URLs that we created
        this.revokeSrc();
        // Clear all event emitter listeners
        this.unAll();
        if (this.isExternalMedia) return;
        this.media.pause();
        this.media.removeAttribute('src');
        // Load resets the media element to its initial state
        this.media.load();
        // Remove from DOM after cleanup
        this.media.remove();
    }
    setMediaElement(element) {
        // Cleanup reactive event listeners from old media element
        this.reactiveMediaEventCleanups.forEach((cleanup)=>cleanup());
        this.reactiveMediaEventCleanups = [];
        // Set new media element
        this.media = element;
        // Reinitialize reactive event listeners on new media element
        this.setupReactiveMediaEvents();
    }
    /** Start playing the audio */ play() {
        return $c6b21edb7e0dc8a9$var$__awaiter(this, void 0, void 0, function*() {
            try {
                return yield this.media.play();
            } catch (err) {
                if (err instanceof DOMException && err.name === 'AbortError') return;
                throw err;
            }
        });
    }
    /** Pause the audio */ pause() {
        this.media.pause();
    }
    /** Check if the audio is playing */ isPlaying() {
        return !this.media.paused && !this.media.ended;
    }
    /** Jump to a specific time in the audio (in seconds) */ setTime(time) {
        this.media.currentTime = Math.max(0, Math.min(time, this.getDuration()));
    }
    /** Get the duration of the audio in seconds */ getDuration() {
        return this.media.duration;
    }
    /** Get the current audio position in seconds */ getCurrentTime() {
        return this.media.currentTime;
    }
    /** Get the audio volume */ getVolume() {
        return this.media.volume;
    }
    /** Set the audio volume */ setVolume(volume) {
        this.media.volume = volume;
    }
    /** Get the audio muted state */ getMuted() {
        return this.media.muted;
    }
    /** Mute or unmute the audio */ setMuted(muted) {
        this.media.muted = muted;
    }
    /** Get the playback speed */ getPlaybackRate() {
        return this.media.playbackRate;
    }
    /** Check if the audio is seeking */ isSeeking() {
        return this.media.seeking;
    }
    /** Set the playback speed, pass an optional false to NOT preserve the pitch */ setPlaybackRate(rate, preservePitch) {
        // preservePitch is true by default in most browsers
        if (preservePitch != null) this.media.preservesPitch = preservePitch;
        this.media.playbackRate = rate;
    }
    /** Get the HTML media element */ getMediaElement() {
        return this.media;
    }
    /** Set a sink id to change the audio output device */ setSinkId(sinkId) {
        // See https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/setSinkId
        const media = this.media;
        return media.setSinkId(sinkId);
    }
}
var $c6b21edb7e0dc8a9$export$2e2bcd8739ae039 = $c6b21edb7e0dc8a9$var$Player;

});
parcelRegister("8Wo0q", function(module, exports) {

$parcel$export(module.exports, "signal", () => $68265c8f5a227946$export$e2ef10f86a8d60e8);
$parcel$export(module.exports, "computed", () => $68265c8f5a227946$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "effect", () => $68265c8f5a227946$export$dc573d8a6576cdb3);
/**
 * Reactive primitives for managing state in WaveSurfer
 *
 * This module provides signal-based reactivity similar to SolidJS signals.
 * Signals are reactive values that notify subscribers when they change.
 */ /**
 * Create a reactive signal that notifies subscribers when its value changes
 *
 * @example
 * ```typescript
 * const count = signal(0)
 * count.subscribe(val => console.log('Count:', val))
 * count.set(5) // Logs: Count: 5
 * ```
 */ function $68265c8f5a227946$export$e2ef10f86a8d60e8(initialValue) {
    let _value = initialValue;
    const subscribers = new Set();
    return {
        get value () {
            return _value;
        },
        set (newValue) {
            // Only update and notify if value actually changed
            if (!Object.is(_value, newValue)) {
                _value = newValue;
                subscribers.forEach((fn)=>fn(_value));
            }
        },
        update (fn) {
            this.set(fn(_value));
        },
        subscribe (callback) {
            subscribers.add(callback);
            return ()=>subscribers.delete(callback);
        }
    };
}
function $68265c8f5a227946$export$2983e091f1a1e8e2(fn, dependencies) {
    const result = $68265c8f5a227946$export$e2ef10f86a8d60e8(fn());
    // Subscribe to all dependencies immediately
    // This ensures the computed value stays in sync even if no one is subscribed to it
    dependencies.forEach((dep)=>dep.subscribe(()=>{
            const newValue = fn();
            // Update the result signal, which will notify our subscribers if value changed
            if (!Object.is(result.value, newValue)) result.set(newValue);
        }));
    // Return a read-only signal that proxies the result
    return {
        get value () {
            return result.value;
        },
        subscribe (callback) {
            // Just subscribe to result changes
            return result.subscribe(callback);
        }
    };
}
function $68265c8f5a227946$export$dc573d8a6576cdb3(fn, dependencies) {
    let cleanup;
    const run = ()=>{
        // Run cleanup from previous execution
        if (cleanup) {
            cleanup();
            cleanup = undefined;
        }
        // Run effect and capture new cleanup
        cleanup = fn();
    };
    // Subscribe to all dependencies
    const unsubscribes = dependencies.map((dep)=>dep.subscribe(run));
    // Run effect immediately
    run();
    // Return function that unsubscribes and runs cleanup
    return ()=>{
        if (cleanup) {
            cleanup();
            cleanup = undefined;
        }
        unsubscribes.forEach((unsub)=>unsub());
    };
}

});


parcelRegister("9n8Xf", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d2d353a3c8f3488$export$2e2bcd8739ae039);

var $6s4Q9 = parcelRequire("6s4Q9");

var $8puGV = parcelRequire("8puGV");

var $jiiVT = parcelRequire("jiiVT");

var $lKrUL = parcelRequire("lKrUL");

var $1mhpw = parcelRequire("1mhpw");

var $8Wo0q = parcelRequire("8Wo0q");
var $6d2d353a3c8f3488$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6d2d353a3c8f3488$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $6d2d353a3c8f3488$var$SMOOTH_SCROLL_FPS = 60;
const $6d2d353a3c8f3488$var$SMOOTH_SCROLL_MAX_DELTA = 10;
const $6d2d353a3c8f3488$var$LOW_ZOOM_PIXELS_PER_SECOND_THRESHOLD = $6d2d353a3c8f3488$var$SMOOTH_SCROLL_MAX_DELTA * $6d2d353a3c8f3488$var$SMOOTH_SCROLL_FPS;
class $6d2d353a3c8f3488$var$Renderer extends (0, $6s4Q9.default) {
    constructor(options, audioElement){
        super();
        this.timeouts = [];
        this.isScrollable = false;
        this.audioData = null;
        this.resizeObserver = null;
        this.lastContainerWidth = 0;
        this.isDragging = false;
        this.subscriptions = [];
        this.unsubscribeOnScroll = [];
        this.dragStream = null;
        this.scrollStream = null;
        this.containerInlinePadding = 0;
        this.onClickWrapper = (e)=>{
            const rect = this.wrapper.getBoundingClientRect();
            const [x, y] = $jiiVT.getRelativePointerPosition(rect, e.clientX, e.clientY);
            this.emit('click', x, y);
        };
        this.onDblClickWrapper = (e)=>{
            const rect = this.wrapper.getBoundingClientRect();
            const [x, y] = $jiiVT.getRelativePointerPosition(rect, e.clientX, e.clientY);
            this.emit('dblclick', x, y);
        };
        this.subscriptions = [];
        this.options = options;
        const parent = this.parentFromOptionsContainer(options.container);
        this.parent = parent;
        const [div, shadow] = this.initHtml();
        parent.appendChild(div);
        this.container = div;
        this.scrollContainer = shadow.querySelector('.scroll');
        this.wrapper = shadow.querySelector('.wrapper');
        this.canvasWrapper = shadow.querySelector('.canvases');
        this.progressWrapper = shadow.querySelector('.progress');
        this.cursor = shadow.querySelector('.cursor');
        this.calculateInlinePadding();
        if (audioElement) shadow.appendChild(audioElement);
        this.initEvents();
    }
    parentFromOptionsContainer(container) {
        let parent;
        if (typeof container === 'string') parent = document.querySelector(container);
        else if ((0, $8puGV.isHTMLElement)(container)) parent = container;
        if (!parent) throw new Error('Container not found');
        return parent;
    }
    initEvents() {
        // Add a click listener
        this.wrapper.addEventListener('click', this.onClickWrapper);
        // Add a double click listener
        this.wrapper.addEventListener('dblclick', this.onDblClickWrapper);
        // Drag
        if (this.options.dragToSeek === true || typeof this.options.dragToSeek === 'object') this.initDrag();
        // Add a scroll listener using reactive stream
        this.scrollStream = (0, $1mhpw.createScrollStream)(this.scrollContainer);
        const unsubscribeScroll = (0, $8Wo0q.effect)(()=>{
            const { startX: startX, endX: endX } = this.scrollStream.percentages.value;
            const { left: left, right: right } = this.scrollStream.bounds.value;
            this.emit('scroll', startX, endX, left, right);
        }, [
            this.scrollStream.percentages,
            this.scrollStream.bounds
        ]);
        this.subscriptions.push(unsubscribeScroll);
        // Re-render the waveform on container resize
        if (typeof ResizeObserver === 'function') {
            const delay = this.createDelay(100);
            this.resizeObserver = new ResizeObserver(()=>{
                delay().then(()=>this.onContainerResize()).catch(()=>undefined);
            });
            this.resizeObserver.observe(this.scrollContainer);
        }
    }
    onContainerResize() {
        const width = this.parent.clientWidth;
        this.calculateInlinePadding();
        if (width === this.lastContainerWidth && this.options.height !== 'auto') return;
        this.lastContainerWidth = width;
        this.reRender();
        this.emit('resize');
    }
    initDrag() {
        // Don't initialize drag if it's already set up
        if (this.dragStream) return;
        this.dragStream = (0, $lKrUL.createDragStream)(this.wrapper);
        const unsubscribeDrag = (0, $8Wo0q.effect)(()=>{
            const drag = this.dragStream.signal.value;
            if (!drag) return;
            const width = this.wrapper.getBoundingClientRect().width;
            const relX = $jiiVT.clampToUnit(drag.x / width);
            if (drag.type === 'start') {
                this.isDragging = true;
                this.emit('dragstart', relX);
            } else if (drag.type === 'move') this.emit('drag', relX);
            else if (drag.type === 'end') {
                this.isDragging = false;
                this.emit('dragend', relX);
            }
        }, [
            this.dragStream.signal
        ]);
        this.subscriptions.push(unsubscribeDrag);
    }
    calculateInlinePadding() {
        const { paddingLeft: paddingLeft, paddingRight: paddingRight } = getComputedStyle(this.scrollContainer);
        const padding = parseFloat(paddingLeft) + parseFloat(paddingRight);
        this.containerInlinePadding = Number.isNaN(padding) ? 0 : padding;
    }
    initHtml() {
        const div = document.createElement('div');
        const shadow = div.attachShadow({
            mode: 'open'
        });
        const cspNonce = this.options.cspNonce && typeof this.options.cspNonce === 'string' ? this.options.cspNonce.replace(/"/g, '') : '';
        shadow.innerHTML = `
      <style${cspNonce ? ` nonce="${cspNonce}"` : ''}>
        :host {
          user-select: none;
          min-width: 1px;
        }
        :host audio {
          display: block;
          width: 100%;
        }
        :host .scroll {
          overflow-x: auto;
          overflow-y: hidden;
          width: 100%;
          position: relative;
        }
        :host .noScrollbar {
          scrollbar-color: transparent;
          scrollbar-width: none;
        }
        :host .noScrollbar::-webkit-scrollbar {
          display: none;
          -webkit-appearance: none;
        }
        :host .wrapper {
          position: relative;
          overflow: visible;
          z-index: 2;
        }
        :host .canvases {
          min-height: ${this.getHeight(this.options.height, this.options.splitChannels)}px;
          pointer-events: none;
        }
        :host .canvases > div {
          position: relative;
        }
        :host canvas {
          display: block;
          position: absolute;
          top: 0;
          image-rendering: pixelated;
        }
        :host .progress {
          pointer-events: none;
          position: absolute;
          z-index: 2;
          top: 0;
          left: 0;
          width: 0;
          height: 100%;
          overflow: hidden;
        }
        :host .progress > div {
          position: relative;
        }
        :host .cursor {
          pointer-events: none;
          position: absolute;
          z-index: 5;
          top: 0;
          left: 0;
          height: 100%;
          border-radius: 2px;
        }
      </style>

      <div class="scroll" part="scroll">
        <div class="wrapper" part="wrapper">
          <div class="canvases" part="canvases"></div>
          <div class="progress" part="progress"></div>
          <div class="cursor" part="cursor"></div>
        </div>
      </div>
    `;
        return [
            div,
            shadow
        ];
    }
    /** Wavesurfer itself calls this method. Do not call it manually. */ setOptions(options) {
        var _a;
        if (this.options.container !== options.container) {
            const newParent = this.parentFromOptionsContainer(options.container);
            newParent.appendChild(this.container);
            this.parent = newParent;
        }
        if (options.dragToSeek === true || typeof this.options.dragToSeek === 'object') this.initDrag();
        else {
            (_a = this.dragStream) === null || _a === void 0 || _a.cleanup();
            this.dragStream = null;
        }
        this.options = options;
        // Re-render the waveform
        this.reRender();
    }
    getWrapper() {
        return this.wrapper;
    }
    getWidth() {
        return this.scrollContainer.clientWidth - this.containerInlinePadding;
    }
    getScroll() {
        return this.scrollContainer.scrollLeft;
    }
    setScroll(pixels) {
        this.scrollContainer.scrollLeft = pixels;
    }
    setScrollPercentage(percent) {
        const { scrollWidth: scrollWidth } = this.scrollContainer;
        const scrollStart = scrollWidth * percent;
        this.setScroll(scrollStart);
    }
    destroy() {
        var _a;
        // Remove DOM event listeners
        this.wrapper.removeEventListener('click', this.onClickWrapper);
        this.wrapper.removeEventListener('dblclick', this.onDblClickWrapper);
        // Clean up all timeouts
        this.timeouts.forEach((clear)=>clear());
        this.timeouts = [];
        this.subscriptions.forEach((unsubscribe)=>unsubscribe());
        this.container.remove();
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
        (_a = this.unsubscribeOnScroll) === null || _a === void 0 || _a.forEach((unsubscribe)=>unsubscribe());
        this.unsubscribeOnScroll = [];
        if (this.dragStream) {
            this.dragStream.cleanup();
            this.dragStream = null;
        }
        if (this.scrollStream) {
            this.scrollStream.cleanup();
            this.scrollStream = null;
        }
    }
    createDelay(delayMs = 10) {
        let timeout;
        let rejectFn;
        const onClear = ()=>{
            if (timeout) {
                clearTimeout(timeout);
                timeout = undefined;
            }
            if (rejectFn) {
                rejectFn();
                rejectFn = undefined;
            }
        };
        this.timeouts.push(onClear);
        return ()=>{
            return new Promise((resolve, reject)=>{
                // Clear any pending delay
                onClear();
                // Store reject function for cleanup
                rejectFn = reject;
                // Set new timeout
                timeout = setTimeout(()=>{
                    timeout = undefined;
                    rejectFn = undefined;
                    resolve();
                }, delayMs);
            });
        };
    }
    getHeight(optionsHeight, optionsSplitChannel) {
        var _a;
        const numberOfChannels = ((_a = this.audioData) === null || _a === void 0 ? void 0 : _a.numberOfChannels) || 1;
        return $jiiVT.resolveChannelHeight({
            optionsHeight: optionsHeight,
            optionsSplitChannels: optionsSplitChannel,
            parentHeight: this.parent.clientHeight,
            numberOfChannels: numberOfChannels,
            defaultHeight: $jiiVT.DEFAULT_HEIGHT
        });
    }
    convertColorValues(color, ctx) {
        return $jiiVT.resolveColorValue(color, this.getPixelRatio(), ctx === null || ctx === void 0 ? void 0 : ctx.canvas.height);
    }
    getPixelRatio() {
        return $jiiVT.getPixelRatio(window.devicePixelRatio);
    }
    renderBarWaveform(channelData, options, ctx, vScale) {
        const { width: width, height: height } = ctx.canvas;
        const { halfHeight: halfHeight, barWidth: barWidth, barRadius: barRadius, barIndexScale: barIndexScale, barSpacing: barSpacing, barMinHeight: barMinHeight } = $jiiVT.calculateBarRenderConfig({
            width: width,
            height: height,
            length: (channelData[0] || []).length,
            options: options,
            pixelRatio: this.getPixelRatio()
        });
        const segments = $jiiVT.calculateBarSegments({
            channelData: channelData,
            barIndexScale: barIndexScale,
            barSpacing: barSpacing,
            barWidth: barWidth,
            halfHeight: halfHeight,
            vScale: vScale,
            canvasHeight: height,
            barAlign: options.barAlign,
            barMinHeight: barMinHeight
        });
        ctx.beginPath();
        for (const segment of segments)if (barRadius && 'roundRect' in ctx) ctx.roundRect(segment.x, segment.y, segment.width, segment.height, barRadius);
        else ctx.rect(segment.x, segment.y, segment.width, segment.height);
        ctx.fill();
        ctx.closePath();
    }
    renderLineWaveform(channelData, _options, ctx, vScale) {
        const { width: width, height: height } = ctx.canvas;
        const paths = $jiiVT.calculateLinePaths({
            channelData: channelData,
            width: width,
            height: height,
            vScale: vScale
        });
        ctx.beginPath();
        for (const path of paths){
            if (!path.length) continue;
            ctx.moveTo(path[0].x, path[0].y);
            for(let i = 1; i < path.length; i++){
                const point = path[i];
                ctx.lineTo(point.x, point.y);
            }
        }
        ctx.fill();
        ctx.closePath();
    }
    renderWaveform(channelData, options, ctx) {
        ctx.fillStyle = this.convertColorValues(options.waveColor, ctx);
        if (options.renderFunction) {
            options.renderFunction(channelData, ctx);
            return;
        }
        const vScale = $jiiVT.calculateVerticalScale({
            channelData: channelData,
            barHeight: options.barHeight,
            normalize: options.normalize,
            maxPeak: options.maxPeak
        });
        if ($jiiVT.shouldRenderBars(options)) {
            this.renderBarWaveform(channelData, options, ctx, vScale);
            return;
        }
        this.renderLineWaveform(channelData, options, ctx, vScale);
    }
    renderSingleCanvas(data, options, width, height, offset, canvasContainer, progressContainer) {
        const pixelRatio = this.getPixelRatio();
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(width * pixelRatio);
        canvas.height = Math.round(height * pixelRatio);
        canvas.style.width = `${width}px`;
        canvas.style.height = `${height}px`;
        canvas.style.left = `${Math.round(offset)}px`;
        canvasContainer.appendChild(canvas);
        const ctx = canvas.getContext('2d');
        if (options.renderFunction) {
            ctx.fillStyle = this.convertColorValues(options.waveColor, ctx);
            options.renderFunction(data, ctx);
        } else this.renderWaveform(data, options, ctx);
        // Draw a progress canvas
        if (canvas.width > 0 && canvas.height > 0) {
            const progressCanvas = canvas.cloneNode();
            const progressCtx = progressCanvas.getContext('2d');
            progressCtx.drawImage(canvas, 0, 0);
            // Set the composition method to draw only where the waveform is drawn
            progressCtx.globalCompositeOperation = 'source-in';
            progressCtx.fillStyle = this.convertColorValues(options.progressColor, progressCtx);
            // This rectangle acts as a mask thanks to the composition method
            progressCtx.fillRect(0, 0, canvas.width, canvas.height);
            progressContainer.appendChild(progressCanvas);
        }
    }
    renderMultiCanvas(channelData, options, width, height, canvasContainer, progressContainer) {
        const pixelRatio = this.getPixelRatio();
        const { clientWidth: clientWidth } = this.scrollContainer;
        const totalWidth = width / pixelRatio;
        const singleCanvasWidth = $jiiVT.calculateSingleCanvasWidth({
            clientWidth: clientWidth,
            totalWidth: totalWidth,
            options: options
        });
        let drawnIndexes = {};
        // Nothing to render
        if (singleCanvasWidth === 0) return;
        // Draw a single canvas
        const draw = (index)=>{
            if (index < 0 || index >= numCanvases) return;
            if (drawnIndexes[index]) return;
            drawnIndexes[index] = true;
            const offset = index * singleCanvasWidth;
            let clampedWidth = Math.min(totalWidth - offset, singleCanvasWidth);
            // Clamp the width to the bar grid to avoid empty canvases at the end
            clampedWidth = $jiiVT.clampWidthToBarGrid(clampedWidth, options);
            if (clampedWidth <= 0) return;
            const data = $jiiVT.sliceChannelData({
                channelData: channelData,
                offset: offset,
                clampedWidth: clampedWidth,
                totalWidth: totalWidth
            });
            this.renderSingleCanvas(data, options, clampedWidth, height, offset, canvasContainer, progressContainer);
        };
        // Clear canvases to avoid too many DOM nodes
        const clearCanvases = ()=>{
            if ($jiiVT.shouldClearCanvases(Object.keys(drawnIndexes).length)) {
                canvasContainer.innerHTML = '';
                progressContainer.innerHTML = '';
                drawnIndexes = {};
            }
        };
        // Calculate how many canvases to render
        const numCanvases = Math.ceil(totalWidth / singleCanvasWidth);
        // Render all canvases if the waveform doesn't scroll
        if (!this.isScrollable) {
            for(let i = 0; i < numCanvases; i++)draw(i);
            return;
        }
        // Lazy rendering
        const initialRange = $jiiVT.getLazyRenderRange({
            scrollLeft: this.scrollContainer.scrollLeft,
            totalWidth: totalWidth,
            numCanvases: numCanvases
        });
        initialRange.forEach((index)=>draw(index));
        // Subscribe to the scroll event to draw additional canvases
        if (numCanvases > 1) {
            const unsubscribe = this.on('scroll', ()=>{
                const { scrollLeft: scrollLeft } = this.scrollContainer;
                clearCanvases();
                $jiiVT.getLazyRenderRange({
                    scrollLeft: scrollLeft,
                    totalWidth: totalWidth,
                    numCanvases: numCanvases
                }).forEach((index)=>draw(index));
            });
            this.unsubscribeOnScroll.push(unsubscribe);
        }
    }
    renderChannel(channelData, _a, width, channelIndex) {
        var { overlay: overlay } = _a, options = $6d2d353a3c8f3488$var$__rest(_a, [
            "overlay"
        ]);
        // A container for canvases
        const canvasContainer = document.createElement('div');
        const height = this.getHeight(options.height, options.splitChannels);
        canvasContainer.style.height = `${height}px`;
        if (overlay && channelIndex > 0) canvasContainer.style.marginTop = `-${height}px`;
        this.canvasWrapper.style.minHeight = `${height}px`;
        this.canvasWrapper.appendChild(canvasContainer);
        // A container for progress canvases
        const progressContainer = canvasContainer.cloneNode();
        this.progressWrapper.appendChild(progressContainer);
        // Render the waveform
        this.renderMultiCanvas(channelData, options, width, height, canvasContainer, progressContainer);
    }
    render(audioData) {
        return $6d2d353a3c8f3488$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            // Clear previous timeouts
            this.timeouts.forEach((clear)=>clear());
            this.timeouts = [];
            // Clear scroll subscriptions from previous render
            this.unsubscribeOnScroll.forEach((unsubscribe)=>unsubscribe());
            this.unsubscribeOnScroll = [];
            // Clear the canvases
            this.canvasWrapper.innerHTML = '';
            this.progressWrapper.innerHTML = '';
            // Width
            if (this.options.width != null) this.scrollContainer.style.width = typeof this.options.width === 'number' ? `${this.options.width}px` : this.options.width;
            // Determine the width of the waveform
            const pixelRatio = this.getPixelRatio();
            const parentWidth = this.scrollContainer.clientWidth - this.containerInlinePadding;
            const { scrollWidth: scrollWidth, isScrollable: isScrollable, useParentWidth: useParentWidth, width: width } = $jiiVT.calculateWaveformLayout({
                duration: audioData.duration,
                minPxPerSec: this.options.minPxPerSec || 0,
                parentWidth: parentWidth,
                fillParent: this.options.fillParent,
                pixelRatio: pixelRatio
            });
            // Whether the container should scroll
            this.isScrollable = isScrollable;
            // Set the width of the wrapper
            this.wrapper.style.width = useParentWidth ? '100%' : `${scrollWidth}px`;
            // Set additional styles
            this.scrollContainer.style.overflowX = this.isScrollable ? 'auto' : 'hidden';
            this.scrollContainer.classList.toggle('noScrollbar', !!this.options.hideScrollbar);
            this.cursor.style.backgroundColor = `${this.options.cursorColor || this.options.progressColor}`;
            this.cursor.style.width = `${this.options.cursorWidth}px`;
            this.audioData = audioData;
            this.emit('render');
            // Render the waveform
            if (this.options.splitChannels) // Render a waveform for each channel
            for(let i = 0; i < audioData.numberOfChannels; i++){
                const options = Object.assign(Object.assign({}, this.options), (_a = this.options.splitChannels) === null || _a === void 0 ? void 0 : _a[i]);
                this.renderChannel([
                    audioData.getChannelData(i)
                ], options, width, i);
            }
            else {
                // Render a single waveform for the first two channels (left and right)
                const channels = [
                    audioData.getChannelData(0)
                ];
                if (audioData.numberOfChannels > 1) channels.push(audioData.getChannelData(1));
                this.renderChannel(channels, this.options, width, 0);
            }
            // Must be emitted asynchronously for backward compatibility
            Promise.resolve().then(()=>this.emit('rendered'));
        });
    }
    reRender() {
        this.unsubscribeOnScroll.forEach((unsubscribe)=>unsubscribe());
        this.unsubscribeOnScroll = [];
        // Return if the waveform has not been rendered yet
        if (!this.audioData) return;
        // Remember the current cursor position
        const { scrollWidth: scrollWidth } = this.scrollContainer;
        const { right: before } = this.progressWrapper.getBoundingClientRect();
        // Re-render the waveform
        this.render(this.audioData);
        // Adjust the scroll position so that the cursor stays in the same place
        if (!this.isScrollable && this.scrollContainer.scrollLeft) this.scrollContainer.scrollLeft = 0;
        else if (this.isScrollable && scrollWidth !== this.scrollContainer.scrollWidth) {
            const { right: after } = this.progressWrapper.getBoundingClientRect();
            const delta = $jiiVT.roundToHalfAwayFromZero(after - before);
            this.scrollContainer.scrollLeft += delta;
        }
    }
    zoom(minPxPerSec) {
        this.options.minPxPerSec = minPxPerSec;
        this.reRender();
    }
    scrollIntoView(progress, isPlaying = false) {
        var _a;
        const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, clientWidth: clientWidth } = this.scrollContainer;
        const progressWidth = progress * scrollWidth;
        const startEdge = scrollLeft;
        const endEdge = scrollLeft + clientWidth;
        const middle = clientWidth / 2;
        if (this.isDragging) {
            // Scroll when dragging close to the edge of the viewport
            const minGap = 30;
            if (progressWidth + minGap > endEdge) this.scrollContainer.scrollLeft += minGap;
            else if (progressWidth - minGap < startEdge) this.scrollContainer.scrollLeft -= minGap;
        } else {
            if (progressWidth < startEdge || progressWidth > endEdge) this.scrollContainer.scrollLeft = progressWidth - (this.options.autoCenter ? middle : 0);
            // Keep the cursor centered when playing
            const center = progressWidth - scrollLeft - middle;
            if (isPlaying && this.options.autoCenter && center > 0) {
                const duration = (_a = this.audioData) === null || _a === void 0 ? void 0 : _a.duration;
                if (duration === undefined || duration <= 0) {
                    this.scrollContainer.scrollLeft += center;
                    return;
                }
                const pixelsPerSecond = scrollWidth / duration;
                if (pixelsPerSecond <= $6d2d353a3c8f3488$var$LOW_ZOOM_PIXELS_PER_SECOND_THRESHOLD) this.scrollContainer.scrollLeft += Math.min(center, $6d2d353a3c8f3488$var$SMOOTH_SCROLL_MAX_DELTA);
                else this.scrollContainer.scrollLeft += center;
            }
        }
    }
    renderProgress(progress, isPlaying) {
        if (isNaN(progress)) return;
        const percents = progress * 100;
        this.canvasWrapper.style.clipPath = `polygon(${percents}% 0%, 100% 0%, 100% 100%, ${percents}% 100%)`;
        this.progressWrapper.style.width = `${percents}%`;
        this.cursor.style.left = `${percents}%`;
        this.cursor.style.transform = this.options.cursorWidth ? `translateX(-${progress * this.options.cursorWidth}px)` : '';
        // Only scroll if we have valid audio data to prevent race conditions during loading
        if (this.isScrollable && this.options.autoScroll && this.audioData && this.audioData.duration > 0) this.scrollIntoView(progress, isPlaying);
    }
    exportImage(format, quality, type) {
        return $6d2d353a3c8f3488$var$__awaiter(this, void 0, void 0, function*() {
            const canvases = this.canvasWrapper.querySelectorAll('canvas');
            if (!canvases.length) throw new Error('No waveform data');
            // Data URLs
            if (type === 'dataURL') {
                const images = Array.from(canvases).map((canvas)=>canvas.toDataURL(format, quality));
                return Promise.resolve(images);
            }
            // Blobs
            return Promise.all(Array.from(canvases).map((canvas)=>{
                return new Promise((resolve, reject)=>{
                    canvas.toBlob((blob)=>{
                        if (blob) resolve(blob);
                        else reject(new Error('Could not export image'));
                    }, format, quality);
                });
            }));
        });
    }
}
var $6d2d353a3c8f3488$export$2e2bcd8739ae039 = $6d2d353a3c8f3488$var$Renderer;

});
parcelRegister("jiiVT", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_HEIGHT", () => $e0be6268e0dcb94b$export$611c894df53833b0);
$parcel$export(module.exports, "clampToUnit", () => $e0be6268e0dcb94b$export$776b1d1435d2fa37);
$parcel$export(module.exports, "calculateBarRenderConfig", () => $e0be6268e0dcb94b$export$69b5491eba61a90b);
$parcel$export(module.exports, "calculateBarSegments", () => $e0be6268e0dcb94b$export$636c362d38494a26);
$parcel$export(module.exports, "getRelativePointerPosition", () => $e0be6268e0dcb94b$export$79263550b33b988b);
$parcel$export(module.exports, "resolveChannelHeight", () => $e0be6268e0dcb94b$export$d630a9b35845d240);
$parcel$export(module.exports, "getPixelRatio", () => $e0be6268e0dcb94b$export$d39ce20a37bba061);
$parcel$export(module.exports, "shouldRenderBars", () => $e0be6268e0dcb94b$export$37d24b806fa5b2b4);
$parcel$export(module.exports, "resolveColorValue", () => $e0be6268e0dcb94b$export$49e8fee65a2fdff4);
$parcel$export(module.exports, "calculateWaveformLayout", () => $e0be6268e0dcb94b$export$9c27752397a2512);
$parcel$export(module.exports, "clampWidthToBarGrid", () => $e0be6268e0dcb94b$export$4766851639f2524b);
$parcel$export(module.exports, "calculateSingleCanvasWidth", () => $e0be6268e0dcb94b$export$4451f28166035aba);
$parcel$export(module.exports, "sliceChannelData", () => $e0be6268e0dcb94b$export$34f17f9de070b166);
$parcel$export(module.exports, "shouldClearCanvases", () => $e0be6268e0dcb94b$export$9285152e38948d30);
$parcel$export(module.exports, "getLazyRenderRange", () => $e0be6268e0dcb94b$export$ba2afa84c20ab77);
$parcel$export(module.exports, "calculateVerticalScale", () => $e0be6268e0dcb94b$export$49323a595c296b40);
$parcel$export(module.exports, "calculateLinePaths", () => $e0be6268e0dcb94b$export$21106e810ee1bb6);
$parcel$export(module.exports, "roundToHalfAwayFromZero", () => $e0be6268e0dcb94b$export$1e39918a51b733b5);
const $e0be6268e0dcb94b$export$611c894df53833b0 = 128;
const $e0be6268e0dcb94b$export$6e4fdb84fb59930 = 8000;
const $e0be6268e0dcb94b$export$53ed3718ef0d5777 = 10;
function $e0be6268e0dcb94b$export$776b1d1435d2fa37(value) {
    if (value < 0) return 0;
    if (value > 1) return 1;
    return value;
}
function $e0be6268e0dcb94b$export$69b5491eba61a90b({ width: width, height: height, length: length, options: options, pixelRatio: pixelRatio }) {
    const halfHeight = height / 2;
    const barWidth = options.barWidth ? options.barWidth * pixelRatio : 1;
    const barGap = options.barGap ? options.barGap * pixelRatio : options.barWidth ? barWidth / 2 : 0;
    const barRadius = options.barRadius || 0;
    const barMinHeight = options.barMinHeight ? options.barMinHeight * pixelRatio : 0;
    const spacing = barWidth + barGap || 1;
    const barIndexScale = length > 0 ? width / spacing / length : 0;
    return {
        halfHeight: halfHeight,
        barWidth: barWidth,
        barGap: barGap,
        barRadius: barRadius,
        barMinHeight: barMinHeight,
        barIndexScale: barIndexScale,
        barSpacing: spacing
    };
}
function $e0be6268e0dcb94b$export$62f79955b284cfcc({ maxTop: maxTop, maxBottom: maxBottom, halfHeight: halfHeight, vScale: vScale, barMinHeight: barMinHeight = 0, barAlign: barAlign }) {
    let topHeight = Math.round(maxTop * halfHeight * vScale);
    const bottomHeight = Math.round(maxBottom * halfHeight * vScale);
    let totalHeight = topHeight + bottomHeight || 1;
    if (totalHeight < barMinHeight) {
        totalHeight = barMinHeight;
        if (!barAlign) topHeight = totalHeight / 2;
    }
    return {
        topHeight: topHeight,
        totalHeight: totalHeight
    };
}
function $e0be6268e0dcb94b$export$ce0c16a2881c3080({ barAlign: barAlign, halfHeight: halfHeight, topHeight: topHeight, totalHeight: totalHeight, canvasHeight: canvasHeight }) {
    if (barAlign === 'top') return 0;
    if (barAlign === 'bottom') return canvasHeight - totalHeight;
    return halfHeight - topHeight;
}
function $e0be6268e0dcb94b$export$636c362d38494a26({ channelData: channelData, barIndexScale: barIndexScale, barSpacing: barSpacing, barWidth: barWidth, halfHeight: halfHeight, vScale: vScale, canvasHeight: canvasHeight, barAlign: barAlign, barMinHeight: barMinHeight }) {
    const topChannel = channelData[0] || [];
    const bottomChannel = channelData[1] || topChannel;
    const length = topChannel.length;
    const segments = [];
    let prevX = 0;
    let maxTop = 0;
    let maxBottom = 0;
    for(let i = 0; i <= length; i++){
        const x = Math.round(i * barIndexScale);
        if (x > prevX) {
            const { topHeight: topHeight, totalHeight: totalHeight } = $e0be6268e0dcb94b$export$62f79955b284cfcc({
                maxTop: maxTop,
                maxBottom: maxBottom,
                halfHeight: halfHeight,
                vScale: vScale,
                barMinHeight: barMinHeight,
                barAlign: barAlign
            });
            const y = $e0be6268e0dcb94b$export$ce0c16a2881c3080({
                barAlign: barAlign,
                halfHeight: halfHeight,
                topHeight: topHeight,
                totalHeight: totalHeight,
                canvasHeight: canvasHeight
            });
            segments.push({
                x: prevX * barSpacing,
                y: y,
                width: barWidth,
                height: totalHeight
            });
            prevX = x;
            maxTop = 0;
            maxBottom = 0;
        }
        const magnitudeTop = Math.abs(topChannel[i] || 0);
        const magnitudeBottom = Math.abs(bottomChannel[i] || 0);
        if (magnitudeTop > maxTop) maxTop = magnitudeTop;
        if (magnitudeBottom > maxBottom) maxBottom = magnitudeBottom;
    }
    return segments;
}
function $e0be6268e0dcb94b$export$79263550b33b988b(rect, clientX, clientY) {
    const x = clientX - rect.left;
    const y = clientY - rect.top;
    const relativeX = x / rect.width;
    const relativeY = y / rect.height;
    return [
        relativeX,
        relativeY
    ];
}
function $e0be6268e0dcb94b$export$d630a9b35845d240({ optionsHeight: optionsHeight, optionsSplitChannels: optionsSplitChannels, parentHeight: parentHeight, numberOfChannels: numberOfChannels, defaultHeight: defaultHeight = $e0be6268e0dcb94b$export$611c894df53833b0 }) {
    if (optionsHeight == null) return defaultHeight;
    const numericHeight = Number(optionsHeight);
    if (!isNaN(numericHeight)) return numericHeight;
    if (optionsHeight === 'auto') {
        const height = parentHeight || defaultHeight;
        if (optionsSplitChannels === null || optionsSplitChannels === void 0 ? void 0 : optionsSplitChannels.every((channel)=>!channel.overlay)) return height / numberOfChannels;
        return height;
    }
    return defaultHeight;
}
function $e0be6268e0dcb94b$export$d39ce20a37bba061(devicePixelRatio) {
    return Math.max(1, devicePixelRatio || 1);
}
function $e0be6268e0dcb94b$export$37d24b806fa5b2b4(options) {
    return Boolean(options.barWidth || options.barGap || options.barAlign);
}
function $e0be6268e0dcb94b$export$49e8fee65a2fdff4(color, devicePixelRatio, canvasHeight) {
    if (!Array.isArray(color)) return color || '';
    if (color.length === 0) return '#999';
    if (color.length < 2) return color[0] || '';
    const canvasElement = document.createElement('canvas');
    const ctx = canvasElement.getContext('2d');
    if (!ctx) return color[0] || '';
    const gradientHeight = canvasHeight || canvasElement.height * devicePixelRatio;
    const gradient = ctx.createLinearGradient(0, 0, 0, gradientHeight);
    const colorStopPercentage = 1 / (color.length - 1);
    color.forEach((value, index)=>{
        gradient.addColorStop(index * colorStopPercentage, value);
    });
    return gradient;
}
function $e0be6268e0dcb94b$export$9c27752397a2512({ duration: duration, minPxPerSec: minPxPerSec = 0, parentWidth: parentWidth, fillParent: fillParent, pixelRatio: pixelRatio }) {
    const scrollWidth = Math.ceil(duration * minPxPerSec);
    const isScrollable = scrollWidth > parentWidth;
    const useParentWidth = Boolean(fillParent && !isScrollable);
    const width = (useParentWidth ? parentWidth : scrollWidth) * pixelRatio;
    return {
        scrollWidth: scrollWidth,
        isScrollable: isScrollable,
        useParentWidth: useParentWidth,
        width: width
    };
}
function $e0be6268e0dcb94b$export$4766851639f2524b(width, options) {
    if (!$e0be6268e0dcb94b$export$37d24b806fa5b2b4(options)) return width;
    const barWidth = options.barWidth || 0.5;
    const barGap = options.barGap || barWidth / 2;
    const totalBarWidth = barWidth + barGap;
    if (totalBarWidth === 0) return width;
    return Math.floor(width / totalBarWidth) * totalBarWidth;
}
function $e0be6268e0dcb94b$export$4451f28166035aba({ clientWidth: clientWidth, totalWidth: totalWidth, options: options }) {
    const baseWidth = Math.min($e0be6268e0dcb94b$export$6e4fdb84fb59930, clientWidth, totalWidth);
    return $e0be6268e0dcb94b$export$4766851639f2524b(baseWidth, options);
}
function $e0be6268e0dcb94b$export$34f17f9de070b166({ channelData: channelData, offset: offset, clampedWidth: clampedWidth, totalWidth: totalWidth }) {
    return channelData.map((channel)=>{
        const start = Math.floor(offset / totalWidth * channel.length);
        const end = Math.floor((offset + clampedWidth) / totalWidth * channel.length);
        return channel.slice(start, end);
    });
}
function $e0be6268e0dcb94b$export$9285152e38948d30(currentNodeCount) {
    return currentNodeCount > $e0be6268e0dcb94b$export$53ed3718ef0d5777;
}
function $e0be6268e0dcb94b$export$ba2afa84c20ab77({ scrollLeft: scrollLeft, totalWidth: totalWidth, numCanvases: numCanvases }) {
    if (totalWidth === 0) return [
        0
    ];
    const viewPosition = scrollLeft / totalWidth;
    const startCanvas = Math.floor(viewPosition * numCanvases);
    return [
        startCanvas - 1,
        startCanvas,
        startCanvas + 1
    ];
}
function $e0be6268e0dcb94b$export$49323a595c296b40({ channelData: channelData, barHeight: barHeight, normalize: normalize, maxPeak: maxPeak }) {
    var _a;
    const baseScale = barHeight || 1;
    if (!normalize) return baseScale;
    const firstChannel = channelData[0];
    if (!firstChannel || firstChannel.length === 0) return baseScale;
    // Use fixed max peak if provided, otherwise calculate from data
    let max = maxPeak !== null && maxPeak !== void 0 ? maxPeak : 0;
    if (!maxPeak) for(let i = 0; i < firstChannel.length; i++){
        const value = (_a = firstChannel[i]) !== null && _a !== void 0 ? _a : 0;
        const magnitude = Math.abs(value);
        if (magnitude > max) max = magnitude;
    }
    if (!max) return baseScale;
    return baseScale / max;
}
function $e0be6268e0dcb94b$export$21106e810ee1bb6({ channelData: channelData, width: width, height: height, vScale: vScale }) {
    const halfHeight = height / 2;
    const primaryChannel = channelData[0] || [];
    const secondaryChannel = channelData[1] || primaryChannel;
    const channels = [
        primaryChannel,
        secondaryChannel
    ];
    return channels.map((channel, index)=>{
        const length = channel.length;
        const hScale = length ? width / length : 0;
        const baseY = halfHeight;
        const direction = index === 0 ? -1 : 1;
        const path = [
            {
                x: 0,
                y: baseY
            }
        ];
        let prevX = 0;
        let max = 0;
        for(let i = 0; i <= length; i++){
            const x = Math.round(i * hScale);
            if (x > prevX) {
                const heightDelta = Math.round(max * halfHeight * vScale) || 1;
                const y = baseY + heightDelta * direction;
                path.push({
                    x: prevX,
                    y: y
                });
                prevX = x;
                max = 0;
            }
            const value = Math.abs(channel[i] || 0);
            if (value > max) max = value;
        }
        path.push({
            x: prevX,
            y: baseY
        });
        return path;
    });
}
function $e0be6268e0dcb94b$export$2d870b98f8da4582({ scrollLeft: scrollLeft, clientWidth: clientWidth, scrollWidth: scrollWidth }) {
    if (scrollWidth === 0) return {
        startX: 0,
        endX: 1
    };
    const startX = scrollLeft / scrollWidth;
    const endX = (scrollLeft + clientWidth) / scrollWidth;
    return {
        startX: Math.max(0, Math.min(1, startX)),
        endX: Math.max(0, Math.min(1, endX))
    };
}
function $e0be6268e0dcb94b$export$1e39918a51b733b5(value) {
    const scaled = value * 2;
    const rounded = scaled < 0 ? Math.floor(scaled) : Math.ceil(scaled);
    return rounded / 2;
}

});

parcelRegister("lKrUL", function(module, exports) {

$parcel$export(module.exports, "createDragStream", () => $fd538c147eac38ab$export$80452e177a17f59a);
/**
 * Reactive drag stream utilities
 *
 * Provides declarative drag handling using reactive streams.
 * Automatically handles mouseup cleanup and supports constraints.
 */ 
var $8Wo0q = parcelRequire("8Wo0q");

var $dZtWw = parcelRequire("dZtWw");
function $fd538c147eac38ab$export$80452e177a17f59a(element, options = {}) {
    const { threshold: threshold = 3, mouseButton: mouseButton = 0, touchDelay: touchDelay = 100 } = options;
    const dragSignal = (0, $8Wo0q.signal)(null);
    const activePointers = new Map();
    const isTouchDevice = matchMedia('(pointer: coarse)').matches;
    let unsubscribeDocument = ()=>void 0;
    const onPointerDown = (event)=>{
        if (event.button !== mouseButton) return;
        if (activePointers.has(event.pointerId)) return;
        activePointers.set(event.pointerId, event);
        if (activePointers.size > 1) return;
        const dragPointerId = event.pointerId;
        let startX = event.clientX;
        let startY = event.clientY;
        let isDragging = false;
        const touchStartTime = Date.now();
        const rect = element.getBoundingClientRect();
        const { left: left, top: top } = rect;
        const onPointerMove = (event)=>{
            if (event.pointerId !== dragPointerId) return;
            if (event.defaultPrevented || activePointers.size > 1) return;
            if (isTouchDevice && Date.now() - touchStartTime < touchDelay) return;
            const x = event.clientX;
            const y = event.clientY;
            const dx = x - startX;
            const dy = y - startY;
            if (isDragging || Math.abs(dx) > threshold || Math.abs(dy) > threshold) {
                event.preventDefault();
                event.stopPropagation();
                if (!isDragging) {
                    // Emit start event
                    dragSignal.set({
                        type: 'start',
                        x: startX - left,
                        y: startY - top
                    });
                    isDragging = true;
                }
                // Emit move event
                dragSignal.set({
                    type: 'move',
                    x: x - left,
                    y: y - top,
                    deltaX: dx,
                    deltaY: dy
                });
                startX = x;
                startY = y;
            }
        };
        const onPointerUp = (event)=>{
            // Only react to pointers that started on the element
            if (!activePointers.delete(event.pointerId)) return;
            // Only the pointer that started the drag can end it
            if (event.pointerId === dragPointerId && isDragging) {
                const x = event.clientX;
                const y = event.clientY;
                // Emit end event
                dragSignal.set({
                    type: 'end',
                    x: x - left,
                    y: y - top
                });
            }
            // Keep listening until all pointers are released
            if (activePointers.size === 0) unsubscribeDocument();
        };
        const onPointerLeave = (e)=>{
            if (!e.relatedTarget || e.relatedTarget === document.documentElement) onPointerUp(e);
        };
        const onClick = (event)=>{
            if (isDragging) {
                event.stopPropagation();
                event.preventDefault();
            }
        };
        const onTouchMove = (event)=>{
            if (event.defaultPrevented || activePointers.size > 1) return;
            if (isDragging) event.preventDefault();
        };
        document.addEventListener('pointermove', onPointerMove);
        document.addEventListener('pointerup', onPointerUp);
        document.addEventListener('pointerout', onPointerLeave);
        document.addEventListener('pointercancel', onPointerLeave);
        document.addEventListener('touchmove', onTouchMove, {
            passive: false
        });
        document.addEventListener('click', onClick, {
            capture: true
        });
        unsubscribeDocument = ()=>{
            document.removeEventListener('pointermove', onPointerMove);
            document.removeEventListener('pointerup', onPointerUp);
            document.removeEventListener('pointerout', onPointerLeave);
            document.removeEventListener('pointercancel', onPointerLeave);
            document.removeEventListener('touchmove', onTouchMove);
            setTimeout(()=>{
                document.removeEventListener('click', onClick, {
                    capture: true
                });
            }, 10);
        };
    };
    element.addEventListener('pointerdown', onPointerDown);
    const cleanupFn = ()=>{
        unsubscribeDocument();
        element.removeEventListener('pointerdown', onPointerDown);
        activePointers.clear();
        (0, $dZtWw.cleanup)(dragSignal);
    };
    return {
        signal: dragSignal,
        cleanup: cleanupFn
    };
}

});
parcelRegister("dZtWw", function(module, exports) {

$parcel$export(module.exports, "cleanup", () => $a2f832ec1a5f59ff$export$de863c629cb9919d);
/**
 * Event stream utilities for converting DOM events to reactive signals
 *
 * These utilities allow composing event handling using reactive primitives.
 */ 
var $8Wo0q = parcelRequire("8Wo0q");
function $a2f832ec1a5f59ff$export$a36e16046ae8f1bb(element, eventName) {
    const stream = (0, $8Wo0q.signal)(null);
    const handler = (event)=>{
        stream.set(event);
    };
    element.addEventListener(eventName, handler);
    stream._cleanup = ()=>{
        element.removeEventListener(eventName, handler);
    };
    return stream;
}
function $a2f832ec1a5f59ff$export$871de8747c9eaa88(source, mapper) {
    const result = (0, $8Wo0q.signal)(mapper(source.value));
    const unsubscribe = source.subscribe((value)=>{
        result.set(mapper(value));
    });
    result._cleanup = unsubscribe;
    return result;
}
function $a2f832ec1a5f59ff$export$3dea766d36a8935f(source, predicate) {
    const initialValue = predicate(source.value) ? source.value : null;
    const result = (0, $8Wo0q.signal)(initialValue);
    const unsubscribe = source.subscribe((value)=>{
        if (predicate(value)) result.set(value);
        else result.set(null);
    });
    result._cleanup = unsubscribe;
    return result;
}
function $a2f832ec1a5f59ff$export$61fc7d43ac8f84b0(source, delay) {
    const result = (0, $8Wo0q.signal)(source.value);
    let timeout;
    const unsubscribe = source.subscribe((value)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>{
            result.set(value);
        }, delay);
    });
    result._cleanup = ()=>{
        clearTimeout(timeout);
        unsubscribe();
    };
    return result;
}
function $a2f832ec1a5f59ff$export$de363e709c412c8a(source, delay) {
    const result = (0, $8Wo0q.signal)(source.value);
    let lastEmit = 0;
    let timeout;
    const unsubscribe = source.subscribe((value)=>{
        const now = Date.now();
        const timeSinceLastEmit = now - lastEmit;
        if (timeSinceLastEmit >= delay) {
            result.set(value);
            lastEmit = now;
        } else {
            // Too soon, schedule for later
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                result.set(value);
                lastEmit = Date.now();
            }, delay - timeSinceLastEmit);
        }
    });
    result._cleanup = ()=>{
        clearTimeout(timeout);
        unsubscribe();
    };
    return result;
}
function $a2f832ec1a5f59ff$export$de863c629cb9919d(stream) {
    const cleanupFn = stream._cleanup;
    if (typeof cleanupFn === 'function') cleanupFn();
}

});


parcelRegister("1mhpw", function(module, exports) {

$parcel$export(module.exports, "createScrollStream", () => $0fd559e5058bd211$export$39b348c1ac25b5dd);
/**
 * Reactive scroll stream utilities
 *
 * Provides declarative scroll handling using reactive streams.
 * Automatically handles scroll event optimization and cleanup.
 */ 
var $8Wo0q = parcelRequire("8Wo0q");

var $dZtWw = parcelRequire("dZtWw");
function $0fd559e5058bd211$export$2d870b98f8da4582(scrollData) {
    const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, clientWidth: clientWidth } = scrollData;
    if (scrollWidth === 0) return {
        startX: 0,
        endX: 1
    };
    const startX = scrollLeft / scrollWidth;
    const endX = (scrollLeft + clientWidth) / scrollWidth;
    return {
        startX: Math.max(0, Math.min(1, startX)),
        endX: Math.max(0, Math.min(1, endX))
    };
}
function $0fd559e5058bd211$export$2ff0b4725276300c(scrollData) {
    return {
        left: scrollData.scrollLeft,
        right: scrollData.scrollLeft + scrollData.clientWidth
    };
}
function $0fd559e5058bd211$export$39b348c1ac25b5dd(element) {
    // Create signals
    const scrollData = (0, $8Wo0q.signal)({
        scrollLeft: element.scrollLeft,
        scrollWidth: element.scrollWidth,
        clientWidth: element.clientWidth
    });
    // Computed derived values
    const percentages = (0, $8Wo0q.computed)(()=>{
        return $0fd559e5058bd211$export$2d870b98f8da4582(scrollData.value);
    }, [
        scrollData
    ]);
    const bounds = (0, $8Wo0q.computed)(()=>{
        return $0fd559e5058bd211$export$2ff0b4725276300c(scrollData.value);
    }, [
        scrollData
    ]);
    // Update scroll data on scroll event
    const onScroll = ()=>{
        scrollData.set({
            scrollLeft: element.scrollLeft,
            scrollWidth: element.scrollWidth,
            clientWidth: element.clientWidth
        });
    };
    // Attach scroll listener
    element.addEventListener('scroll', onScroll, {
        passive: true
    });
    // Cleanup function
    const cleanupFn = ()=>{
        element.removeEventListener('scroll', onScroll);
        (0, $dZtWw.cleanup)(scrollData);
    };
    return {
        scrollData: scrollData,
        percentages: percentages,
        bounds: bounds,
        cleanup: cleanupFn
    };
}
function $0fd559e5058bd211$export$214800893e04d063(element, onScrollChange) {
    const stream = $0fd559e5058bd211$export$39b348c1ac25b5dd(element);
    // Effect to update external state
    const unsubscribe = (0, $8Wo0q.effect)(()=>{
        onScrollChange(stream.scrollData.value.scrollLeft);
    }, [
        stream.scrollData
    ]);
    // Wrap cleanup to include effect cleanup
    const originalCleanup = stream.cleanup;
    stream.cleanup = ()=>{
        unsubscribe();
        originalCleanup();
    };
    return stream;
}

});


parcelRegister("kNEh8", function(module, exports) {

$parcel$export(module.exports, "default", () => $f247a01f02ab362f$export$2e2bcd8739ae039);

var $6s4Q9 = parcelRequire("6s4Q9");
class $f247a01f02ab362f$var$Timer extends (0, $6s4Q9.default) {
    constructor(){
        super(...arguments);
        this.animationFrameId = null;
        this.isRunning = false;
    }
    start() {
        // Prevent multiple simultaneous loops
        if (this.isRunning) return;
        this.isRunning = true;
        const tick = ()=>{
            // Only continue if timer is still running
            if (!this.isRunning) return;
            this.emit('tick');
            // Schedule next frame
            this.animationFrameId = requestAnimationFrame(tick);
        };
        // Start the loop
        tick();
    }
    stop() {
        this.isRunning = false;
        // Cancel any pending animation frame
        if (this.animationFrameId !== null) {
            cancelAnimationFrame(this.animationFrameId);
            this.animationFrameId = null;
        }
    }
    destroy() {
        this.stop();
        this.unAll();
    }
}
var $f247a01f02ab362f$export$2e2bcd8739ae039 = $f247a01f02ab362f$var$Timer;

});

parcelRegister("lv1Tt", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa6df64967662716$export$2e2bcd8739ae039);

var $6s4Q9 = parcelRequire("6s4Q9");
var $fa6df64967662716$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $fa6df64967662716$var$setWebAudioSessionPlayback() {
    const navigator = globalThis.navigator;
    if (!(navigator === null || navigator === void 0 ? void 0 : navigator.audioSession)) return;
    try {
        navigator.audioSession.type = 'playback';
    } catch (e) {
        console.warn('Setting navigator.audioSession.type failed:', e);
    }
}
/**
 * A Web Audio buffer player emulating the behavior of an HTML5 Audio element.
 *
 * Note: This class does not manage blob: URLs. If you pass a blob: URL to setSrc(),
 * you are responsible for revoking it when done. The Player class (player.ts) handles
 * blob URL lifecycle management automatically.
 */ class $fa6df64967662716$var$WebAudioPlayer extends (0, $6s4Q9.default) {
    constructor(audioContext){
        super();
        this.bufferNode = null;
        this.playStartTime = 0;
        this.playbackPosition = 0;
        this._muted = false;
        this._playbackRate = 1;
        this._duration = undefined;
        this.buffer = null;
        this.currentSrc = '';
        this.paused = true;
        this.crossOrigin = null;
        this.seeking = false;
        this.autoplay = false;
        /** Subscribe to an event. Returns an unsubscribe function. */ this.addEventListener = this.on;
        /** Unsubscribe from an event */ this.removeEventListener = this.un;
        this._destroyed = false;
        $fa6df64967662716$var$setWebAudioSessionPlayback();
        this.audioContext = audioContext || new AudioContext();
        this.gainNode = this.audioContext.createGain();
        this.gainNode.connect(this.audioContext.destination);
    }
    load() {
        return $fa6df64967662716$var$__awaiter(this, void 0, void 0, function*() {
            return;
        });
    }
    /** For compatibility with HTMLMediaElement.remove(). Delegates to destroy(). */ remove() {
        this.destroy();
    }
    /** Clean up all resources. Idempotent — safe to call multiple times. */ destroy() {
        if (this._destroyed) return;
        this._destroyed = true;
        // Clear currentSrc so any in-flight fetch/decode chains bail out
        // via their existing `this.currentSrc !== value` guards
        this.currentSrc = '';
        // Stop and disconnect buffer node
        if (this.bufferNode) {
            this.bufferNode.onended = null;
            try {
                this.bufferNode.stop();
            } catch (_a) {
            // Ignore InvalidStateError if node already stopped
            }
            this.bufferNode.disconnect();
            this.bufferNode = null;
        }
        // Disconnect gain node
        this.gainNode.disconnect();
        // Close audio context (returns a promise, catch rejection if already closed)
        // Guard with typeof check for mock environments where close may not exist
        if (typeof this.audioContext.close === 'function') Promise.resolve(this.audioContext.close.call(this.audioContext)).catch(()=>undefined);
        // Clear buffer reference
        this.buffer = null;
        // Clear all event listeners
        this.unAll();
    }
    get src() {
        return this.currentSrc;
    }
    set src(value) {
        this.currentSrc = value;
        this._duration = undefined;
        if (!value) {
            this.buffer = null;
            this.emit('emptied');
            return;
        }
        fetch(value).then((response)=>{
            if (response.status >= 400) throw new Error(`Failed to fetch ${value}: ${response.status} (${response.statusText})`);
            return response.arrayBuffer();
        }).then((arrayBuffer)=>{
            if (this.currentSrc !== value) return null;
            return this.audioContext.decodeAudioData(arrayBuffer);
        }).then((audioBuffer)=>{
            if (this.currentSrc !== value) return;
            this.buffer = audioBuffer;
            this.emit('loadedmetadata');
            this.emit('canplay');
            if (this.autoplay) this.play();
        }).catch((err)=>{
            // Emit error for proper error handling
            console.error('WebAudioPlayer load error:', err);
        });
    }
    _play() {
        if (!this.paused) return;
        this.paused = false;
        // Clean up old buffer node completely before creating new one
        if (this.bufferNode) {
            this.bufferNode.onended = null;
            this.bufferNode.disconnect();
        }
        this.bufferNode = this.audioContext.createBufferSource();
        if (this.buffer) this.bufferNode.buffer = this.buffer;
        this.bufferNode.playbackRate.value = this._playbackRate;
        this.bufferNode.connect(this.gainNode);
        let currentPos = this.playbackPosition;
        if (currentPos >= this.duration || currentPos < 0) {
            currentPos = 0;
            this.playbackPosition = 0;
        }
        this.bufferNode.start(this.audioContext.currentTime, currentPos);
        this.playStartTime = this.audioContext.currentTime;
        this.bufferNode.onended = ()=>{
            if (!this.paused && this.duration - this.currentTime < 0.01) {
                this.pause();
                this.emit('ended');
            }
        };
    }
    _pause() {
        this.paused = true;
        // Clear onended before stopping to prevent spurious 'ended' event
        if (this.bufferNode) {
            this.bufferNode.onended = null;
            try {
                this.bufferNode.stop();
            } catch (_a) {
            // Ignore InvalidStateError if node already stopped
            }
        }
        this.playbackPosition += (this.audioContext.currentTime - this.playStartTime) * this._playbackRate;
    }
    play() {
        return $fa6df64967662716$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.paused) return;
            this._play();
            this.emit('play');
        });
    }
    pause() {
        if (this.paused) return;
        this._pause();
        this.emit('pause');
    }
    stopAt(timeSeconds) {
        // The stop is scheduled on the AudioContext clock, so convert the remaining
        // media time to real time via the playback rate
        const delay = (timeSeconds - this.currentTime) / this._playbackRate;
        const currentBufferNode = this.bufferNode;
        currentBufferNode === null || currentBufferNode === void 0 || currentBufferNode.stop(this.audioContext.currentTime + delay);
        currentBufferNode === null || currentBufferNode === void 0 || currentBufferNode.addEventListener('ended', ()=>{
            if (currentBufferNode === this.bufferNode) {
                this.bufferNode = null;
                this.pause();
                // The 'ended' event fires with some latency, so clamp the reported
                // position to the exact stop time
                this.playbackPosition = Math.min(timeSeconds, this.duration);
                this.emit('timeupdate');
            }
        }, {
            once: true
        });
    }
    setSinkId(deviceId) {
        return $fa6df64967662716$var$__awaiter(this, void 0, void 0, function*() {
            const ac = this.audioContext;
            return ac.setSinkId(deviceId);
        });
    }
    get playbackRate() {
        return this._playbackRate;
    }
    set playbackRate(value) {
        const wasPlaying = !this.paused;
        if (wasPlaying) this._pause();
        this._playbackRate = value;
        if (wasPlaying) this._play();
        if (this.bufferNode) this.bufferNode.playbackRate.value = value;
    }
    get currentTime() {
        return this.paused ? this.playbackPosition : this.playbackPosition + (this.audioContext.currentTime - this.playStartTime) * this._playbackRate;
    }
    set currentTime(value) {
        const wasPlaying = !this.paused;
        if (wasPlaying) this._pause();
        this.playbackPosition = value;
        if (wasPlaying) this._play();
        this.emit('seeking');
        this.emit('timeupdate');
    }
    get duration() {
        var _a, _b;
        return (_a = this._duration) !== null && _a !== void 0 ? _a : ((_b = this.buffer) === null || _b === void 0 ? void 0 : _b.duration) || 0;
    }
    set duration(value) {
        this._duration = value;
    }
    get volume() {
        return this.gainNode.gain.value;
    }
    set volume(value) {
        this.gainNode.gain.value = value;
        this.emit('volumechange');
    }
    get muted() {
        return this._muted;
    }
    set muted(value) {
        if (this._muted === value) return;
        this._muted = value;
        if (this._muted) this.gainNode.disconnect();
        else this.gainNode.connect(this.audioContext.destination);
    }
    canPlayType(mimeType) {
        return /^(audio|video)\//.test(mimeType);
    }
    /** Get the GainNode used to play the audio. Can be used to attach filters. */ getGainNode() {
        return this.gainNode;
    }
    /** Get decoded audio */ getChannelData() {
        const channels = [];
        if (!this.buffer) return channels;
        const numChannels = this.buffer.numberOfChannels;
        for(let i = 0; i < numChannels; i++)channels.push(this.buffer.getChannelData(i));
        return channels;
    }
    /**
     * Imitate `HTMLElement.removeAttribute` for compatibility with `Player`.
     */ removeAttribute(attrName) {
        switch(attrName){
            case 'src':
                this.src = '';
                break;
            case 'playbackRate':
                this.playbackRate = 0;
                break;
            case 'currentTime':
                this.currentTime = 0;
                break;
            case 'duration':
                this.duration = 0;
                break;
            case 'volume':
                this.volume = 0;
                break;
            case 'muted':
                this.muted = false;
                break;
        }
    }
}
var $fa6df64967662716$export$2e2bcd8739ae039 = $fa6df64967662716$var$WebAudioPlayer;

});

parcelRegister("epTtS", function(module, exports) {

$parcel$export(module.exports, "createWaveSurferState", () => $a7ee6fda039ad836$export$db59e96ed790cb58);
/**
 * Centralized reactive state for WaveSurfer
 *
 * This module provides a single source of truth for all WaveSurfer state.
 * State is managed using reactive signals that automatically notify subscribers.
 */ 
var $8Wo0q = parcelRequire("8Wo0q");
function $a7ee6fda039ad836$export$db59e96ed790cb58(playerSignals) {
    var _a, _b, _c, _d, _e, _f;
    // Use Player signals if provided, otherwise create new ones
    const currentTime = (_a = playerSignals === null || playerSignals === void 0 ? void 0 : playerSignals.currentTime) !== null && _a !== void 0 ? _a : (0, $8Wo0q.signal)(0);
    const duration = (_b = playerSignals === null || playerSignals === void 0 ? void 0 : playerSignals.duration) !== null && _b !== void 0 ? _b : (0, $8Wo0q.signal)(0);
    const isPlaying = (_c = playerSignals === null || playerSignals === void 0 ? void 0 : playerSignals.isPlaying) !== null && _c !== void 0 ? _c : (0, $8Wo0q.signal)(false);
    const isSeeking = (_d = playerSignals === null || playerSignals === void 0 ? void 0 : playerSignals.isSeeking) !== null && _d !== void 0 ? _d : (0, $8Wo0q.signal)(false);
    const volume = (_e = playerSignals === null || playerSignals === void 0 ? void 0 : playerSignals.volume) !== null && _e !== void 0 ? _e : (0, $8Wo0q.signal)(1);
    const playbackRate = (_f = playerSignals === null || playerSignals === void 0 ? void 0 : playerSignals.playbackRate) !== null && _f !== void 0 ? _f : (0, $8Wo0q.signal)(1);
    // WaveSurfer-specific signals (not in Player)
    const audioBuffer = (0, $8Wo0q.signal)(null);
    const peaks = (0, $8Wo0q.signal)(null);
    const url = (0, $8Wo0q.signal)('');
    const zoom = (0, $8Wo0q.signal)(0);
    const scrollPosition = (0, $8Wo0q.signal)(0);
    // Computed values (derived state)
    const isPaused = (0, $8Wo0q.computed)(()=>!isPlaying.value, [
        isPlaying
    ]);
    const canPlay = (0, $8Wo0q.computed)(()=>audioBuffer.value !== null, [
        audioBuffer
    ]);
    const isReady = (0, $8Wo0q.computed)(()=>{
        return canPlay.value && duration.value > 0;
    }, [
        canPlay,
        duration
    ]);
    const progress = (0, $8Wo0q.computed)(()=>currentTime.value, [
        currentTime
    ]);
    const progressPercent = (0, $8Wo0q.computed)(()=>{
        return duration.value > 0 ? currentTime.value / duration.value : 0;
    }, [
        currentTime,
        duration
    ]);
    // Public read-only state
    const state = {
        currentTime: currentTime,
        duration: duration,
        isPlaying: isPlaying,
        isPaused: isPaused,
        isSeeking: isSeeking,
        volume: volume,
        playbackRate: playbackRate,
        audioBuffer: audioBuffer,
        peaks: peaks,
        url: url,
        zoom: zoom,
        scrollPosition: scrollPosition,
        canPlay: canPlay,
        isReady: isReady,
        progress: progress,
        progressPercent: progressPercent
    };
    // Actions that modify state
    const actions = {
        setCurrentTime: (time)=>{
            const clampedTime = Math.max(0, Math.min(duration.value || Infinity, time));
            currentTime.set(clampedTime);
        },
        setDuration: (d)=>{
            duration.set(Math.max(0, d));
        },
        setPlaying: (playing)=>{
            isPlaying.set(playing);
        },
        setSeeking: (seeking)=>{
            isSeeking.set(seeking);
        },
        setVolume: (v)=>{
            const clampedVolume = Math.max(0, Math.min(1, v));
            volume.set(clampedVolume);
        },
        setPlaybackRate: (rate)=>{
            const clampedRate = Math.max(0.1, Math.min(16, rate));
            playbackRate.set(clampedRate);
        },
        setAudioBuffer: (buffer)=>{
            audioBuffer.set(buffer);
            if (buffer) duration.set(buffer.duration);
        },
        setPeaks: (p)=>{
            peaks.set(p);
        },
        setUrl: (u)=>{
            url.set(u);
        },
        setZoom: (z)=>{
            zoom.set(Math.max(0, z));
        },
        setScrollPosition: (pos)=>{
            scrollPosition.set(Math.max(0, pos));
        }
    };
    return {
        state: state,
        actions: actions
    };
}

});

parcelRegister("gQK5r", function(module, exports) {

$parcel$export(module.exports, "setupStateEventEmission", () => $c445408530c4d6d4$export$a76f26ef7b2198c1);
/**
 * State-driven event emission utilities
 *
 * Automatically emit events when reactive state changes.
 * Ensures events are always in sync with state and removes manual emit() calls.
 */ 
var $8Wo0q = parcelRequire("8Wo0q");
function $c445408530c4d6d4$export$a76f26ef7b2198c1(state, emitter) {
    const cleanups = [];
    // ============================================================================
    // Play/Pause Events
    // ============================================================================
    // Emit play/pause events when playing state changes
    cleanups.push((0, $8Wo0q.effect)(()=>{
        const isPlaying = state.isPlaying.value;
        emitter.emit(isPlaying ? 'play' : 'pause');
    }, [
        state.isPlaying
    ]));
    // ============================================================================
    // Time Update Events
    // ============================================================================
    // Emit timeupdate when current time changes
    cleanups.push((0, $8Wo0q.effect)(()=>{
        const currentTime = state.currentTime.value;
        emitter.emit('timeupdate', currentTime);
        // Also emit audioprocess when playing
        if (state.isPlaying.value) emitter.emit('audioprocess', currentTime);
    }, [
        state.currentTime,
        state.isPlaying
    ]));
    // ============================================================================
    // Seeking Events
    // ============================================================================
    // Emit seeking event when seeking state changes to true
    cleanups.push((0, $8Wo0q.effect)(()=>{
        const isSeeking = state.isSeeking.value;
        if (isSeeking) emitter.emit('seeking', state.currentTime.value);
    }, [
        state.isSeeking,
        state.currentTime
    ]));
    // ============================================================================
    // Ready Event
    // ============================================================================
    // Emit ready when state becomes ready
    let wasReady = false;
    cleanups.push((0, $8Wo0q.effect)(()=>{
        const isReady = state.isReady.value;
        if (isReady && !wasReady) {
            wasReady = true;
            emitter.emit('ready', state.duration.value);
        }
    }, [
        state.isReady,
        state.duration
    ]));
    // Reset wasReady when audio buffer is cleared (new load starting)
    // This allows the 'ready' event to fire again on subsequent loads
    cleanups.push((0, $8Wo0q.effect)(()=>{
        if (state.audioBuffer.value === null) wasReady = false;
    }, [
        state.audioBuffer
    ]));
    // ============================================================================
    // Finish Event
    // ============================================================================
    // Emit finish when playback ends (reached duration and stopped)
    let wasPlayingAtEnd = false;
    cleanups.push((0, $8Wo0q.effect)(()=>{
        const isPlaying = state.isPlaying.value;
        const currentTime = state.currentTime.value;
        const duration = state.duration.value;
        // Check if we're at the end
        const isAtEnd = duration > 0 && currentTime >= duration;
        // Emit finish when we were playing at end and now stopped
        if (wasPlayingAtEnd && !isPlaying && isAtEnd) emitter.emit('finish');
        // Track if we're playing at the end
        wasPlayingAtEnd = isPlaying && isAtEnd;
    }, [
        state.isPlaying,
        state.currentTime,
        state.duration
    ]));
    // ============================================================================
    // Zoom Events
    // ============================================================================
    // Emit zoom when zoom level changes
    cleanups.push((0, $8Wo0q.effect)(()=>{
        const zoom = state.zoom.value;
        if (zoom > 0) emitter.emit('zoom', zoom);
    }, [
        state.zoom
    ]));
    // Return cleanup function
    return ()=>{
        cleanups.forEach((cleanup)=>cleanup());
    };
}
function $c445408530c4d6d4$export$478d05cd8240f75(signal, emitter, getEventData) {
    return (0, $8Wo0q.effect)(()=>{
        const value = signal.value;
        const [eventName, ...args] = getEventData(value);
        emitter.emit(eventName, ...args);
    }, [
        signal
    ]);
}
function $c445408530c4d6d4$export$380599a071a4cead(signal, emitter, getEventData, debounceMs) {
    let timeoutId = null;
    const cleanup = (0, $8Wo0q.effect)(()=>{
        const value = signal.value;
        // Clear previous timeout
        if (timeoutId !== null) clearTimeout(timeoutId);
        // Set new timeout
        timeoutId = setTimeout(()=>{
            const [eventName, ...args] = getEventData(value);
            emitter.emit(eventName, ...args);
            timeoutId = null;
        }, debounceMs);
    }, [
        signal
    ]);
    // Return cleanup that also clears pending timeout
    return ()=>{
        if (timeoutId !== null) clearTimeout(timeoutId);
        cleanup();
    };
}
function $c445408530c4d6d4$export$5f8bb86fb2808297(signal, emitter, condition, getEventData) {
    return (0, $8Wo0q.effect)(()=>{
        const value = signal.value;
        if (condition(value)) {
            const [eventName, ...args] = getEventData(value);
            emitter.emit(eventName, ...args);
        }
    }, [
        signal
    ]);
}

});


parcelRegister("1zDll", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), Y = _.prototype;
    return O.prototype = Y, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        Y[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("jIjd8", function(module, exports) {
"use strict";

});

parcelRegister("dpGzb", function(module, exports) {
/**
 * This file automatically generated from `build.js`.
 * Do not manually edit.
 */ module.exports = [
    "address",
    "article",
    "aside",
    "blockquote",
    "canvas",
    "dd",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "li",
    "main",
    "nav",
    "noscript",
    "ol",
    "output",
    "p",
    "pre",
    "section",
    "table",
    "tfoot",
    "ul",
    "video"
];

});

parcelRegister("gCnfA", function(module, exports) {
'use strict';

var $2Z6Kw = parcelRequire("2Z6Kw");
var $c1923aff78480095$require$div = $2Z6Kw.div;
var $c1923aff78480095$require$p = $2Z6Kw.p;
var $c1923aff78480095$require$section = $2Z6Kw.section;

var $5Uq5a = parcelRequire("5Uq5a");

var $gol9c = parcelRequire("gol9c");

// custom admin UIs (override generic schema-driven resources when present)
const $c1923aff78480095$var$custom = {
    users: (parcelRequire("6SF7B"))
};
module.exports = ({ state: state, actions: actions, i18n: i18n })=>{
    const collection = state.router.path[1];
    return $c1923aff78480095$require$section('.admin', [
        $5Uq5a({
            state: state,
            actions: actions,
            i18n: i18n
        }),
        $c1923aff78480095$var$custom[collection] ? $c1923aff78480095$var$custom[collection]({
            state: state,
            actions: actions,
            i18n: i18n
        }) : state.rest.routes.api[collection] ? $gol9c({
            state: state,
            actions: actions,
            i18n: i18n
        }) : $c1923aff78480095$require$div($c1923aff78480095$require$p('Welcome to admin'))
    ]);
};

});
parcelRegister("2Z6Kw", function(module, exports) {

$parcel$export(module.exports, "patchStream", () => $22c6838f21f4f3e5$export$6d1478bea94d2d41);
$parcel$export(module.exports, "a", () => $22c6838f21f4f3e5$export$407448d2b89b1813);
$parcel$export(module.exports, "article", () => $22c6838f21f4f3e5$export$bba2aacf8566461b);
$parcel$export(module.exports, "aside", () => $22c6838f21f4f3e5$export$64a02cd6422b91be);
$parcel$export(module.exports, "body", () => $22c6838f21f4f3e5$export$32180ef41b15b513);
$parcel$export(module.exports, "br", () => $22c6838f21f4f3e5$export$479ac0420f53ed26);
$parcel$export(module.exports, "button", () => $22c6838f21f4f3e5$export$2ba01fb71ed41cb6);
$parcel$export(module.exports, "canvas", () => $22c6838f21f4f3e5$export$67ea982130081db);
$parcel$export(module.exports, "div", () => $22c6838f21f4f3e5$export$159d9494db57879b);
$parcel$export(module.exports, "fieldset", () => $22c6838f21f4f3e5$export$a38812d1aa1302d9);
$parcel$export(module.exports, "form", () => $22c6838f21f4f3e5$export$6210fa4921d2a466);
$parcel$export(module.exports, "h1", () => $22c6838f21f4f3e5$export$448e4850cad7c7b0);
$parcel$export(module.exports, "h2", () => $22c6838f21f4f3e5$export$a943aa9a0fca3f0b);
$parcel$export(module.exports, "h3", () => $22c6838f21f4f3e5$export$7edd4a21fac8ce55);
$parcel$export(module.exports, "h4", () => $22c6838f21f4f3e5$export$51a85cc1b68f452c);
$parcel$export(module.exports, "header", () => $22c6838f21f4f3e5$export$38e42c68cf43b5d4);
$parcel$export(module.exports, "hr", () => $22c6838f21f4f3e5$export$b4adb3f464574dcf);
$parcel$export(module.exports, "i", () => $22c6838f21f4f3e5$export$23f2a1d2818174ef);
$parcel$export(module.exports, "iframe", () => $22c6838f21f4f3e5$export$8cde213409fd6377);
$parcel$export(module.exports, "img", () => $22c6838f21f4f3e5$export$463b44d9bf3628be);
$parcel$export(module.exports, "input", () => $22c6838f21f4f3e5$export$b7e3ae3d7c15e42e);
$parcel$export(module.exports, "label", () => $22c6838f21f4f3e5$export$1237798dc640739a);
$parcel$export(module.exports, "legend", () => $22c6838f21f4f3e5$export$9a9b59e08de24cef);
$parcel$export(module.exports, "li", () => $22c6838f21f4f3e5$export$19caeaf7d9d84644);
$parcel$export(module.exports, "main", () => $22c6838f21f4f3e5$export$f22da7240b7add18);
$parcel$export(module.exports, "option", () => $22c6838f21f4f3e5$export$a75d1723e6bda2ec);
$parcel$export(module.exports, "p", () => $22c6838f21f4f3e5$export$ffb5f4729a158638);
$parcel$export(module.exports, "section", () => $22c6838f21f4f3e5$export$fe2e36411d703b3d);
$parcel$export(module.exports, "select", () => $22c6838f21f4f3e5$export$2e6c959c16ff56b8);
$parcel$export(module.exports, "span", () => $22c6838f21f4f3e5$export$afc1bfabebaf28a2);
$parcel$export(module.exports, "table", () => $22c6838f21f4f3e5$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tbody", () => $22c6838f21f4f3e5$export$7cdd536eaa8f163c);
$parcel$export(module.exports, "td", () => $22c6838f21f4f3e5$export$2beef8af2014e5c6);
$parcel$export(module.exports, "textarea", () => $22c6838f21f4f3e5$export$a3574df893ffa88d);
$parcel$export(module.exports, "th", () => $22c6838f21f4f3e5$export$d657bc098992a431);
$parcel$export(module.exports, "thead", () => $22c6838f21f4f3e5$export$e3f32a5920890b82);
$parcel$export(module.exports, "tr", () => $22c6838f21f4f3e5$export$72451b88a72ad9c2);
$parcel$export(module.exports, "ul", () => $22c6838f21f4f3e5$export$b5023c870cb34848);
/**
 * @module iblokz-snabbdom-helpers
 * @description Snabbdom virtual DOM helpers with hyperscript syntax sugar
 * @version 2.0.0
 */ 
var $hg1zz = parcelRequire("hg1zz");
var $lIFbp = parcelRequire("lIFbp");
var $jasng = parcelRequire("jasng");
var $eQjvH = parcelRequire("eQjvH");
var $cLIDp = parcelRequire("cLIDp");
var $efxP4 = parcelRequire("efxP4");
var $g8AdR = parcelRequire("g8AdR");

var $f6wSa = parcelRequire("f6wSa");

var $94573 = parcelRequire("94573");

var $aADWn = parcelRequire("aADWn");
const $22c6838f21f4f3e5$export$b76953f99ab2be78 = (0, $cLIDp.init)([
    (0, $lIFbp.classModule),
    (0, $efxP4.propsModule),
    (0, $hg1zz.attributesModule),
    (0, $g8AdR.styleModule),
    (0, $jasng.eventListenersModule // attaches event listeners
    )
]);
const $22c6838f21f4f3e5$export$6d1478bea94d2d41 = (stream, dom)=>{
    dom = typeof dom === 'string' ? document.querySelector(dom) : dom;
    return stream.pipe((0, $f6wSa.scan)((vnode, newVnode)=>$22c6838f21f4f3e5$export$b76953f99ab2be78(vnode, newVnode), dom)).subscribe();
};
/**
 * Generate hyperscript helper functions for all HTML tags
 */ const $22c6838f21f4f3e5$var$hyperHelpers = (0, (/*@__PURE__*/$parcel$interopDefault($94573))).reduce((o, tag)=>{
    o[tag] = function() {
        return [
            Array.from(arguments)
        ].map($aADWn.process).map((args)=>// is the first argument a selector
            args[0] && typeof args[0] === 'string' && args[0].match(/^(\.|#)[a-zA-Z\-_0-9]+/ig) ? [].concat(tag + args[0], args.slice(1)) : [
                tag
            ].concat(args)).map((args)=>(0, $eQjvH.h).apply(this, args)).pop();
    };
    return o;
}, {});
const { a: $22c6838f21f4f3e5$export$407448d2b89b1813, abbr: $22c6838f21f4f3e5$export$2bcb785951133fe5, address: $22c6838f21f4f3e5$export$f7d3c097ceca6c15, area: $22c6838f21f4f3e5$export$bb3edc44842b5f2e, article: $22c6838f21f4f3e5$export$bba2aacf8566461b, aside: $22c6838f21f4f3e5$export$64a02cd6422b91be, audio: $22c6838f21f4f3e5$export$592b77e6034db746, b: $22c6838f21f4f3e5$export$8b22cf2602fb60ce, base: $22c6838f21f4f3e5$export$e2253033e6e1df16, bdi: $22c6838f21f4f3e5$export$2d20a4e9df674436, bdo: $22c6838f21f4f3e5$export$fae0db89ef70aab2, blockquote: $22c6838f21f4f3e5$export$67dc04e652a298ca, body: $22c6838f21f4f3e5$export$32180ef41b15b513, br: $22c6838f21f4f3e5$export$479ac0420f53ed26, button: $22c6838f21f4f3e5$export$2ba01fb71ed41cb6, canvas: $22c6838f21f4f3e5$export$67ea982130081db, caption: $22c6838f21f4f3e5$export$8e3c2dfdc4f0453d, cite: $22c6838f21f4f3e5$export$3035df57df42c31a, code: $22c6838f21f4f3e5$export$6565f9f03506010b, col: $22c6838f21f4f3e5$export$aba86695643891f5, colgroup: $22c6838f21f4f3e5$export$3db318dd257cd653, data: $22c6838f21f4f3e5$export$4051a07651545597, datalist: $22c6838f21f4f3e5$export$d6956b5f6d5ee87d, dd: $22c6838f21f4f3e5$export$eaaeafa904fe3ddf, del: $22c6838f21f4f3e5$export$1d2f21e549771e67, details: $22c6838f21f4f3e5$export$41ee12f6f6f05843, dfn: $22c6838f21f4f3e5$export$771f54d1a902afc9, dialog: $22c6838f21f4f3e5$export$518824cf31321346, div: $22c6838f21f4f3e5$export$159d9494db57879b, dl: $22c6838f21f4f3e5$export$53d26b7a9a23d594, dt: $22c6838f21f4f3e5$export$9198f9466fc833e, em: $22c6838f21f4f3e5$export$c63c6f932822f543, embed: $22c6838f21f4f3e5$export$2be46bb7e96db87f, fieldset: $22c6838f21f4f3e5$export$a38812d1aa1302d9, figcaption: $22c6838f21f4f3e5$export$b75acb72a9c69c26, figure: $22c6838f21f4f3e5$export$991dc94f816a1d48, footer: $22c6838f21f4f3e5$export$adb608be33961c98, form: $22c6838f21f4f3e5$export$6210fa4921d2a466, h1: $22c6838f21f4f3e5$export$448e4850cad7c7b0, h2: $22c6838f21f4f3e5$export$a943aa9a0fca3f0b, h3: $22c6838f21f4f3e5$export$7edd4a21fac8ce55, h4: $22c6838f21f4f3e5$export$51a85cc1b68f452c, h5: $22c6838f21f4f3e5$export$f44841a11990acb2, h6: $22c6838f21f4f3e5$export$c9ccd321d64f47e3, head: $22c6838f21f4f3e5$export$5fd5031fecdacec3, header: $22c6838f21f4f3e5$export$38e42c68cf43b5d4, hgroup: $22c6838f21f4f3e5$export$e7c17d6cef8bd1c, hr: $22c6838f21f4f3e5$export$b4adb3f464574dcf, html: $22c6838f21f4f3e5$export$c0bb0b647f701bb5, i: $22c6838f21f4f3e5$export$23f2a1d2818174ef, iframe: $22c6838f21f4f3e5$export$8cde213409fd6377, img: $22c6838f21f4f3e5$export$463b44d9bf3628be, input: $22c6838f21f4f3e5$export$b7e3ae3d7c15e42e, ins: $22c6838f21f4f3e5$export$27a48efc044c200a, kbd: $22c6838f21f4f3e5$export$1ed45b69d23c052b, label: $22c6838f21f4f3e5$export$1237798dc640739a, legend: $22c6838f21f4f3e5$export$9a9b59e08de24cef, li: $22c6838f21f4f3e5$export$19caeaf7d9d84644, link: $22c6838f21f4f3e5$export$9c30223ca0a664fb, main: $22c6838f21f4f3e5$export$f22da7240b7add18, map: $22c6838f21f4f3e5$export$871de8747c9eaa88, mark: $22c6838f21f4f3e5$export$bf7f2fce5c1cf636, menu: $22c6838f21f4f3e5$export$b1e5508a851be14d, meta: $22c6838f21f4f3e5$export$6990040ee07315, meter: $22c6838f21f4f3e5$export$82334bbdfcebb57, nav: $22c6838f21f4f3e5$export$80e4b313e5e6b30d, noscript: $22c6838f21f4f3e5$export$528ba0e6da49e146, object: $22c6838f21f4f3e5$export$be5493f9613cbbe, ol: $22c6838f21f4f3e5$export$b2235297ee22a6fe, optgroup: $22c6838f21f4f3e5$export$b9d336f245a516e8, option: $22c6838f21f4f3e5$export$a75d1723e6bda2ec, output: $22c6838f21f4f3e5$export$c789db2c85949867, p: $22c6838f21f4f3e5$export$ffb5f4729a158638, picture: $22c6838f21f4f3e5$export$1188214e9d38144e, pre: $22c6838f21f4f3e5$export$2af2ac64526e2aa9, progress: $22c6838f21f4f3e5$export$504d7abb21fa8c9, q: $22c6838f21f4f3e5$export$9e5f44173e64f162, rp: $22c6838f21f4f3e5$export$6d4c73e3ddf8818b, rt: $22c6838f21f4f3e5$export$f08282231bb71285, ruby: $22c6838f21f4f3e5$export$f2b283820b448b35, s: $22c6838f21f4f3e5$export$2408f22a0fab9ae5, samp: $22c6838f21f4f3e5$export$8c1cb8fb6818c292, script: $22c6838f21f4f3e5$export$bc237d627614fc48, search: $22c6838f21f4f3e5$export$d76128d007d19019, section: $22c6838f21f4f3e5$export$fe2e36411d703b3d, select: $22c6838f21f4f3e5$export$2e6c959c16ff56b8, slot: $22c6838f21f4f3e5$export$103b78750979eead, small: $22c6838f21f4f3e5$export$3c17b0e969a90510, source: $22c6838f21f4f3e5$export$b4d5da5f34fb77ad, span: $22c6838f21f4f3e5$export$afc1bfabebaf28a2, strong: $22c6838f21f4f3e5$export$59ae2c325a998f89, style: $22c6838f21f4f3e5$export$1d567c320f4763bc, sub: $22c6838f21f4f3e5$export$f93b5905241a7cca, summary: $22c6838f21f4f3e5$export$9a2dbef7a17e2e58, sup: $22c6838f21f4f3e5$export$abe1cd54efe9b9cd, table: $22c6838f21f4f3e5$export$9852986a3ec5f6a0, tbody: $22c6838f21f4f3e5$export$7cdd536eaa8f163c, td: $22c6838f21f4f3e5$export$2beef8af2014e5c6, template: $22c6838f21f4f3e5$export$ce69bd05624d0c48, textarea: $22c6838f21f4f3e5$export$a3574df893ffa88d, tfoot: $22c6838f21f4f3e5$export$9396b2f97a03ad14, th: $22c6838f21f4f3e5$export$d657bc098992a431, thead: $22c6838f21f4f3e5$export$e3f32a5920890b82, time: $22c6838f21f4f3e5$export$2da9be4cfdb689b1, title: $22c6838f21f4f3e5$export$fb184b623420d9be, tr: $22c6838f21f4f3e5$export$72451b88a72ad9c2, track: $22c6838f21f4f3e5$export$6b2a7d5132615086, u: $22c6838f21f4f3e5$export$3b14a55fb2447963, ul: $22c6838f21f4f3e5$export$b5023c870cb34848, video: $22c6838f21f4f3e5$export$5f8d3589eb8441ca, wbr: $22c6838f21f4f3e5$export$ee8f8f9447a35bdc } = $22c6838f21f4f3e5$var$hyperHelpers;

});
parcelRegister("hg1zz", function(module, exports) {

$parcel$export(module.exports, "attributesModule", () => $c905269ff18f4bdc$export$5381d68fac100f69);
const $c905269ff18f4bdc$var$xlinkNS = "http://www.w3.org/1999/xlink";
const $c905269ff18f4bdc$var$xmlnsNS = "http://www.w3.org/2000/xmlns/";
const $c905269ff18f4bdc$var$xmlNS = "http://www.w3.org/XML/1998/namespace";
const $c905269ff18f4bdc$var$colonChar = 58;
const $c905269ff18f4bdc$var$xChar = 120;
const $c905269ff18f4bdc$var$mChar = 109;
function $c905269ff18f4bdc$var$updateAttrs(oldVnode, vnode) {
    let key;
    const elm = vnode.elm;
    let oldAttrs = oldVnode.data.attrs;
    let attrs = vnode.data.attrs;
    if (!oldAttrs && !attrs) return;
    if (oldAttrs === attrs) return;
    oldAttrs = oldAttrs || {};
    attrs = attrs || {};
    // update modified attributes, add new attributes
    for(key in attrs){
        const cur = attrs[key];
        const old = oldAttrs[key];
        if (old !== cur) {
            if (cur === true) elm.setAttribute(key, "");
            else if (cur === false) elm.removeAttribute(key);
            else {
                if (key.charCodeAt(0) !== $c905269ff18f4bdc$var$xChar) elm.setAttribute(key, cur);
                else if (key.charCodeAt(3) === $c905269ff18f4bdc$var$colonChar) // Assume xml namespace
                elm.setAttributeNS($c905269ff18f4bdc$var$xmlNS, key, cur);
                else if (key.charCodeAt(5) === $c905269ff18f4bdc$var$colonChar) {
                    // Assume 'xmlns' or 'xlink' namespace
                    if (key.charCodeAt(1) === $c905269ff18f4bdc$var$mChar) elm.setAttributeNS($c905269ff18f4bdc$var$xmlnsNS, key, cur);
                    else elm.setAttributeNS($c905269ff18f4bdc$var$xlinkNS, key, cur);
                } else elm.setAttribute(key, cur);
            }
        }
    }
    // remove removed attributes
    // use `in` operator since the previous `for` iteration uses it (.i.e. add even attributes with undefined value)
    // the other option is to remove all attributes with value == undefined
    for(key in oldAttrs)if (!(key in attrs)) elm.removeAttribute(key);
}
const $c905269ff18f4bdc$export$5381d68fac100f69 = {
    create: $c905269ff18f4bdc$var$updateAttrs,
    update: $c905269ff18f4bdc$var$updateAttrs
};

});

parcelRegister("lIFbp", function(module, exports) {

$parcel$export(module.exports, "classModule", () => $fcfda722655c3634$export$63b0a5e02d9d5ac4);
function $fcfda722655c3634$var$updateClass(oldVnode, vnode) {
    let cur;
    let name;
    const elm = vnode.elm;
    let oldClass = oldVnode.data.class;
    let klass = vnode.data.class;
    if (!oldClass && !klass) return;
    if (oldClass === klass) return;
    oldClass = oldClass || {};
    klass = klass || {};
    for(name in oldClass)if (oldClass[name] && !Object.prototype.hasOwnProperty.call(klass, name)) // was `true` and now not provided
    elm.classList.remove(name);
    for(name in klass){
        cur = klass[name];
        if (cur !== oldClass[name]) elm.classList[cur ? "add" : "remove"](name);
    }
}
const $fcfda722655c3634$export$63b0a5e02d9d5ac4 = {
    create: $fcfda722655c3634$var$updateClass,
    update: $fcfda722655c3634$var$updateClass
};

});

parcelRegister("jasng", function(module, exports) {

$parcel$export(module.exports, "eventListenersModule", () => $df44f605b59168e5$export$7141f6ad17467258);
function $df44f605b59168e5$var$invokeHandler(handler, vnode, event) {
    if (typeof handler === "function") // call function handler
    handler.call(vnode, event, vnode);
    else if (typeof handler === "object") // call multiple handlers
    for(let i = 0; i < handler.length; i++)$df44f605b59168e5$var$invokeHandler(handler[i], vnode, event);
}
function $df44f605b59168e5$var$handleEvent(event, vnode) {
    const name = event.type;
    const on = vnode.data.on;
    // call event handler(s) if exists
    if (on && on[name]) $df44f605b59168e5$var$invokeHandler(on[name], vnode, event);
}
function $df44f605b59168e5$var$createListener() {
    return function handler(event) {
        $df44f605b59168e5$var$handleEvent(event, handler.vnode);
    };
}
function $df44f605b59168e5$var$updateEventListeners(oldVnode, vnode) {
    const oldOn = oldVnode.data.on;
    const oldListener = oldVnode.listener;
    const oldElm = oldVnode.elm;
    const on = vnode && vnode.data.on;
    const elm = vnode && vnode.elm;
    let name;
    // optimization for reused immutable handlers
    if (oldOn === on) return;
    // remove existing listeners which no longer used
    if (oldOn && oldListener) {
        // if element changed or deleted we remove all existing listeners unconditionally
        if (!on) for(name in oldOn)// remove listener if element was changed or existing listeners removed
        oldElm.removeEventListener(name, oldListener, false);
        else {
            for(name in oldOn)// remove listener if existing listener removed
            if (!on[name]) oldElm.removeEventListener(name, oldListener, false);
        }
    }
    // add new listeners which has not already attached
    if (on) {
        // reuse existing listener or create new
        const listener = vnode.listener = oldVnode.listener || $df44f605b59168e5$var$createListener();
        // update vnode for listener
        listener.vnode = vnode;
        // if element changed or added we add all needed listeners unconditionally
        if (!oldOn) for(name in on)// add listener if element was changed or new listeners added
        elm.addEventListener(name, listener, false);
        else {
            for(name in on)// add listener if new listener added
            if (!oldOn[name]) elm.addEventListener(name, listener, false);
        }
    }
}
const $df44f605b59168e5$export$7141f6ad17467258 = {
    create: $df44f605b59168e5$var$updateEventListeners,
    update: $df44f605b59168e5$var$updateEventListeners,
    destroy: $df44f605b59168e5$var$updateEventListeners
};

});

parcelRegister("eQjvH", function(module, exports) {

$parcel$export(module.exports, "addNS", () => $ace50e5f286f0b69$export$588773bb5c18f715);
$parcel$export(module.exports, "h", () => $ace50e5f286f0b69$export$dda1d9f60106f0e9);

var $dllzs = parcelRequire("dllzs");

var $2DIoR = parcelRequire("2DIoR");
function $ace50e5f286f0b69$export$588773bb5c18f715(data, children, sel) {
    data.ns = "http://www.w3.org/2000/svg";
    if (sel !== "foreignObject" && children !== undefined) for(let i = 0; i < children.length; ++i){
        const child = children[i];
        if (typeof child === "string") continue;
        const childData = child.data;
        if (childData !== undefined) $ace50e5f286f0b69$export$588773bb5c18f715(childData, child.children, child.sel);
    }
}
function $ace50e5f286f0b69$export$dda1d9f60106f0e9(sel, b, c) {
    let data = {};
    let children;
    let text;
    let i;
    if (c !== undefined) {
        if (b !== null) data = b;
        if ($2DIoR.array(c)) children = c;
        else if ($2DIoR.primitive(c)) text = c.toString();
        else if (c && c.sel) children = [
            c
        ];
    } else if (b !== undefined && b !== null) {
        if ($2DIoR.array(b)) children = b;
        else if ($2DIoR.primitive(b)) text = b.toString();
        else if (b && b.sel) children = [
            b
        ];
        else data = b;
    }
    if (children !== undefined) {
        for(i = 0; i < children.length; ++i)if ($2DIoR.primitive(children[i])) children[i] = (0, $dllzs.vnode)(undefined, undefined, undefined, children[i], undefined);
    }
    if (sel.startsWith("svg") && (sel.length === 3 || sel[3] === "." || sel[3] === "#")) $ace50e5f286f0b69$export$588773bb5c18f715(data, children, sel);
    return (0, $dllzs.vnode)(sel, data, children, text, undefined);
}
function $ace50e5f286f0b69$export$f00aeb236b6f05af(children) {
    let c;
    let text;
    if ($2DIoR.array(children)) c = children;
    else if ($2DIoR.primitive(c)) text = children;
    else if (c && c.sel) c = [
        children
    ];
    if (c !== undefined) {
        for(let i = 0; i < c.length; ++i)if ($2DIoR.primitive(c[i])) c[i] = (0, $dllzs.vnode)(undefined, undefined, undefined, c[i], undefined);
    }
    return (0, $dllzs.vnode)(undefined, {}, c, text, undefined);
}

});
parcelRegister("dllzs", function(module, exports) {

$parcel$export(module.exports, "vnode", () => $9b6df8085d8266b1$export$86f1c2e46be1e431);
function $9b6df8085d8266b1$export$86f1c2e46be1e431(sel, data, children, text, elm) {
    const key = data === undefined ? undefined : data.key;
    return {
        sel: sel,
        data: data,
        children: children,
        text: text,
        elm: elm,
        key: key
    };
}

});

parcelRegister("2DIoR", function(module, exports) {

$parcel$export(module.exports, "array", () => $1ec1aa3418df2d29$export$2f23118c22fb2630);
$parcel$export(module.exports, "primitive", () => $1ec1aa3418df2d29$export$f371853e3c41119);
const $1ec1aa3418df2d29$export$2f23118c22fb2630 = Array.isArray;
function $1ec1aa3418df2d29$export$f371853e3c41119(s) {
    return typeof s === "string" || typeof s === "number" || s instanceof String || s instanceof Number;
}

});


parcelRegister("cLIDp", function(module, exports) {

$parcel$export(module.exports, "init", () => $94bc7f5630ba261c$export$2cd8252107eb640b);

var $dllzs = parcelRequire("dllzs");

var $2DIoR = parcelRequire("2DIoR");

var $7jrlB = parcelRequire("7jrlB");
const $94bc7f5630ba261c$var$emptyNode = (0, $dllzs.vnode)("", {}, [], undefined, undefined);
function $94bc7f5630ba261c$var$sameVnode(vnode1, vnode2) {
    var _a, _b;
    const isSameKey = vnode1.key === vnode2.key;
    const isSameIs = ((_a = vnode1.data) === null || _a === void 0 ? void 0 : _a.is) === ((_b = vnode2.data) === null || _b === void 0 ? void 0 : _b.is);
    const isSameSel = vnode1.sel === vnode2.sel;
    const isSameTextOrFragment = !vnode1.sel && vnode1.sel === vnode2.sel ? typeof vnode1.text === typeof vnode2.text : true;
    return isSameSel && isSameKey && isSameIs && isSameTextOrFragment;
}
/**
 * @todo Remove this function when the document fragment is considered stable.
 */ function $94bc7f5630ba261c$var$documentFragmentIsNotSupported() {
    throw new Error("The document fragment is not supported on this platform.");
}
function $94bc7f5630ba261c$var$isElement(api, vnode) {
    return api.isElement(vnode);
}
function $94bc7f5630ba261c$var$isDocumentFragment(api, vnode) {
    return api.isDocumentFragment(vnode);
}
function $94bc7f5630ba261c$var$createKeyToOldIdx(children, beginIdx, endIdx) {
    var _a;
    const map = {};
    for(let i = beginIdx; i <= endIdx; ++i){
        const key = (_a = children[i]) === null || _a === void 0 ? void 0 : _a.key;
        if (key !== undefined) map[key] = i;
    }
    return map;
}
const $94bc7f5630ba261c$var$hooks = [
    "create",
    "update",
    "remove",
    "destroy",
    "pre",
    "post"
];
function $94bc7f5630ba261c$export$2cd8252107eb640b(modules, domApi, options) {
    const cbs = {
        create: [],
        update: [],
        remove: [],
        destroy: [],
        pre: [],
        post: []
    };
    const api = domApi !== undefined ? domApi : (0, $7jrlB.htmlDomApi);
    for (const hook of $94bc7f5630ba261c$var$hooks)for (const module of modules){
        const currentHook = module[hook];
        if (currentHook !== undefined) cbs[hook].push(currentHook);
    }
    function emptyNodeAt(elm) {
        const id = elm.id ? "#" + elm.id : "";
        // elm.className doesn't return a string when elm is an SVG element inside a shadowRoot.
        // https://stackoverflow.com/questions/29454340/detecting-classname-of-svganimatedstring
        const classes = elm.getAttribute("class");
        const c = classes ? "." + classes.split(" ").join(".") : "";
        return (0, $dllzs.vnode)(api.tagName(elm).toLowerCase() + id + c, {}, [], undefined, elm);
    }
    function emptyDocumentFragmentAt(frag) {
        return (0, $dllzs.vnode)(undefined, {}, [], undefined, frag);
    }
    function createRmCb(childElm, listeners) {
        return function rmCb() {
            if (--listeners === 0) {
                const parent = api.parentNode(childElm);
                if (parent !== null) api.removeChild(parent, childElm);
            }
        };
    }
    function createElm(vnode, insertedVnodeQueue) {
        var _a, _b, _c, _d, _e;
        let i;
        const data = vnode.data;
        const hook = data === null || data === void 0 ? void 0 : data.hook;
        (_a = hook === null || hook === void 0 ? void 0 : hook.init) === null || _a === void 0 || _a.call(hook, vnode);
        const children = vnode.children;
        const sel = vnode.sel;
        if (sel === "!") {
            (_b = vnode.text) !== null && _b !== void 0 ? _b : vnode.text = "";
            vnode.elm = api.createComment(vnode.text);
        } else if (sel === "") // textNode has no selector
        vnode.elm = api.createTextNode(vnode.text);
        else if (sel !== undefined) {
            // Parse selector
            const hashIdx = sel.indexOf("#");
            const dotIdx = sel.indexOf(".", hashIdx);
            const hash = hashIdx > 0 ? hashIdx : sel.length;
            const dot = dotIdx > 0 ? dotIdx : sel.length;
            const tag = hashIdx !== -1 || dotIdx !== -1 ? sel.slice(0, Math.min(hash, dot)) : sel;
            const ns = data === null || data === void 0 ? void 0 : data.ns;
            const elm = ns === undefined ? api.createElement(tag, data) : api.createElementNS(ns, tag, data);
            vnode.elm = elm;
            if (hash < dot) elm.setAttribute("id", sel.slice(hash + 1, dot));
            if (dotIdx > 0) elm.setAttribute("class", sel.slice(dot + 1).replace(/\./g, " "));
            for(i = 0; i < cbs.create.length; ++i)cbs.create[i]($94bc7f5630ba261c$var$emptyNode, vnode);
            if ($2DIoR.primitive(vnode.text) && (!$2DIoR.array(children) || children.length === 0)) // allow h1 and similar nodes to be created w/ text and empty child list
            api.appendChild(elm, api.createTextNode(vnode.text));
            if ($2DIoR.array(children)) for(i = 0; i < children.length; ++i){
                const ch = children[i];
                if (ch != null) api.appendChild(elm, createElm(ch, insertedVnodeQueue));
            }
            if (hook !== undefined) {
                (_c = hook.create) === null || _c === void 0 || _c.call(hook, $94bc7f5630ba261c$var$emptyNode, vnode);
                if (hook.insert !== undefined) insertedVnodeQueue.push(vnode);
            }
        } else if (((_d = options === null || options === void 0 ? void 0 : options.experimental) === null || _d === void 0 ? void 0 : _d.fragments) && vnode.children) {
            vnode.elm = ((_e = api.createDocumentFragment) !== null && _e !== void 0 ? _e : $94bc7f5630ba261c$var$documentFragmentIsNotSupported)();
            for(i = 0; i < cbs.create.length; ++i)cbs.create[i]($94bc7f5630ba261c$var$emptyNode, vnode);
            for(i = 0; i < vnode.children.length; ++i){
                const ch = vnode.children[i];
                if (ch != null) api.appendChild(vnode.elm, createElm(ch, insertedVnodeQueue));
            }
        } else vnode.elm = api.createTextNode(vnode.text);
        return vnode.elm;
    }
    function addVnodes(parentElm, before, vnodes, startIdx, endIdx, insertedVnodeQueue) {
        for(; startIdx <= endIdx; ++startIdx){
            const ch = vnodes[startIdx];
            if (ch != null) api.insertBefore(parentElm, createElm(ch, insertedVnodeQueue), before);
        }
    }
    function invokeDestroyHook(vnode) {
        var _a, _b;
        const data = vnode.data;
        if (data !== undefined) {
            (_b = (_a = data === null || data === void 0 ? void 0 : data.hook) === null || _a === void 0 ? void 0 : _a.destroy) === null || _b === void 0 || _b.call(_a, vnode);
            for(let i = 0; i < cbs.destroy.length; ++i)cbs.destroy[i](vnode);
            if (vnode.children !== undefined) for(let j = 0; j < vnode.children.length; ++j){
                const child = vnode.children[j];
                if (child != null && typeof child !== "string") invokeDestroyHook(child);
            }
        }
    }
    function removeVnodes(parentElm, vnodes, startIdx, endIdx) {
        var _a, _b;
        for(; startIdx <= endIdx; ++startIdx){
            let listeners;
            const ch = vnodes[startIdx];
            if (ch != null) {
                if (ch.sel !== undefined) {
                    invokeDestroyHook(ch);
                    listeners = cbs.remove.length + 1;
                    const rm = createRmCb(ch.elm, listeners);
                    for(let i = 0; i < cbs.remove.length; ++i)cbs.remove[i](ch, rm);
                    const removeHook = (_b = (_a = ch === null || ch === void 0 ? void 0 : ch.data) === null || _a === void 0 ? void 0 : _a.hook) === null || _b === void 0 ? void 0 : _b.remove;
                    if (removeHook !== undefined) removeHook(ch, rm);
                    else rm();
                } else if (ch.children) {
                    // Fragment node
                    invokeDestroyHook(ch);
                    removeVnodes(parentElm, ch.children, 0, ch.children.length - 1);
                } else // Text node
                api.removeChild(parentElm, ch.elm);
            }
        }
    }
    function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue) {
        let oldStartIdx = 0;
        let newStartIdx = 0;
        let oldEndIdx = oldCh.length - 1;
        let oldStartVnode = oldCh[0];
        let oldEndVnode = oldCh[oldEndIdx];
        let newEndIdx = newCh.length - 1;
        let newStartVnode = newCh[0];
        let newEndVnode = newCh[newEndIdx];
        let oldKeyToIdx;
        let idxInOld;
        let elmToMove;
        let before;
        while(oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx){
            if (oldStartVnode == null) oldStartVnode = oldCh[++oldStartIdx]; // Vnode might have been moved left
            else if (oldEndVnode == null) oldEndVnode = oldCh[--oldEndIdx];
            else if (newStartVnode == null) newStartVnode = newCh[++newStartIdx];
            else if (newEndVnode == null) newEndVnode = newCh[--newEndIdx];
            else if ($94bc7f5630ba261c$var$sameVnode(oldStartVnode, newStartVnode)) {
                patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
                oldStartVnode = oldCh[++oldStartIdx];
                newStartVnode = newCh[++newStartIdx];
            } else if ($94bc7f5630ba261c$var$sameVnode(oldEndVnode, newEndVnode)) {
                patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
                oldEndVnode = oldCh[--oldEndIdx];
                newEndVnode = newCh[--newEndIdx];
            } else if ($94bc7f5630ba261c$var$sameVnode(oldStartVnode, newEndVnode)) {
                // Vnode moved right
                patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
                api.insertBefore(parentElm, oldStartVnode.elm, api.nextSibling(oldEndVnode.elm));
                oldStartVnode = oldCh[++oldStartIdx];
                newEndVnode = newCh[--newEndIdx];
            } else if ($94bc7f5630ba261c$var$sameVnode(oldEndVnode, newStartVnode)) {
                // Vnode moved left
                patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
                api.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
                oldEndVnode = oldCh[--oldEndIdx];
                newStartVnode = newCh[++newStartIdx];
            } else {
                if (oldKeyToIdx === undefined) oldKeyToIdx = $94bc7f5630ba261c$var$createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
                idxInOld = oldKeyToIdx[newStartVnode.key];
                if (idxInOld === undefined) {
                    // `newStartVnode` is new, create and insert it in beginning
                    api.insertBefore(parentElm, createElm(newStartVnode, insertedVnodeQueue), oldStartVnode.elm);
                    newStartVnode = newCh[++newStartIdx];
                } else if (oldKeyToIdx[newEndVnode.key] === undefined) {
                    // `newEndVnode` is new, create and insert it in the end
                    api.insertBefore(parentElm, createElm(newEndVnode, insertedVnodeQueue), api.nextSibling(oldEndVnode.elm));
                    newEndVnode = newCh[--newEndIdx];
                } else {
                    // Neither of the new endpoints are new vnodes, so we make progress by
                    // moving `newStartVnode` into position
                    elmToMove = oldCh[idxInOld];
                    if (elmToMove.sel !== newStartVnode.sel) api.insertBefore(parentElm, createElm(newStartVnode, insertedVnodeQueue), oldStartVnode.elm);
                    else {
                        patchVnode(elmToMove, newStartVnode, insertedVnodeQueue);
                        oldCh[idxInOld] = undefined;
                        api.insertBefore(parentElm, elmToMove.elm, oldStartVnode.elm);
                    }
                    newStartVnode = newCh[++newStartIdx];
                }
            }
        }
        if (newStartIdx <= newEndIdx) {
            before = newCh[newEndIdx + 1] == null ? null : newCh[newEndIdx + 1].elm;
            addVnodes(parentElm, before, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
        }
        if (oldStartIdx <= oldEndIdx) removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
    function patchVnode(oldVnode, vnode, insertedVnodeQueue) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const hook = (_a = vnode.data) === null || _a === void 0 ? void 0 : _a.hook;
        (_b = hook === null || hook === void 0 ? void 0 : hook.prepatch) === null || _b === void 0 || _b.call(hook, oldVnode, vnode);
        const elm = vnode.elm = oldVnode.elm;
        if (oldVnode === vnode) return;
        if (vnode.data !== undefined || vnode.text !== undefined && vnode.text !== oldVnode.text) {
            (_c = vnode.data) !== null && _c !== void 0 ? _c : vnode.data = {};
            (_d = oldVnode.data) !== null && _d !== void 0 ? _d : oldVnode.data = {};
            for(let i = 0; i < cbs.update.length; ++i)cbs.update[i](oldVnode, vnode);
            (_g = (_f = (_e = vnode.data) === null || _e === void 0 ? void 0 : _e.hook) === null || _f === void 0 ? void 0 : _f.update) === null || _g === void 0 || _g.call(_f, oldVnode, vnode);
        }
        const oldCh = oldVnode.children;
        const ch = vnode.children;
        if (vnode.text === undefined) {
            if (oldCh !== undefined && ch !== undefined) {
                if (oldCh !== ch) updateChildren(elm, oldCh, ch, insertedVnodeQueue);
            } else if (ch !== undefined) {
                if (oldVnode.text !== undefined) api.setTextContent(elm, "");
                addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
            } else if (oldCh !== undefined) removeVnodes(elm, oldCh, 0, oldCh.length - 1);
            else if (oldVnode.text !== undefined) api.setTextContent(elm, "");
        } else if (oldVnode.text !== vnode.text) {
            if (oldCh !== undefined) removeVnodes(elm, oldCh, 0, oldCh.length - 1);
            api.setTextContent(elm, vnode.text);
        }
        (_h = hook === null || hook === void 0 ? void 0 : hook.postpatch) === null || _h === void 0 || _h.call(hook, oldVnode, vnode);
    }
    return function patch(oldVnode, vnode) {
        let i, elm, parent;
        const insertedVnodeQueue = [];
        for(i = 0; i < cbs.pre.length; ++i)cbs.pre[i]();
        if ($94bc7f5630ba261c$var$isElement(api, oldVnode)) oldVnode = emptyNodeAt(oldVnode);
        else if ($94bc7f5630ba261c$var$isDocumentFragment(api, oldVnode)) oldVnode = emptyDocumentFragmentAt(oldVnode);
        if ($94bc7f5630ba261c$var$sameVnode(oldVnode, vnode)) patchVnode(oldVnode, vnode, insertedVnodeQueue);
        else {
            elm = oldVnode.elm;
            parent = api.parentNode(elm);
            createElm(vnode, insertedVnodeQueue);
            if (parent !== null) {
                api.insertBefore(parent, vnode.elm, api.nextSibling(elm));
                removeVnodes(parent, [
                    oldVnode
                ], 0, 0);
            }
        }
        for(i = 0; i < insertedVnodeQueue.length; ++i)insertedVnodeQueue[i].data.hook.insert(insertedVnodeQueue[i]);
        for(i = 0; i < cbs.post.length; ++i)cbs.post[i]();
        return vnode;
    };
}

});
parcelRegister("7jrlB", function(module, exports) {

$parcel$export(module.exports, "htmlDomApi", () => $552f855d193e367d$export$b5620185d61e7315);
function $552f855d193e367d$var$createElement(tagName, options) {
    return document.createElement(tagName, options);
}
function $552f855d193e367d$var$createElementNS(namespaceURI, qualifiedName, options) {
    return document.createElementNS(namespaceURI, qualifiedName, options);
}
function $552f855d193e367d$var$createDocumentFragment() {
    return $552f855d193e367d$var$parseFragment(document.createDocumentFragment());
}
function $552f855d193e367d$var$createTextNode(text) {
    return document.createTextNode(text);
}
function $552f855d193e367d$var$createComment(text) {
    return document.createComment(text);
}
function $552f855d193e367d$var$insertBefore(parentNode, newNode, referenceNode) {
    if ($552f855d193e367d$var$isDocumentFragment(parentNode)) {
        let node = parentNode;
        while(node && $552f855d193e367d$var$isDocumentFragment(node)){
            const fragment = $552f855d193e367d$var$parseFragment(node);
            node = fragment.parent;
        }
        parentNode = node !== null && node !== void 0 ? node : parentNode;
    }
    if ($552f855d193e367d$var$isDocumentFragment(newNode)) newNode = $552f855d193e367d$var$parseFragment(newNode, parentNode);
    if (referenceNode && $552f855d193e367d$var$isDocumentFragment(referenceNode)) referenceNode = $552f855d193e367d$var$parseFragment(referenceNode).firstChildNode;
    parentNode.insertBefore(newNode, referenceNode);
}
function $552f855d193e367d$var$removeChild(node, child) {
    node.removeChild(child);
}
function $552f855d193e367d$var$appendChild(node, child) {
    if ($552f855d193e367d$var$isDocumentFragment(child)) child = $552f855d193e367d$var$parseFragment(child, node);
    node.appendChild(child);
}
function $552f855d193e367d$var$parentNode(node) {
    if ($552f855d193e367d$var$isDocumentFragment(node)) {
        while(node && $552f855d193e367d$var$isDocumentFragment(node)){
            const fragment = $552f855d193e367d$var$parseFragment(node);
            node = fragment.parent;
        }
        return node !== null && node !== void 0 ? node : null;
    }
    return node.parentNode;
}
function $552f855d193e367d$var$nextSibling(node) {
    var _a;
    if ($552f855d193e367d$var$isDocumentFragment(node)) {
        const fragment = $552f855d193e367d$var$parseFragment(node);
        const parent = $552f855d193e367d$var$parentNode(fragment);
        if (parent && fragment.lastChildNode) {
            const children = Array.from(parent.childNodes);
            const index = children.indexOf(fragment.lastChildNode);
            return (_a = children[index + 1]) !== null && _a !== void 0 ? _a : null;
        }
        return null;
    }
    return node.nextSibling;
}
function $552f855d193e367d$var$tagName(elm) {
    return elm.tagName;
}
function $552f855d193e367d$var$setTextContent(node, text) {
    node.textContent = text;
}
function $552f855d193e367d$var$getTextContent(node) {
    return node.textContent;
}
function $552f855d193e367d$var$isElement(node) {
    return node.nodeType === 1;
}
function $552f855d193e367d$var$isText(node) {
    return node.nodeType === 3;
}
function $552f855d193e367d$var$isComment(node) {
    return node.nodeType === 8;
}
function $552f855d193e367d$var$isDocumentFragment(node) {
    return node.nodeType === 11;
}
function $552f855d193e367d$var$parseFragment(fragmentNode, parentNode) {
    var _a, _b, _c;
    const fragment = fragmentNode;
    (_a = fragment.parent) !== null && _a !== void 0 ? _a : fragment.parent = parentNode !== null && parentNode !== void 0 ? parentNode : null;
    (_b = fragment.firstChildNode) !== null && _b !== void 0 ? _b : fragment.firstChildNode = fragmentNode.firstChild;
    (_c = fragment.lastChildNode) !== null && _c !== void 0 ? _c : fragment.lastChildNode = fragmentNode.lastChild;
    return fragment;
}
const $552f855d193e367d$export$b5620185d61e7315 = {
    createElement: $552f855d193e367d$var$createElement,
    createElementNS: $552f855d193e367d$var$createElementNS,
    createTextNode: $552f855d193e367d$var$createTextNode,
    createDocumentFragment: $552f855d193e367d$var$createDocumentFragment,
    createComment: $552f855d193e367d$var$createComment,
    insertBefore: $552f855d193e367d$var$insertBefore,
    removeChild: $552f855d193e367d$var$removeChild,
    appendChild: $552f855d193e367d$var$appendChild,
    parentNode: $552f855d193e367d$var$parentNode,
    nextSibling: $552f855d193e367d$var$nextSibling,
    tagName: $552f855d193e367d$var$tagName,
    setTextContent: $552f855d193e367d$var$setTextContent,
    getTextContent: $552f855d193e367d$var$getTextContent,
    isElement: $552f855d193e367d$var$isElement,
    isText: $552f855d193e367d$var$isText,
    isComment: $552f855d193e367d$var$isComment,
    isDocumentFragment: $552f855d193e367d$var$isDocumentFragment
};

});


parcelRegister("efxP4", function(module, exports) {

$parcel$export(module.exports, "propsModule", () => $a5fcb3dde66b7835$export$d0f594d8c58ce469);
function $a5fcb3dde66b7835$var$updateProps(oldVnode, vnode) {
    let key;
    let cur;
    let old;
    const elm = vnode.elm;
    let oldProps = oldVnode.data.props;
    let props = vnode.data.props;
    if (!oldProps && !props) return;
    if (oldProps === props) return;
    oldProps = oldProps || {};
    props = props || {};
    for(key in props){
        cur = props[key];
        old = oldProps[key];
        if (old !== cur && (key !== "value" || elm[key] !== cur)) elm[key] = cur;
    }
}
const $a5fcb3dde66b7835$export$d0f594d8c58ce469 = {
    create: $a5fcb3dde66b7835$var$updateProps,
    update: $a5fcb3dde66b7835$var$updateProps
};

});

parcelRegister("g8AdR", function(module, exports) {

$parcel$export(module.exports, "styleModule", () => $bbf97dbe45808d07$export$8f225d2f409cea76);
// Binding `requestAnimationFrame` like this fixes a bug in IE/Edge. See #360 and #409.
const $bbf97dbe45808d07$var$raf = typeof (window === null || window === void 0 ? void 0 : window.requestAnimationFrame) === "function" ? window.requestAnimationFrame.bind(window) : setTimeout;
const $bbf97dbe45808d07$var$nextFrame = (fn)=>{
    $bbf97dbe45808d07$var$raf(()=>{
        $bbf97dbe45808d07$var$raf(fn);
    });
};
let $bbf97dbe45808d07$var$reflowForced = false;
function $bbf97dbe45808d07$var$setNextFrame(obj, prop, val) {
    $bbf97dbe45808d07$var$nextFrame(()=>{
        obj[prop] = val;
    });
}
function $bbf97dbe45808d07$var$updateStyle(oldVnode, vnode) {
    let cur;
    let name;
    const elm = vnode.elm;
    let oldStyle = oldVnode.data.style;
    let style = vnode.data.style;
    if (!oldStyle && !style) return;
    if (oldStyle === style) return;
    oldStyle = oldStyle || {};
    style = style || {};
    const oldHasDel = "delayed" in oldStyle;
    for(name in oldStyle)if (!(name in style)) {
        if (name[0] === "-" && name[1] === "-") elm.style.removeProperty(name);
        else elm.style[name] = "";
    }
    for(name in style){
        cur = style[name];
        if (name === "delayed" && style.delayed) for(const name2 in style.delayed){
            cur = style.delayed[name2];
            if (!oldHasDel || cur !== oldStyle.delayed[name2]) $bbf97dbe45808d07$var$setNextFrame(elm.style, name2, cur);
        }
        else if (name !== "remove" && cur !== oldStyle[name]) {
            if (name[0] === "-" && name[1] === "-") elm.style.setProperty(name, cur);
            else elm.style[name] = cur;
        }
    }
}
function $bbf97dbe45808d07$var$applyDestroyStyle(vnode) {
    let style;
    let name;
    const elm = vnode.elm;
    const s = vnode.data.style;
    if (!s || !(style = s.destroy)) return;
    for(name in style)elm.style[name] = style[name];
}
function $bbf97dbe45808d07$var$applyRemoveStyle(vnode, rm) {
    const s = vnode.data.style;
    if (!s || !s.remove) {
        rm();
        return;
    }
    if (!$bbf97dbe45808d07$var$reflowForced) {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        vnode.elm.offsetLeft;
        $bbf97dbe45808d07$var$reflowForced = true;
    }
    let name;
    const elm = vnode.elm;
    let i = 0;
    const style = s.remove;
    let amount = 0;
    const applied = [];
    for(name in style){
        applied.push(name);
        elm.style[name] = style[name];
    }
    const compStyle = getComputedStyle(elm);
    const props = compStyle["transition-property"].split(", ");
    for(; i < props.length; ++i)if (applied.indexOf(props[i]) !== -1) amount++;
    elm.addEventListener("transitionend", (ev)=>{
        if (ev.target === elm) --amount;
        if (amount === 0) rm();
    });
}
function $bbf97dbe45808d07$var$forceReflow() {
    $bbf97dbe45808d07$var$reflowForced = false;
}
const $bbf97dbe45808d07$export$8f225d2f409cea76 = {
    pre: $bbf97dbe45808d07$var$forceReflow,
    create: $bbf97dbe45808d07$var$updateStyle,
    update: $bbf97dbe45808d07$var$updateStyle,
    destroy: $bbf97dbe45808d07$var$applyDestroyStyle,
    remove: $bbf97dbe45808d07$var$applyRemoveStyle
};

});

parcelRegister("f6wSa", function(module, exports) {

$parcel$export(module.exports, "scan", () => $aff0ea62bddc8b76$export$c87d910e63d22ed6);

var $iZT3c = parcelRequire("iZT3c");

var $5F2Ze = parcelRequire("5F2Ze");
function $aff0ea62bddc8b76$export$c87d910e63d22ed6(accumulator, seed) {
    return (0, $iZT3c.operate)((0, $5F2Ze.scanInternals)(accumulator, seed, arguments.length >= 2, true));
}

});
parcelRegister("iZT3c", function(module, exports) {

$parcel$export(module.exports, "operate", () => $dd48a069f37f5009$export$871731df685d7753);

var $dFWVS = parcelRequire("dFWVS");
function $dd48a069f37f5009$export$ebec8610810318c5(source) {
    return (0, $dFWVS.isFunction)(source === null || source === void 0 ? void 0 : source.lift);
}
function $dd48a069f37f5009$export$871731df685d7753(init) {
    return function(source) {
        if ($dd48a069f37f5009$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError('Unable to lift unknown Observable type');
    };
}

});
parcelRegister("dFWVS", function(module, exports) {

$parcel$export(module.exports, "isFunction", () => $9f4cd17d3bfb739b$export$f6e2535fb5126e54);
function $9f4cd17d3bfb739b$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}

});


parcelRegister("5F2Ze", function(module, exports) {

$parcel$export(module.exports, "scanInternals", () => $41f319248fadf70f$export$30fc204bc7867c02);

var $lo1Ce = parcelRequire("lo1Ce");
function $41f319248fadf70f$export$30fc204bc7867c02(accumulator, seed, hasSeed, emitOnNext, emitBeforeComplete) {
    return function(source, subscriber) {
        var hasState = hasSeed;
        var state = seed;
        var index = 0;
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            var i = index++;
            state = hasState ? accumulator(state, value, i) : (hasState = true, value);
            emitOnNext && subscriber.next(state);
        }, emitBeforeComplete && function() {
            hasState && subscriber.next(state);
            subscriber.complete();
        }));
    };
}

});
parcelRegister("lo1Ce", function(module, exports) {

$parcel$export(module.exports, "createOperatorSubscriber", () => $f91d17b1cd8d7dd0$export$b9e075132cc6937f);

var $ceFTv = parcelRequire("ceFTv");

var $dUP5u = parcelRequire("dUP5u");
function $f91d17b1cd8d7dd0$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $f91d17b1cd8d7dd0$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $f91d17b1cd8d7dd0$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $ceFTv.__extends)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $dUP5u.Subscriber));

});
parcelRegister("ceFTv", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $8e874a2fb001c377$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__awaiter", () => $8e874a2fb001c377$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $8e874a2fb001c377$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__values", () => $8e874a2fb001c377$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $8e874a2fb001c377$export$8d051b38c9118094);
$parcel$export(module.exports, "__spreadArray", () => $8e874a2fb001c377$export$1216008129fb82ed);
$parcel$export(module.exports, "__await", () => $8e874a2fb001c377$export$10c90e4f7922046c);
$parcel$export(module.exports, "__asyncGenerator", () => $8e874a2fb001c377$export$e427f37a30a4de9b);
$parcel$export(module.exports, "__asyncValues", () => $8e874a2fb001c377$export$e3b29a3d6162315f);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $8e874a2fb001c377$var$extendStatics = function(d, b) {
    $8e874a2fb001c377$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $8e874a2fb001c377$var$extendStatics(d, b);
};
function $8e874a2fb001c377$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $8e874a2fb001c377$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $8e874a2fb001c377$export$18ce0697a983be9b = function() {
    $8e874a2fb001c377$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8e874a2fb001c377$export$18ce0697a983be9b.apply(this, arguments);
};
function $8e874a2fb001c377$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $8e874a2fb001c377$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $8e874a2fb001c377$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $8e874a2fb001c377$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $8e874a2fb001c377$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $8e874a2fb001c377$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $8e874a2fb001c377$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $8e874a2fb001c377$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $8e874a2fb001c377$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $8e874a2fb001c377$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $8e874a2fb001c377$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $8e874a2fb001c377$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $8e874a2fb001c377$export$45d3717a4c69092e(o, m, p);
}
function $8e874a2fb001c377$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $8e874a2fb001c377$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $8e874a2fb001c377$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($8e874a2fb001c377$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $8e874a2fb001c377$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $8e874a2fb001c377$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $8e874a2fb001c377$export$10c90e4f7922046c(v) {
    return this instanceof $8e874a2fb001c377$export$10c90e4f7922046c ? (this.v = v, this) : new $8e874a2fb001c377$export$10c90e4f7922046c(v);
}
function $8e874a2fb001c377$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $8e874a2fb001c377$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $8e874a2fb001c377$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $8e874a2fb001c377$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $8e874a2fb001c377$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $8e874a2fb001c377$export$19a8beecd37a4c45 === "function" ? $8e874a2fb001c377$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $8e874a2fb001c377$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $8e874a2fb001c377$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $8e874a2fb001c377$var$ownKeys = function(o) {
    $8e874a2fb001c377$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $8e874a2fb001c377$var$ownKeys(o);
};
function $8e874a2fb001c377$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $8e874a2fb001c377$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $8e874a2fb001c377$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $8e874a2fb001c377$var$__setModuleDefault(result, mod);
    return result;
}
function $8e874a2fb001c377$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $8e874a2fb001c377$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $8e874a2fb001c377$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $8e874a2fb001c377$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $8e874a2fb001c377$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $8e874a2fb001c377$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $8e874a2fb001c377$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $8e874a2fb001c377$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $8e874a2fb001c377$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $8e874a2fb001c377$export$2e2bcd8739ae039 = {
    __extends: $8e874a2fb001c377$export$a8ba968b8961cb8a,
    __assign: $8e874a2fb001c377$export$18ce0697a983be9b,
    __rest: $8e874a2fb001c377$export$3c9a16f847548506,
    __decorate: $8e874a2fb001c377$export$29e00dfd3077644b,
    __param: $8e874a2fb001c377$export$d5ad3fd78186038f,
    __esDecorate: $8e874a2fb001c377$export$3a84e1ae4e97e9b0,
    __runInitializers: $8e874a2fb001c377$export$d831c04e792af3d,
    __propKey: $8e874a2fb001c377$export$6a2a36740a146cb8,
    __setFunctionName: $8e874a2fb001c377$export$d1a06452d3489bc7,
    __metadata: $8e874a2fb001c377$export$f1db080c865becb9,
    __awaiter: $8e874a2fb001c377$export$1050f835b63b671e,
    __generator: $8e874a2fb001c377$export$67ebef60e6f28a6,
    __createBinding: $8e874a2fb001c377$export$45d3717a4c69092e,
    __exportStar: $8e874a2fb001c377$export$f33643c0debef087,
    __values: $8e874a2fb001c377$export$19a8beecd37a4c45,
    __read: $8e874a2fb001c377$export$8d051b38c9118094,
    __spread: $8e874a2fb001c377$export$afc72e2116322959,
    __spreadArrays: $8e874a2fb001c377$export$6388937ca91ccae8,
    __spreadArray: $8e874a2fb001c377$export$1216008129fb82ed,
    __await: $8e874a2fb001c377$export$10c90e4f7922046c,
    __asyncGenerator: $8e874a2fb001c377$export$e427f37a30a4de9b,
    __asyncDelegator: $8e874a2fb001c377$export$bbd80228419bb833,
    __asyncValues: $8e874a2fb001c377$export$e3b29a3d6162315f,
    __makeTemplateObject: $8e874a2fb001c377$export$4fb47efe1390b86f,
    __importStar: $8e874a2fb001c377$export$c21735bcef00d192,
    __importDefault: $8e874a2fb001c377$export$da59b14a69baef04,
    __classPrivateFieldGet: $8e874a2fb001c377$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $8e874a2fb001c377$export$d40a35129aaff81f,
    __classPrivateFieldIn: $8e874a2fb001c377$export$81fdc39f203e4e04,
    __addDisposableResource: $8e874a2fb001c377$export$88ac25d8e944e405,
    __disposeResources: $8e874a2fb001c377$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $8e874a2fb001c377$export$889dfb5d17574b0b
};

});

parcelRegister("dUP5u", function(module, exports) {

$parcel$export(module.exports, "Subscriber", () => $a21822406e53a1a5$export$60959659b2c22881);
$parcel$export(module.exports, "SafeSubscriber", () => $a21822406e53a1a5$export$94eeb6a328cab6c7);

var $ceFTv = parcelRequire("ceFTv");

var $dFWVS = parcelRequire("dFWVS");

var $fgwAY = parcelRequire("fgwAY");

var $1Dr3d = parcelRequire("1Dr3d");

var $ZIGxP = parcelRequire("ZIGxP");

var $QfuEL = parcelRequire("QfuEL");

var $lMJIa = parcelRequire("lMJIa");

var $7hZdR = parcelRequire("7hZdR");

var $iQsM4 = parcelRequire("iQsM4");
var $a21822406e53a1a5$export$60959659b2c22881 = function(_super) {
    (0, $ceFTv.__extends)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $fgwAY.isSubscription)(destination)) destination.add(_this);
        } else _this.destination = $a21822406e53a1a5$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $a21822406e53a1a5$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $a21822406e53a1a5$var$handleStoppedNotification((0, $lMJIa.nextNotification)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $a21822406e53a1a5$var$handleStoppedNotification((0, $lMJIa.errorNotification)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $a21822406e53a1a5$var$handleStoppedNotification((0, $lMJIa.COMPLETE_NOTIFICATION), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $fgwAY.Subscription));
var $a21822406e53a1a5$var$_bind = Function.prototype.bind;
function $a21822406e53a1a5$var$bind(fn, thisArg) {
    return $a21822406e53a1a5$var$_bind.call(fn, thisArg);
}
var $a21822406e53a1a5$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $a21822406e53a1a5$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $a21822406e53a1a5$var$handleUnhandledError(error);
        }
        else $a21822406e53a1a5$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $a21822406e53a1a5$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $a21822406e53a1a5$export$94eeb6a328cab6c7 = function(_super) {
    (0, $ceFTv.__extends)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $dFWVS.isFunction)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $1Dr3d.config).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $a21822406e53a1a5$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $a21822406e53a1a5$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $a21822406e53a1a5$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $a21822406e53a1a5$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($a21822406e53a1a5$export$60959659b2c22881);
function $a21822406e53a1a5$var$handleUnhandledError(error) {
    if ((0, $1Dr3d.config).useDeprecatedSynchronousErrorHandling) (0, $iQsM4.captureError)(error);
    else (0, $ZIGxP.reportUnhandledError)(error);
}
function $a21822406e53a1a5$var$defaultErrorHandler(err) {
    throw err;
}
function $a21822406e53a1a5$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $1Dr3d.config).onStoppedNotification;
    onStoppedNotification && (0, $7hZdR.timeoutProvider).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $a21822406e53a1a5$export$88d395d20619a0af = {
    closed: true,
    next: (0, $QfuEL.noop),
    error: $a21822406e53a1a5$var$defaultErrorHandler,
    complete: (0, $QfuEL.noop)
};

});
parcelRegister("fgwAY", function(module, exports) {

$parcel$export(module.exports, "Subscription", () => $b1d1a261220cb194$export$f55210826850c514);
$parcel$export(module.exports, "EMPTY_SUBSCRIPTION", () => $b1d1a261220cb194$export$610f9c3ca1a38dd8);
$parcel$export(module.exports, "isSubscription", () => $b1d1a261220cb194$export$4f9221cbada3c4fc);

var $ceFTv = parcelRequire("ceFTv");

var $dFWVS = parcelRequire("dFWVS");

var $aQn3b = parcelRequire("aQn3b");

var $ebAl1 = parcelRequire("ebAl1");
var $b1d1a261220cb194$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $ceFTv.__values)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $dFWVS.isFunction)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $aQn3b.UnsubscriptionError) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $ceFTv.__values)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $b1d1a261220cb194$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $aQn3b.UnsubscriptionError)) errors = (0, $ceFTv.__spreadArray)((0, $ceFTv.__spreadArray)([], (0, $ceFTv.__read)(errors)), (0, $ceFTv.__read)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $aQn3b.UnsubscriptionError)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $b1d1a261220cb194$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $ebAl1.arrRemove)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $ebAl1.arrRemove)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $b1d1a261220cb194$export$610f9c3ca1a38dd8 = $b1d1a261220cb194$export$f55210826850c514.EMPTY;
function $b1d1a261220cb194$export$4f9221cbada3c4fc(value) {
    return value instanceof $b1d1a261220cb194$export$f55210826850c514 || value && 'closed' in value && (0, $dFWVS.isFunction)(value.remove) && (0, $dFWVS.isFunction)(value.add) && (0, $dFWVS.isFunction)(value.unsubscribe);
}
function $b1d1a261220cb194$var$execFinalizer(finalizer) {
    if ((0, $dFWVS.isFunction)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}

});
parcelRegister("aQn3b", function(module, exports) {

$parcel$export(module.exports, "UnsubscriptionError", () => $7e50a408673c5151$export$c9648b76fd580c34);

var $jaWRE = parcelRequire("jaWRE");
var $7e50a408673c5151$export$c9648b76fd580c34 = (0, $jaWRE.createErrorClass)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join('\n  ') : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});

});
parcelRegister("jaWRE", function(module, exports) {

$parcel$export(module.exports, "createErrorClass", () => $df5c9cb6183aeff9$export$128a15b65d1b6041);
function $df5c9cb6183aeff9$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}

});


parcelRegister("ebAl1", function(module, exports) {

$parcel$export(module.exports, "arrRemove", () => $a53e47be1b60c3c3$export$dae3f38077fc36c0);
function $a53e47be1b60c3c3$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}

});


parcelRegister("1Dr3d", function(module, exports) {

$parcel$export(module.exports, "config", () => $130e6ab1a4f4ab41$export$e506a1d27d1eaa20);
var $130e6ab1a4f4ab41$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};

});

parcelRegister("ZIGxP", function(module, exports) {

$parcel$export(module.exports, "reportUnhandledError", () => $0b985c2ba288a978$export$ebf645db02d3e99f);

var $1Dr3d = parcelRequire("1Dr3d");

var $7hZdR = parcelRequire("7hZdR");
function $0b985c2ba288a978$export$ebf645db02d3e99f(err) {
    (0, $7hZdR.timeoutProvider).setTimeout(function() {
        var onUnhandledError = (0, $1Dr3d.config).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}

});
parcelRegister("7hZdR", function(module, exports) {

$parcel$export(module.exports, "timeoutProvider", () => $54e99c791bb8207c$export$365aa6bd3c788e3d);

var $ceFTv = parcelRequire("ceFTv");
var $54e99c791bb8207c$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $54e99c791bb8207c$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $ceFTv.__spreadArray)([
            handler,
            timeout
        ], (0, $ceFTv.__read)(args)));
        return setTimeout.apply(void 0, (0, $ceFTv.__spreadArray)([
            handler,
            timeout
        ], (0, $ceFTv.__read)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $54e99c791bb8207c$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};

});


parcelRegister("QfuEL", function(module, exports) {

$parcel$export(module.exports, "noop", () => $09d0e01f28fdde08$export$8793edee2d425525);
function $09d0e01f28fdde08$export$8793edee2d425525() {}

});

parcelRegister("lMJIa", function(module, exports) {

$parcel$export(module.exports, "COMPLETE_NOTIFICATION", () => $fdc189fd52d09f69$export$b7f97edb34bc1f87);
$parcel$export(module.exports, "errorNotification", () => $fdc189fd52d09f69$export$dd472c3d8fe5a85a);
$parcel$export(module.exports, "nextNotification", () => $fdc189fd52d09f69$export$ff9346b0d1d30313);
var $fdc189fd52d09f69$export$b7f97edb34bc1f87 = function() {
    return $fdc189fd52d09f69$export$9c8f6e8d39c60cf3('C', undefined, undefined);
}();
function $fdc189fd52d09f69$export$dd472c3d8fe5a85a(error) {
    return $fdc189fd52d09f69$export$9c8f6e8d39c60cf3('E', undefined, error);
}
function $fdc189fd52d09f69$export$ff9346b0d1d30313(value) {
    return $fdc189fd52d09f69$export$9c8f6e8d39c60cf3('N', value, undefined);
}
function $fdc189fd52d09f69$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}

});

parcelRegister("iQsM4", function(module, exports) {

$parcel$export(module.exports, "errorContext", () => $db83674f177e2fa2$export$d974811edc77eafa);
$parcel$export(module.exports, "captureError", () => $db83674f177e2fa2$export$3e205fbb5df021e0);

var $1Dr3d = parcelRequire("1Dr3d");
var $db83674f177e2fa2$var$context = null;
function $db83674f177e2fa2$export$d974811edc77eafa(cb) {
    if ((0, $1Dr3d.config).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$db83674f177e2fa2$var$context;
        if (isRoot) $db83674f177e2fa2$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $db83674f177e2fa2$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $db83674f177e2fa2$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $db83674f177e2fa2$export$3e205fbb5df021e0(err) {
    if ((0, $1Dr3d.config).useDeprecatedSynchronousErrorHandling && $db83674f177e2fa2$var$context) {
        $db83674f177e2fa2$var$context.errorThrown = true;
        $db83674f177e2fa2$var$context.error = err;
    }
}

});





parcelRegister("94573", function(module, exports) {
module.exports = JSON.parse("[\"a\",\"abbr\",\"address\",\"area\",\"article\",\"aside\",\"audio\",\"b\",\"base\",\"bdi\",\"bdo\",\"blockquote\",\"body\",\"br\",\"button\",\"canvas\",\"caption\",\"cite\",\"code\",\"col\",\"colgroup\",\"data\",\"datalist\",\"dd\",\"del\",\"details\",\"dfn\",\"dialog\",\"div\",\"dl\",\"dt\",\"em\",\"embed\",\"fieldset\",\"figcaption\",\"figure\",\"footer\",\"form\",\"h1\",\"h2\",\"h3\",\"h4\",\"h5\",\"h6\",\"head\",\"header\",\"hgroup\",\"hr\",\"html\",\"i\",\"iframe\",\"img\",\"input\",\"ins\",\"kbd\",\"label\",\"legend\",\"li\",\"link\",\"main\",\"map\",\"mark\",\"math\",\"menu\",\"meta\",\"meter\",\"nav\",\"noscript\",\"object\",\"ol\",\"optgroup\",\"option\",\"output\",\"p\",\"picture\",\"pre\",\"progress\",\"q\",\"rp\",\"rt\",\"ruby\",\"s\",\"samp\",\"script\",\"search\",\"section\",\"select\",\"selectedcontent\",\"slot\",\"small\",\"source\",\"span\",\"strong\",\"style\",\"sub\",\"summary\",\"sup\",\"svg\",\"table\",\"tbody\",\"td\",\"template\",\"textarea\",\"tfoot\",\"th\",\"thead\",\"time\",\"title\",\"tr\",\"track\",\"u\",\"ul\",\"var\",\"video\",\"wbr\"]");

});

parcelRegister("aADWn", function(module, exports) {

$parcel$export(module.exports, "process", () => $7b5c3f842c3ee33f$export$e54fe5b0f43758f7);
/**
 * Attribute utilities for snabbdom helpers
 * @module util/attrs
 */ 
var $jjnZg = parcelRequire("jjnZg");
/**
 * Parse string values to appropriate types
 * @param {string} s - String to parse
 * @return {number|boolean|string} Parsed value
 */ const $7b5c3f842c3ee33f$export$4e21b1533c28e5b8 = (s)=>s.match(/^[0-9]+$/) ? parseInt(s, 10) : s.match(/^[0-9.]+$/) ? parseFloat(s) : s === 'true' ? true : s === 'false' ? false : s;
/**
 * Process hyperscript arguments with attribute selector support
 * @param {Array} args - Arguments to process
 * @return {Array} Processed arguments
 * @example
 * process(['[name="john"]']) // => [{attrs: {name: 'john'}}]
 */ const $7b5c3f842c3ee33f$export$e54fe5b0f43758f7 = (args)=>{
    let newArgs = args.slice();
    let selector = newArgs[0] && typeof newArgs[0] === 'string' && newArgs[0] || '';
    if (selector !== '') newArgs = newArgs.slice(1);
    const attrRegExp = /\[[a-z\-0-9]+=("[^"]+"|'[^']+'|[0-9.]+|true|false|[^\]^=^"^']+)\]/ig;
    let attrs = selector && selector.match(attrRegExp);
    selector = selector.replace(attrRegExp, '');
    attrs = attrs && attrs.map && attrs.map((c)=>c.replace(/[[\]("|')]/g, '').split('=')).reduce((o, attr)=>(0, $jjnZg.obj).patch(o, attr[0], $7b5c3f842c3ee33f$export$4e21b1533c28e5b8(attr[1])), {}) || {};
    if (attrs && Object.keys(attrs).length > 0) {
        if (!newArgs[0] || newArgs[0] && typeof newArgs[0] === 'object' && !(newArgs[0] instanceof Array)) {
            attrs = Object.assign({}, newArgs[0] && newArgs[0].attrs || {}, attrs);
            newArgs[0] = Object.assign({}, newArgs[0] || {}, {
                attrs: attrs
            });
        } else newArgs = [
            {
                attrs: attrs
            }
        ].concat(newArgs);
    }
    if (selector !== '') newArgs = [
        selector
    ].concat(newArgs);
    return newArgs;
};

});
parcelRegister("jjnZg", function(module, exports) {
/**
 * @module iblokz-data
 * @description Immutable data manipulation utilities for JavaScript
 * @version 1.5.0
 */ /**
 * Object utilities for immutable operations
 * @type {Object}
 */ 
var $f30cz = parcelRequire("f30cz");

var $llUvA = parcelRequire("llUvA");

var $054Xj = parcelRequire("054Xj");

var $cMwYg = parcelRequire("cMwYg");
module.exports = {
    obj: $f30cz,
    arr: $llUvA,
    str: $054Xj,
    fn: $cMwYg
};

});
parcelRegister("f30cz", function(module, exports) {
'use strict';
/**
 * Creates an object with a single key-value pair.
 * @param {string} k - The key
 * @param {*} v - The value
 * @returns {Object} An object with the single key-value pair
 * @example
 * keyValue('name', 'John') // => { name: 'John' }
 */ const $02d3bb03c028877b$var$keyValue = (k, v)=>({
        [k]: v
    });
/**
 * Checks if a value is a plain object literal (not an array, null, or other object type).
 * @param {*} o - The value to check
 * @returns {boolean} True if the value is a plain object literal
 * @example
 * isLiteral({}) // => true
 * isLiteral([]) // => false
 * isLiteral(null) // => false
 */ const $02d3bb03c028877b$var$isLiteral = (o)=>typeof o === 'object' && o !== null && o.constructor === Object;
/**
 * Creates a shallow clone of an object, preserving its prototype.
 * @param {Object} o - The object to clone
 * @returns {Object} A shallow clone of the object
 * @example
 * const obj = { a: 1, b: 2 };
 * const cloned = clone(obj);
 * cloned.a = 3;
 * console.log(obj.a) // => 1 (original unchanged)
 */ const $02d3bb03c028877b$var$clone = (o)=>Object.assign(Object.create(Object.getPrototypeOf(o) || {}), o);
/**
 * Gets a nested value from an object using a path.
 * @param {Object} o - The source object
 * @param {string|Array<string>} p - The path (string key or array of keys for nested access)
 * @returns {*} The value at the path, or undefined if not found
 * @example
 * sub({ a: { b: { c: 1 } } }, ['a', 'b', 'c']) // => 1
 * sub({ a: 1 }, 'a') // => 1
 * sub({ a: 1 }, 'b') // => undefined
 */ const $02d3bb03c028877b$var$sub = (o, p)=>o === undefined || o === null ? undefined : p instanceof Array ? p.length > 1 ? $02d3bb03c028877b$var$sub(o[p[0]], p.slice(1)) : o[p[0]] : o[p];
/**
 * Immutably updates a value in an object at a given path.
 * For nested paths, creates intermediate objects as needed.
 * If the value at the path is a literal object and v is also a literal object, they are merged.
 * @param {Object} o - The source object
 * @param {string|Array<string>} k - The path (string key or array of keys for nested updates)
 * @param {*} v - The value to set
 * @returns {Object} A new object with the value updated at the path
 * @example
 * patch({ a: 1 }, 'b', 2) // => { a: 1, b: 2 }
 * patch({ a: { b: 1 } }, ['a', 'c'], 2) // => { a: { b: 1, c: 2 } }
 * patch({ a: { b: 1 } }, 'a', { c: 2 }) // => { a: { b: 1, c: 2 } } (merged)
 */ const $02d3bb03c028877b$var$patch = (o, k, v)=>Object.assign($02d3bb03c028877b$var$clone(o), k instanceof Array ? $02d3bb03c028877b$var$keyValue(k[0], k.length > 1 ? $02d3bb03c028877b$var$patch(o[k[0]] || {}, k.slice(1), v) : $02d3bb03c028877b$var$isLiteral(o[k[0]]) && Object.assign($02d3bb03c028877b$var$clone(o[k[0]]), v) || v) : $02d3bb03c028877b$var$keyValue(k, $02d3bb03c028877b$var$isLiteral(o[k]) && Object.assign($02d3bb03c028877b$var$clone(o[k]), v) || v));
/**
 * Reduces an object to a single value by iterating over its keys.
 * Similar to Array.reduce, but for objects.
 * @param {Object} o - The object to reduce
 * @param {Function} reduceFn - The reducer function (accumulator, key, value, index, originalObject) => newAccumulator
 * @param {*} [initial] - The initial accumulator value (defaults to first property value)
 * @returns {*} The final accumulated value
 * @example
 * reduce({ a: 1, b: 2, c: 3 }, (sum, key, val) => sum + val, 0) // => 6
 */ const $02d3bb03c028877b$var$reduce = (o, reduceFn, initial)=>Object.keys(o).reduce((accumulator, key, index)=>reduceFn(accumulator, key, o[key], index, o), typeof initial === 'undefined' ? o[Object.keys(o)[0]] // to confirm with the array reduce spec in this case the firts property is used
     : initial);
/**
 * Immutably maps over an object's values.
 * @param {Object} o - The source object
 * @param {Function} mapFn - The mapping function (key, value, index, originalObject) => newValue
 * @returns {Object} A new object with mapped values
 * @example
 * map({ a: 1, b: 2 }, (k, v) => v * 2) // => { a: 2, b: 4 }
 */ const $02d3bb03c028877b$var$map = (o, mapFn)=>$02d3bb03c028877b$var$reduce(o, (o2, key, value, index)=>$02d3bb03c028877b$var$patch(o2, key, mapFn(key, value, index, o)), {});
/**
 * Immutably filters an object's properties based on a predicate.
 * @param {Object} o - The source object
 * @param {Function} filterFn - The filter predicate (key, value, index, originalObject) => boolean
 * @returns {Object} A new object with only properties that pass the predicate
 * @example
 * filter({ a: 1, b: 2, c: 3 }, (k, v) => v > 1) // => { b: 2, c: 3 }
 */ const $02d3bb03c028877b$var$filter = (o, filterFn)=>$02d3bb03c028877b$var$reduce(o, (o2, key, value, index)=>filterFn(key, value, index, o) ? $02d3bb03c028877b$var$patch(o2, key, value) : o2, {});
/**
 * Recursively traverses an object tree and applies a function to leaf values.
 * Non-literal values (primitives, arrays, etc.) are transformed by the function.
 * @param {Object} tree - The object tree to traverse
 * @param {Function} fn - The function to apply to leaf values (key, value, index, parent) => newValue
 * @returns {Object} A new object tree with transformed leaf values
 * @example
 * traverse({ a: { b: 1 }, c: 2 }, (k, v) => v * 2) // => { a: { b: 2 }, c: 4 }
 */ const $02d3bb03c028877b$var$traverse = (tree, fn)=>Object.keys(tree).reduce((o, key, index)=>$02d3bb03c028877b$var$patch(o, key, $02d3bb03c028877b$var$isLiteral(tree[key]) ? $02d3bb03c028877b$var$traverse(tree[key], fn) : fn(key, tree[key], index, tree)), {});
/**
 * Chains multiple method calls on an object.
 * @param {Object} o - The object to call methods on
 * @param {Array<Array>} chain - Array of [methodName, ...args] tuples
 * @returns {*} The result of the final method call
 * @example
 * chainCall([1, 2, 3], [['map', x => x * 2], ['filter', x => x > 2]]) // => [4, 6]
 */ const $02d3bb03c028877b$var$chainCall = (o, chain)=>chain.reduce((o, [prop, ...args])=>o[prop](...args), o);
/**
 * Pattern matching utility that returns a value based on matching a value to cases.
 * Supports nested array paths for partial matching and a 'default' case.
 * @param {*} value - The value to match (can be a string, array path, etc.)
 * @param {Object} cases - Object with cases to match against (supports 'default' key)
 * @returns {*} The matched case value, or false if no match
 * @example
 * _switch('a', { a: 1, b: 2, default: 0 }) // => 1
 * _switch('c', { a: 1, b: 2, default: 0 }) // => 0
 * _switch(['a', 'b'], { a: { b: 1 } }) // => 1
 */ const $02d3bb03c028877b$var$_switch = (value, cases)=>$02d3bb03c028877b$var$sub(cases, value) && $02d3bb03c028877b$var$sub(cases, value)['default'] || $02d3bb03c028877b$var$sub(cases, value) || value instanceof Array && value.length > 1 && $02d3bb03c028877b$var$_switch(value.slice(0, value.length - 1), cases) || cases['default'] || false;
module.exports = {
    keyValue: $02d3bb03c028877b$var$keyValue,
    isLiteral: $02d3bb03c028877b$var$isLiteral,
    clone: $02d3bb03c028877b$var$clone,
    sub: $02d3bb03c028877b$var$sub,
    patch: $02d3bb03c028877b$var$patch,
    reduce: $02d3bb03c028877b$var$reduce,
    map: $02d3bb03c028877b$var$map,
    filter: $02d3bb03c028877b$var$filter,
    traverse: $02d3bb03c028877b$var$traverse,
    chainCall: $02d3bb03c028877b$var$chainCall,
    switch: $02d3bb03c028877b$var$_switch
};

});

parcelRegister("llUvA", function(module, exports) {
'use strict';
/**
 * Immutably adds an item to an array (returns a new array).
 * @param {Array} arr - The source array
 * @param {*} item - The item to add
 * @returns {Array} A new array with the item added at the end
 * @example
 * add([1, 2, 3], 4) // => [1, 2, 3, 4]
 */ const $f8b7648db1f1c5a5$var$add = (arr, item)=>[].concat(arr, [
        item
    ]);
/**
 * Immutably removes the first occurrence of an item from an array.
 * If the item is not found, returns the original array.
 * @param {Array} arr - The source array
 * @param {*} item - The item to remove
 * @returns {Array} A new array with the item removed, or the original array if not found
 * @example
 * remove([1, 2, 3, 2], 2) // => [1, 3, 2]
 * remove([1, 2, 3], 4) // => [1, 2, 3]
 */ const $f8b7648db1f1c5a5$var$remove = (arr, item)=>arr.indexOf(item) > -1 ? [].concat(arr.slice(0, arr.indexOf(item)), arr.slice(arr.indexOf(item) + 1)) : arr;
/**
 * Immutably toggles an item in an array (adds if not present, removes if present).
 * @param {Array} arr - The source array
 * @param {*} item - The item to toggle
 * @returns {Array} A new array with the item toggled
 * @example
 * toggle([1, 2, 3], 2) // => [1, 3]
 * toggle([1, 2, 3], 4) // => [1, 2, 3, 4]
 */ const $f8b7648db1f1c5a5$var$toggle = (arr, item)=>arr.indexOf(item) > -1 ? $f8b7648db1f1c5a5$var$remove(arr, item) : $f8b7648db1f1c5a5$var$add(arr, item);
/**
 * Checks if an array or comma-separated string contains an element.
 * @param {Array|string} a - The array or comma-separated string to check
 * @param {*} el - The element to look for
 * @returns {boolean} True if the element is found, false otherwise
 * @example
 * contains([1, 2, 3], 2) // => true
 * contains('a,b,c', 'b') // => true
 * contains([1, 2, 3], 4) // => false
 */ const $f8b7648db1f1c5a5$var$contains = (a, el)=>[].concat(typeof a === 'string' && a.split(',') || a instanceof Array && a || []).indexOf(el) > -1;
module.exports = {
    add: $f8b7648db1f1c5a5$var$add,
    remove: $f8b7648db1f1c5a5$var$remove,
    toggle: $f8b7648db1f1c5a5$var$toggle,
    contains: $f8b7648db1f1c5a5$var$contains
};

});

parcelRegister("054Xj", function(module, exports) {
'use strict';
/**
 * Capitalizes the first character of a string.
 * @param {string} chunk - The string to capitalize
 * @returns {string} The capitalized string
 * @example
 * capitalize('hello') // => 'Hello'
 */ const $00f44fd4f3d3ff8c$var$capitalize = (chunk)=>chunk.charAt(0).toUpperCase() + chunk.slice(1);
/**
 * Converts a string to camelCase from a delimited format.
 * @param {string} str - The string to convert
 * @param {string} [glue='_'] - The delimiter to split on
 * @returns {string} The camelCase string
 * @example
 * toCamelCase('hello_world') // => 'helloWorld'
 * toCamelCase('hello-world', '-') // => 'helloWorld'
 */ const $00f44fd4f3d3ff8c$var$toCamelCase = (str, glue = '_')=>str.split(glue).map((chunk, i)=>i === 0 ? chunk : $00f44fd4f3d3ff8c$var$capitalize(chunk)).join('');
/**
 * Converts a camelCase string to a delimited format.
 * @param {string} str - The camelCase string to convert
 * @param {string} [glue='_'] - The delimiter to use
 * @returns {string} The delimited string in lowercase
 * @example
 * fromCamelCase('helloWorld') // => 'hello_world'
 * fromCamelCase('helloWorld', '-') // => 'hello-world'
 */ const $00f44fd4f3d3ff8c$var$fromCamelCase = (str, glue = '_')=>str.replace(/([A-Z])/g, ' $1').split(' ').map((chunk)=>chunk.toLowerCase()).join(glue);
/**
 * Converts a singular word to its plural form (basic English rules).
 * @param {string} str - The singular word
 * @returns {string} The plural form
 * @example
 * singularToPlural('category') // => 'categories'
 * singularToPlural('user') // => 'users'
 */ const $00f44fd4f3d3ff8c$var$singularToPlural = (str)=>str.replace(/y$/, 'ie').concat('s');
/**
 * Converts a plural word to its singular form (basic English rules).
 * @param {string} str - The plural word
 * @returns {string} The singular form
 * @example
 * pluralToSingular('categories') // => 'category'
 * pluralToSingular('users') // => 'user'
 */ const $00f44fd4f3d3ff8c$var$pluralToSingular = (str)=>str.replace(/ies$/, 'y').replace(/s$/, '');
/**
 * Converts a string to a document ID format (typically used for database foreign keys).
 * @param {string} str - The string to convert
 * @param {string} [glue='_'] - The delimiter in the input string
 * @param {string} [suffix='Id'] - The suffix to append
 * @param {string} [prefix=''] - The prefix to prepend
 * @returns {string} The document ID string
 * @example
 * toDocumentId('user_roles') // => 'userRoleId'
 * toDocumentId('categories', '_', 'ID', 'ref') // => 'refCategoryID'
 */ const $00f44fd4f3d3ff8c$var$toDocumentId = (str, glue = '_', suffix = 'Id', prefix = '')=>prefix.concat($00f44fd4f3d3ff8c$var$pluralToSingular($00f44fd4f3d3ff8c$var$toCamelCase(str, glue)), suffix);
module.exports = {
    capitalize: $00f44fd4f3d3ff8c$var$capitalize,
    toCamelCase: $00f44fd4f3d3ff8c$var$toCamelCase,
    fromCamelCase: $00f44fd4f3d3ff8c$var$fromCamelCase,
    singularToPlural: $00f44fd4f3d3ff8c$var$singularToPlural,
    pluralToSingular: $00f44fd4f3d3ff8c$var$pluralToSingular,
    toDocumentId: $00f44fd4f3d3ff8c$var$toDocumentId
};

});

parcelRegister("cMwYg", function(module, exports) {
'use strict';

var $f30cz = parcelRequire("f30cz");
/**
 * Creates a left-to-right function composition pipeline.
 * The first function can accept multiple arguments; the remaining functions must be unary.
 * @param {Function} a - The first function in the pipeline (can accept multiple arguments)
 * @param {...Function} fns - The remaining functions to pipe through (each takes one argument)
 * @returns {Function} A function that passes the result through each function from left to right
 * @example
 * const addOne = x => x + 1;
 * const double = x => x * 2;
 * const addOneThenDouble = pipe(addOne, double);
 * addOneThenDouble(3) // => 8 (3 + 1 = 4, 4 * 2 = 8)
 */ const $94e38b133e22c353$var$pipe = (a, ...fns)=>(...args)=>fns.reduce((res, fn)=>fn(res), a(...args));
/**
 * Creates a right-to-left function composition.
 * The rightmost function can accept multiple arguments; the remaining functions must be unary.
 * @param {...Function} fns - Functions to compose (executed right to left)
 * @returns {Function} A function that passes the result through each function from right to left
 * @example
 * const addOne = x => x + 1;
 * const double = x => x * 2;
 * const doubleThenAddOne = compose(addOne, double);
 * doubleThenAddOne(3) // => 7 (3 * 2 = 6, 6 + 1 = 7)
 */ const $94e38b133e22c353$var$compose = (...fns)=>$94e38b133e22c353$var$pipe(fns.slice(-1).pop(), ...fns.reverse().slice(1));
// switch for backwards compatibility
module.exports = {
    compose: $94e38b133e22c353$var$compose,
    pipe: $94e38b133e22c353$var$pipe,
    switch: $f30cz.switch
};

});




parcelRegister("5Uq5a", function(module, exports) {
'use strict';

var $2Z6Kw = parcelRequire("2Z6Kw");
var $44d66a1ecfc31f00$require$h1 = $2Z6Kw.h1;
var $44d66a1ecfc31f00$require$a = $2Z6Kw.a;
var $44d66a1ecfc31f00$require$div = $2Z6Kw.div;
var $44d66a1ecfc31f00$require$header = $2Z6Kw.header;
var $44d66a1ecfc31f00$require$p = $2Z6Kw.p;
var $44d66a1ecfc31f00$require$section = $2Z6Kw.section;
var $44d66a1ecfc31f00$require$button = $2Z6Kw.button;
var $44d66a1ecfc31f00$require$span = $2Z6Kw.span;
var $44d66a1ecfc31f00$require$ul = $2Z6Kw.ul;
var $44d66a1ecfc31f00$require$li = $2Z6Kw.li;
module.exports = ({ state: state, actions: actions, i18n: i18n })=>$44d66a1ecfc31f00$require$ul('.breadcrumb', [].concat(state.router.path.map((page, index, arr)=>$44d66a1ecfc31f00$require$li({
            style: {
                'font-size': `${(index === arr.length - 1 ? 1.2 : 1) * (page.length > 8 ? 0.8 : 1.2)}em`
            }
        }, $44d66a1ecfc31f00$require$a(`[href="#/${arr.slice(0, index + 1).join('/')}"]`, i18n.breadcrumb && i18n.breadcrumb[page] || page)))));

});

parcelRegister("gol9c", function(module, exports) {
'use strict';

var $2Z6Kw = parcelRequire("2Z6Kw");
var $beef4aadd51781c1$require$h1 = $2Z6Kw.h1;
var $beef4aadd51781c1$require$a = $2Z6Kw.a;
var $beef4aadd51781c1$require$div = $2Z6Kw.div;
var $beef4aadd51781c1$require$header = $2Z6Kw.header;
var $beef4aadd51781c1$require$p = $2Z6Kw.p;
var $beef4aadd51781c1$require$section = $2Z6Kw.section;
var $beef4aadd51781c1$require$button = $2Z6Kw.button;
var $beef4aadd51781c1$require$span = $2Z6Kw.span;
var $beef4aadd51781c1$require$ul = $2Z6Kw.ul;
var $beef4aadd51781c1$require$li = $2Z6Kw.li;

var $6hyCw = parcelRequire("6hyCw");

var $jgFPa = parcelRequire("jgFPa");
module.exports = ({ state: state, actions: actions, i18n: i18n })=>$beef4aadd51781c1$require$div('.admin-resources', [].concat(!state.router.pageId ? $6hyCw({
        state: state,
        actions: actions,
        i18n: i18n
    }) : $jgFPa({
        state: state,
        actions: actions,
        i18n: i18n
    })));

});
parcelRegister("6hyCw", function(module, exports) {
'use strict';

var $2Z6Kw = parcelRequire("2Z6Kw");
var $492f2f7b6290e44f$require$h1 = $2Z6Kw.h1;
var $492f2f7b6290e44f$require$a = $2Z6Kw.a;
var $492f2f7b6290e44f$require$div = $2Z6Kw.div;
var $492f2f7b6290e44f$require$header = $2Z6Kw.header;
var $492f2f7b6290e44f$require$p = $2Z6Kw.p;
var $492f2f7b6290e44f$require$i = $2Z6Kw.i;
var $492f2f7b6290e44f$require$img = $2Z6Kw.img;
var $492f2f7b6290e44f$require$section = $2Z6Kw.section;
var $492f2f7b6290e44f$require$button = $2Z6Kw.button;
var $492f2f7b6290e44f$require$span = $2Z6Kw.span;
var $492f2f7b6290e44f$require$ul = $2Z6Kw.ul;
var $492f2f7b6290e44f$require$li = $2Z6Kw.li;


// components
const $492f2f7b6290e44f$var$grid = (parcelRequire("ejiHk")).default ?? (parcelRequire("ejiHk"));

var $ehn3l = parcelRequire("ehn3l");
var $492f2f7b6290e44f$require$fieldLabel = $ehn3l.fieldLabel;

var $jjnZg = parcelRequire("jjnZg");
var $492f2f7b6290e44f$require$obj = $jjnZg.obj;

var $3QJuk = parcelRequire("3QJuk");
const { resolveLocalized: $492f2f7b6290e44f$var$resolveLocalized, DEFAULT_LOCALE: $492f2f7b6290e44f$var$DEFAULT_LOCALE } = $3QJuk.default || $3QJuk;
const $492f2f7b6290e44f$var$orderWeight = [
    '_id',
    'name',
    'title',
    'function',
    'type',
    'values',
    'default',
    'author',
    'start',
    'end'
];
const $492f2f7b6290e44f$var$skipFields = [
    'description',
    'info'
];
const $492f2f7b6290e44f$var$schemaToFields = (schema, i18n)=>[
        '_id'
    ].concat(Object.keys(schema || {})).sort((a, b)=>$492f2f7b6290e44f$var$orderWeight[b] - $492f2f7b6290e44f$var$orderWeight[a]).map((field)=>$492f2f7b6290e44f$require$obj.switch(field, {
            default: ()=>({
                    name: field,
                    title: $492f2f7b6290e44f$require$fieldLabel(i18n, field)
                }),
            _id: ()=>({
                    name: '_id',
                    title: $492f2f7b6290e44f$require$fieldLabel(i18n, '_id')
                })
        })());
module.exports = ({ state: state, actions: actions, i18n: i18n })=>{
    const collection = state.router.path[1];
    const view = state.rest.views && state.rest.views[collection];
    const colMeta = state.rest.collections && state.rest.collections[collection];
    const schema = colMeta && colMeta.schema;
    const i18nFields = colMeta && colMeta.i18n || [];
    const lang = state.lang || $492f2f7b6290e44f$var$DEFAULT_LOCALE;
    const withSchema = (field)=>{
        const name = field.name || field;
        const fieldSchema = schema && schema[name];
        const type = fieldSchema && (typeof fieldSchema === 'string' ? fieldSchema : fieldSchema.type);
        const titled = typeof field === 'string' ? {
            name: field,
            title: $492f2f7b6290e44f$require$fieldLabel(i18n, field)
        } : Object.assign({}, field, {
            title: $492f2f7b6290e44f$require$fieldLabel(i18n, name)
        });
        return Object.assign({}, titled, {
            schema: titled.schema || (type ? {
                type: type
            } : {}),
            i18n: i18nFields.indexOf(name) > -1
        });
    };
    const list = (state[collection].list || []).map((doc)=>{
        const out = Object.assign({}, doc);
        i18nFields.forEach((key)=>{
            if (out[key] !== undefined) out[key] = $492f2f7b6290e44f$var$resolveLocalized(out[key], lang);
        });
        return out;
    });
    return [
        $492f2f7b6290e44f$require$button('.btn', {
            on: {
                click: ()=>actions.router.go(`admin.${collection}.new`)
            }
        }, [
            $492f2f7b6290e44f$require$i('.fa.fa-file-o'),
            ' ',
            i18n.common.actions.create
        ]),
        $492f2f7b6290e44f$var$grid({
            i18n: i18n,
            fields: (view ? view.list.columns : $492f2f7b6290e44f$var$schemaToFields(schema, i18n)).map(withSchema),
            list: list,
            actions: [
                {
                    sel: '.grid-action-button',
                    title: $492f2f7b6290e44f$require$img(`[src='/assets/icons/edit.svg']`),
                    cb: ({ doc: doc, ev: ev })=>actions.router.go(`admin.${collection}.${doc._id}`)
                },
                {
                    sel: '.grid-action-button',
                    title: $492f2f7b6290e44f$require$img(`[src='/assets/icons/delete.svg']`),
                    cb: ({ doc: doc, ev: ev })=>actions[collection].delete(doc._id, state.auth.token)
                }
            ]
        })
    ];
};

});
parcelRegister("ejiHk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a6b1580976d07d7d$export$2e2bcd8739ae039);

var $2Z6Kw = parcelRequire("2Z6Kw");

var $jjnZg = parcelRequire("jjnZg");

var $1zDll = parcelRequire("1zDll");

var $4rZD9 = parcelRequire("4rZD9");

var $ehn3l = parcelRequire("ehn3l");
'use strict';
(0, (/*@__PURE__*/$parcel$interopDefault($1zDll))).extend((0, (/*@__PURE__*/$parcel$interopDefault($4rZD9))));
const $a6b1580976d07d7d$var$getName = (field)=>field.name || field.title || field;
var $a6b1580976d07d7d$export$2e2bcd8739ae039 = ({ fields: fields = [], list: list = [], actions: actions = [], mods: mods = {}, i18n: i18n = {} })=>(0, $2Z6Kw.table)('.grid', [
        (0, $2Z6Kw.thead)((0, $2Z6Kw.tr)([].concat(fields.map((field)=>{
            const name = field.name || field;
            return (0, $2Z6Kw.th)(field.title || (0, $ehn3l.fieldLabel)(i18n, name) || field);
        }), (0, $2Z6Kw.th)(i18n?.common?.actions?.actions ?? 'Actions')))),
        (0, $2Z6Kw.tbody)(list.map((doc)=>(0, $2Z6Kw.tr)([].concat(fields.map((field)=>({
                    ...field,
                    value: doc[field.name || field] || ''
                })).map((field)=>({
                    ...field,
                    value: field.value instanceof Array ? field.value.map($a6b1580976d07d7d$var$getName).join(', ') : $a6b1580976d07d7d$var$getName(field.value)
                })).map(({ name: name, value: value, schema: schema = {} })=>mods[name] && mods[name] instanceof Function ? (0, $2Z6Kw.td)(mods[name](value)) : (0, $jjnZg.obj).switch(schema.type, {
                    Date: ()=>(0, $2Z6Kw.td)([
                            value && (0, (/*@__PURE__*/$parcel$interopDefault($1zDll)))(value).isValid() ? (0, (/*@__PURE__*/$parcel$interopDefault($1zDll)))(value).format('ll HH:mm') : value || (i18n?.common?.actions?.na ?? 'n/a')
                        ]),
                    Boolean: ()=>(0, $2Z6Kw.td)({
                            attrs: {
                                align: 'center'
                            }
                        }, (0, $2Z6Kw.i)('.fa', {
                            class: {
                                'fa-check-square-o': value,
                                'fa-square-o': !value
                            }
                        })),
                    default: ()=>(0, $2Z6Kw.td)([
                            value
                        ])
                })()), (0, $2Z6Kw.td)('[align="center"]', actions.reduce((arr, act)=>[].concat(arr, act.href ? (0, $2Z6Kw.a)(`${act.href}${act.sel || ''}`, {
                    style: {}
                }, act.title || '') : (0, $2Z6Kw.button)(`${act.sel || '.plchldr'}`, {
                    style: {},
                    on: {
                        click: (ev)=>act.cb({
                                ev: ev,
                                doc: doc
                            })
                    }
                }, act.title || '')), []))))))
    ]);

});
parcelRegister("4rZD9", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    return function(t, o, n) {
        var r = o.prototype, i = r.format;
        n.en.formats = e, r.format = function(t) {
            void 0 === t && (t = "YYYY-MM-DDTHH:mm:ssZ");
            var o = this.$locale().formats, n = function(t, o) {
                return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
                    var i = r && r.toUpperCase();
                    return n || o[r] || e[r] || o[i].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, o) {
                        return t || o.slice(1);
                    });
                });
            }(t, void 0 === o ? {} : o);
            return i.call(this, n);
        };
    };
});

});

parcelRegister("ehn3l", function(module, exports) {

$parcel$export(module.exports, "fieldLabel", () => $a6548909356df423$export$48db87e3f4768880);
$parcel$export(module.exports, "enumLabel", () => $a6548909356df423$export$2a850aae3686057);

var $jjnZg = parcelRequire("jjnZg");
const $a6548909356df423$export$5baf63ee9fe718f5 = (field)=>(0, $jjnZg.str).fromCamelCase(field, '-').split('-').map((word)=>(0, $jjnZg.str).capitalize(word)).join(' ');
const $a6548909356df423$export$48db87e3f4768880 = (i18n, name)=>i18n && i18n.fields && i18n.fields[name] || $a6548909356df423$export$5baf63ee9fe718f5(name);
const $a6548909356df423$export$2a850aae3686057 = (i18n, group, value)=>i18n && i18n.enums && i18n.enums[group] && i18n.enums[group][value] || value;
var $a6548909356df423$export$2e2bcd8739ae039 = {
    fieldToTitle: $a6548909356df423$export$5baf63ee9fe718f5,
    fieldLabel: $a6548909356df423$export$48db87e3f4768880,
    enumLabel: $a6548909356df423$export$2a850aae3686057
};

});


parcelRegister("3QJuk", function(module, exports) {

$parcel$export(module.exports, "LOCALES", () => $2cd9836c61fea821$export$e49c1078bc46f17);
$parcel$export(module.exports, "DEFAULT_LOCALE", () => $2cd9836c61fea821$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "resolveLocalized", () => $2cd9836c61fea821$export$120b21fa6f0ce60f);
$parcel$export(module.exports, "normalizeLocalized", () => $2cd9836c61fea821$export$bc816e7779fb41a2);
$parcel$export(module.exports, "writeLocalized", () => $2cd9836c61fea821$export$1b8d477a417eaf12);
$parcel$export(module.exports, "normalizeI18nPair", () => $2cd9836c61fea821$export$188131e14c2a0aed);
$parcel$export(module.exports, "formatLocalizedBilingual", () => $2cd9836c61fea821$export$53cc8198d745b4fd);
$parcel$export(module.exports, "normalizeDocI18nFields", () => $2cd9836c61fea821$export$827bf31a3402a1c9);
'use strict';
const $2cd9836c61fea821$export$e49c1078bc46f17 = [
    'bg',
    'en'
];
const $2cd9836c61fea821$export$1af4c7e47ad72f44 = 'bg';
/** If a localized map was accidentally JSON.stringified, parse it back. */ const $2cd9836c61fea821$var$coerceLocalizedValue = (value)=>{
    if (typeof value !== 'string') return value;
    const trimmed = value.trim();
    if (!trimmed || trimmed[0] !== '{') return value;
    try {
        const parsed = JSON.parse(trimmed);
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
            const keys = Object.keys(parsed);
            if (keys.some((k)=>$2cd9836c61fea821$export$e49c1078bc46f17.indexOf(k) > -1)) return parsed;
        }
    } catch (err) {
    /* keep original string */ }
    return value;
};
function $2cd9836c61fea821$export$120b21fa6f0ce60f(value, locale, fallbacks = $2cd9836c61fea821$export$e49c1078bc46f17) {
    const loc = (locale || $2cd9836c61fea821$export$1af4c7e47ad72f44).toString().slice(0, 2).toLowerCase();
    if (value == null) return '';
    value = $2cd9836c61fea821$var$coerceLocalizedValue(value);
    if (typeof value === 'string') return value;
    if (typeof value === 'object' && !Array.isArray(value)) {
        const direct = value[loc];
        if (direct != null && String(direct).trim() !== '') return String(direct);
        for(let i = 0; i < fallbacks.length; i++){
            const k = fallbacks[i];
            if (k === loc) continue;
            const v = value[k];
            if (v != null && String(v).trim() !== '') return String(v);
        }
        const keys = Object.keys(value);
        for(let i = 0; i < keys.length; i++){
            const v = value[keys[i]];
            if (v != null && String(v).trim() !== '') return String(v);
        }
        return '';
    }
    return String(value);
}
function $2cd9836c61fea821$export$bc816e7779fb41a2(value, locales = $2cd9836c61fea821$export$e49c1078bc46f17) {
    if (value == null) return '';
    if (typeof value === 'string') return value;
    if (typeof value !== 'object' || Array.isArray(value)) return '';
    const filled = locales.map((l)=>[
            l,
            String(value[l] != null ? value[l] : '').trim()
        ]).filter(([, v])=>v);
    if (filled.length === 0) return '';
    if (filled.length === 1) return filled[0][1];
    const texts = filled.map(([, v])=>v);
    if (texts.every((t)=>t === texts[0])) return texts[0];
    return Object.fromEntries(filled);
}
function $2cd9836c61fea821$export$1b8d477a417eaf12(current, locale, text, locales = $2cd9836c61fea821$export$e49c1078bc46f17) {
    const loc = (locale || $2cd9836c61fea821$export$1af4c7e47ad72f44).toString().slice(0, 2).toLowerCase();
    const t = text == null ? '' : String(text);
    if (current == null || current === '') return t;
    if (typeof current === 'string') {
        if (t === current) return current;
        const map = {};
        locales.forEach((l)=>{
            map[l] = l === loc ? t : current;
        });
        return map;
    }
    if (typeof current === 'object' && !Array.isArray(current)) return Object.assign({}, current, {
        [loc]: t
    });
    return t;
}
function $2cd9836c61fea821$export$188131e14c2a0aed(en, bg) {
    return $2cd9836c61fea821$export$bc816e7779fb41a2({
        en: en,
        bg: bg
    }, [
        'en',
        'bg'
    ]);
}
function $2cd9836c61fea821$export$53cc8198d745b4fd(value) {
    if (value == null || value === '') return '';
    if (typeof value === 'string') return String(value).trim();
    if (typeof value === 'object' && !Array.isArray(value)) {
        const en = $2cd9836c61fea821$export$120b21fa6f0ce60f(value, 'en');
        const bg = $2cd9836c61fea821$export$120b21fa6f0ce60f(value, 'bg');
        if (en && bg && String(en).trim() !== String(bg).trim()) return String(en).trim() + ' / ' + String(bg).trim();
        return (en || bg || '').trim();
    }
    return String(value).trim();
}
function $2cd9836c61fea821$export$827bf31a3402a1c9(doc, i18nFields, locales = $2cd9836c61fea821$export$e49c1078bc46f17) {
    if (!doc || !i18nFields || !i18nFields.length) return doc;
    const out = Object.assign({}, doc);
    i18nFields.forEach((path)=>{
        if (String(path).indexOf('.') !== -1) return;
        if (out[path] !== undefined) out[path] = $2cd9836c61fea821$export$bc816e7779fb41a2(out[path], locales);
    });
    return out;
}

});


parcelRegister("jgFPa", function(module, exports) {
'use strict';

var $2Z6Kw = parcelRequire("2Z6Kw");
var $e06ff4633f3c6852$require$h1 = $2Z6Kw.h1;
var $e06ff4633f3c6852$require$a = $2Z6Kw.a;
var $e06ff4633f3c6852$require$div = $2Z6Kw.div;
var $e06ff4633f3c6852$require$header = $2Z6Kw.header;
var $e06ff4633f3c6852$require$p = $2Z6Kw.p;
var $e06ff4633f3c6852$require$section = $2Z6Kw.section;
var $e06ff4633f3c6852$require$button = $2Z6Kw.button;
var $e06ff4633f3c6852$require$span = $2Z6Kw.span;
var $e06ff4633f3c6852$require$ul = $2Z6Kw.ul;
var $e06ff4633f3c6852$require$li = $2Z6Kw.li;

var $2ysVK = parcelRequire("2ysVK");

var $jjnZg = parcelRequire("jjnZg");
var $e06ff4633f3c6852$require$obj = $jjnZg.obj;

var $3QJuk = parcelRequire("3QJuk");
const { normalizeDocI18nFields: $e06ff4633f3c6852$var$normalizeDocI18nFields } = $3QJuk.default || $3QJuk;

var $4hyaE = parcelRequire("4hyaE");
const $e06ff4633f3c6852$var$excludeFields = [
    'createdBy',
    'createdOn'
];
// Keep multipart upload handles for resource.save → FormData (avatar/poster).
const $e06ff4633f3c6852$var$uploadMetaKeys = {
    _avatarFile: true,
    _avatarFileName: true,
    _avatarKind: true,
    _posterFile: true,
    _posterFileName: true,
    _posterKind: true
};
// Strip UI-only / mongoose internals — keep `_id` so save updates instead of creates
const $e06ff4633f3c6852$var$ephemeralKeys = (key)=>key === 'fieldLang' || key === '__v' || key.charAt(0) === '_' && key !== '_id' && !$e06ff4633f3c6852$var$uploadMetaKeys[key];
module.exports = ({ state: state, actions: actions, i18n: i18n })=>{
    const collection = state.router.path[1];
    const colMeta = state.rest.collections[collection] || {};
    const schema = colMeta.schema || {};
    const i18nFields = colMeta.i18n || [];
    const fieldLangs = state[collection] && state[collection].fieldLang || {};
    return $2ysVK({
        sel: state.router.pageId === 'new' ? '.create' : '.edit',
        schema: $e06ff4633f3c6852$require$obj.filter(schema, (field, value)=>$e06ff4633f3c6852$var$excludeFields.indexOf(field) === -1),
        doc: state[collection].doc,
        focused: state[collection].focused || false,
        state: state,
        i18n: i18n,
        i18nFields: i18nFields,
        fieldLangs: fieldLangs,
        setFieldLang: (fieldName, loc)=>actions.set([
                collection,
                'fieldLang',
                fieldName
            ], {
                lang: loc,
                base: state.lang || 'bg'
            }),
        fullActions: actions,
        actions: {
            update: (field, value)=>actions.set([
                    collection,
                    'doc'
                ], (doc)=>$e06ff4633f3c6852$require$obj.patch(doc || {}, field, value)),
            save: ({ data: data, ev: ev })=>{
                const merged = Object.assign({}, state[collection].doc, data);
                const cleaned = $e06ff4633f3c6852$require$obj.filter($e06ff4633f3c6852$require$obj.map(merged, (key, value)=>{
                    if ($e06ff4633f3c6852$var$ephemeralKeys(key)) return undefined;
                    if (i18nFields.indexOf(key) > -1) // prefer doc (locale map) over form string snapshot
                    return state[collection].doc[key];
                    if ([
                        'content',
                        'article',
                        'post',
                        'text',
                        'about'
                    ].indexOf(key) > -1 && value && value.content !== undefined) return value.content;
                    const schemaField = schema[key];
                    if (schemaField instanceof Array && typeof value === 'string') return value.split(',').map((s)=>s.trim()).filter(Boolean);
                    if (schemaField && schemaField.type === 'ObjectId' && (value === '' || value === undefined || value === null)) return undefined;
                    // Event start/end: wall clock in doc.timezone → real UTC
                    if ((key === 'startDateTime' || key === 'endDateTime') && (schemaField === 'Date' || schemaField && schemaField.type === 'Date')) return $4hyaE.fromInputValue(value, merged.timezone || $4hyaE.DEFAULT_TZ);
                    return value;
                }), (key, value)=>value !== undefined);
                const payload = $e06ff4633f3c6852$var$normalizeDocI18nFields(cleaned, i18nFields);
                actions[collection].save(payload, state.auth.token, ()=>actions.router.go(state.router.path.slice(0, 2).join('.')));
            },
            cancel: ({ ev: ev })=>actions.router.go(state.router.path.slice(0, 2).join('.'))
        }
    });
};

});
parcelRegister("2ysVK", function(module, exports) {
'use strict';

var $2Z6Kw = parcelRequire("2Z6Kw");
var $1dc532b9aea9cd9b$require$h1 = $2Z6Kw.h1;
var $1dc532b9aea9cd9b$require$a = $2Z6Kw.a;
var $1dc532b9aea9cd9b$require$div = $2Z6Kw.div;
var $1dc532b9aea9cd9b$require$header = $2Z6Kw.header;
var $1dc532b9aea9cd9b$require$section = $2Z6Kw.section;
var $1dc532b9aea9cd9b$require$button = $2Z6Kw.button;
var $1dc532b9aea9cd9b$require$span = $2Z6Kw.span;
var $1dc532b9aea9cd9b$require$ul = $2Z6Kw.ul;
var $1dc532b9aea9cd9b$require$li = $2Z6Kw.li;
var $1dc532b9aea9cd9b$require$br = $2Z6Kw.br;
var $1dc532b9aea9cd9b$require$i = $2Z6Kw.i;
var $1dc532b9aea9cd9b$require$hr = $2Z6Kw.hr;
var $1dc532b9aea9cd9b$require$img = $2Z6Kw.img;
var $1dc532b9aea9cd9b$require$table = $2Z6Kw.table;
var $1dc532b9aea9cd9b$require$thead = $2Z6Kw.thead;
var $1dc532b9aea9cd9b$require$tbody = $2Z6Kw.tbody;
var $1dc532b9aea9cd9b$require$tr = $2Z6Kw.tr;
var $1dc532b9aea9cd9b$require$th = $2Z6Kw.th;
var $1dc532b9aea9cd9b$require$td = $2Z6Kw.td;
var $1dc532b9aea9cd9b$require$form = $2Z6Kw.form;
var $1dc532b9aea9cd9b$require$input = $2Z6Kw.input;
var $1dc532b9aea9cd9b$require$label = $2Z6Kw.label;
var $1dc532b9aea9cd9b$require$fieldset = $2Z6Kw.fieldset;
var $1dc532b9aea9cd9b$require$legend = $2Z6Kw.legend;
var $1dc532b9aea9cd9b$require$select = $2Z6Kw.select;
var $1dc532b9aea9cd9b$require$option = $2Z6Kw.option;
var $1dc532b9aea9cd9b$require$textarea = $2Z6Kw.textarea;
parcelRequire("1zDll");

var $jjnZg = parcelRequire("jjnZg");
var $1dc532b9aea9cd9b$require$obj = $jjnZg.obj;
var $1dc532b9aea9cd9b$require$str = $jjnZg.str;
var $1dc532b9aea9cd9b$require$arr = $jjnZg.arr;

var $bLEu3 = parcelRequire("bLEu3");

var $4hyaE = parcelRequire("4hyaE");

var $ehn3l = parcelRequire("ehn3l");
var $1dc532b9aea9cd9b$require$fieldLabel = $ehn3l.fieldLabel;
var $1dc532b9aea9cd9b$require$enumLabel = $ehn3l.enumLabel;

var $3QJuk = parcelRequire("3QJuk");
const { LOCALES: $1dc532b9aea9cd9b$var$LOCALES, DEFAULT_LOCALE: $1dc532b9aea9cd9b$var$DEFAULT_LOCALE, resolveLocalized: $1dc532b9aea9cd9b$var$resolveLocalized, writeLocalized: $1dc532b9aea9cd9b$var$writeLocalized } = $3QJuk.default || $3QJuk;

var $c3IWw = parcelRequire("c3IWw");

var $kGspc = parcelRequire("kGspc");


const $1dc532b9aea9cd9b$var$wysiwyg = (parcelRequire("5o8PO")).default ?? (parcelRequire("5o8PO"));

var $8vHB3 = parcelRequire("8vHB3");

var $8k6FZ = parcelRequire("8k6FZ");
const $1dc532b9aea9cd9b$var$sub = (o, p, d = false)=>o === undefined ? d : p instanceof Array ? o[p[0]] && p.length > 1 ? [
        $1dc532b9aea9cd9b$var$sub(o[p[0]], p.slice(1))
    ].map((sO)=>sO !== undefined ? sO : d).pop() : o[p[0]] : o[p] !== undefined ? o[p] : d;
const $1dc532b9aea9cd9b$var$schemaInputFieldMap = {
    String: 'text',
    Number: 'number',
    Date: 'datetime-local',
    Boolean: 'checkbox'
};
const $1dc532b9aea9cd9b$var$keys = (o)=>Object.keys(o);
const $1dc532b9aea9cd9b$var$RICH_KEYS = [
    'content',
    'article',
    'post',
    'text',
    'about'
];
// Do not use obj.switch here: schema fields may have a `default` property, and
// obj.switch treats cases[type].default as the result (e.g. status.default → "draft").
const $1dc532b9aea9cd9b$var$decorateField = (field)=>{
    if (!field || typeof field !== 'object') return field;
    if ((field.type === 'String' || field.type === 'Mixed') && $1dc532b9aea9cd9b$var$RICH_KEYS.indexOf(field.name) > -1) return {
        ...field,
        type: 'RichText'
    };
    return field;
};
const $1dc532b9aea9cd9b$var$parseField = (field, name)=>typeof field === 'string' ? {
        type: field,
        name: name,
        required: true
    } : field && typeof field.type === 'string' ? Object.assign({}, field, {
        name: name
    }) : field instanceof Array ? {
        type: 'Array',
        name: name,
        schema: $1dc532b9aea9cd9b$var$parseField(field[0])
    } : field instanceof Object ? {
        type: 'Object',
        name: name,
        fields: $1dc532b9aea9cd9b$var$keys(field).map((key)=>$1dc532b9aea9cd9b$var$parseField(field[key], [
                name,
                key
            ].join('.')))
    } : false;
const $1dc532b9aea9cd9b$var$refToCollection = {
    User: 'users',
    Profile: 'profiles',
    Event: 'events',
    Article: 'articles',
    Page: 'pages'
};
const $1dc532b9aea9cd9b$var$labelKeys = [
    'fullName',
    'email',
    'title',
    'name',
    'path'
];
const $1dc532b9aea9cd9b$var$hashFromRef = (state, ref)=>{
    const ns = $1dc532b9aea9cd9b$var$refToCollection[ref];
    const list = ns && state && state[ns] && state[ns].list;
    if (!list) return {};
    return list.reduce((hash, doc)=>{
        const label = $1dc532b9aea9cd9b$var$labelKeys.map((k)=>{
            const v = doc[k];
            if (v == null) return '';
            if (typeof v === 'string') return v;
            if (typeof v === 'object') return $1dc532b9aea9cd9b$var$resolveLocalized(v, state && state.lang || $1dc532b9aea9cd9b$var$DEFAULT_LOCALE);
            return String(v);
        }).find(Boolean) || String(doc._id);
        return Object.assign(hash, {
            [doc._id]: label
        });
    }, {});
};
const $1dc532b9aea9cd9b$var$getParent = (el, tagName)=>[].concat(tagName).indexOf(el.tagName) === -1 ? $1dc532b9aea9cd9b$var$getParent(el.parentNode, tagName) : el;
const $1dc532b9aea9cd9b$var$inputAddons = (content, field, addons)=>addons.length > 0 && field.type === 'String' ? $1dc532b9aea9cd9b$require$div('.input-group', [
        content,
        $1dc532b9aea9cd9b$require$div('.input-group-btn', addons.map((addon)=>$1dc532b9aea9cd9b$require$button(`.btn.btn-default[type=button]`, {
                on: {
                    click: (ev)=>addon.cb(field, $1dc532b9aea9cd9b$var$getParent(ev.target, 'DIV').parentNode.querySelector('input').value)
                }
            }, [
                $1dc532b9aea9cd9b$require$i(`.fa.${addon.icon}`)
            ])))
    ]) : content;
const $1dc532b9aea9cd9b$var$columnsAndNewItemFromSchema = (schema, i18n)=>{
    if (!schema || schema.type !== 'Object' || !schema.fields || !schema.fields.length) return null;
    const columns = schema.fields.map((f)=>{
        const key = f.name.split('.').pop();
        return {
            key: key,
            type: f.type,
            label: $1dc532b9aea9cd9b$require$fieldLabel(i18n, key),
            enum: f.enum instanceof Array ? f.enum : undefined
        };
    });
    const colRank = (key)=>key === 'type' || key === 'source' ? 0 : key === 'url' ? 1 : 2;
    columns.sort((a, b)=>colRank(a.key) - colRank(b.key));
    const newItem = schema.fields.reduce((o, f)=>{
        const key = f.name.split('.').pop();
        let value = '';
        if (f.type === 'Number') value = 0;
        else if (f.enum instanceof Array) value = f.enum[0];
        return {
            ...o,
            [key]: value
        };
    }, {});
    return {
        columns: columns,
        newItem: newItem
    };
};
const $1dc532b9aea9cd9b$var$isI18nField = (field, i18nFields)=>(i18nFields || []).indexOf(field.name) > -1;
const $1dc532b9aea9cd9b$var$fieldLangOf = (fieldLangs, fieldName, stateLang)=>{
    const fallback = stateLang || $1dc532b9aea9cd9b$var$DEFAULT_LOCALE;
    const override = fieldLangs && fieldLangs[fieldName];
    if (!override) return fallback;
    // sticky only while global lang matches the base when the override was set
    if (typeof override === 'object' && override.lang) return override.base === fallback ? override.lang : fallback;
    if (typeof override === 'string') return override;
    return fallback;
};
const $1dc532b9aea9cd9b$var$LOCALE_FLAGS = {
    bg: '/assets/flags/bg.svg',
    en: '/assets/flags/gb.svg'
};
const $1dc532b9aea9cd9b$var$nextLocale = (active, locales = $1dc532b9aea9cd9b$var$LOCALES)=>{
    const i = locales.indexOf(active);
    return locales[(i + 1) % locales.length] || locales[0];
};
/** Single flag that toggles locale on click (not side-by-side). */ const $1dc532b9aea9cd9b$var$langSwitcher = ({ active: active, onSelect: onSelect })=>{
    const loc = active || $1dc532b9aea9cd9b$var$DEFAULT_LOCALE;
    const next = $1dc532b9aea9cd9b$var$nextLocale(loc);
    return $1dc532b9aea9cd9b$require$span('.field-lang-switch', {
        attrs: {
            'data-lang': loc,
            title: `${loc.toUpperCase()} \u{2192} ${next.toUpperCase()}`,
            role: 'button',
            tabindex: '0',
            'aria-label': `Language ${loc.toUpperCase()}, switch to ${next.toUpperCase()}`
        },
        on: {
            mousedown: (ev)=>ev.preventDefault(),
            dblclick: (ev)=>ev.preventDefault(),
            click: (ev)=>(ev.preventDefault(), ev.stopPropagation(), onSelect(next)),
            keydown: (ev)=>{
                if (ev.key === 'Enter' || ev.key === ' ') {
                    ev.preventDefault();
                    onSelect(next);
                }
            }
        }
    }, $1dc532b9aea9cd9b$require$img(`.field-lang-flag[src="${$1dc532b9aea9cd9b$var$LOCALE_FLAGS[loc]}"][alt="${loc.toUpperCase()}"]`));
};
const $1dc532b9aea9cd9b$var$formElement = ({ field: field, doc: doc, update: update = ()=>{}, focused: focused = false, addons: addons = [], state: state, fullActions: fullActions, i18n: i18n = {}, i18nFields: i18nFields = [], fieldLangs: fieldLangs = {}, setFieldLang: setFieldLang = ()=>{} })=>{
    const stateLang = state && state.lang || $1dc532b9aea9cd9b$var$DEFAULT_LOCALE;
    const localized = $1dc532b9aea9cd9b$var$isI18nField(field, i18nFields);
    const activeLang = $1dc532b9aea9cd9b$var$fieldLangOf(fieldLangs, field.name, stateLang);
    const collection = state && state.router && state.router.path ? state.router.path[0] === 'admin' ? state.router.path[1] : state.router.path[0] : null;
    const patchLocalized = (text)=>{
        if (fullActions && collection) {
            fullActions.set([
                collection,
                'doc'
            ], (current)=>{
                const base = current || {};
                return Object.assign({}, base, {
                    [field.name]: $1dc532b9aea9cd9b$var$writeLocalized(base[field.name], activeLang, text)
                });
            });
            return;
        }
        update(field.name.split('.'), $1dc532b9aea9cd9b$var$writeLocalized($1dc532b9aea9cd9b$var$sub(doc, field.name.split('.')), activeLang, text));
    };
    const switcher = localized ? $1dc532b9aea9cd9b$var$langSwitcher({
        active: activeLang,
        onSelect: (loc)=>{
            const el = document.activeElement;
            if (el && typeof el.blur === 'function') el.blur();
            setFieldLang(field.name, loc);
        }
    }) : null;
    return $1dc532b9aea9cd9b$require$obj.switch(field.type, {
        File: (value)=>$kGspc({
                field: field,
                value: value,
                update: update,
                focused: focused,
                i18n: i18n
            }),
        RichText: (value)=>{
            const raw = localized ? value : value;
            const content = localized ? $1dc532b9aea9cd9b$var$resolveLocalized(raw, activeLang) : value && value.content !== undefined ? value.content : value;
            const richUi = doc && doc[`_${field.name}Rich`] || {};
            const richValue = {
                content: content || '',
                pos: richUi.pos || {
                    start: {
                        row: 0,
                        col: 0
                    },
                    end: {
                        row: 0,
                        col: 1
                    }
                },
                mode: richUi.mode || 'wysiwyg'
            };
            const richUpdate = (path, next)=>{
                if (localized && fullActions && collection) fullActions.set([
                    collection,
                    'doc'
                ], (current)=>{
                    const base = current || {};
                    return Object.assign({}, base, {
                        [field.name]: $1dc532b9aea9cd9b$var$writeLocalized(base[field.name], activeLang, next.content),
                        [`_${field.name}Rich`]: {
                            pos: next.pos,
                            mode: next.mode
                        }
                    });
                });
                else if (localized) update(field.name.split('.'), $1dc532b9aea9cd9b$var$writeLocalized($1dc532b9aea9cd9b$var$sub(doc, field.name.split('.')), activeLang, next.content));
                else update(path, next);
            };
            return $1dc532b9aea9cd9b$var$wysiwyg({
                field: field,
                value: richValue,
                update: richUpdate,
                focused: focused,
                addons: addons,
                i18n: i18n,
                langSwitcher: switcher,
                contentKey: localized ? activeLang : ''
            });
        },
        Text: (value)=>$1dc532b9aea9cd9b$require$div('.field', {
                class: {
                    'field-i18n': localized
                }
            }, [
                field.name.split('.').length === 1 ? $1dc532b9aea9cd9b$require$label([
                    $1dc532b9aea9cd9b$require$fieldLabel(i18n, field.name.split('.').pop()),
                    ': '
                ]) : '',
                $1dc532b9aea9cd9b$require$div('.field-control', [
                    switcher,
                    $1dc532b9aea9cd9b$require$textarea({
                        style: {
                            width: '100%',
                            minHeight: '160px',
                            outline: 'none'
                        },
                        on: {
                            input: (ev)=>localized ? patchLocalized(ev.target.value) : update(field.name.split('.'), ev.target.value)
                        },
                        attrs: {
                            name: localized ? undefined : field.name,
                            disabled: field.disabled,
                            hidden: field.hidden
                        },
                        props: {
                            value: localized ? $1dc532b9aea9cd9b$var$resolveLocalized(value, activeLang) : value
                        }
                    })
                ])
            ]),
        Mixed: (value)=>localized ? $1dc532b9aea9cd9b$require$div('.field.field-i18n', [
                field.name.split('.').length === 1 ? $1dc532b9aea9cd9b$require$label([
                    $1dc532b9aea9cd9b$require$fieldLabel(i18n, field.name.split('.').pop()),
                    ': '
                ]) : '',
                $1dc532b9aea9cd9b$require$div('.field-control', [
                    switcher,
                    $1dc532b9aea9cd9b$require$input({
                        on: {
                            input: (ev)=>patchLocalized(ev.target.value)
                        },
                        attrs: {
                            type: 'text',
                            placeholder: $1dc532b9aea9cd9b$require$fieldLabel(i18n, field.name.split('.').pop()),
                            disabled: field.disabled
                        },
                        props: {
                            value: $1dc532b9aea9cd9b$var$resolveLocalized(value, activeLang) || ''
                        }
                    })
                ])
            ]) : $1dc532b9aea9cd9b$require$div('.field', [
                field.name.split('.').length === 1 ? $1dc532b9aea9cd9b$require$label('.col-sm-2.control-label', [
                    $1dc532b9aea9cd9b$require$fieldLabel(i18n, field.name.split('.').pop()),
                    ': '
                ]) : '',
                $1dc532b9aea9cd9b$require$textarea({
                    on: {
                        input: (ev)=>update(field.name.split('.'), ev.target.value)
                    },
                    attrs: {
                        name: field.name,
                        disabled: field.disabled,
                        hidden: field.hidden
                    }
                }, typeof value === 'string' ? value : JSON.stringify(value))
            ]),
        Array: (value)=>field.schema.type === 'String' || field.schema.type === 'ObjectId' ? $c3IWw({
                field: field,
                value: value,
                update: update,
                i18n: i18n
            }) : state && fullActions && field.schema && field.schema.type === 'Object' && field.schema.fields && field.schema.fields.length ? (()=>{
                const derived = $1dc532b9aea9cd9b$var$columnsAndNewItemFromSchema(field.schema, i18n);
                const collection = state.router.path[0] === 'admin' ? state.router.path[1] : state.router.path[0];
                return derived ? $1dc532b9aea9cd9b$require$div('.field', [
                    field.name.split('.').length === 1 ? $1dc532b9aea9cd9b$require$label([
                        $1dc532b9aea9cd9b$require$fieldLabel(i18n, field.name),
                        ': '
                    ]) : '',
                    $8vHB3({
                        path: [
                            collection,
                            'doc',
                            field.name
                        ],
                        columns: derived.columns,
                        newItem: derived.newItem,
                        state: state,
                        actions: fullActions,
                        i18n: i18n
                    })
                ]) : $1dc532b9aea9cd9b$var$formElement({
                    field: {
                        ...field,
                        type: 'Mixed'
                    },
                    doc: doc,
                    update: update,
                    focused: focused,
                    addons: addons,
                    state: state,
                    fullActions: fullActions,
                    i18n: i18n,
                    i18nFields: i18nFields,
                    fieldLangs: fieldLangs,
                    setFieldLang: setFieldLang
                });
            })() : $1dc532b9aea9cd9b$var$formElement({
                field: {
                    ...field,
                    type: 'Mixed'
                },
                doc: doc,
                update: update,
                focused: focused,
                addons: addons,
                state: state,
                fullActions: fullActions,
                i18n: i18n,
                i18nFields: i18nFields,
                fieldLangs: fieldLangs,
                setFieldLang: setFieldLang
            }),
        default: (value)=>$1dc532b9aea9cd9b$require$div('.field', {
                class: {
                    'field-i18n': localized && field.type === 'String'
                }
            }, [
                field.name.split('.').length === 1 ? $1dc532b9aea9cd9b$require$label([
                    $1dc532b9aea9cd9b$require$fieldLabel(i18n, field.name.split('.').pop()),
                    ': '
                ]) : '',
                field.type === 'String' && field.enum instanceof Array ? $1dc532b9aea9cd9b$require$select({
                    on: {
                        change: (ev)=>update(field.name.split('.'), ev.target.value)
                    },
                    attrs: {
                        name: field.name,
                        disabled: field.disabled
                    }
                }, [].concat(field.enum.map((val, index)=>$1dc532b9aea9cd9b$require$option({
                        attrs: {
                            value: val,
                            selected: typeof value === 'undefined' && index === 0 || val === value
                        },
                        props: {
                            value: val,
                            selected: typeof value === 'undefined' && index === 0 || val === value
                        }
                    }, $1dc532b9aea9cd9b$require$enumLabel(i18n, field.name.split('.').pop(), val))))) : field.type === 'ObjectId' ? (()=>{
                    const hash = field.hash instanceof Object ? field.hash : $1dc532b9aea9cd9b$var$hashFromRef(state, field.ref);
                    const selected = value ? String(value) : '';
                    const na = i18n.common && i18n.common.actions && i18n.common.actions.na || 'n/a';
                    return $1dc532b9aea9cd9b$require$select({
                        on: {
                            change: (ev)=>update(field.name.split('.'), ev.target.value)
                        },
                        attrs: {
                            name: field.name,
                            disabled: field.disabled
                        }
                    }, [].concat($1dc532b9aea9cd9b$require$option({
                        attrs: {
                            value: '',
                            selected: selected === ''
                        },
                        props: {
                            value: '',
                            selected: selected === ''
                        }
                    }, na), Object.keys(hash).map((id)=>$1dc532b9aea9cd9b$require$option({
                            attrs: {
                                value: id,
                                selected: id === selected
                            },
                            props: {
                                value: id,
                                selected: id === selected
                            }
                        }, hash[id]))));
                })() : [
                    'avatar',
                    'poster'
                ].indexOf(field.name) > -1 && state && fullActions ? (()=>{
                    const collection = state.router.path[0] === 'admin' ? state.router.path[1] : state.router.path[0];
                    const fileKey = `_${field.name}File`;
                    const nameKey = `_${field.name}FileName`;
                    const kindKey = `_${field.name}Kind`;
                    const kind = doc[kindKey] || (doc[fileKey] ? 'file' : 'url');
                    const patchDoc = (patch)=>fullActions.set([
                            collection,
                            'doc'
                        ], Object.assign({}, doc, patch));
                    return $8k6FZ({
                        kind: kind,
                        url: value || '',
                        fileName: doc[nameKey] || '',
                        accept: 'image/*',
                        onKind: (next)=>patchDoc({
                                [kindKey]: next,
                                [fileKey]: next === 'file' ? doc[fileKey] : undefined,
                                [nameKey]: next === 'file' ? doc[nameKey] : undefined
                            }),
                        onUrl: (v)=>patchDoc({
                                [field.name]: v,
                                [kindKey]: 'url'
                            }),
                        onFile: (files)=>{
                            const f = files[0];
                            if (!f) return;
                            patchDoc({
                                [kindKey]: 'file',
                                [fileKey]: f,
                                [nameKey]: f.name
                            });
                        },
                        onClear: ()=>patchDoc({
                                [field.name]: '',
                                [kindKey]: kind,
                                [fileKey]: undefined,
                                [nameKey]: undefined
                            })
                    });
                })() : localized ? $1dc532b9aea9cd9b$require$div('.field-control', [
                    switcher,
                    $1dc532b9aea9cd9b$require$input({
                        on: {
                            input: (ev)=>patchLocalized(ev.target.value)
                        },
                        attrs: {
                            type: 'text',
                            placeholder: $1dc532b9aea9cd9b$require$fieldLabel(i18n, field.name.split('.').pop()),
                            disabled: field.disabled
                        },
                        props: {
                            value: $1dc532b9aea9cd9b$var$resolveLocalized(value, activeLang) || ''
                        }
                    })
                ]) : $1dc532b9aea9cd9b$require$input({
                    on: {
                        input: (ev)=>update(field.name.split('.'), ev.target.value)
                    },
                    attrs: {
                        name: field.name,
                        type: field.name.match('password') ? 'password' : field.name.match(/(^|\.)email$/) ? 'email' : $1dc532b9aea9cd9b$var$schemaInputFieldMap[field.type],
                        step: 0.01,
                        placeholder: $1dc532b9aea9cd9b$require$fieldLabel(i18n, field.name.split('.').pop()),
                        checked: field.type === 'Boolean' && value === true,
                        disabled: field.disabled
                    },
                    props: {
                        value: field.type === 'Date' ? $4hyaE.toInputValue(value, doc && doc.timezone) : value || ''
                    }
                })
            ]),
        Object: ()=>$1dc532b9aea9cd9b$require$div('.field', [].concat($1dc532b9aea9cd9b$require$label('', [
                $1dc532b9aea9cd9b$require$fieldLabel(i18n, field.name.split('.').pop()),
                ': '
            ]), field.fields.map((f)=>$1dc532b9aea9cd9b$var$formElement({
                    field: f,
                    doc: doc,
                    update: update,
                    focused: focused,
                    addons: addons,
                    state: state,
                    fullActions: fullActions,
                    i18n: i18n,
                    i18nFields: i18nFields,
                    fieldLangs: fieldLangs,
                    setFieldLang: setFieldLang
                }))))
    })($1dc532b9aea9cd9b$var$sub(doc, field.name.split('.'), field.type === 'Array' ? [] : ''));
};
module.exports = ({ schema: schema, doc: doc = {}, sel: sel = '', noactions: noactions = false, actions: { save: save, cancel: cancel, update: update = ()=>{} }, focused: focused = false, addons: addons = [], state: state, fullActions: fullActions, i18n: i18n = {}, i18nFields: i18nFields = [], fieldLangs: fieldLangs = {}, setFieldLang: setFieldLang = ()=>{} })=>$1dc532b9aea9cd9b$require$form(sel, {
        on: {
            submit: (ev)=>(ev.preventDefault(), save({
                    data: $bLEu3.toData(ev.target),
                    ev: ev
                }))
        }
    }, [].concat($1dc532b9aea9cd9b$var$keys(schema).map((key)=>$1dc532b9aea9cd9b$var$parseField(schema[key], key)).map($1dc532b9aea9cd9b$var$decorateField).reduce((els, field)=>[].concat(els, $1dc532b9aea9cd9b$var$formElement({
            field: field,
            doc: doc,
            update: update,
            focused: focused === field.name,
            addons: addons,
            state: state,
            fullActions: fullActions,
            i18n: i18n,
            i18nFields: i18nFields,
            fieldLangs: fieldLangs,
            setFieldLang: setFieldLang
        })), []), !noactions ? $1dc532b9aea9cd9b$require$div(`.buttons`, [
        $1dc532b9aea9cd9b$require$button(`#edit-cancel.btn.btn-white[type="button"]`, {
            on: {
                click: (ev)=>cancel({
                        ev: ev
                    })
            }
        }, i18n.common && i18n.common.actions && i18n.common.actions.cancel || 'Cancel'),
        ' ',
        $1dc532b9aea9cd9b$require$button(`#edit-save.btn.btn-primary[type="sumbit"]`, i18n.common && i18n.common.actions && i18n.common.actions.save || 'Save')
    ]) : []));

});
parcelRegister("bLEu3", function(module, exports) {
'use strict';

var $jjnZg = parcelRequire("jjnZg");
var $89137cbbe6170870$require$obj = $jjnZg.obj;
const $89137cbbe6170870$var$keys = Object.keys;
const $89137cbbe6170870$var$arrify = (o)=>o instanceof Object ? !(o instanceof Array) && $89137cbbe6170870$var$keys(o).filter((k)=>k.match(/^-?[0-9.]+$/)).length === $89137cbbe6170870$var$keys(o).length ? $89137cbbe6170870$var$keys(o).map((k)=>$89137cbbe6170870$var$arrify(o[k])) : $89137cbbe6170870$var$keys(o).reduce((o2, k)=>$89137cbbe6170870$require$obj.patch(o2, k, $89137cbbe6170870$var$arrify(o[k])), {}) : o;
const $89137cbbe6170870$var$toData = (form)=>$89137cbbe6170870$var$arrify(Array.from(form.elements)// .map(el => (console.log(el.name), el))
    .filter((el)=>el.name !== undefined && el.name !== '').reduce((o, el)=>$89137cbbe6170870$require$obj.patch(o, el.name.split('.'), el.type && el.type === 'number' ? Number(el.value) : el.type === 'checkbox' ? el.checked : el.value), {}));
const $89137cbbe6170870$var$clear = (form)=>Array.from(form.elements).forEach((el)=>el.value = null);
module.exports = {
    toData: $89137cbbe6170870$var$toData,
    clear: $89137cbbe6170870$var$clear
};

});

parcelRegister("4hyaE", function(module, exports) {
'use strict';

var $1zDll = parcelRequire("1zDll");

var $g10CX = parcelRequire("g10CX");

var $jRT2Z = parcelRequire("jRT2Z");
$1zDll.extend($g10CX);
$1zDll.extend($jRT2Z);
const $31e34189bd28f499$var$DEFAULT_TZ = 'Europe/Sofia';
const $31e34189bd28f499$var$resolveTz = (tz)=>{
    const t = tz && String(tz).trim();
    return t || $31e34189bd28f499$var$DEFAULT_TZ;
};
/** Strip to a naive local datetime string for dayjs.tz. */ const $31e34189bd28f499$var$naiveLocal = (value)=>{
    if (value == null || value === '') return '';
    if (typeof value !== 'string') {
        const d = $1zDll.utc(value);
        return d.isValid() ? d.format('YYYY-MM-DDTHH:mm:ss.SSS') : '';
    }
    const v = value.trim();
    if (!v) return '';
    const m = v.match(/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2})(?::(\d{2})(?:\.(\d+))?)?(?:Z|[+-]\d{2}:?\d{2})?$/i);
    if (!m) return v;
    const sec = m[2] != null ? m[2] : '00';
    const ms = m[3] != null ? m[3].padEnd(3, '0').slice(0, 3) : '000';
    return `${m[1]}:${sec}.${ms}`;
};
const $31e34189bd28f499$var$hasOffset = (v)=>/Z$/i.test(v) || /[+-]\d{2}:?\d{2}$/.test(v);
/**
 * UTC instant → datetime-local in event timezone.
 * Naive datetime-local strings (from the input while typing) are left as-is —
 * otherwise dayjs.utc(…).tz(Sofia) shifts them by the offset on every keystroke.
 */ const $31e34189bd28f499$var$toInputValue = (value, tz)=>{
    if (value == null || value === '') return '';
    if (typeof value === 'string') {
        const v = value.trim();
        if (!v) return '';
        if (!$31e34189bd28f499$var$hasOffset(v)) {
            const m = v.match(/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2})/);
            return m ? m[1] : v;
        }
    }
    const d = $1zDll.utc(value).tz($31e34189bd28f499$var$resolveTz(tz));
    return d.isValid() ? d.format('YYYY-MM-DDTHH:mm') : '';
};
/** datetime-local (wall in tz) → real UTC ISO for API storage. */ const $31e34189bd28f499$var$fromInputValue = (value, tz)=>{
    if (value == null || value === '') return value;
    if (typeof value !== 'string') {
        const d = $1zDll(value);
        return d.isValid() ? d.toISOString() : value;
    }
    const v = value.trim();
    if (!v) return v;
    const zone = $31e34189bd28f499$var$resolveTz(tz);
    // Already an absolute instant (e.g. untouched API value) — keep as real UTC.
    if ($31e34189bd28f499$var$hasOffset(v)) {
        const d = $1zDll(v);
        return d.isValid() ? d.toISOString() : v;
    }
    const local = $31e34189bd28f499$var$naiveLocal(v);
    const d = $1zDll.tz(local, zone);
    return d.isValid() ? d.toISOString() : v;
};
/** Parse stored UTC instant as dayjs in event timezone (for display). */ const $31e34189bd28f499$var$parse = (value, tz)=>{
    if (value == null || value === '') return null;
    const d = $1zDll.utc(value).tz($31e34189bd28f499$var$resolveTz(tz));
    return d.isValid() ? d : null;
};
module.exports = {
    DEFAULT_TZ: $31e34189bd28f499$var$DEFAULT_TZ,
    toInputValue: $31e34189bd28f499$var$toInputValue,
    fromInputValue: $31e34189bd28f499$var$fromInputValue,
    parse: $31e34189bd28f499$var$parse
};

});
parcelRegister("g10CX", function(module, exports) {
!function(t, i) {
    module.exports = i();
}(module.exports, function() {
    "use strict";
    var t = "minute", i = /[+-]\d\d(?::?\d\d)?/g, e = /([+-]|\d\d)/g;
    return function(s, f, n) {
        var u = f.prototype;
        n.utc = function(t) {
            var i = {
                date: t,
                utc: !0,
                args: arguments
            };
            return new f(i);
        }, u.utc = function(i) {
            var e = n(this.toDate(), {
                locale: this.$L,
                utc: !0
            });
            return i ? e.add(this.utcOffset(), t) : e;
        }, u.local = function() {
            return n(this.toDate(), {
                locale: this.$L,
                utc: !1
            });
        };
        var r = u.parse;
        u.parse = function(t) {
            t.utc && (this.$u = !0), this.$utils().u(t.$offset) || (this.$offset = t.$offset), r.call(this, t);
        };
        var o = u.init;
        u.init = function() {
            if (this.$u) {
                var t = this.$d;
                this.$y = t.getUTCFullYear(), this.$M = t.getUTCMonth(), this.$D = t.getUTCDate(), this.$W = t.getUTCDay(), this.$H = t.getUTCHours(), this.$m = t.getUTCMinutes(), this.$s = t.getUTCSeconds(), this.$ms = t.getUTCMilliseconds();
            } else o.call(this);
        };
        var a = u.utcOffset;
        u.utcOffset = function(s, f) {
            var n = this.$utils().u;
            if (n(s)) return this.$u ? 0 : n(this.$offset) ? a.call(this) : this.$offset;
            if ("string" == typeof s && (s = function(t) {
                void 0 === t && (t = "");
                var s = t.match(i);
                if (!s) return null;
                var f = ("" + s[0]).match(e) || [
                    "-",
                    0,
                    0
                ], n = f[0], u = 60 * +f[1] + +f[2];
                return 0 === u ? 0 : "+" === n ? u : -u;
            }(s), null === s)) return this;
            var u = Math.abs(s) <= 16 ? 60 * s : s;
            if (0 === u) return this.utc(f);
            var r = this.clone();
            if (f) return r.$offset = u, r.$u = !1, r;
            var o = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
            return (r = this.local().add(u + o, t)).$offset = u, r.$x.$localOffset = o, r;
        };
        var h = u.format;
        u.format = function(t) {
            var i = t || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
            return h.call(this, i);
        }, u.valueOf = function() {
            var t = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
            return this.$d.valueOf() - 6e4 * t;
        }, u.isUTC = function() {
            return !!this.$u;
        }, u.toISOString = function() {
            return this.toDate().toISOString();
        }, u.toString = function() {
            return this.toDate().toUTCString();
        };
        var l = u.toDate;
        u.toDate = function(t) {
            return "s" === t && this.$offset ? n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : l.call(this);
        };
        var c = u.diff;
        u.diff = function(t, i, e) {
            if (t && this.$u === t.$u) return c.call(this, t, i, e);
            var s = this.local(), f = n(t).local();
            return c.call(s, f, i, e);
        };
    };
});

});

parcelRegister("jRT2Z", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = {
        year: 0,
        month: 1,
        day: 2,
        hour: 3,
        minute: 4,
        second: 5
    }, e = {};
    return function(n, i, r) {
        var o, a = function(t, n, i) {
            void 0 === i && (i = {});
            var r = new Date(t), o = function(t, n) {
                void 0 === n && (n = {});
                var i = n.timeZoneName || "short", r = t + "|" + i, o = e[r];
                return o || (o = new Intl.DateTimeFormat("en-US", {
                    hour12: !1,
                    timeZone: t,
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                    timeZoneName: i
                }), e[r] = o), o;
            }(n, i);
            return o.formatToParts(r);
        }, u = function(e, n) {
            for(var i = a(e, n), o = [], u = 0; u < i.length; u += 1){
                var f = i[u], s = f.type, m = f.value, c = t[s];
                c >= 0 && (o[c] = parseInt(m, 10));
            }
            var l = o[3], d = 24 === l ? 0 : l, h = o[0] + "-" + o[1] + "-" + o[2] + " " + d + ":" + o[4] + ":" + o[5] + ":000", v = +e;
            return (r.utc(h).valueOf() - (v -= v % 1e3)) / 6e4;
        }, f = i.prototype;
        f.tz = function(t, e) {
            if (void 0 === t && (t = o), !this.isValid()) return this;
            var n, i = this.utcOffset(), a = this.toDate(), f = a.toLocaleString("en-US", {
                timeZone: t
            }), s = u(+a, t);
            if (!Number(s)) n = this.utcOffset(0, e);
            else if (n = r(f, {
                locale: this.$L
            }).$set("millisecond", this.$ms).utcOffset(s, !0), e) {
                var m = n.utcOffset();
                n = n.add(i - m, "minute");
            }
            return n.$x.$timezone = t, n;
        }, f.offsetName = function(t) {
            var e = this.$x.$timezone || r.tz.guess(), n = a(this.valueOf(), e, {
                timeZoneName: t
            }).find(function(t) {
                return "timezonename" === t.type.toLowerCase();
            });
            return n && n.value;
        };
        var s = f.startOf;
        f.startOf = function(t, e) {
            if (!this.$x || !this.$x.$timezone) return s.call(this, t, e);
            var n = r(this.format("YYYY-MM-DD HH:mm:ss:SSS"), {
                locale: this.$L
            });
            return s.call(n, t, e).tz(this.$x.$timezone, !0);
        }, r.tz = function(t, e, n) {
            var i = n && e, a = n || e || o, f = u(+r(), a);
            if ("string" != typeof t) return r(t).tz(a);
            var s = r.utc(t, i).valueOf();
            if (Number.isNaN(s)) {
                var m = r(NaN);
                return m.$x.$timezone = a, m;
            }
            var c = function(t, e, n) {
                var i = t - 60 * e * 1e3, r = u(i, n);
                if (e === r) return [
                    i,
                    e
                ];
                var o = u(i -= 60 * (r - e) * 1e3, n);
                return r === o ? [
                    i,
                    r
                ] : [
                    t - 60 * Math.min(r, o) * 1e3,
                    Math.max(r, o)
                ];
            }(s, f, a), l = c[0], d = c[1], h = r(l).utcOffset(d);
            return h.$x.$timezone = a, h;
        }, r.tz.guess = function() {
            return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, r.tz.setDefault = function(t) {
            o = t;
        };
    };
});

});


parcelRegister("c3IWw", function(module, exports) {
'use strict';

var $2Z6Kw = parcelRequire("2Z6Kw");
var $8c78a08fabb12def$require$h1 = $2Z6Kw.h1;
var $8c78a08fabb12def$require$a = $2Z6Kw.a;
var $8c78a08fabb12def$require$div = $2Z6Kw.div;
var $8c78a08fabb12def$require$header = $2Z6Kw.header;
var $8c78a08fabb12def$require$section = $2Z6Kw.section;
var $8c78a08fabb12def$require$button = $2Z6Kw.button;
var $8c78a08fabb12def$require$span = $2Z6Kw.span;
var $8c78a08fabb12def$require$ul = $2Z6Kw.ul;
var $8c78a08fabb12def$require$li = $2Z6Kw.li;
var $8c78a08fabb12def$require$br = $2Z6Kw.br;
var $8c78a08fabb12def$require$table = $2Z6Kw.table;
var $8c78a08fabb12def$require$thead = $2Z6Kw.thead;
var $8c78a08fabb12def$require$tbody = $2Z6Kw.tbody;
var $8c78a08fabb12def$require$tr = $2Z6Kw.tr;
var $8c78a08fabb12def$require$th = $2Z6Kw.th;
var $8c78a08fabb12def$require$td = $2Z6Kw.td;
var $8c78a08fabb12def$require$form = $2Z6Kw.form;
var $8c78a08fabb12def$require$input = $2Z6Kw.input;
var $8c78a08fabb12def$require$label = $2Z6Kw.label;
var $8c78a08fabb12def$require$fieldset = $2Z6Kw.fieldset;
var $8c78a08fabb12def$require$legend = $2Z6Kw.legend;
var $8c78a08fabb12def$require$select = $2Z6Kw.select;
var $8c78a08fabb12def$require$option = $2Z6Kw.option;
var $8c78a08fabb12def$require$textarea = $2Z6Kw.textarea;

var $jjnZg = parcelRequire("jjnZg");
// lib
const { obj: $8c78a08fabb12def$var$obj, str: $8c78a08fabb12def$var$str, arr: $8c78a08fabb12def$var$arr, fn: { pipe: $8c78a08fabb12def$var$pipe } } = $jjnZg;

var $3S4qV = parcelRequire("3S4qV");

var $ehn3l = parcelRequire("ehn3l");
var $8c78a08fabb12def$require$fieldLabel = $ehn3l.fieldLabel;
const $8c78a08fabb12def$var$set = (o, k, v)=>Object.assign(o, {
        [k]: v
    });
const $8c78a08fabb12def$var$trim = (s)=>s.trim();
const $8c78a08fabb12def$var$syncWidth = (text, parent, list)=>(console.log(text, parent, list), $8c78a08fabb12def$var$set(text, 'style', `width: ${parent.clientWidth - list.clientWidth - 3}px`));
const $8c78a08fabb12def$var$removeVal = (target, val)=>$8c78a08fabb12def$var$pipe(()=>$3S4qV.select(target, `.form-multiple > input[type="hidden"]`, true), (el)=>(console.log(target, el), el), (el)=>el && ($8c78a08fabb12def$var$set(el, 'value', $8c78a08fabb12def$var$arr.toggle(el.value.split(',').map($8c78a08fabb12def$var$trim).filter(Boolean), val).join(', ')), console.log(target.parentNode.parentNode, target.parentNode), setTimeout(()=>$8c78a08fabb12def$var$syncWidth($3S4qV.select(el, '.tail', true), el.parentNode, $3S4qV.select(el, 'ul', true))), target.parentNode.parentNode.removeChild(target.parentNode)))();
module.exports = ({ field: field, value: value = [], i18n: i18n = {} })=>(console.log(field, value), $8c78a08fabb12def$require$div(`.field`, [
        field.name.split('.').length === 1 ? $8c78a08fabb12def$require$label([
            $8c78a08fabb12def$require$fieldLabel(i18n, field.name.split('.').pop()),
            ': '
        ]) : '',
        $8c78a08fabb12def$require$div(`.form-multiple`, [
            $8c78a08fabb12def$require$input({
                attrs: {
                    type: 'hidden',
                    name: field.name,
                    value: value.join(', ')
                },
                on: {
                    change: (ev)=>$8c78a08fabb12def$var$syncWidth($3S4qV.select(ev.target, '.tail', true), $3S4qV.select(ev.target, '.form-multiple', true), $3S4qV.select(ev.target, 'ul', true))
                }
            }),
            $8c78a08fabb12def$require$ul(value.map((val)=>$8c78a08fabb12def$require$li([
                    $8c78a08fabb12def$require$span(val),
                    $8c78a08fabb12def$require$button(`.fa.fa-times-circle`, {
                        on: {
                            click: (ev)=>$8c78a08fabb12def$var$removeVal(ev.target, val)
                        }
                    })
                ]))),
            $8c78a08fabb12def$require$input(`.tail[type="text"]`, {
                on: {
                    input: (ev)=>ev.data === ',' ? $8c78a08fabb12def$var$pipe(()=>({
                                el: $3S4qV.select(ev.target, `.form-multiple > input[type="hidden"]`, true),
                                value: ev.target.value.replace(',', '').trim()
                            }), ({ el: el, value: value })=>($8c78a08fabb12def$var$set(el, 'value', $8c78a08fabb12def$var$arr.add(el.value.split(',').map($8c78a08fabb12def$var$trim).filter(Boolean), value).join(', ')), $3S4qV.append($3S4qV.select(el.parentNode, 'ul'), $3S4qV.create('li', {
                                innerHTML: `<span>${value}</span><button class="fa fa-times-circle"></button>`
                            })), $3S4qV.on($3S4qV.select(el.parentNode, 'ul > li:last-child > button'), 'click', (ev)=>$8c78a08fabb12def$var$removeVal(ev.target, value)), $8c78a08fabb12def$var$syncWidth(ev.target, ev.target.parentNode, $3S4qV.select(el.parentNode, 'ul'))), ()=>$8c78a08fabb12def$var$set(ev.target, 'value', ''))() : []
                },
                hook: {
                    insert: ({ elm: elm })=>$8c78a08fabb12def$var$syncWidth(elm, elm.parentNode, $3S4qV.select(elm, 'ul', true)),
                    update: ({ elm: elm })=>$8c78a08fabb12def$var$syncWidth(elm, elm.parentNode, $3S4qV.select(elm, 'ul', true))
                }
            })
        ])
    ]));

});
parcelRegister("3S4qV", function(module, exports) {
'use strict';

var $jjnZg = parcelRequire("jjnZg");
const { obj: $2d19da9cdec12bca$var$obj, str: $2d19da9cdec12bca$var$str, arr: $2d19da9cdec12bca$var$arr, fn: { pipe: $2d19da9cdec12bca$var$pipe } } = $jjnZg;
// some dom manipulation functions here
// select html dom element
const $2d19da9cdec12bca$var$select = (el, q, recursive = false)=>$2d19da9cdec12bca$var$pipe(()=>el.querySelectorAll(q), // res => (console.log(el, res), res),
    (res)=>recursive && !(res instanceof HTMLElement) && res.length === 0 && el.parentNode ? $2d19da9cdec12bca$var$select(el.parentNode, q, recursive) : res, (res)=>res instanceof HTMLElement ? res : res.length ? Array.from(res) : [], (res)=>res.length === 1 ? res[0] : res)();
// append child to el
const $2d19da9cdec12bca$var$append = (el, child)=>(console.log(el), el.appendChild(child), el);
// set prop to element
const $2d19da9cdec12bca$var$set = (el, prop, value)=>Object.assign(el, {
        [prop]: value
    });
// create dom element, apply props and add children
const $2d19da9cdec12bca$var$create = (tag, props, children = [])=>children.reduce((el, child)=>$2d19da9cdec12bca$var$append(el, child), Object.keys(props).reduce((el, prop)=>$2d19da9cdec12bca$var$set(el, prop, props[prop]), document.createElement(tag.toUpperCase())));
// attach event listener
const $2d19da9cdec12bca$var$on = (el, event, callback)=>el instanceof HTMLElement ? el.addEventListener(event, callback) : typeof el === 'string' ? $2d19da9cdec12bca$var$pipe(()=>$2d19da9cdec12bca$var$select(document, el), (els)=>els.length ? els.forEach((el)=>$2d19da9cdec12bca$var$on(el, event, callback)) : $2d19da9cdec12bca$var$on(els, event, callback))() : console.log(el);
module.exports = {
    select: $2d19da9cdec12bca$var$select,
    create: $2d19da9cdec12bca$var$create,
    append: $2d19da9cdec12bca$var$append,
    on: $2d19da9cdec12bca$var$on
};

});


parcelRegister("kGspc", function(module, exports) {
'use strict';

var $2Z6Kw = parcelRequire("2Z6Kw");
var $f0edc39f8c702ee5$require$h1 = $2Z6Kw.h1;
var $f0edc39f8c702ee5$require$a = $2Z6Kw.a;
var $f0edc39f8c702ee5$require$div = $2Z6Kw.div;
var $f0edc39f8c702ee5$require$header = $2Z6Kw.header;
var $f0edc39f8c702ee5$require$section = $2Z6Kw.section;
var $f0edc39f8c702ee5$require$button = $2Z6Kw.button;
var $f0edc39f8c702ee5$require$span = $2Z6Kw.span;
var $f0edc39f8c702ee5$require$ul = $2Z6Kw.ul;
var $f0edc39f8c702ee5$require$li = $2Z6Kw.li;
var $f0edc39f8c702ee5$require$br = $2Z6Kw.br;
var $f0edc39f8c702ee5$require$img = $2Z6Kw.img;
var $f0edc39f8c702ee5$require$i = $2Z6Kw.i;
var $f0edc39f8c702ee5$require$table = $2Z6Kw.table;
var $f0edc39f8c702ee5$require$thead = $2Z6Kw.thead;
var $f0edc39f8c702ee5$require$tbody = $2Z6Kw.tbody;
var $f0edc39f8c702ee5$require$tr = $2Z6Kw.tr;
var $f0edc39f8c702ee5$require$th = $2Z6Kw.th;
var $f0edc39f8c702ee5$require$td = $2Z6Kw.td;
var $f0edc39f8c702ee5$require$form = $2Z6Kw.form;
var $f0edc39f8c702ee5$require$input = $2Z6Kw.input;
var $f0edc39f8c702ee5$require$label = $2Z6Kw.label;
var $f0edc39f8c702ee5$require$fieldset = $2Z6Kw.fieldset;
var $f0edc39f8c702ee5$require$legend = $2Z6Kw.legend;
var $f0edc39f8c702ee5$require$select = $2Z6Kw.select;
var $f0edc39f8c702ee5$require$option = $2Z6Kw.option;
var $f0edc39f8c702ee5$require$textarea = $2Z6Kw.textarea;

var $jjnZg = parcelRequire("jjnZg");
// util
const { obj: $f0edc39f8c702ee5$var$obj, str: $f0edc39f8c702ee5$var$str, arr: $f0edc39f8c702ee5$var$arr, fn: { pipe: $f0edc39f8c702ee5$var$pipe } } = $jjnZg;
parcelRequire("3S4qV");

var $5vl5m = parcelRequire("5vl5m");

var $ehn3l = parcelRequire("ehn3l");
var $f0edc39f8c702ee5$require$fieldLabel = $ehn3l.fieldLabel;
const $f0edc39f8c702ee5$var$set = (o, k, v)=>Object.assign(o, {
        [k]: v
    });
const $f0edc39f8c702ee5$var$trim = (s)=>s.trim();
module.exports = ({ sel: sel = '.field', field: field, value: value = [], update: update = ()=>{}, i18n: i18n = {} })=>$f0edc39f8c702ee5$require$div('.field', [
        field.name.split('.').length === 1 ? $f0edc39f8c702ee5$require$label([
            $f0edc39f8c702ee5$require$fieldLabel(i18n, field.name.split('.').pop()),
            ': '
        ]) : '',
        $f0edc39f8c702ee5$require$div(`.col-sm-10`, [].concat(value.map((image)=>$f0edc39f8c702ee5$require$div(`.col-xs-4.col-md-2`, $f0edc39f8c702ee5$require$a(`.thumbnail[title=""]`, {
                style: {
                    width: '100%',
                    textAlign: 'center'
                },
                on: {
                    click: ()=>{}
                }
            }, $f0edc39f8c702ee5$require$img({
                attrs: {
                    src: `data:image/gif;base64,${image}`
                },
                style: {
                    textAlign: 'center',
                    maxWidth: '100%',
                    maxHeight: '100%'
                }
            })))), $f0edc39f8c702ee5$require$div(`.col-xs-4.col-md-2`, $f0edc39f8c702ee5$require$a(`.thumbnail[title="add new image"]`, {
            on: {
                click: ()=>$5vl5m.openDialog((files)=>$5vl5m.load(files[0], 'arrayBuffer').subscribe((content)=>{
                            let base64String = btoa(new Uint8Array(content).reduce((data, byte)=>`${data}${String.fromCharCode(byte)}`, ''));
                            console.log(update);
                            update(field.name.split('.'), [].concat(value, base64String));
                            console.log(content, base64String);
                        }))
            }
        }, $f0edc39f8c702ee5$require$i(`.fa.fa-plus`, {
            style: {
                textAlign: 'center',
                fontSize: '2em',
                width: '100%',
                height: '36px',
                lineHeight: '36px'
            }
        })))))
    ]);

});
parcelRegister("5vl5m", function(module, exports) {
'use strict';

var $aIPjU = parcelRequire("aIPjU");
var $drQX9 = parcelRequire("drQX9");
var $gN3J6 = parcelRequire("gN3J6");
var $a68Z4 = parcelRequire("a68Z4");
var $402034278e652d5b$require$Observable = $gN3J6.Observable;
var $402034278e652d5b$require$from = $aIPjU.from;
var $402034278e652d5b$require$of = $a68Z4.of;

var $aIPjU = parcelRequire("aIPjU");
var $drQX9 = parcelRequire("drQX9");
var $gN3J6 = parcelRequire("gN3J6");
var $a68Z4 = parcelRequire("a68Z4");
var $402034278e652d5b$require$mergeMap = $drQX9.mergeMap;

var $jjnZg = parcelRequire("jjnZg");
var $402034278e652d5b$require$fn = $jjnZg.fn;
const $402034278e652d5b$var$openDialog = (cb)=>{
    let fileEl = document.createElement('input');
    fileEl.setAttribute('type', 'file');
    fileEl.addEventListener('change', (ev)=>{
        console.log(ev.target.files, module.exports);
        cb(ev.target.files);
    });
    fileEl.dispatchEvent(new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true
    }));
};
const $402034278e652d5b$var$load = (file, readAs = 'text')=>new $402034278e652d5b$require$Observable((subscriber)=>{
        const fr = new FileReader();
        fr.onload = function(ev) {
            subscriber.next(readAs === 'json' ? JSON.parse(ev.target.result) : ev.target.result);
            subscriber.complete();
        };
        (typeof file === 'string' ? $402034278e652d5b$require$from(fetch(file)).pipe($402034278e652d5b$require$mergeMap((res)=>$402034278e652d5b$require$from(res.blob()))) : $402034278e652d5b$require$of(file)).subscribe((f)=>$402034278e652d5b$require$fn.switch(readAs, {
                arrayBuffer: (f)=>fr.readAsArrayBuffer(f),
                default: (f)=>fr.readAsText(f)
            })(f));
    });
module.exports = {
    openDialog: $402034278e652d5b$var$openDialog,
    load: $402034278e652d5b$var$load
};

});
parcelRegister("aIPjU", function(module, exports) {

$parcel$export(module.exports, "from", () => $7ce5d289b5184c6b$export$6788812c4e6611e6);

var $dKd2f = parcelRequire("dKd2f");

var $kA4PZ = parcelRequire("kA4PZ");
function $7ce5d289b5184c6b$export$6788812c4e6611e6(input, scheduler) {
    return scheduler ? (0, $dKd2f.scheduled)(input, scheduler) : (0, $kA4PZ.innerFrom)(input);
}

});
parcelRegister("dKd2f", function(module, exports) {

$parcel$export(module.exports, "scheduled", () => $a019aecb764db494$export$49c44dfc2bb21d70);

var $9r8N2 = parcelRequire("9r8N2");

var $74NcO = parcelRequire("74NcO");

var $8ggmu = parcelRequire("8ggmu");

var $b9aB1 = parcelRequire("b9aB1");

var $hyfii = parcelRequire("hyfii");

var $5THWY = parcelRequire("5THWY");

var $3kIRy = parcelRequire("3kIRy");

var $deWbE = parcelRequire("deWbE");

var $k5iK4 = parcelRequire("k5iK4");

var $7EGUs = parcelRequire("7EGUs");

var $eNbzY = parcelRequire("eNbzY");

var $Xuqb1 = parcelRequire("Xuqb1");

var $iXq3J = parcelRequire("iXq3J");
function $a019aecb764db494$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $5THWY.isInteropObservable)(input)) return (0, $9r8N2.scheduleObservable)(input, scheduler);
        if ((0, $deWbE.isArrayLike)(input)) return (0, $8ggmu.scheduleArray)(input, scheduler);
        if ((0, $3kIRy.isPromise)(input)) return (0, $74NcO.schedulePromise)(input, scheduler);
        if ((0, $7EGUs.isAsyncIterable)(input)) return (0, $hyfii.scheduleAsyncIterable)(input, scheduler);
        if ((0, $k5iK4.isIterable)(input)) return (0, $b9aB1.scheduleIterable)(input, scheduler);
        if ((0, $Xuqb1.isReadableStreamLike)(input)) return (0, $iXq3J.scheduleReadableStreamLike)(input, scheduler);
    }
    throw (0, $eNbzY.createInvalidObservableTypeError)(input);
}

});
parcelRegister("9r8N2", function(module, exports) {

$parcel$export(module.exports, "scheduleObservable", () => $6ded7429c90fe31e$export$ed8bd553a12b6a30);

var $kA4PZ = parcelRequire("kA4PZ");

var $jsLpm = parcelRequire("jsLpm");

var $hOWB1 = parcelRequire("hOWB1");
function $6ded7429c90fe31e$export$ed8bd553a12b6a30(input, scheduler) {
    return (0, $kA4PZ.innerFrom)(input).pipe((0, $hOWB1.subscribeOn)(scheduler), (0, $jsLpm.observeOn)(scheduler));
}

});
parcelRegister("kA4PZ", function(module, exports) {

$parcel$export(module.exports, "innerFrom", () => $efbaec1979d81ee1$export$6a9cfa3ebc765910);

var $ceFTv = parcelRequire("ceFTv");

var $deWbE = parcelRequire("deWbE");

var $3kIRy = parcelRequire("3kIRy");

var $gN3J6 = parcelRequire("gN3J6");

var $5THWY = parcelRequire("5THWY");

var $7EGUs = parcelRequire("7EGUs");

var $eNbzY = parcelRequire("eNbzY");

var $k5iK4 = parcelRequire("k5iK4");

var $Xuqb1 = parcelRequire("Xuqb1");

var $dFWVS = parcelRequire("dFWVS");

var $ZIGxP = parcelRequire("ZIGxP");

var $lzR1Z = parcelRequire("lzR1Z");
function $efbaec1979d81ee1$export$6a9cfa3ebc765910(input) {
    if (input instanceof (0, $gN3J6.Observable)) return input;
    if (input != null) {
        if ((0, $5THWY.isInteropObservable)(input)) return $efbaec1979d81ee1$export$aa3d41784b3267fa(input);
        if ((0, $deWbE.isArrayLike)(input)) return $efbaec1979d81ee1$export$4cb2acdbcda2c253(input);
        if ((0, $3kIRy.isPromise)(input)) return $efbaec1979d81ee1$export$60f45028237c39d1(input);
        if ((0, $7EGUs.isAsyncIterable)(input)) return $efbaec1979d81ee1$export$e073fccf36d78cc1(input);
        if ((0, $k5iK4.isIterable)(input)) return $efbaec1979d81ee1$export$dcccc29c315dd646(input);
        if ((0, $Xuqb1.isReadableStreamLike)(input)) return $efbaec1979d81ee1$export$b2dcb11d46e7a4ad(input);
    }
    throw (0, $eNbzY.createInvalidObservableTypeError)(input);
}
function $efbaec1979d81ee1$export$aa3d41784b3267fa(obj) {
    return new (0, $gN3J6.Observable)(function(subscriber) {
        var obs = obj[0, $lzR1Z.observable]();
        if ((0, $dFWVS.isFunction)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
}
function $efbaec1979d81ee1$export$4cb2acdbcda2c253(array) {
    return new (0, $gN3J6.Observable)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function $efbaec1979d81ee1$export$60f45028237c39d1(promise) {
    return new (0, $gN3J6.Observable)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $ZIGxP.reportUnhandledError));
    });
}
function $efbaec1979d81ee1$export$dcccc29c315dd646(iterable) {
    return new (0, $gN3J6.Observable)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, $ceFTv.__values)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function $efbaec1979d81ee1$export$e073fccf36d78cc1(asyncIterable) {
    return new (0, $gN3J6.Observable)(function(subscriber) {
        $efbaec1979d81ee1$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function $efbaec1979d81ee1$export$b2dcb11d46e7a4ad(readableStream) {
    return $efbaec1979d81ee1$export$e073fccf36d78cc1((0, $Xuqb1.readableStreamLikeToAsyncGenerator)(readableStream));
}
function $efbaec1979d81ee1$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, $ceFTv.__awaiter)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, $ceFTv.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, $ceFTv.__asyncValues)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}

});
parcelRegister("deWbE", function(module, exports) {

$parcel$export(module.exports, "isArrayLike", () => $9a39b7dcf35b06dd$export$1e2f57719e155213);
var $9a39b7dcf35b06dd$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === 'number' && typeof x !== 'function';
};

});

parcelRegister("3kIRy", function(module, exports) {

$parcel$export(module.exports, "isPromise", () => $26d60a2a32edbe86$export$4369c812aac99591);

var $dFWVS = parcelRequire("dFWVS");
function $26d60a2a32edbe86$export$4369c812aac99591(value) {
    return (0, $dFWVS.isFunction)(value === null || value === void 0 ? void 0 : value.then);
}

});

parcelRegister("gN3J6", function(module, exports) {

$parcel$export(module.exports, "Observable", () => $c3941cf54d4aa4ba$export$77cea355fa80b5f4);

var $dUP5u = parcelRequire("dUP5u");

var $fgwAY = parcelRequire("fgwAY");

var $lzR1Z = parcelRequire("lzR1Z");

var $lrpjn = parcelRequire("lrpjn");

var $1Dr3d = parcelRequire("1Dr3d");

var $dFWVS = parcelRequire("dFWVS");

var $iQsM4 = parcelRequire("iQsM4");
var $c3941cf54d4aa4ba$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $c3941cf54d4aa4ba$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $dUP5u.SafeSubscriber)(observerOrNext, error, complete);
        (0, $iQsM4.errorContext)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $c3941cf54d4aa4ba$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $dUP5u.SafeSubscriber)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $lzR1Z.observable] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $lrpjn.pipeFromArray)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $c3941cf54d4aa4ba$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $c3941cf54d4aa4ba$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $1Dr3d.config).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $c3941cf54d4aa4ba$var$isObserver(value) {
    return value && (0, $dFWVS.isFunction)(value.next) && (0, $dFWVS.isFunction)(value.error) && (0, $dFWVS.isFunction)(value.complete);
}
function $c3941cf54d4aa4ba$var$isSubscriber(value) {
    return value && value instanceof (0, $dUP5u.Subscriber) || $c3941cf54d4aa4ba$var$isObserver(value) && (0, $fgwAY.isSubscription)(value);
}

});
parcelRegister("lzR1Z", function(module, exports) {

$parcel$export(module.exports, "observable", () => $fb5600b8b605d96c$export$5ab46cbf6120b33a);
var $fb5600b8b605d96c$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();

});

parcelRegister("lrpjn", function(module, exports) {

$parcel$export(module.exports, "pipeFromArray", () => $f9bfc0ec752e7991$export$71f88a61afaa14d7);

var $hYEnO = parcelRequire("hYEnO");
function $f9bfc0ec752e7991$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $f9bfc0ec752e7991$export$71f88a61afaa14d7(fns);
}
function $f9bfc0ec752e7991$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $hYEnO.identity;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}

});
parcelRegister("hYEnO", function(module, exports) {

$parcel$export(module.exports, "identity", () => $d1675d7b83173212$export$f0954fd7d5368655);
function $d1675d7b83173212$export$f0954fd7d5368655(x) {
    return x;
}

});



parcelRegister("5THWY", function(module, exports) {

$parcel$export(module.exports, "isInteropObservable", () => $44b42e641422b891$export$48c0cddbc99c45c2);

var $lzR1Z = parcelRequire("lzR1Z");

var $dFWVS = parcelRequire("dFWVS");
function $44b42e641422b891$export$48c0cddbc99c45c2(input) {
    return (0, $dFWVS.isFunction)(input[0, $lzR1Z.observable]);
}

});

parcelRegister("7EGUs", function(module, exports) {

$parcel$export(module.exports, "isAsyncIterable", () => $592d8dcd5a9b21b1$export$edb10ab8dd75a915);

var $dFWVS = parcelRequire("dFWVS");
function $592d8dcd5a9b21b1$export$edb10ab8dd75a915(obj) {
    return Symbol.asyncIterator && (0, $dFWVS.isFunction)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}

});

parcelRegister("eNbzY", function(module, exports) {

$parcel$export(module.exports, "createInvalidObservableTypeError", () => $ac4e9fb3b188f5d1$export$7cbe71b9fa263484);
function $ac4e9fb3b188f5d1$export$7cbe71b9fa263484(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}

});

parcelRegister("k5iK4", function(module, exports) {

$parcel$export(module.exports, "isIterable", () => $e9f2d015065e1e76$export$9652023d9040757);

var $624cO = parcelRequire("624cO");

var $dFWVS = parcelRequire("dFWVS");
function $e9f2d015065e1e76$export$9652023d9040757(input) {
    return (0, $dFWVS.isFunction)(input === null || input === void 0 ? void 0 : input[0, $624cO.iterator]);
}

});
parcelRegister("624cO", function(module, exports) {

$parcel$export(module.exports, "iterator", () => $4646311d9288ad3b$export$6f58e2338da23f4d);
function $4646311d9288ad3b$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) return '@@iterator';
    return Symbol.iterator;
}
var $4646311d9288ad3b$export$6f58e2338da23f4d = $4646311d9288ad3b$export$aa9956be4ae4fe8();

});


parcelRegister("Xuqb1", function(module, exports) {

$parcel$export(module.exports, "readableStreamLikeToAsyncGenerator", () => $0b2d1bd226c6ae7a$export$cf4785e597badab3);
$parcel$export(module.exports, "isReadableStreamLike", () => $0b2d1bd226c6ae7a$export$c088ffafdba7405f);

var $ceFTv = parcelRequire("ceFTv");

var $dFWVS = parcelRequire("dFWVS");
function $0b2d1bd226c6ae7a$export$cf4785e597badab3(readableStream) {
    return (0, $ceFTv.__asyncGenerator)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, $ceFTv.__generator)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, $ceFTv.__await)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $ceFTv.__await)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, $ceFTv.__await)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function $0b2d1bd226c6ae7a$export$c088ffafdba7405f(obj) {
    return (0, $dFWVS.isFunction)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}

});


parcelRegister("jsLpm", function(module, exports) {

$parcel$export(module.exports, "observeOn", () => $e2b56815ecd2be16$export$9007f49c319d1ac7);

var $aj4TV = parcelRequire("aj4TV");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $e2b56815ecd2be16$export$9007f49c319d1ac7(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $iZT3c.operate)(function(source, subscriber) {
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            return (0, $aj4TV.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, $aj4TV.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, $aj4TV.executeSchedule)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}

});
parcelRegister("aj4TV", function(module, exports) {

$parcel$export(module.exports, "executeSchedule", () => $780f7af860c3a5ff$export$a2b7447487315232);
function $780f7af860c3a5ff$export$a2b7447487315232(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}

});


parcelRegister("hOWB1", function(module, exports) {

$parcel$export(module.exports, "subscribeOn", () => $cf948f2287cf1d0f$export$1eb44d8f5f64733b);

var $iZT3c = parcelRequire("iZT3c");
function $cf948f2287cf1d0f$export$1eb44d8f5f64733b(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $iZT3c.operate)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}

});


parcelRegister("74NcO", function(module, exports) {

$parcel$export(module.exports, "schedulePromise", () => $526f135d9ae5f351$export$fc9afd948577f0a8);

var $kA4PZ = parcelRequire("kA4PZ");

var $jsLpm = parcelRequire("jsLpm");

var $hOWB1 = parcelRequire("hOWB1");
function $526f135d9ae5f351$export$fc9afd948577f0a8(input, scheduler) {
    return (0, $kA4PZ.innerFrom)(input).pipe((0, $hOWB1.subscribeOn)(scheduler), (0, $jsLpm.observeOn)(scheduler));
}

});

parcelRegister("8ggmu", function(module, exports) {

$parcel$export(module.exports, "scheduleArray", () => $603c82704db88b23$export$b34673931371729a);

var $gN3J6 = parcelRequire("gN3J6");
function $603c82704db88b23$export$b34673931371729a(input, scheduler) {
    return new (0, $gN3J6.Observable)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}

});

parcelRegister("b9aB1", function(module, exports) {

$parcel$export(module.exports, "scheduleIterable", () => $81d8c1228c5c8d3e$export$2b75c58ab9b5b766);

var $gN3J6 = parcelRequire("gN3J6");

var $624cO = parcelRequire("624cO");

var $dFWVS = parcelRequire("dFWVS");

var $aj4TV = parcelRequire("aj4TV");
function $81d8c1228c5c8d3e$export$2b75c58ab9b5b766(input, scheduler) {
    return new (0, $gN3J6.Observable)(function(subscriber) {
        var iterator;
        (0, $aj4TV.executeSchedule)(subscriber, scheduler, function() {
            iterator = input[0, $624cO.iterator]();
            (0, $aj4TV.executeSchedule)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, $dFWVS.isFunction)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}

});

parcelRegister("hyfii", function(module, exports) {

$parcel$export(module.exports, "scheduleAsyncIterable", () => $cc7179c0e97e93d0$export$7c7f0979b56a32f3);

var $gN3J6 = parcelRequire("gN3J6");

var $aj4TV = parcelRequire("aj4TV");
function $cc7179c0e97e93d0$export$7c7f0979b56a32f3(input, scheduler) {
    if (!input) throw new Error('Iterable cannot be null');
    return new (0, $gN3J6.Observable)(function(subscriber) {
        (0, $aj4TV.executeSchedule)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, $aj4TV.executeSchedule)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}

});

parcelRegister("iXq3J", function(module, exports) {

$parcel$export(module.exports, "scheduleReadableStreamLike", () => $dcd1f37ffc5e3a09$export$3385251aeecad28a);

var $hyfii = parcelRequire("hyfii");

var $Xuqb1 = parcelRequire("Xuqb1");
function $dcd1f37ffc5e3a09$export$3385251aeecad28a(input, scheduler) {
    return (0, $hyfii.scheduleAsyncIterable)((0, $Xuqb1.readableStreamLikeToAsyncGenerator)(input), scheduler);
}

});



parcelRegister("drQX9", function(module, exports) {

$parcel$export(module.exports, "mergeMap", () => $9ca6df5404eb8e3a$export$6b9f6c0d32c093f9);

var $6SBin = parcelRequire("6SBin");

var $kA4PZ = parcelRequire("kA4PZ");

var $iZT3c = parcelRequire("iZT3c");

var $bqdkM = parcelRequire("bqdkM");

var $dFWVS = parcelRequire("dFWVS");
function $9ca6df5404eb8e3a$export$6b9f6c0d32c093f9(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, $dFWVS.isFunction)(resultSelector)) return $9ca6df5404eb8e3a$export$6b9f6c0d32c093f9(function(a, i) {
        return (0, $6SBin.map)(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })((0, $kA4PZ.innerFrom)(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === 'number') concurrent = resultSelector;
    return (0, $iZT3c.operate)(function(source, subscriber) {
        return (0, $bqdkM.mergeInternals)(source, subscriber, project, concurrent);
    });
}

});
parcelRegister("6SBin", function(module, exports) {

$parcel$export(module.exports, "map", () => $5024b74c40e3eace$export$871de8747c9eaa88);

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $5024b74c40e3eace$export$871de8747c9eaa88(project, thisArg) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}

});

parcelRegister("bqdkM", function(module, exports) {

$parcel$export(module.exports, "mergeInternals", () => $850c775404996a72$export$600918ebaa9e0a1b);

var $kA4PZ = parcelRequire("kA4PZ");

var $aj4TV = parcelRequire("aj4TV");

var $lo1Ce = parcelRequire("lo1Ce");
function $850c775404996a72$export$600918ebaa9e0a1b(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        (0, $kA4PZ.innerFrom)(project(value, index++)).subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) (0, $aj4TV.executeSchedule)(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}

});


parcelRegister("a68Z4", function(module, exports) {

$parcel$export(module.exports, "of", () => $75a16ef51bd88dd7$export$ba255e9e49e00608);

var $6kN4i = parcelRequire("6kN4i");

var $aIPjU = parcelRequire("aIPjU");
function $75a16ef51bd88dd7$export$ba255e9e49e00608() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $6kN4i.popScheduler)(args);
    return (0, $aIPjU.from)(args, scheduler);
}

});
parcelRegister("6kN4i", function(module, exports) {

$parcel$export(module.exports, "popResultSelector", () => $49caac480e766f10$export$9ae19b645239a61b);
$parcel$export(module.exports, "popScheduler", () => $49caac480e766f10$export$29534b2f653ae592);
$parcel$export(module.exports, "popNumber", () => $49caac480e766f10$export$3de14b735070dcd5);

var $dFWVS = parcelRequire("dFWVS");

var $iYL21 = parcelRequire("iYL21");
function $49caac480e766f10$var$last(arr) {
    return arr[arr.length - 1];
}
function $49caac480e766f10$export$9ae19b645239a61b(args) {
    return (0, $dFWVS.isFunction)($49caac480e766f10$var$last(args)) ? args.pop() : undefined;
}
function $49caac480e766f10$export$29534b2f653ae592(args) {
    return (0, $iYL21.isScheduler)($49caac480e766f10$var$last(args)) ? args.pop() : undefined;
}
function $49caac480e766f10$export$3de14b735070dcd5(args, defaultValue) {
    return typeof $49caac480e766f10$var$last(args) === 'number' ? args.pop() : defaultValue;
}

});
parcelRegister("iYL21", function(module, exports) {

$parcel$export(module.exports, "isScheduler", () => $dd125016ed30f8c3$export$187e35932e88c15c);

var $dFWVS = parcelRequire("dFWVS");
function $dd125016ed30f8c3$export$187e35932e88c15c(value) {
    return value && (0, $dFWVS.isFunction)(value.schedule);
}

});





parcelRegister("5o8PO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3ec60c080c0ec333$export$2e2bcd8739ae039);

var $2Z6Kw = parcelRequire("2Z6Kw");

var $j1Rp6 = parcelRequire("j1Rp6");
var $gvBMK = parcelRequire("gvBMK");
var $6SBin = parcelRequire("6SBin");
var $5w0HR = parcelRequire("5w0HR");

var $amJim = parcelRequire("amJim");

var $bkA54 = parcelRequire("bkA54");

var $ehn3l = parcelRequire("ehn3l");
const $3ec60c080c0ec333$var$getParent = (el, tagName)=>[].concat(tagName).indexOf(el.tagName) === -1 ? $3ec60c080c0ec333$var$getParent(el.parentNode, tagName) : el;
const $3ec60c080c0ec333$var$isEditableFocused = (elm)=>elm === document.activeElement || elm.contains(document.activeElement);
const $3ec60c080c0ec333$var$applyHtml = (elm, content)=>{
    const html = (0, (/*@__PURE__*/$parcel$interopDefault($amJim))).toHTML(content || '<p><br></p>');
    if (elm.innerHTML !== html) elm.innerHTML = html;
};
var // innerHTML via hooks (not props) so contenteditable DOM mutations do not
// desync Snabbdom's vnode children — also fixes mode-switch stacking a
// second textarea under the rich-edit area.
$3ec60c080c0ec333$export$2e2bcd8739ae039 = ({ field: field, value: { content: content = '', pos: pos = {
    start: {
        row: 0,
        col: 0
    },
    end: {
        row: 0,
        col: 1
    }
}, mode: mode = 'wysiwyg' } = {}, update: update = ()=>{}, focused: focused = false, addons: addons = [], i18n: i18n = {}, langSwitcher: langSwitcher = null, contentKey: contentKey = '' })=>(0, $2Z6Kw.div)('.field', [
        field.name.split('.').length === 1 ? (0, $2Z6Kw.label)([
            (0, $ehn3l.fieldLabel)(i18n, field.name.split('.').pop()),
            ': '
        ]) : '',
        (0, $2Z6Kw.div)({
            key: `wysiwyg-root-${field.name}-${contentKey}`,
            class: {
                wysiwyg: true
            },
            attrs: {
                'data-mode': mode
            }
        }, [
            (0, $2Z6Kw.div)('.toolbox', [].concat((0, $2Z6Kw.ul)(`.left`, [].concat((0, $2Z6Kw.li)((0, $2Z6Kw.button)('.btn.btn-white.fa.fa-bold', {
                on: {
                    click: (ev)=>(ev.preventDefault(), document.execCommand('bold'))
                }
            })), (0, $2Z6Kw.li)((0, $2Z6Kw.button)('.btn.btn-white.fa.fa-italic', {
                on: {
                    click: (ev)=>(ev.preventDefault(), document.execCommand('italic'))
                }
            })), (0, $2Z6Kw.li)((0, $2Z6Kw.button)('.btn.btn-white.fa.fa-underline', {
                on: {
                    click: (ev)=>(ev.preventDefault(), document.execCommand('underline'))
                }
            })), (0, $2Z6Kw.li)('  '), (0, $2Z6Kw.li)((0, $2Z6Kw.button)('.btn.btn-white.fa.fa-list-ul', {
                on: {
                    click: (ev)=>(ev.preventDefault(), document.execCommand('insertUnorderedList'))
                }
            })), (0, $2Z6Kw.li)((0, $2Z6Kw.button)('.btn.btn-white.fa.fa-list-ol', {
                on: {
                    click: (ev)=>(ev.preventDefault(), document.execCommand('insertOrderedList'))
                }
            })), (0, $2Z6Kw.li)('  '), (0, $2Z6Kw.li)((0, $2Z6Kw.button)('.btn.btn-white.fa.fa-outdent', {
                on: {
                    click: (ev)=>(ev.preventDefault(), document.execCommand('outdent'))
                }
            })), (0, $2Z6Kw.li)((0, $2Z6Kw.button)('.btn.btn-white.fa.fa-indent', {
                on: {
                    click: (ev)=>(ev.preventDefault(), document.execCommand('indent'))
                }
            })))), (0, $2Z6Kw.ul)('.right', [].concat((0, $2Z6Kw.li)((0, $2Z6Kw.button)(`.btn.btn-white.fa.fa-code`, {
                class: {
                    active: mode === 'markdown'
                },
                on: {
                    click: (ev)=>(ev.preventDefault(), update(field.name.split('.'), {
                            content: content,
                            pos: pos,
                            mode: mode === 'wysiwyg' ? 'markdown' : 'wysiwyg'
                        }))
                }
            })), addons.map((addon)=>(0, $2Z6Kw.li)((0, $2Z6Kw.button)(`.btn.btn-white.fa.${addon.icon}[type="button"]`, {
                    on: {
                        click: (ev)=>addon.cb(field, {
                                content: (0, (/*@__PURE__*/$parcel$interopDefault($amJim))).fromHTML($3ec60c080c0ec333$var$getParent(ev.target, 'DIV').parentNode.querySelector('.wysiwyg').innerHTML)
                            })
                    }
                }))), langSwitcher ? (0, $2Z6Kw.li)('.field-lang-switch-wrap', langSwitcher) : [])))),
            (0, $2Z6Kw.div)({
                key: `wysiwyg-${field.name}-${contentKey}-${mode}`,
                attrs: {
                    contenteditable: 'true'
                },
                hook: {
                    insert: ({ elm: elm })=>{
                        $3ec60c080c0ec333$var$applyHtml(elm, content);
                        if (mode === 'wysiwyg' && focused) (0, (/*@__PURE__*/$parcel$interopDefault($bkA54))).set(elm, pos, 'p, li, div, h1, h2, h3, h4, h5');
                    },
                    update: (oldVnode, { elm: elm })=>{
                        // While typing, DOM is source of truth — rewriting/caret fights selection
                        if (!$3ec60c080c0ec333$var$isEditableFocused(elm)) $3ec60c080c0ec333$var$applyHtml(elm, content);
                    }
                },
                on: {
                    focus: ({ target: target })=>(0, $gvBMK.fromEvent)(target, 'input').pipe((0, $6SBin.map)((ev)=>ev.target), (0, $5w0HR.takeUntil)((0, $gvBMK.fromEvent)(target, 'blur')), (0, $j1Rp6.debounceTime)(500)).subscribe((el)=>update(field.name.split('.'), {
                                content: (0, (/*@__PURE__*/$parcel$interopDefault($amJim))).fromHTML(el.innerHTML),
                                pos: (0, (/*@__PURE__*/$parcel$interopDefault($bkA54))).get(el, 'p, li, div, h1, h2, h3, h4, h5'),
                                mode: mode
                            }))
                }
            }),
            (0, $2Z6Kw.textarea)({
                key: `md-${field.name}-${contentKey}-${mode}`,
                attrs: langSwitcher ? {} : {
                    name: field.name || field
                },
                hook: {
                    insert: ({ elm: elm })=>{
                        elm.value = content || '';
                    },
                    update: (oldVnode, { elm: elm })=>{
                        if (document.activeElement !== elm && elm.value !== (content || '')) elm.value = content || '';
                    }
                },
                on: {
                    focus: ({ target: target })=>(0, $gvBMK.fromEvent)(target, 'input').pipe((0, $6SBin.map)((ev)=>ev.target), (0, $5w0HR.takeUntil)((0, $gvBMK.fromEvent)(target, 'blur')), (0, $j1Rp6.debounceTime)(500)).subscribe(({ value: value })=>update(field.name.split('.'), {
                                content: value,
                                pos: pos,
                                mode: mode
                            }))
                }
            })
        ])
    ]);

});
parcelRegister("j1Rp6", function(module, exports) {

$parcel$export(module.exports, "debounceTime", () => $dda78935103f1d48$export$7843a4469d64c07e);

var $lbxJc = parcelRequire("lbxJc");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $dda78935103f1d48$export$7843a4469d64c07e(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = (0, $lbxJc.asyncScheduler);
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var activeTask = null;
        var lastValue = null;
        var lastTime = null;
        var emit = function() {
            if (activeTask) {
                activeTask.unsubscribe();
                activeTask = null;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        };
        function emitWhenIdle() {
            var targetTime = lastTime + dueTime;
            var now = scheduler.now();
            if (now < targetTime) {
                activeTask = this.schedule(undefined, targetTime - now);
                subscriber.add(activeTask);
                return;
            }
            emit();
        }
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            lastValue = value;
            lastTime = scheduler.now();
            if (!activeTask) {
                activeTask = scheduler.schedule(emitWhenIdle, dueTime);
                subscriber.add(activeTask);
            }
        }, function() {
            emit();
            subscriber.complete();
        }, undefined, function() {
            lastValue = activeTask = null;
        }));
    });
}

});
parcelRegister("lbxJc", function(module, exports) {

$parcel$export(module.exports, "asyncScheduler", () => $f6c4c9bd71b20294$export$8d6b71a2b178fc32);

var $dnZ34 = parcelRequire("dnZ34");

var $6hfhx = parcelRequire("6hfhx");
var $f6c4c9bd71b20294$export$8d6b71a2b178fc32 = new (0, $6hfhx.AsyncScheduler)((0, $dnZ34.AsyncAction));
var $f6c4c9bd71b20294$export$12af436354f1a4f7 = $f6c4c9bd71b20294$export$8d6b71a2b178fc32;

});
parcelRegister("dnZ34", function(module, exports) {

$parcel$export(module.exports, "AsyncAction", () => $9becc74b1b373225$export$b5369ffd7cb2211b);

var $ceFTv = parcelRequire("ceFTv");

var $5oSnx = parcelRequire("5oSnx");

var $hAVup = parcelRequire("hAVup");

var $ebAl1 = parcelRequire("ebAl1");
var $9becc74b1b373225$export$b5369ffd7cb2211b = function(_super) {
    (0, $ceFTv.__extends)(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, _id, delay) {
        if (delay === void 0) delay = 0;
        return (0, $hAVup.intervalProvider).setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(_scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay != null && this.delay === delay && this.pending === false) return id;
        if (id != null) (0, $hAVup.intervalProvider).clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error('executing a cancelled action');
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, _delay) {
        var errored = false;
        var errorValue;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = e ? e : new Error('Scheduled action threw falsy error');
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype.unsubscribe = function() {
        if (!this.closed) {
            var _a = this, id = _a.id, scheduler = _a.scheduler;
            var actions = scheduler.actions;
            this.work = this.state = this.scheduler = null;
            this.pending = false;
            (0, $ebAl1.arrRemove)(actions, this);
            if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
            this.delay = null;
            _super.prototype.unsubscribe.call(this);
        }
    };
    return AsyncAction;
}((0, $5oSnx.Action));

});
parcelRegister("5oSnx", function(module, exports) {

$parcel$export(module.exports, "Action", () => $3ee960211923e35c$export$e19cd5f9376f8cee);

var $ceFTv = parcelRequire("ceFTv");

var $fgwAY = parcelRequire("fgwAY");
var $3ee960211923e35c$export$e19cd5f9376f8cee = function(_super) {
    (0, $ceFTv.__extends)(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, $fgwAY.Subscription));

});

parcelRegister("hAVup", function(module, exports) {

$parcel$export(module.exports, "intervalProvider", () => $ccf264af78c278c5$export$f0ca5e16f6f68711);

var $ceFTv = parcelRequire("ceFTv");
var $ccf264af78c278c5$export$f0ca5e16f6f68711 = {
    setInterval: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $ccf264af78c278c5$export$f0ca5e16f6f68711.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) return delegate.setInterval.apply(delegate, (0, $ceFTv.__spreadArray)([
            handler,
            timeout
        ], (0, $ceFTv.__read)(args)));
        return setInterval.apply(void 0, (0, $ceFTv.__spreadArray)([
            handler,
            timeout
        ], (0, $ceFTv.__read)(args)));
    },
    clearInterval: function(handle) {
        var delegate = $ccf264af78c278c5$export$f0ca5e16f6f68711.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
    },
    delegate: undefined
};

});


parcelRegister("6hfhx", function(module, exports) {

$parcel$export(module.exports, "AsyncScheduler", () => $49202f47f01b459a$export$4114a3ec92faa3c6);

var $ceFTv = parcelRequire("ceFTv");

var $f68ij = parcelRequire("f68ij");
var $49202f47f01b459a$export$4114a3ec92faa3c6 = function(_super) {
    (0, $ceFTv.__extends)(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, $f68ij.Scheduler).now;
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        return _this;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this._active) {
            actions.push(action);
            return;
        }
        var error;
        this._active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this._active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, $f68ij.Scheduler));

});
parcelRegister("f68ij", function(module, exports) {

$parcel$export(module.exports, "Scheduler", () => $afddd99de6dafc81$export$d3e54bb8584cda7c);

var $ggeIx = parcelRequire("ggeIx");
var $afddd99de6dafc81$export$d3e54bb8584cda7c = function() {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) now = Scheduler.now;
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = (0, $ggeIx.dateTimestampProvider).now;
    return Scheduler;
}();

});
parcelRegister("ggeIx", function(module, exports) {

$parcel$export(module.exports, "dateTimestampProvider", () => $bd698e8115fc86c4$export$c1895ea2d519a677);
var $bd698e8115fc86c4$export$c1895ea2d519a677 = {
    now: function() {
        return ($bd698e8115fc86c4$export$c1895ea2d519a677.delegate || Date).now();
    },
    delegate: undefined
};

});





parcelRegister("gvBMK", function(module, exports) {

$parcel$export(module.exports, "fromEvent", () => $c04cd9fa17908b59$export$a36e16046ae8f1bb);

var $ceFTv = parcelRequire("ceFTv");

var $kA4PZ = parcelRequire("kA4PZ");

var $gN3J6 = parcelRequire("gN3J6");

var $drQX9 = parcelRequire("drQX9");

var $deWbE = parcelRequire("deWbE");

var $dFWVS = parcelRequire("dFWVS");

var $hYp6u = parcelRequire("hYp6u");
var $c04cd9fa17908b59$var$nodeEventEmitterMethods = [
    'addListener',
    'removeListener'
];
var $c04cd9fa17908b59$var$eventTargetMethods = [
    'addEventListener',
    'removeEventListener'
];
var $c04cd9fa17908b59$var$jqueryMethods = [
    'on',
    'off'
];
function $c04cd9fa17908b59$export$a36e16046ae8f1bb(target, eventName, options, resultSelector) {
    if ((0, $dFWVS.isFunction)(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) return $c04cd9fa17908b59$export$a36e16046ae8f1bb(target, eventName, options).pipe((0, $hYp6u.mapOneOrManyArgs)(resultSelector));
    var _a = (0, $ceFTv.__read)($c04cd9fa17908b59$var$isEventTarget(target) ? $c04cd9fa17908b59$var$eventTargetMethods.map(function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler, options);
        };
    }) : $c04cd9fa17908b59$var$isNodeStyleEventEmitter(target) ? $c04cd9fa17908b59$var$nodeEventEmitterMethods.map($c04cd9fa17908b59$var$toCommonHandlerRegistry(target, eventName)) : $c04cd9fa17908b59$var$isJQueryStyleEventEmitter(target) ? $c04cd9fa17908b59$var$jqueryMethods.map($c04cd9fa17908b59$var$toCommonHandlerRegistry(target, eventName)) : [], 2), add = _a[0], remove = _a[1];
    if (!add) {
        if ((0, $deWbE.isArrayLike)(target)) return (0, $drQX9.mergeMap)(function(subTarget) {
            return $c04cd9fa17908b59$export$a36e16046ae8f1bb(subTarget, eventName, options);
        })((0, $kA4PZ.innerFrom)(target));
    }
    if (!add) throw new TypeError('Invalid event target');
    return new (0, $gN3J6.Observable)(function(subscriber) {
        var handler = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return subscriber.next(1 < args.length ? args : args[0]);
        };
        add(handler);
        return function() {
            return remove(handler);
        };
    });
}
function $c04cd9fa17908b59$var$toCommonHandlerRegistry(target, eventName) {
    return function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler);
        };
    };
}
function $c04cd9fa17908b59$var$isNodeStyleEventEmitter(target) {
    return (0, $dFWVS.isFunction)(target.addListener) && (0, $dFWVS.isFunction)(target.removeListener);
}
function $c04cd9fa17908b59$var$isJQueryStyleEventEmitter(target) {
    return (0, $dFWVS.isFunction)(target.on) && (0, $dFWVS.isFunction)(target.off);
}
function $c04cd9fa17908b59$var$isEventTarget(target) {
    return (0, $dFWVS.isFunction)(target.addEventListener) && (0, $dFWVS.isFunction)(target.removeEventListener);
}

});
parcelRegister("hYp6u", function(module, exports) {

$parcel$export(module.exports, "mapOneOrManyArgs", () => $d15b83506ca8cd39$export$559affaa48f4288d);

var $ceFTv = parcelRequire("ceFTv");

var $6SBin = parcelRequire("6SBin");
var $d15b83506ca8cd39$var$isArray = Array.isArray;
function $d15b83506ca8cd39$var$callOrApply(fn, args) {
    return $d15b83506ca8cd39$var$isArray(args) ? fn.apply(void 0, (0, $ceFTv.__spreadArray)([], (0, $ceFTv.__read)(args))) : fn(args);
}
function $d15b83506ca8cd39$export$559affaa48f4288d(fn) {
    return (0, $6SBin.map)(function(args) {
        return $d15b83506ca8cd39$var$callOrApply(fn, args);
    });
}

});


parcelRegister("5w0HR", function(module, exports) {

$parcel$export(module.exports, "takeUntil", () => $40407d315c2cba58$export$ac8dfd3a7ad06e80);

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");

var $kA4PZ = parcelRequire("kA4PZ");

var $QfuEL = parcelRequire("QfuEL");
function $40407d315c2cba58$export$ac8dfd3a7ad06e80(notifier) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        (0, $kA4PZ.innerFrom)(notifier).subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function() {
            return subscriber.complete();
        }, (0, $QfuEL.noop)));
        !subscriber.closed && source.subscribe(subscriber);
    });
}

});

parcelRegister("amJim", function(module, exports) {
'use strict';

var $4xYVh = parcelRequire("4xYVh");

var $hmUYm = parcelRequire("hmUYm");
/** Survives to-markdown + marked; invisible in the editor. */ const $78bf1822e5b7e965$var$EMPTY_P = '\u200b';
const $78bf1822e5b7e965$var$options = {
    toMarkdown: {
        converters: [
            {
                filter: 'li',
                replacement: (content, node)=>{
                    content = content.replace(/^\s+/, '').replace(/\n/gm, '\n ');
                    let prefix = '- ';
                    const parent = node.parentNode;
                    const index = Array.prototype.indexOf.call(parent.children, node) + 1;
                    prefix = /ol/i.test(parent.nodeName) ? index + '. ' : '- ';
                    return prefix + content;
                }
            },
            // Chrome wraps typed text in <span style="font-size:…"> — never keep that in markdown
            {
                filter: 'span',
                replacement: (content)=>content
            },
            {
                // Blank paragraphs (Enter at end of doc) — keep as empty lines in markdown
                filter: (node)=>{
                    if (node.nodeName !== 'P') return false;
                    if (node.parentNode && node.parentNode.tagName === 'LI') return false;
                    const text = (node.textContent || '').replace(/\u00a0/g, '');
                    return text === '' || text === $78bf1822e5b7e965$var$EMPTY_P;
                },
                replacement: ()=>`\n\n${$78bf1822e5b7e965$var$EMPTY_P}\n\n`
            },
            {
                filter: 'p',
                replacement: (content, node)=>node.parentNode.tagName !== 'LI' ? `\n\n${content}` : content
            }
        ]
    },
    marked: {
        gfm: true,
        breaks: false,
        smartLists: true
    }
};
$hmUYm.setOptions($78bf1822e5b7e965$var$options.marked);
/**
 * Strip contenteditable chrome before markdown:
 * empty / font-size spans, leftover style wrappers.
 */ const $78bf1822e5b7e965$var$stripEditorNoise = (html)=>{
    let out = String(html || '');
    let prev;
    do {
        prev = out;
        out = out.replace(/<span\b[^>]*>\s*<\/span>/gi, '').replace(/<span\b[^>]*\sstyle\s*=\s*("[^"]*"|'[^']*')[^>]*>([\s\S]*?)<\/span>/gi, '$2').replace(/<\/?font\b[^>]*>/gi, '');
    }while (out !== prev);
    return out;
};
/** Turn empty / <br>-only blocks into a placeholder to-markdown will keep. */ const $78bf1822e5b7e965$var$preserveEmptyBlocks = (html)=>String(html || '').replace(/<div>/gi, '<p>').replace(/<\/div>/gi, '</p>').replace(/<p\b[^>]*>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, `<p>${$78bf1822e5b7e965$var$EMPTY_P}</p>`);
const $78bf1822e5b7e965$var$toHTML = (md)=>$hmUYm.parse(md || '').replace(/<div>/ig, '<p>').replace(/<\/div>/ig, '</p>').replace(/<li><p>/ig, '<li>').replace(/<\/p>(\n)?<\/li>/ig, '</li>')// contenteditable prefers <br> in blank lines for caret placement
    .replace(new RegExp(`<p>${$78bf1822e5b7e965$var$EMPTY_P}</p>`, 'g'), '<p><br></p>').replace(/<p><\/p>/ig, '');
/** Public display: no editor empty `<p><br></p>`, no `<br>` inside paragraphs. */ const $78bf1822e5b7e965$var$toDisplayHTML = (source)=>{
    let html = $78bf1822e5b7e965$var$toHTML(source).replace(/<p>\s*(?:<br\s*\/?>|&nbsp;|\u200b|\s)*<\/p>/gi, '');
    html = html.replace(/<p\b[^>]*>([\s\S]*?)<\/p>/gi, (_, inner)=>{
        if (!/<br\s*\/?>/i.test(inner)) return `<p>${inner}</p>`;
        return String(inner).split(/<br\s*\/?>/i).map((chunk)=>chunk.trim()).filter(Boolean).map((chunk)=>`<p>${chunk}</p>`).join('');
    });
    return html;
};
const $78bf1822e5b7e965$var$fromHTML = (html)=>$4xYVh($78bf1822e5b7e965$var$preserveEmptyBlocks($78bf1822e5b7e965$var$stripEditorNoise(html)), $78bf1822e5b7e965$var$options.toMarkdown);
module.exports = {
    options: $78bf1822e5b7e965$var$options,
    toHTML: $78bf1822e5b7e965$var$toHTML,
    toDisplayHTML: $78bf1822e5b7e965$var$toDisplayHTML,
    fromHTML: $78bf1822e5b7e965$var$fromHTML
};

});
parcelRegister("4xYVh", function(module, exports) {
/*
 * to-markdown - an HTML to Markdown converter
 *
 * Copyright 2011+, Dom Christie
 * Licenced under the MIT licence
 *
 */ 'use strict';
var $34f9807d74d023cf$var$toMarkdown;
var $34f9807d74d023cf$var$converters;

var $g2Ipw = parcelRequire("g2Ipw");

var $hbfci = parcelRequire("hbfci");

var $adbel = parcelRequire("adbel");

var $jRNXp = parcelRequire("jRNXp");
/*
 * Utilities
 */ var $34f9807d74d023cf$var$blocks = [
    'address',
    'article',
    'aside',
    'audio',
    'blockquote',
    'body',
    'canvas',
    'center',
    'dd',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'header',
    'hgroup',
    'hr',
    'html',
    'isindex',
    'li',
    'main',
    'menu',
    'nav',
    'noframes',
    'noscript',
    'ol',
    'output',
    'p',
    'pre',
    'section',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'tr',
    'ul'
];
function $34f9807d74d023cf$var$isBlock(node) {
    return $34f9807d74d023cf$var$blocks.indexOf(node.nodeName.toLowerCase()) !== -1;
}
var $34f9807d74d023cf$var$voids = [
    'area',
    'base',
    'br',
    'col',
    'command',
    'embed',
    'hr',
    'img',
    'input',
    'keygen',
    'link',
    'meta',
    'param',
    'source',
    'track',
    'wbr'
];
function $34f9807d74d023cf$var$isVoid(node) {
    return $34f9807d74d023cf$var$voids.indexOf(node.nodeName.toLowerCase()) !== -1;
}
function $34f9807d74d023cf$var$htmlToDom(string) {
    var tree = new $adbel().parseFromString(string, 'text/html');
    $jRNXp(tree.documentElement, $34f9807d74d023cf$var$isBlock);
    return tree;
}
/*
 * Flattens DOM tree into single array
 */ function $34f9807d74d023cf$var$bfsOrder(node) {
    var inqueue = [
        node
    ];
    var outqueue = [];
    var elem;
    var children;
    var i;
    while(inqueue.length > 0){
        elem = inqueue.shift();
        outqueue.push(elem);
        children = elem.childNodes;
        for(i = 0; i < children.length; i++)if (children[i].nodeType === 1) inqueue.push(children[i]);
    }
    outqueue.shift();
    return outqueue;
}
/*
 * Contructs a Markdown string of replacement text for a given node
 */ function $34f9807d74d023cf$var$getContent(node) {
    var text = '';
    for(var i = 0; i < node.childNodes.length; i++){
        if (node.childNodes[i].nodeType === 1) text += node.childNodes[i]._replacement;
        else if (node.childNodes[i].nodeType === 3) text += node.childNodes[i].data;
        else continue;
    }
    return text;
}
/*
 * Returns the HTML string of an element with its contents converted
 */ function $34f9807d74d023cf$var$outer(node, content) {
    return node.cloneNode(false).outerHTML.replace('><', '>' + content + '<');
}
function $34f9807d74d023cf$var$canConvert(node, filter) {
    if (typeof filter === 'string') return filter === node.nodeName.toLowerCase();
    if (Array.isArray(filter)) return filter.indexOf(node.nodeName.toLowerCase()) !== -1;
    else if (typeof filter === 'function') return filter.call($34f9807d74d023cf$var$toMarkdown, node);
    else throw new TypeError('`filter` needs to be a string, array, or function');
}
function $34f9807d74d023cf$var$isFlankedByWhitespace(side, node) {
    var sibling;
    var regExp;
    var isFlanked;
    if (side === 'left') {
        sibling = node.previousSibling;
        regExp = / $/;
    } else {
        sibling = node.nextSibling;
        regExp = /^ /;
    }
    if (sibling) {
        if (sibling.nodeType === 3) isFlanked = regExp.test(sibling.nodeValue);
        else if (sibling.nodeType === 1 && !$34f9807d74d023cf$var$isBlock(sibling)) isFlanked = regExp.test(sibling.textContent);
    }
    return isFlanked;
}
function $34f9807d74d023cf$var$flankingWhitespace(node, content) {
    var leading = '';
    var trailing = '';
    if (!$34f9807d74d023cf$var$isBlock(node)) {
        var hasLeading = /^[ \r\n\t]/.test(content);
        var hasTrailing = /[ \r\n\t]$/.test(content);
        if (hasLeading && !$34f9807d74d023cf$var$isFlankedByWhitespace('left', node)) leading = ' ';
        if (hasTrailing && !$34f9807d74d023cf$var$isFlankedByWhitespace('right', node)) trailing = ' ';
    }
    return {
        leading: leading,
        trailing: trailing
    };
}
/*
 * Finds a Markdown converter, gets the replacement, and sets it on
 * `_replacement`
 */ function $34f9807d74d023cf$var$process(node) {
    var replacement;
    var content = $34f9807d74d023cf$var$getContent(node);
    // Remove blank nodes
    if (!$34f9807d74d023cf$var$isVoid(node) && !/A|TH|TD/.test(node.nodeName) && /^\s*$/i.test(content)) {
        node._replacement = '';
        return;
    }
    for(var i = 0; i < $34f9807d74d023cf$var$converters.length; i++){
        var converter = $34f9807d74d023cf$var$converters[i];
        if ($34f9807d74d023cf$var$canConvert(node, converter.filter)) {
            if (typeof converter.replacement !== 'function') throw new TypeError('`replacement` needs to be a function that returns a string');
            var whitespace = $34f9807d74d023cf$var$flankingWhitespace(node, content);
            if (whitespace.leading || whitespace.trailing) content = content.trim();
            replacement = whitespace.leading + converter.replacement.call($34f9807d74d023cf$var$toMarkdown, content, node) + whitespace.trailing;
            break;
        }
    }
    node._replacement = replacement;
}
$34f9807d74d023cf$var$toMarkdown = function(input, options) {
    options = options || {};
    if (typeof input !== 'string') throw new TypeError(input + ' is not a string');
    if (input === '') return '';
    // Escape potential ol triggers
    input = input.replace(/(\d+)\. /g, '$1\\. ');
    var clone = $34f9807d74d023cf$var$htmlToDom(input).body;
    var nodes = $34f9807d74d023cf$var$bfsOrder(clone);
    var output;
    $34f9807d74d023cf$var$converters = $g2Ipw.slice(0);
    if (options.gfm) $34f9807d74d023cf$var$converters = $hbfci.concat($34f9807d74d023cf$var$converters);
    if (options.converters) $34f9807d74d023cf$var$converters = options.converters.concat($34f9807d74d023cf$var$converters);
    // Process through nodes in reverse (so deepest child elements are first).
    for(var i = nodes.length - 1; i >= 0; i--)$34f9807d74d023cf$var$process(nodes[i]);
    output = $34f9807d74d023cf$var$getContent(clone);
    return output.replace(/^[\t\r\n]+|[\t\r\n\s]+$/g, '').replace(/\n\s+\n/g, '\n\n').replace(/\n{3,}/g, '\n\n');
};
$34f9807d74d023cf$var$toMarkdown.isBlock = $34f9807d74d023cf$var$isBlock;
$34f9807d74d023cf$var$toMarkdown.isVoid = $34f9807d74d023cf$var$isVoid;
$34f9807d74d023cf$var$toMarkdown.outer = $34f9807d74d023cf$var$outer;
module.exports = $34f9807d74d023cf$var$toMarkdown;

});
parcelRegister("g2Ipw", function(module, exports) {
'use strict';
module.exports = [
    {
        filter: 'p',
        replacement: function(content) {
            return '\n\n' + content + '\n\n';
        }
    },
    {
        filter: 'br',
        replacement: function() {
            return '  \n';
        }
    },
    {
        filter: [
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6'
        ],
        replacement: function(content, node) {
            var hLevel = node.nodeName.charAt(1);
            var hPrefix = '';
            for(var i = 0; i < hLevel; i++)hPrefix += '#';
            return '\n\n' + hPrefix + ' ' + content + '\n\n';
        }
    },
    {
        filter: 'hr',
        replacement: function() {
            return '\n\n* * *\n\n';
        }
    },
    {
        filter: [
            'em',
            'i'
        ],
        replacement: function(content) {
            return '_' + content + '_';
        }
    },
    {
        filter: [
            'strong',
            'b'
        ],
        replacement: function(content) {
            return '**' + content + '**';
        }
    },
    // Inline code
    {
        filter: function(node) {
            var hasSiblings = node.previousSibling || node.nextSibling;
            var isCodeBlock = node.parentNode.nodeName === 'PRE' && !hasSiblings;
            return node.nodeName === 'CODE' && !isCodeBlock;
        },
        replacement: function(content) {
            return '`' + content + '`';
        }
    },
    {
        filter: function(node) {
            return node.nodeName === 'A' && node.getAttribute('href');
        },
        replacement: function(content, node) {
            var titlePart = node.title ? ' "' + node.title + '"' : '';
            return '[' + content + '](' + node.getAttribute('href') + titlePart + ')';
        }
    },
    {
        filter: 'img',
        replacement: function(content, node) {
            var alt = node.alt || '';
            var src = node.getAttribute('src') || '';
            var title = node.title || '';
            var titlePart = title ? ' "' + title + '"' : '';
            return src ? '![' + alt + ']' + '(' + src + titlePart + ')' : '';
        }
    },
    // Code blocks
    {
        filter: function(node) {
            return node.nodeName === 'PRE' && node.firstChild.nodeName === 'CODE';
        },
        replacement: function(content, node) {
            return '\n\n    ' + node.firstChild.textContent.replace(/\n/g, '\n    ') + '\n\n';
        }
    },
    {
        filter: 'blockquote',
        replacement: function(content) {
            content = content.trim();
            content = content.replace(/\n{3,}/g, '\n\n');
            content = content.replace(/^/gm, '> ');
            return '\n\n' + content + '\n\n';
        }
    },
    {
        filter: 'li',
        replacement: function(content, node) {
            content = content.replace(/^\s+/, '').replace(/\n/gm, '\n    ');
            var prefix = '*   ';
            var parent = node.parentNode;
            if (parent.nodeName === 'OL') {
                var start = parent.getAttribute('start');
                var index = Array.prototype.indexOf.call(parent.children, node);
                prefix = (start ? Number(start) + index : index + 1) + '.  ';
            }
            return prefix + content;
        }
    },
    {
        filter: [
            'ul',
            'ol'
        ],
        replacement: function(content, node) {
            var strings = [];
            for(var i = 0; i < node.childNodes.length; i++)strings.push(node.childNodes[i]._replacement);
            if (/li/i.test(node.parentNode.nodeName)) return '\n' + strings.join('\n');
            return '\n\n' + strings.join('\n') + '\n\n';
        }
    },
    {
        filter: function(node) {
            return this.isBlock(node);
        },
        replacement: function(content, node) {
            return '\n\n' + this.outer(node, content) + '\n\n';
        }
    },
    // Anything else!
    {
        filter: function() {
            return true;
        },
        replacement: function(content, node) {
            return this.outer(node, content);
        }
    }
];

});

parcelRegister("hbfci", function(module, exports) {
'use strict';
function $c81f40a42ff7e2bb$var$cell(content, node) {
    var index = Array.prototype.indexOf.call(node.parentNode.childNodes, node);
    var prefix = ' ';
    if (index === 0) prefix = '| ';
    return prefix + content + ' |';
}
var $c81f40a42ff7e2bb$var$highlightRegEx = /highlight highlight-(\S+)/;
module.exports = [
    {
        filter: 'br',
        replacement: function() {
            return '\n';
        }
    },
    {
        filter: [
            'del',
            's',
            'strike'
        ],
        replacement: function(content) {
            return '~~' + content + '~~';
        }
    },
    {
        filter: function(node) {
            return node.type === 'checkbox' && node.parentNode.nodeName === 'LI';
        },
        replacement: function(content, node) {
            return (node.checked ? '[x]' : '[ ]') + ' ';
        }
    },
    {
        filter: [
            'th',
            'td'
        ],
        replacement: function(content, node) {
            return $c81f40a42ff7e2bb$var$cell(content, node);
        }
    },
    {
        filter: 'tr',
        replacement: function(content, node) {
            var borderCells = '';
            var alignMap = {
                left: ':--',
                right: '--:',
                center: ':-:'
            };
            if (node.parentNode.nodeName === 'THEAD') for(var i = 0; i < node.childNodes.length; i++){
                var align = node.childNodes[i].attributes.align;
                var border = '---';
                if (align) border = alignMap[align.value] || border;
                borderCells += $c81f40a42ff7e2bb$var$cell(border, node.childNodes[i]);
            }
            return '\n' + content + (borderCells ? '\n' + borderCells : '');
        }
    },
    {
        filter: 'table',
        replacement: function(content) {
            return '\n\n' + content + '\n\n';
        }
    },
    {
        filter: [
            'thead',
            'tbody',
            'tfoot'
        ],
        replacement: function(content) {
            return content;
        }
    },
    // Fenced code blocks
    {
        filter: function(node) {
            return node.nodeName === 'PRE' && node.firstChild && node.firstChild.nodeName === 'CODE';
        },
        replacement: function(content, node) {
            return '\n\n```\n' + node.firstChild.textContent + '\n```\n\n';
        }
    },
    // Syntax-highlighted code blocks
    {
        filter: function(node) {
            return node.nodeName === 'PRE' && node.parentNode.nodeName === 'DIV' && $c81f40a42ff7e2bb$var$highlightRegEx.test(node.parentNode.className);
        },
        replacement: function(content, node) {
            var language = node.parentNode.className.match($c81f40a42ff7e2bb$var$highlightRegEx)[1];
            return '\n\n```' + language + '\n' + node.textContent + '\n```\n\n';
        }
    },
    {
        filter: function(node) {
            return node.nodeName === 'DIV' && $c81f40a42ff7e2bb$var$highlightRegEx.test(node.className);
        },
        replacement: function(content) {
            return '\n\n' + content + '\n\n';
        }
    }
];

});

parcelRegister("adbel", function(module, exports) {
/*
 * Set up window for Node.js
 */ var $76f3d46681972a89$var$_window = typeof window !== 'undefined' ? window : module.exports;
/*
 * Parsing HTML strings
 */ function $76f3d46681972a89$var$canParseHtmlNatively() {
    var Parser = $76f3d46681972a89$var$_window.DOMParser;
    var canParse = false;
    // Adapted from https://gist.github.com/1129031
    // Firefox/Opera/IE throw errors on unsupported types
    try {
        // WebKit returns null on unsupported types
        if (new Parser().parseFromString('', 'text/html')) canParse = true;
    } catch (e) {}
    return canParse;
}

function $76f3d46681972a89$var$createHtmlParser() {
    var Parser = function() {};
    // For Node.js environments
    if (typeof document === 'undefined') {
        var jsdom = (parcelRequire("jIjd8"));
        Parser.prototype.parseFromString = function(string) {
            return jsdom.jsdom(string, {
                features: {
                    FetchExternalResources: [],
                    ProcessExternalResources: false
                }
            });
        };
    } else if (!$76f3d46681972a89$var$shouldUseActiveX()) Parser.prototype.parseFromString = function(string) {
        var doc = document.implementation.createHTMLDocument('');
        doc.open();
        doc.write(string);
        doc.close();
        return doc;
    };
    else Parser.prototype.parseFromString = function(string) {
        var doc = new window.ActiveXObject('htmlfile');
        doc.designMode = 'on' // disable on-page scripts
        ;
        doc.open();
        doc.write(string);
        doc.close();
        return doc;
    };
    return Parser;
}
function $76f3d46681972a89$var$shouldUseActiveX() {
    var useActiveX = false;
    try {
        document.implementation.createHTMLDocument('').open();
    } catch (e) {
        if (window.ActiveXObject) useActiveX = true;
    }
    return useActiveX;
}
module.exports = $76f3d46681972a89$var$canParseHtmlNatively() ? $76f3d46681972a89$var$_window.DOMParser : $76f3d46681972a89$var$createHtmlParser();

});

parcelRegister("jRNXp", function(module, exports) {
'use strict';

var $kAlDV = parcelRequire("kAlDV");
Object.keys($kAlDV).forEach(function(name) {
    $kAlDV[name.toUpperCase()] = 1;
});
var $e769b80105821458$var$blockElements = {};

(parcelRequire("dpGzb")).forEach(function(name) {
    $e769b80105821458$var$blockElements[name.toUpperCase()] = 1;
});
/**
 * isBlockElem(node) determines if the given node is a block element.
 *
 * @param {Node} node
 * @return {Boolean}
 */ function $e769b80105821458$var$isBlockElem(node) {
    return !!(node && $e769b80105821458$var$blockElements[node.nodeName]);
}
/**
 * isVoid(node) determines if the given node is a void element.
 *
 * @param {Node} node
 * @return {Boolean}
 */ function $e769b80105821458$var$isVoid(node) {
    return !!(node && $kAlDV[node.nodeName]);
}
/**
 * whitespace(elem [, isBlock]) removes extraneous whitespace from an
 * the given element. The function isBlock may optionally be passed in
 * to determine whether or not an element is a block element; if none
 * is provided, defaults to using the list of block elements provided
 * by the `block-elements` module.
 *
 * @param {Node} elem
 * @param {Function} blockTest
 */ function $e769b80105821458$var$collapseWhitespace(elem, isBlock) {
    if (!elem.firstChild || elem.nodeName === 'PRE') return;
    if (typeof isBlock !== 'function') isBlock = $e769b80105821458$var$isBlockElem;
    var prevText = null;
    var prevVoid = false;
    var prev = null;
    var node = $e769b80105821458$var$next(prev, elem);
    while(node !== elem){
        if (node.nodeType === 3) {
            // Node.TEXT_NODE
            var text = node.data.replace(/[ \r\n\t]+/g, ' ');
            if ((!prevText || / $/.test(prevText.data)) && !prevVoid && text[0] === ' ') text = text.substr(1);
            // `text` might be empty at this point.
            if (!text) {
                node = $e769b80105821458$var$remove(node);
                continue;
            }
            node.data = text;
            prevText = node;
        } else if (node.nodeType === 1) {
            // Node.ELEMENT_NODE
            if (isBlock(node) || node.nodeName === 'BR') {
                if (prevText) prevText.data = prevText.data.replace(/ $/, '');
                prevText = null;
                prevVoid = false;
            } else if ($e769b80105821458$var$isVoid(node)) {
                // Avoid trimming space around non-block, non-BR void elements.
                prevText = null;
                prevVoid = true;
            }
        } else {
            node = $e769b80105821458$var$remove(node);
            continue;
        }
        var nextNode = $e769b80105821458$var$next(prev, node);
        prev = node;
        node = nextNode;
    }
    if (prevText) {
        prevText.data = prevText.data.replace(/ $/, '');
        if (!prevText.data) $e769b80105821458$var$remove(prevText);
    }
}
/**
 * remove(node) removes the given node from the DOM and returns the
 * next node in the sequence.
 *
 * @param {Node} node
 * @return {Node} node
 */ function $e769b80105821458$var$remove(node) {
    var next = node.nextSibling || node.parentNode;
    node.parentNode.removeChild(node);
    return next;
}
/**
 * next(prev, current) returns the next node in the sequence, given the
 * current and previous nodes.
 *
 * @param {Node} prev
 * @param {Node} current
 * @return {Node}
 */ function $e769b80105821458$var$next(prev, current) {
    if (prev && prev.parentNode === current || current.nodeName === 'PRE') return current.nextSibling || current.parentNode;
    return current.firstChild || current.nextSibling || current.parentNode;
}
module.exports = $e769b80105821458$var$collapseWhitespace;

});
parcelRegister("kAlDV", function(module, exports) {
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ module.exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "keygen": true,
    "link": true,
    "menuitem": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};

});



parcelRegister("hmUYm", function(module, exports) {
/**
 * marked v4.3.0 - a markdown parser
 * Copyright (c) 2011-2023, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */ /**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    'use strict';
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function _extends() {
        _extends = Object.assign ? Object.assign.bind() : function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        return _extends.apply(this, arguments);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _createForOfIteratorHelperLoose(o, allowArrayLike) {
        var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
        if (it) return (it = it.call(o)).next.bind(it);
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            return function() {
                if (i >= o.length) return {
                    done: true
                };
                return {
                    done: false,
                    value: o[i++]
                };
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function _toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function _toPropertyKey(arg) {
        var key = _toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    function getDefaults() {
        return {
            async: false,
            baseUrl: null,
            breaks: false,
            extensions: null,
            gfm: true,
            headerIds: true,
            headerPrefix: '',
            highlight: null,
            hooks: null,
            langPrefix: 'language-',
            mangle: true,
            pedantic: false,
            renderer: null,
            sanitize: false,
            sanitizer: null,
            silent: false,
            smartypants: false,
            tokenizer: null,
            walkTokens: null,
            xhtml: false
        };
    }
    exports1.defaults = getDefaults();
    function changeDefaults(newDefaults) {
        exports1.defaults = newDefaults;
    }
    /**
   * Helpers
   */ var escapeTest = /[&<>"']/;
    var escapeReplace = new RegExp(escapeTest.source, 'g');
    var escapeTestNoEncode = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/;
    var escapeReplaceNoEncode = new RegExp(escapeTestNoEncode.source, 'g');
    var escapeReplacements = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    var getEscapeReplacement = function getEscapeReplacement(ch) {
        return escapeReplacements[ch];
    };
    function escape(html, encode) {
        if (encode) {
            if (escapeTest.test(html)) return html.replace(escapeReplace, getEscapeReplacement);
        } else {
            if (escapeTestNoEncode.test(html)) return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
        }
        return html;
    }
    var unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
    /**
   * @param {string} html
   */ function unescape(html) {
        // explicitly match decimal, hex, and named HTML entities
        return html.replace(unescapeTest, function(_, n) {
            n = n.toLowerCase();
            if (n === 'colon') return ':';
            if (n.charAt(0) === '#') return n.charAt(1) === 'x' ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
            return '';
        });
    }
    var caret = /(^|[^\[])\^/g;
    /**
   * @param {string | RegExp} regex
   * @param {string} opt
   */ function edit(regex, opt) {
        regex = typeof regex === 'string' ? regex : regex.source;
        opt = opt || '';
        var obj = {
            replace: function replace(name, val) {
                val = val.source || val;
                val = val.replace(caret, '$1');
                regex = regex.replace(name, val);
                return obj;
            },
            getRegex: function getRegex() {
                return new RegExp(regex, opt);
            }
        };
        return obj;
    }
    var nonWordAndColonTest = /[^\w:]/g;
    var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;
    /**
   * @param {boolean} sanitize
   * @param {string} base
   * @param {string} href
   */ function cleanUrl(sanitize, base, href) {
        if (sanitize) {
            var prot;
            try {
                prot = decodeURIComponent(unescape(href)).replace(nonWordAndColonTest, '').toLowerCase();
            } catch (e) {
                return null;
            }
            if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) return null;
        }
        if (base && !originIndependentUrl.test(href)) href = resolveUrl(base, href);
        try {
            href = encodeURI(href).replace(/%25/g, '%');
        } catch (e) {
            return null;
        }
        return href;
    }
    var baseUrls = {};
    var justDomain = /^[^:]+:\/*[^/]*$/;
    var protocol = /^([^:]+:)[\s\S]*$/;
    var domain = /^([^:]+:\/*[^/]*)[\s\S]*$/;
    /**
   * @param {string} base
   * @param {string} href
   */ function resolveUrl(base, href) {
        if (!baseUrls[' ' + base]) {
            // we can ignore everything in base after the last slash of its path component,
            // but we might need to add _that_
            // https://tools.ietf.org/html/rfc3986#section-3
            if (justDomain.test(base)) baseUrls[' ' + base] = base + '/';
            else baseUrls[' ' + base] = rtrim(base, '/', true);
        }
        base = baseUrls[' ' + base];
        var relativeBase = base.indexOf(':') === -1;
        if (href.substring(0, 2) === '//') {
            if (relativeBase) return href;
            return base.replace(protocol, '$1') + href;
        } else if (href.charAt(0) === '/') {
            if (relativeBase) return href;
            return base.replace(domain, '$1') + href;
        } else return base + href;
    }
    var noopTest = {
        exec: function noopTest() {}
    };
    function splitCells(tableRow, count) {
        // ensure that every cell-delimiting pipe has a space
        // before it to distinguish it from an escaped pipe
        var row = tableRow.replace(/\|/g, function(match, offset, str) {
            var escaped = false, curr = offset;
            while(--curr >= 0 && str[curr] === '\\')escaped = !escaped;
            if (escaped) // odd number of slashes means | is escaped
            // so we leave it alone
            return '|';
            else // add space before unescaped |
            return ' |';
        }), cells = row.split(/ \|/);
        var i = 0;
        // First/last cell in a row cannot be empty if it has no leading/trailing pipe
        if (!cells[0].trim()) cells.shift();
        if (cells.length > 0 && !cells[cells.length - 1].trim()) cells.pop();
        if (cells.length > count) cells.splice(count);
        else while(cells.length < count)cells.push('');
        for(; i < cells.length; i++)// leading or trailing whitespace is ignored per the gfm spec
        cells[i] = cells[i].trim().replace(/\\\|/g, '|');
        return cells;
    }
    /**
   * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
   * /c*$/ is vulnerable to REDOS.
   *
   * @param {string} str
   * @param {string} c
   * @param {boolean} invert Remove suffix of non-c chars instead. Default falsey.
   */ function rtrim(str, c, invert) {
        var l = str.length;
        if (l === 0) return '';
        // Length of suffix matching the invert condition.
        var suffLen = 0;
        // Step left until we fail to match the invert condition.
        while(suffLen < l){
            var currChar = str.charAt(l - suffLen - 1);
            if (currChar === c && !invert) suffLen++;
            else if (currChar !== c && invert) suffLen++;
            else break;
        }
        return str.slice(0, l - suffLen);
    }
    function findClosingBracket(str, b) {
        if (str.indexOf(b[1]) === -1) return -1;
        var l = str.length;
        var level = 0, i = 0;
        for(; i < l; i++){
            if (str[i] === '\\') i++;
            else if (str[i] === b[0]) level++;
            else if (str[i] === b[1]) {
                level--;
                if (level < 0) return i;
            }
        }
        return -1;
    }
    function checkSanitizeDeprecation(opt) {
        if (opt && opt.sanitize && !opt.silent) console.warn('marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options');
    }
    // copied from https://stackoverflow.com/a/5450113/806777
    /**
   * @param {string} pattern
   * @param {number} count
   */ function repeatString(pattern, count) {
        if (count < 1) return '';
        var result = '';
        while(count > 1){
            if (count & 1) result += pattern;
            count >>= 1;
            pattern += pattern;
        }
        return result + pattern;
    }
    function outputLink(cap, link, raw, lexer) {
        var href = link.href;
        var title = link.title ? escape(link.title) : null;
        var text = cap[1].replace(/\\([\[\]])/g, '$1');
        if (cap[0].charAt(0) !== '!') {
            lexer.state.inLink = true;
            var token = {
                type: 'link',
                raw: raw,
                href: href,
                title: title,
                text: text,
                tokens: lexer.inlineTokens(text)
            };
            lexer.state.inLink = false;
            return token;
        }
        return {
            type: 'image',
            raw: raw,
            href: href,
            title: title,
            text: escape(text)
        };
    }
    function indentCodeCompensation(raw, text) {
        var matchIndentToCode = raw.match(/^(\s+)(?:```)/);
        if (matchIndentToCode === null) return text;
        var indentToCode = matchIndentToCode[1];
        return text.split('\n').map(function(node) {
            var matchIndentInNode = node.match(/^\s+/);
            if (matchIndentInNode === null) return node;
            var indentInNode = matchIndentInNode[0];
            if (indentInNode.length >= indentToCode.length) return node.slice(indentToCode.length);
            return node;
        }).join('\n');
    }
    /**
   * Tokenizer
   */ var Tokenizer = /*#__PURE__*/ function() {
        function Tokenizer(options) {
            this.options = options || exports1.defaults;
        }
        var _proto = Tokenizer.prototype;
        _proto.space = function space(src) {
            var cap = this.rules.block.newline.exec(src);
            if (cap && cap[0].length > 0) return {
                type: 'space',
                raw: cap[0]
            };
        };
        _proto.code = function code(src) {
            var cap = this.rules.block.code.exec(src);
            if (cap) {
                var text = cap[0].replace(/^ {1,4}/gm, '');
                return {
                    type: 'code',
                    raw: cap[0],
                    codeBlockStyle: 'indented',
                    text: !this.options.pedantic ? rtrim(text, '\n') : text
                };
            }
        };
        _proto.fences = function fences(src) {
            var cap = this.rules.block.fences.exec(src);
            if (cap) {
                var raw = cap[0];
                var text = indentCodeCompensation(raw, cap[3] || '');
                return {
                    type: 'code',
                    raw: raw,
                    lang: cap[2] ? cap[2].trim().replace(this.rules.inline._escapes, '$1') : cap[2],
                    text: text
                };
            }
        };
        _proto.heading = function heading(src) {
            var cap = this.rules.block.heading.exec(src);
            if (cap) {
                var text = cap[2].trim();
                // remove trailing #s
                if (/#$/.test(text)) {
                    var trimmed = rtrim(text, '#');
                    if (this.options.pedantic) text = trimmed.trim();
                    else if (!trimmed || / $/.test(trimmed)) // CommonMark requires space before trailing #s
                    text = trimmed.trim();
                }
                return {
                    type: 'heading',
                    raw: cap[0],
                    depth: cap[1].length,
                    text: text,
                    tokens: this.lexer.inline(text)
                };
            }
        };
        _proto.hr = function hr(src) {
            var cap = this.rules.block.hr.exec(src);
            if (cap) return {
                type: 'hr',
                raw: cap[0]
            };
        };
        _proto.blockquote = function blockquote(src) {
            var cap = this.rules.block.blockquote.exec(src);
            if (cap) {
                var text = cap[0].replace(/^ *>[ \t]?/gm, '');
                var top = this.lexer.state.top;
                this.lexer.state.top = true;
                var tokens = this.lexer.blockTokens(text);
                this.lexer.state.top = top;
                return {
                    type: 'blockquote',
                    raw: cap[0],
                    tokens: tokens,
                    text: text
                };
            }
        };
        _proto.list = function list(src) {
            var cap = this.rules.block.list.exec(src);
            if (cap) {
                var raw, istask, ischecked, indent, i, blankLine, endsWithBlankLine, line, nextLine, rawLine, itemContents, endEarly;
                var bull = cap[1].trim();
                var isordered = bull.length > 1;
                var list = {
                    type: 'list',
                    raw: '',
                    ordered: isordered,
                    start: isordered ? +bull.slice(0, -1) : '',
                    loose: false,
                    items: []
                };
                bull = isordered ? "\\d{1,9}\\" + bull.slice(-1) : "\\" + bull;
                if (this.options.pedantic) bull = isordered ? bull : '[*+-]';
                // Get next list item
                var itemRegex = new RegExp("^( {0,3}" + bull + ")((?:[\t ][^\\n]*)?(?:\\n|$))");
                // Check if current bullet point can start a new List Item
                while(src){
                    endEarly = false;
                    if (!(cap = itemRegex.exec(src))) break;
                    if (this.rules.block.hr.test(src)) break;
                    raw = cap[0];
                    src = src.substring(raw.length);
                    line = cap[2].split('\n', 1)[0].replace(/^\t+/, function(t) {
                        return ' '.repeat(3 * t.length);
                    });
                    nextLine = src.split('\n', 1)[0];
                    if (this.options.pedantic) {
                        indent = 2;
                        itemContents = line.trimLeft();
                    } else {
                        indent = cap[2].search(/[^ ]/); // Find first non-space char
                        indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
                        itemContents = line.slice(indent);
                        indent += cap[1].length;
                    }
                    blankLine = false;
                    if (!line && /^ *$/.test(nextLine)) {
                        // Items begin with at most one blank line
                        raw += nextLine + '\n';
                        src = src.substring(nextLine.length + 1);
                        endEarly = true;
                    }
                    if (!endEarly) {
                        var nextBulletRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))");
                        var hrRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)");
                        var fencesBeginRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}(?:```|~~~)");
                        var headingBeginRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}#");
                        // Check if following lines should be included in List Item
                        while(src){
                            rawLine = src.split('\n', 1)[0];
                            nextLine = rawLine;
                            // Re-align to follow commonmark nesting rules
                            if (this.options.pedantic) nextLine = nextLine.replace(/^ {1,4}(?=( {4})*[^ ])/g, '  ');
                            // End list item if found code fences
                            if (fencesBeginRegex.test(nextLine)) break;
                            // End list item if found start of new heading
                            if (headingBeginRegex.test(nextLine)) break;
                            // End list item if found start of new bullet
                            if (nextBulletRegex.test(nextLine)) break;
                            // Horizontal rule found
                            if (hrRegex.test(src)) break;
                            if (nextLine.search(/[^ ]/) >= indent || !nextLine.trim()) // Dedent if possible
                            itemContents += '\n' + nextLine.slice(indent);
                            else {
                                // not enough indentation
                                if (blankLine) break;
                                // paragraph continuation unless last line was a different block level element
                                if (line.search(/[^ ]/) >= 4) break;
                                if (fencesBeginRegex.test(line)) break;
                                if (headingBeginRegex.test(line)) break;
                                if (hrRegex.test(line)) break;
                                itemContents += '\n' + nextLine;
                            }
                            if (!blankLine && !nextLine.trim()) // Check if current line is blank
                            blankLine = true;
                            raw += rawLine + '\n';
                            src = src.substring(rawLine.length + 1);
                            line = nextLine.slice(indent);
                        }
                    }
                    if (!list.loose) {
                        // If the previous item ended with a blank line, the list is loose
                        if (endsWithBlankLine) list.loose = true;
                        else if (/\n *\n *$/.test(raw)) endsWithBlankLine = true;
                    }
                    // Check for task list items
                    if (this.options.gfm) {
                        istask = /^\[[ xX]\] /.exec(itemContents);
                        if (istask) {
                            ischecked = istask[0] !== '[ ] ';
                            itemContents = itemContents.replace(/^\[[ xX]\] +/, '');
                        }
                    }
                    list.items.push({
                        type: 'list_item',
                        raw: raw,
                        task: !!istask,
                        checked: ischecked,
                        loose: false,
                        text: itemContents
                    });
                    list.raw += raw;
                }
                // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
                list.items[list.items.length - 1].raw = raw.trimRight();
                list.items[list.items.length - 1].text = itemContents.trimRight();
                list.raw = list.raw.trimRight();
                var l = list.items.length;
                // Item child tokens handled here at end because we needed to have the final item to trim it first
                for(i = 0; i < l; i++){
                    this.lexer.state.top = false;
                    list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
                    if (!list.loose) {
                        // Check if list should be loose
                        var spacers = list.items[i].tokens.filter(function(t) {
                            return t.type === 'space';
                        });
                        var hasMultipleLineBreaks = spacers.length > 0 && spacers.some(function(t) {
                            return /\n.*\n/.test(t.raw);
                        });
                        list.loose = hasMultipleLineBreaks;
                    }
                }
                // Set all items to loose if list is loose
                if (list.loose) for(i = 0; i < l; i++)list.items[i].loose = true;
                return list;
            }
        };
        _proto.html = function html(src) {
            var cap = this.rules.block.html.exec(src);
            if (cap) {
                var token = {
                    type: 'html',
                    raw: cap[0],
                    pre: !this.options.sanitizer && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
                    text: cap[0]
                };
                if (this.options.sanitize) {
                    var text = this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]);
                    token.type = 'paragraph';
                    token.text = text;
                    token.tokens = this.lexer.inline(text);
                }
                return token;
            }
        };
        _proto.def = function def(src) {
            var cap = this.rules.block.def.exec(src);
            if (cap) {
                var tag = cap[1].toLowerCase().replace(/\s+/g, ' ');
                var href = cap[2] ? cap[2].replace(/^<(.*)>$/, '$1').replace(this.rules.inline._escapes, '$1') : '';
                var title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline._escapes, '$1') : cap[3];
                return {
                    type: 'def',
                    tag: tag,
                    raw: cap[0],
                    href: href,
                    title: title
                };
            }
        };
        _proto.table = function table(src) {
            var cap = this.rules.block.table.exec(src);
            if (cap) {
                var item = {
                    type: 'table',
                    header: splitCells(cap[1]).map(function(c) {
                        return {
                            text: c
                        };
                    }),
                    align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
                    rows: cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, '').split('\n') : []
                };
                if (item.header.length === item.align.length) {
                    item.raw = cap[0];
                    var l = item.align.length;
                    var i, j, k, row;
                    for(i = 0; i < l; i++){
                        if (/^ *-+: *$/.test(item.align[i])) item.align[i] = 'right';
                        else if (/^ *:-+: *$/.test(item.align[i])) item.align[i] = 'center';
                        else if (/^ *:-+ *$/.test(item.align[i])) item.align[i] = 'left';
                        else item.align[i] = null;
                    }
                    l = item.rows.length;
                    for(i = 0; i < l; i++)item.rows[i] = splitCells(item.rows[i], item.header.length).map(function(c) {
                        return {
                            text: c
                        };
                    });
                    // parse child tokens inside headers and cells
                    // header child tokens
                    l = item.header.length;
                    for(j = 0; j < l; j++)item.header[j].tokens = this.lexer.inline(item.header[j].text);
                    // cell child tokens
                    l = item.rows.length;
                    for(j = 0; j < l; j++){
                        row = item.rows[j];
                        for(k = 0; k < row.length; k++)row[k].tokens = this.lexer.inline(row[k].text);
                    }
                    return item;
                }
            }
        };
        _proto.lheading = function lheading(src) {
            var cap = this.rules.block.lheading.exec(src);
            if (cap) return {
                type: 'heading',
                raw: cap[0],
                depth: cap[2].charAt(0) === '=' ? 1 : 2,
                text: cap[1],
                tokens: this.lexer.inline(cap[1])
            };
        };
        _proto.paragraph = function paragraph(src) {
            var cap = this.rules.block.paragraph.exec(src);
            if (cap) {
                var text = cap[1].charAt(cap[1].length - 1) === '\n' ? cap[1].slice(0, -1) : cap[1];
                return {
                    type: 'paragraph',
                    raw: cap[0],
                    text: text,
                    tokens: this.lexer.inline(text)
                };
            }
        };
        _proto.text = function text(src) {
            var cap = this.rules.block.text.exec(src);
            if (cap) return {
                type: 'text',
                raw: cap[0],
                text: cap[0],
                tokens: this.lexer.inline(cap[0])
            };
        };
        _proto.escape = function escape$1(src) {
            var cap = this.rules.inline.escape.exec(src);
            if (cap) return {
                type: 'escape',
                raw: cap[0],
                text: escape(cap[1])
            };
        };
        _proto.tag = function tag(src) {
            var cap = this.rules.inline.tag.exec(src);
            if (cap) {
                if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) this.lexer.state.inLink = true;
                else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) this.lexer.state.inLink = false;
                if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = true;
                else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) this.lexer.state.inRawBlock = false;
                return {
                    type: this.options.sanitize ? 'text' : 'html',
                    raw: cap[0],
                    inLink: this.lexer.state.inLink,
                    inRawBlock: this.lexer.state.inRawBlock,
                    text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0]
                };
            }
        };
        _proto.link = function link(src) {
            var cap = this.rules.inline.link.exec(src);
            if (cap) {
                var trimmedUrl = cap[2].trim();
                if (!this.options.pedantic && /^</.test(trimmedUrl)) {
                    // commonmark requires matching angle brackets
                    if (!/>$/.test(trimmedUrl)) return;
                    // ending angle bracket cannot be escaped
                    var rtrimSlash = rtrim(trimmedUrl.slice(0, -1), '\\');
                    if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) return;
                } else {
                    // find closing parenthesis
                    var lastParenIndex = findClosingBracket(cap[2], '()');
                    if (lastParenIndex > -1) {
                        var start = cap[0].indexOf('!') === 0 ? 5 : 4;
                        var linkLen = start + cap[1].length + lastParenIndex;
                        cap[2] = cap[2].substring(0, lastParenIndex);
                        cap[0] = cap[0].substring(0, linkLen).trim();
                        cap[3] = '';
                    }
                }
                var href = cap[2];
                var title = '';
                if (this.options.pedantic) {
                    // split pedantic href and title
                    var link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
                    if (link) {
                        href = link[1];
                        title = link[3];
                    }
                } else title = cap[3] ? cap[3].slice(1, -1) : '';
                href = href.trim();
                if (/^</.test(href)) {
                    if (this.options.pedantic && !/>$/.test(trimmedUrl)) // pedantic allows starting angle bracket without ending angle bracket
                    href = href.slice(1);
                    else href = href.slice(1, -1);
                }
                return outputLink(cap, {
                    href: href ? href.replace(this.rules.inline._escapes, '$1') : href,
                    title: title ? title.replace(this.rules.inline._escapes, '$1') : title
                }, cap[0], this.lexer);
            }
        };
        _proto.reflink = function reflink(src, links) {
            var cap;
            if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
                var link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
                link = links[link.toLowerCase()];
                if (!link) {
                    var text = cap[0].charAt(0);
                    return {
                        type: 'text',
                        raw: text,
                        text: text
                    };
                }
                return outputLink(cap, link, cap[0], this.lexer);
            }
        };
        _proto.emStrong = function emStrong(src, maskedSrc, prevChar) {
            if (prevChar === void 0) prevChar = '';
            var match = this.rules.inline.emStrong.lDelim.exec(src);
            if (!match) return;
            // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
            if (match[3] && prevChar.match(/(?:[0-9A-Za-z\xAA\xB2\xB3\xB5\xB9\xBA\xBC-\xBE\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u0660-\u0669\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07C0-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0966-\u096F\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09E6-\u09F1\u09F4-\u09F9\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AE6-\u0AEF\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F\u0B71-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0BE6-\u0BF2\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C66-\u0C6F\u0C78-\u0C7E\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CE6-\u0CEF\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D58-\u0D61\u0D66-\u0D78\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DE6-\u0DEF\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F20-\u0F33\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F-\u1049\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1369-\u137C\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A16\u1A20-\u1A54\u1A80-\u1A89\u1A90-\u1A99\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B50-\u1B59\u1B83-\u1BA0\u1BAE-\u1BE5\u1C00-\u1C23\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2070\u2071\u2074-\u2079\u207F-\u2089\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2CFD\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u3192-\u3195\u31A0-\u31BF\u31F0-\u31FF\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA830-\uA835\uA840-\uA873\uA882-\uA8B3\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA900-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF-\uA9D9\uA9E0-\uA9E4\uA9E6-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA50-\uAA59\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDE80-\uDE9C\uDEA0-\uDED0\uDEE1-\uDEFB\uDF00-\uDF23\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC58-\uDC76\uDC79-\uDC9E\uDCA7-\uDCAF\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDD1B\uDD20-\uDD39\uDD80-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE40-\uDE48\uDE60-\uDE7E\uDE80-\uDE9F\uDEC0-\uDEC7\uDEC9-\uDEE4\uDEEB-\uDEEF\uDF00-\uDF35\uDF40-\uDF55\uDF58-\uDF72\uDF78-\uDF91\uDFA9-\uDFAF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDD23\uDD30-\uDD39\uDE60-\uDE7E\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF27\uDF30-\uDF45\uDF51-\uDF54\uDF70-\uDF81\uDFB0-\uDFCB\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC52-\uDC6F\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD03-\uDD26\uDD36-\uDD3F\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDD0-\uDDDA\uDDDC\uDDE1-\uDDF4\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDEF0-\uDEF9\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC50-\uDC59\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE50-\uDE59\uDE80-\uDEAA\uDEB8\uDEC0-\uDEC9\uDF00-\uDF1A\uDF30-\uDF3B\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCF2\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDD50-\uDD59\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC50-\uDC6C\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD50-\uDD59\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDA0-\uDDA9\uDEE0-\uDEF2\uDFB0\uDFC0-\uDFD4]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDE70-\uDEBE\uDEC0-\uDEC9\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE96\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD50-\uDD52\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD834[\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD837[\uDF00-\uDF1E]|\uD838[\uDD00-\uDD2C\uDD37-\uDD3D\uDD40-\uDD49\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB\uDEF0-\uDEF9]|\uD839[\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDCC7-\uDCCF\uDD00-\uDD43\uDD4B\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF38\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A])/)) return;
            var nextChar = match[1] || match[2] || '';
            if (!nextChar || nextChar && (prevChar === '' || this.rules.inline.punctuation.exec(prevChar))) {
                var lLength = match[0].length - 1;
                var rDelim, rLength, delimTotal = lLength, midDelimTotal = 0;
                var endReg = match[0][0] === '*' ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
                endReg.lastIndex = 0;
                // Clip maskedSrc to same section of string as src (move to lexer?)
                maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
                while((match = endReg.exec(maskedSrc)) != null){
                    rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
                    if (!rDelim) continue; // skip single * in __abc*abc__
                    rLength = rDelim.length;
                    if (match[3] || match[4]) {
                        // found another Left Delim
                        delimTotal += rLength;
                        continue;
                    } else if (match[5] || match[6]) // either Left or Right Delim
                    {
                        if (lLength % 3 && !((lLength + rLength) % 3)) {
                            midDelimTotal += rLength;
                            continue; // CommonMark Emphasis Rules 9-10
                        }
                    }
                    delimTotal -= rLength;
                    if (delimTotal > 0) continue; // Haven't found enough closing delimiters
                    // Remove extra characters. *a*** -> *a*
                    rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
                    var raw = src.slice(0, lLength + match.index + (match[0].length - rDelim.length) + rLength);
                    // Create `em` if smallest delimiter has odd char count. *a***
                    if (Math.min(lLength, rLength) % 2) {
                        var _text = raw.slice(1, -1);
                        return {
                            type: 'em',
                            raw: raw,
                            text: _text,
                            tokens: this.lexer.inlineTokens(_text)
                        };
                    }
                    // Create 'strong' if smallest delimiter has even char count. **a***
                    var text = raw.slice(2, -2);
                    return {
                        type: 'strong',
                        raw: raw,
                        text: text,
                        tokens: this.lexer.inlineTokens(text)
                    };
                }
            }
        };
        _proto.codespan = function codespan(src) {
            var cap = this.rules.inline.code.exec(src);
            if (cap) {
                var text = cap[2].replace(/\n/g, ' ');
                var hasNonSpaceChars = /[^ ]/.test(text);
                var hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
                if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) text = text.substring(1, text.length - 1);
                text = escape(text, true);
                return {
                    type: 'codespan',
                    raw: cap[0],
                    text: text
                };
            }
        };
        _proto.br = function br(src) {
            var cap = this.rules.inline.br.exec(src);
            if (cap) return {
                type: 'br',
                raw: cap[0]
            };
        };
        _proto.del = function del(src) {
            var cap = this.rules.inline.del.exec(src);
            if (cap) return {
                type: 'del',
                raw: cap[0],
                text: cap[2],
                tokens: this.lexer.inlineTokens(cap[2])
            };
        };
        _proto.autolink = function autolink(src, mangle) {
            var cap = this.rules.inline.autolink.exec(src);
            if (cap) {
                var text, href;
                if (cap[2] === '@') {
                    text = escape(this.options.mangle ? mangle(cap[1]) : cap[1]);
                    href = 'mailto:' + text;
                } else {
                    text = escape(cap[1]);
                    href = text;
                }
                return {
                    type: 'link',
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: 'text',
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        };
        _proto.url = function url(src, mangle) {
            var cap;
            if (cap = this.rules.inline.url.exec(src)) {
                var text, href;
                if (cap[2] === '@') {
                    text = escape(this.options.mangle ? mangle(cap[0]) : cap[0]);
                    href = 'mailto:' + text;
                } else {
                    // do extended autolink path validation
                    var prevCapZero;
                    do {
                        prevCapZero = cap[0];
                        cap[0] = this.rules.inline._backpedal.exec(cap[0])[0];
                    }while (prevCapZero !== cap[0]);
                    text = escape(cap[0]);
                    if (cap[1] === 'www.') href = 'http://' + cap[0];
                    else href = cap[0];
                }
                return {
                    type: 'link',
                    raw: cap[0],
                    text: text,
                    href: href,
                    tokens: [
                        {
                            type: 'text',
                            raw: text,
                            text: text
                        }
                    ]
                };
            }
        };
        _proto.inlineText = function inlineText(src, smartypants) {
            var cap = this.rules.inline.text.exec(src);
            if (cap) {
                var text;
                if (this.lexer.state.inRawBlock) text = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0];
                else text = escape(this.options.smartypants ? smartypants(cap[0]) : cap[0]);
                return {
                    type: 'text',
                    raw: cap[0],
                    text: text
                };
            }
        };
        return Tokenizer;
    }();
    /**
   * Block-Level Grammar
   */ var block = {
        newline: /^(?: *(?:\n|$))+/,
        code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
        fences: /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
        hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
        heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
        blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
        list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
        html: "^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))",
        def: /^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
        table: noopTest,
        lheading: /^((?:.|\n(?!\n))+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        // regex template, placeholders will be replaced according to different paragraph
        // interruption rules of commonmark and the original markdown spec:
        _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
        text: /^[^\n]+/
    };
    block._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
    block._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
    block.def = edit(block.def).replace('label', block._label).replace('title', block._title).getRegex();
    block.bullet = /(?:[*+-]|\d{1,9}[.)])/;
    block.listItemStart = edit(/^( *)(bull) */).replace('bull', block.bullet).getRegex();
    block.list = edit(block.list).replace(/bull/g, block.bullet).replace('hr', '\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))').replace('def', '\\n+(?=' + block.def.source + ')').getRegex();
    block._tag = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul";
    block._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
    block.html = edit(block.html, 'i').replace('comment', block._comment).replace('tag', block._tag).replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
    block.paragraph = edit(block._paragraph).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
    .replace('|table', '').replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
    .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
    .getRegex();
    block.blockquote = edit(block.blockquote).replace('paragraph', block.paragraph).getRegex();
    /**
   * Normal Block Grammar
   */ block.normal = _extends({}, block);
    /**
   * GFM Block Grammar
   */ block.gfm = _extends({}, block.normal, {
        table: "^ *([^\\n ].*\\|.*)\\n {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)" // Cells
    });
    block.gfm.table = edit(block.gfm.table).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('blockquote', ' {0,3}>').replace('code', ' {4}[^\\n]').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
    .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // tables can be interrupted by type (6) html blocks
    .getRegex();
    block.gfm.paragraph = edit(block._paragraph).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
    .replace('table', block.gfm.table) // interrupt paragraphs with table
    .replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
    .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
    .getRegex();
    /**
   * Pedantic grammar (original John Gruber's loose markdown specification)
   */ block.pedantic = _extends({}, block.normal, {
        html: edit("^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:\"[^\"]*\"|'[^']*'|\\s[^'\"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))").replace('comment', block._comment).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
        def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
        heading: /^(#{1,6})(.*)(?:\n+|$)/,
        fences: noopTest,
        // fences not supported
        lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
        paragraph: edit(block.normal._paragraph).replace('hr', block.hr).replace('heading', ' *#{1,6} *[^\n]').replace('lheading', block.lheading).replace('blockquote', ' {0,3}>').replace('|fences', '').replace('|list', '').replace('|html', '').getRegex()
    });
    /**
   * Inline-Level Grammar
   */ var inline = {
        escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
        autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
        url: noopTest,
        tag: "^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>",
        // CDATA section
        link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
        reflink: /^!?\[(label)\]\[(ref)\]/,
        nolink: /^!?\[(ref)\](?:\[\])?/,
        reflinkSearch: 'reflink|nolink(?!\\()',
        emStrong: {
            lDelim: /^(?:\*+(?:([punct_])|[^\s*]))|^_+(?:([punct*])|([^\s_]))/,
            //        (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
            //          () Skip orphan inside strong                                      () Consume to delim     (1) #***                (2) a***#, a***                             (3) #***a, ***a                 (4) ***#              (5) #***#                 (6) a***a
            rDelimAst: /^(?:[^_*\\]|\\.)*?\_\_(?:[^_*\\]|\\.)*?\*(?:[^_*\\]|\\.)*?(?=\_\_)|(?:[^*\\]|\\.)+(?=[^*])|[punct_](\*+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\*+)(?=[punct_\s]|$)|[punct_\s](\*+)(?=[^punct*_\s])|[\s](\*+)(?=[punct_])|[punct_](\*+)(?=[punct_])|(?:[^punct*_\s\\]|\\.)(\*+)(?=[^punct*_\s])/,
            rDelimUnd: /^(?:[^_*\\]|\\.)*?\*\*(?:[^_*\\]|\\.)*?\_(?:[^_*\\]|\\.)*?(?=\*\*)|(?:[^_\\]|\\.)+(?=[^_])|[punct*](\_+)(?=[\s]|$)|(?:[^punct*_\s\\]|\\.)(\_+)(?=[punct*\s]|$)|[punct*\s](\_+)(?=[^punct*_\s])|[\s](\_+)(?=[punct*])|[punct*](\_+)(?=[punct*])/ // ^- Not allowed for _
        },
        code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
        br: /^( {2,}|\\)\n(?!\s*$)/,
        del: noopTest,
        text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
        punctuation: /^([\spunctuation])/
    };
    // list of punctuation marks from CommonMark spec
    // without * and _ to handle the different emphasis markers * and _
    inline._punctuation = '!"#$%&\'()+\\-.,/:;<=>?@\\[\\]`^{|}~';
    inline.punctuation = edit(inline.punctuation).replace(/punctuation/g, inline._punctuation).getRegex();
    // sequences em should skip over [title](link), `code`, <html>
    inline.blockSkip = /\[[^\]]*?\]\([^\)]*?\)|`[^`]*?`|<[^>]*?>/g;
    // lookbehind is not available on Safari as of version 16
    // inline.escapedEmSt = /(?<=(?:^|[^\\)(?:\\[^])*)\\[*_]/g;
    inline.escapedEmSt = /(?:^|[^\\])(?:\\\\)*\\[*_]/g;
    inline._comment = edit(block._comment).replace('(?:-->|$)', '-->').getRegex();
    inline.emStrong.lDelim = edit(inline.emStrong.lDelim).replace(/punct/g, inline._punctuation).getRegex();
    inline.emStrong.rDelimAst = edit(inline.emStrong.rDelimAst, 'g').replace(/punct/g, inline._punctuation).getRegex();
    inline.emStrong.rDelimUnd = edit(inline.emStrong.rDelimUnd, 'g').replace(/punct/g, inline._punctuation).getRegex();
    inline._escapes = /\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/g;
    inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
    inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
    inline.autolink = edit(inline.autolink).replace('scheme', inline._scheme).replace('email', inline._email).getRegex();
    inline._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
    inline.tag = edit(inline.tag).replace('comment', inline._comment).replace('attribute', inline._attribute).getRegex();
    inline._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
    inline._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
    inline._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
    inline.link = edit(inline.link).replace('label', inline._label).replace('href', inline._href).replace('title', inline._title).getRegex();
    inline.reflink = edit(inline.reflink).replace('label', inline._label).replace('ref', block._label).getRegex();
    inline.nolink = edit(inline.nolink).replace('ref', block._label).getRegex();
    inline.reflinkSearch = edit(inline.reflinkSearch, 'g').replace('reflink', inline.reflink).replace('nolink', inline.nolink).getRegex();
    /**
   * Normal Inline Grammar
   */ inline.normal = _extends({}, inline);
    /**
   * Pedantic Inline Grammar
   */ inline.pedantic = _extends({}, inline.normal, {
        strong: {
            start: /^__|\*\*/,
            middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
            endAst: /\*\*(?!\*)/g,
            endUnd: /__(?!_)/g
        },
        em: {
            start: /^_|\*/,
            middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
            endAst: /\*(?!\*)/g,
            endUnd: /_(?!_)/g
        },
        link: edit(/^!?\[(label)\]\((.*?)\)/).replace('label', inline._label).getRegex(),
        reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace('label', inline._label).getRegex()
    });
    /**
   * GFM Inline Grammar
   */ inline.gfm = _extends({}, inline.normal, {
        escape: edit(inline.escape).replace('])', '~|])').getRegex(),
        _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
        url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
        _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
        del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
        text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
    });
    inline.gfm.url = edit(inline.gfm.url, 'i').replace('email', inline.gfm._extended_email).getRegex();
    /**
   * GFM + Line Breaks Inline Grammar
   */ inline.breaks = _extends({}, inline.gfm, {
        br: edit(inline.br).replace('{2,}', '*').getRegex(),
        text: edit(inline.gfm.text).replace('\\b_', '\\b_| {2,}\\n').replace(/\{2,\}/g, '*').getRegex()
    });
    /**
   * smartypants text replacement
   * @param {string} text
   */ function smartypants(text) {
        return text// em-dashes
        .replace(/---/g, "\u2014")// en-dashes
        .replace(/--/g, "\u2013")// opening singles
        .replace(/(^|[-\u2014/(\[{"\s])'/g, "$1\u2018")// closing singles & apostrophes
        .replace(/'/g, "\u2019")// opening doubles
        .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1\u201C")// closing doubles
        .replace(/"/g, "\u201D")// ellipses
        .replace(/\.{3}/g, "\u2026");
    }
    /**
   * mangle email addresses
   * @param {string} text
   */ function mangle(text) {
        var out = '', i, ch;
        var l = text.length;
        for(i = 0; i < l; i++){
            ch = text.charCodeAt(i);
            if (Math.random() > 0.5) ch = 'x' + ch.toString(16);
            out += '&#' + ch + ';';
        }
        return out;
    }
    /**
   * Block Lexer
   */ var Lexer = /*#__PURE__*/ function() {
        function Lexer(options) {
            this.tokens = [];
            this.tokens.links = Object.create(null);
            this.options = options || exports1.defaults;
            this.options.tokenizer = this.options.tokenizer || new Tokenizer();
            this.tokenizer = this.options.tokenizer;
            this.tokenizer.options = this.options;
            this.tokenizer.lexer = this;
            this.inlineQueue = [];
            this.state = {
                inLink: false,
                inRawBlock: false,
                top: true
            };
            var rules = {
                block: block.normal,
                inline: inline.normal
            };
            if (this.options.pedantic) {
                rules.block = block.pedantic;
                rules.inline = inline.pedantic;
            } else if (this.options.gfm) {
                rules.block = block.gfm;
                if (this.options.breaks) rules.inline = inline.breaks;
                else rules.inline = inline.gfm;
            }
            this.tokenizer.rules = rules;
        }
        /**
     * Expose Rules
     */ /**
     * Static Lex Method
     */ Lexer.lex = function lex(src, options) {
            var lexer = new Lexer(options);
            return lexer.lex(src);
        };
        Lexer.lexInline = function lexInline(src, options) {
            var lexer = new Lexer(options);
            return lexer.inlineTokens(src);
        };
        var _proto = Lexer.prototype;
        _proto.lex = function lex(src) {
            src = src.replace(/\r\n|\r/g, '\n');
            this.blockTokens(src, this.tokens);
            var next;
            while(next = this.inlineQueue.shift())this.inlineTokens(next.src, next.tokens);
            return this.tokens;
        };
        _proto.blockTokens = function blockTokens(src, tokens) {
            var _this = this;
            if (tokens === void 0) tokens = [];
            if (this.options.pedantic) src = src.replace(/\t/g, '    ').replace(/^ +$/gm, '');
            else src = src.replace(/^( *)(\t+)/gm, function(_, leading, tabs) {
                return leading + '    '.repeat(tabs.length);
            });
            var token, lastToken, cutSrc, lastParagraphClipped;
            while(src){
                if (this.options.extensions && this.options.extensions.block && this.options.extensions.block.some(function(extTokenizer) {
                    if (token = extTokenizer.call({
                        lexer: _this
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                // newline
                if (token = this.tokenizer.space(src)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.length === 1 && tokens.length > 0) // if there's a single \n as a spacer, it's terminating the last line,
                    // so move it there so that we don't get unecessary paragraph tags
                    tokens[tokens.length - 1].raw += '\n';
                    else tokens.push(token);
                    continue;
                }
                // code
                if (token = this.tokenizer.code(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    // An indented code block cannot interrupt a paragraph.
                    if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.text;
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                }
                // fences
                if (token = this.tokenizer.fences(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // heading
                if (token = this.tokenizer.heading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // hr
                if (token = this.tokenizer.hr(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // blockquote
                if (token = this.tokenizer.blockquote(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // list
                if (token = this.tokenizer.list(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // html
                if (token = this.tokenizer.html(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // def
                if (token = this.tokenizer.def(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.raw;
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else if (!this.tokens.links[token.tag]) this.tokens.links[token.tag] = {
                        href: token.href,
                        title: token.title
                    };
                    continue;
                }
                // table (gfm)
                if (token = this.tokenizer.table(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // lheading
                if (token = this.tokenizer.lheading(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // top-level paragraph
                // prevent paragraph consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startBlock) (function() {
                    var startIndex = Infinity;
                    var tempSrc = src.slice(1);
                    var tempStart = void 0;
                    _this.options.extensions.startBlock.forEach(function(getStartIndex) {
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === 'number' && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                })();
                if (this.state.top && (token = this.tokenizer.paragraph(cutSrc))) {
                    lastToken = tokens[tokens.length - 1];
                    if (lastParagraphClipped && lastToken.type === 'paragraph') {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    lastParagraphClipped = cutSrc.length !== src.length;
                    src = src.substring(token.raw.length);
                    continue;
                }
                // text
                if (token = this.tokenizer.text(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === 'text') {
                        lastToken.raw += '\n' + token.raw;
                        lastToken.text += '\n' + token.text;
                        this.inlineQueue.pop();
                        this.inlineQueue[this.inlineQueue.length - 1].src = lastToken.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    var errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            this.state.top = true;
            return tokens;
        };
        _proto.inline = function inline(src, tokens) {
            if (tokens === void 0) tokens = [];
            this.inlineQueue.push({
                src: src,
                tokens: tokens
            });
            return tokens;
        };
        _proto.inlineTokens = function inlineTokens(src, tokens) {
            var _this2 = this;
            if (tokens === void 0) tokens = [];
            var token, lastToken, cutSrc;
            // String with links masked to avoid interference with em and strong
            var maskedSrc = src;
            var match;
            var keepPrevChar, prevChar;
            // Mask out reflinks
            if (this.tokens.links) {
                var links = Object.keys(this.tokens.links);
                if (links.length > 0) {
                    while((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null)if (links.includes(match[0].slice(match[0].lastIndexOf('[') + 1, -1))) maskedSrc = maskedSrc.slice(0, match.index) + '[' + repeatString('a', match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
                }
            }
            // Mask out other blocks
            while((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null)maskedSrc = maskedSrc.slice(0, match.index) + '[' + repeatString('a', match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
            // Mask out escaped em & strong delimiters
            while((match = this.tokenizer.rules.inline.escapedEmSt.exec(maskedSrc)) != null){
                maskedSrc = maskedSrc.slice(0, match.index + match[0].length - 2) + '++' + maskedSrc.slice(this.tokenizer.rules.inline.escapedEmSt.lastIndex);
                this.tokenizer.rules.inline.escapedEmSt.lastIndex--;
            }
            while(src){
                if (!keepPrevChar) prevChar = '';
                keepPrevChar = false;
                // extensions
                if (this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some(function(extTokenizer) {
                    if (token = extTokenizer.call({
                        lexer: _this2
                    }, src, tokens)) {
                        src = src.substring(token.raw.length);
                        tokens.push(token);
                        return true;
                    }
                    return false;
                })) continue;
                // escape
                if (token = this.tokenizer.escape(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // tag
                if (token = this.tokenizer.tag(src)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && token.type === 'text' && lastToken.type === 'text') {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                // link
                if (token = this.tokenizer.link(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // reflink, nolink
                if (token = this.tokenizer.reflink(src, this.tokens.links)) {
                    src = src.substring(token.raw.length);
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && token.type === 'text' && lastToken.type === 'text') {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                // em & strong
                if (token = this.tokenizer.emStrong(src, maskedSrc, prevChar)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // code
                if (token = this.tokenizer.codespan(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // br
                if (token = this.tokenizer.br(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // del (gfm)
                if (token = this.tokenizer.del(src)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // autolink
                if (token = this.tokenizer.autolink(src, mangle)) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // url (gfm)
                if (!this.state.inLink && (token = this.tokenizer.url(src, mangle))) {
                    src = src.substring(token.raw.length);
                    tokens.push(token);
                    continue;
                }
                // text
                // prevent inlineText consuming extensions by clipping 'src' to extension start
                cutSrc = src;
                if (this.options.extensions && this.options.extensions.startInline) (function() {
                    var startIndex = Infinity;
                    var tempSrc = src.slice(1);
                    var tempStart = void 0;
                    _this2.options.extensions.startInline.forEach(function(getStartIndex) {
                        tempStart = getStartIndex.call({
                            lexer: this
                        }, tempSrc);
                        if (typeof tempStart === 'number' && tempStart >= 0) startIndex = Math.min(startIndex, tempStart);
                    });
                    if (startIndex < Infinity && startIndex >= 0) cutSrc = src.substring(0, startIndex + 1);
                })();
                if (token = this.tokenizer.inlineText(cutSrc, smartypants)) {
                    src = src.substring(token.raw.length);
                    if (token.raw.slice(-1) !== '_') // Track prevChar before string of ____ started
                    prevChar = token.raw.slice(-1);
                    keepPrevChar = true;
                    lastToken = tokens[tokens.length - 1];
                    if (lastToken && lastToken.type === 'text') {
                        lastToken.raw += token.raw;
                        lastToken.text += token.text;
                    } else tokens.push(token);
                    continue;
                }
                if (src) {
                    var errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
                    if (this.options.silent) {
                        console.error(errMsg);
                        break;
                    } else throw new Error(errMsg);
                }
            }
            return tokens;
        };
        _createClass(Lexer, null, [
            {
                key: "rules",
                get: function get() {
                    return {
                        block: block,
                        inline: inline
                    };
                }
            }
        ]);
        return Lexer;
    }();
    /**
   * Renderer
   */ var Renderer = /*#__PURE__*/ function() {
        function Renderer(options) {
            this.options = options || exports1.defaults;
        }
        var _proto = Renderer.prototype;
        _proto.code = function code(_code, infostring, escaped) {
            var lang = (infostring || '').match(/\S*/)[0];
            if (this.options.highlight) {
                var out = this.options.highlight(_code, lang);
                if (out != null && out !== _code) {
                    escaped = true;
                    _code = out;
                }
            }
            _code = _code.replace(/\n$/, '') + '\n';
            if (!lang) return '<pre><code>' + (escaped ? _code : escape(_code, true)) + '</code></pre>\n';
            return '<pre><code class="' + this.options.langPrefix + escape(lang) + '">' + (escaped ? _code : escape(_code, true)) + '</code></pre>\n';
        };
        _proto.blockquote = function blockquote(quote) {
            return "<blockquote>\n" + quote + "</blockquote>\n";
        };
        _proto.html = function html(_html) {
            return _html;
        };
        _proto.heading = function heading(text, level, raw, slugger) {
            if (this.options.headerIds) {
                var id = this.options.headerPrefix + slugger.slug(raw);
                return "<h" + level + " id=\"" + id + "\">" + text + "</h" + level + ">\n";
            }
            // ignore IDs
            return "<h" + level + ">" + text + "</h" + level + ">\n";
        };
        _proto.hr = function hr() {
            return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
        };
        _proto.list = function list(body, ordered, start) {
            var type = ordered ? 'ol' : 'ul', startatt = ordered && start !== 1 ? ' start="' + start + '"' : '';
            return '<' + type + startatt + '>\n' + body + '</' + type + '>\n';
        };
        _proto.listitem = function listitem(text) {
            return "<li>" + text + "</li>\n";
        };
        _proto.checkbox = function checkbox(checked) {
            return '<input ' + (checked ? 'checked="" ' : '') + 'disabled="" type="checkbox"' + (this.options.xhtml ? ' /' : '') + '> ';
        };
        _proto.paragraph = function paragraph(text) {
            return "<p>" + text + "</p>\n";
        };
        _proto.table = function table(header, body) {
            if (body) body = "<tbody>" + body + "</tbody>";
            return "<table>\n<thead>\n" + header + '</thead>\n' + body + '</table>\n';
        };
        _proto.tablerow = function tablerow(content) {
            return "<tr>\n" + content + "</tr>\n";
        };
        _proto.tablecell = function tablecell(content, flags) {
            var type = flags.header ? 'th' : 'td';
            var tag = flags.align ? "<" + type + " align=\"" + flags.align + "\">" : "<" + type + ">";
            return tag + content + ("</" + type + ">\n");
        };
        _proto.strong = function strong(text) {
            return "<strong>" + text + "</strong>";
        };
        _proto.em = function em(text) {
            return "<em>" + text + "</em>";
        };
        _proto.codespan = function codespan(text) {
            return "<code>" + text + "</code>";
        };
        _proto.br = function br() {
            return this.options.xhtml ? '<br/>' : '<br>';
        };
        _proto.del = function del(text) {
            return "<del>" + text + "</del>";
        };
        _proto.link = function link(href, title, text) {
            href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
            if (href === null) return text;
            var out = '<a href="' + href + '"';
            if (title) out += ' title="' + title + '"';
            out += '>' + text + '</a>';
            return out;
        };
        _proto.image = function image(href, title, text) {
            href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
            if (href === null) return text;
            var out = "<img src=\"" + href + "\" alt=\"" + text + "\"";
            if (title) out += " title=\"" + title + "\"";
            out += this.options.xhtml ? '/>' : '>';
            return out;
        };
        _proto.text = function text(_text) {
            return _text;
        };
        return Renderer;
    }();
    /**
   * TextRenderer
   * returns only the textual part of the token
   */ var TextRenderer = /*#__PURE__*/ function() {
        function TextRenderer() {}
        var _proto = TextRenderer.prototype;
        // no need for block level renderers
        _proto.strong = function strong(text) {
            return text;
        };
        _proto.em = function em(text) {
            return text;
        };
        _proto.codespan = function codespan(text) {
            return text;
        };
        _proto.del = function del(text) {
            return text;
        };
        _proto.html = function html(text) {
            return text;
        };
        _proto.text = function text(_text) {
            return _text;
        };
        _proto.link = function link(href, title, text) {
            return '' + text;
        };
        _proto.image = function image(href, title, text) {
            return '' + text;
        };
        _proto.br = function br() {
            return '';
        };
        return TextRenderer;
    }();
    /**
   * Slugger generates header id
   */ var Slugger = /*#__PURE__*/ function() {
        function Slugger() {
            this.seen = {};
        }
        /**
     * @param {string} value
     */ var _proto = Slugger.prototype;
        _proto.serialize = function serialize(value) {
            return value.toLowerCase().trim()// remove html tags
            .replace(/<[!\/a-z].*?>/ig, '')// remove unwanted chars
            .replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, '').replace(/\s/g, '-');
        };
        _proto.getNextSafeSlug = function getNextSafeSlug(originalSlug, isDryRun) {
            var slug = originalSlug;
            var occurenceAccumulator = 0;
            if (this.seen.hasOwnProperty(slug)) {
                occurenceAccumulator = this.seen[originalSlug];
                do {
                    occurenceAccumulator++;
                    slug = originalSlug + '-' + occurenceAccumulator;
                }while (this.seen.hasOwnProperty(slug));
            }
            if (!isDryRun) {
                this.seen[originalSlug] = occurenceAccumulator;
                this.seen[slug] = 0;
            }
            return slug;
        };
        _proto.slug = function slug(value, options) {
            if (options === void 0) options = {};
            var slug = this.serialize(value);
            return this.getNextSafeSlug(slug, options.dryrun);
        };
        return Slugger;
    }();
    /**
   * Parsing & Compiling
   */ var Parser = /*#__PURE__*/ function() {
        function Parser(options) {
            this.options = options || exports1.defaults;
            this.options.renderer = this.options.renderer || new Renderer();
            this.renderer = this.options.renderer;
            this.renderer.options = this.options;
            this.textRenderer = new TextRenderer();
            this.slugger = new Slugger();
        }
        /**
     * Static Parse Method
     */ Parser.parse = function parse(tokens, options) {
            var parser = new Parser(options);
            return parser.parse(tokens);
        };
        Parser.parseInline = function parseInline(tokens, options) {
            var parser = new Parser(options);
            return parser.parseInline(tokens);
        };
        var _proto = Parser.prototype;
        _proto.parse = function parse(tokens, top) {
            if (top === void 0) top = true;
            var out = '', i, j, k, l2, l3, row, cell, header, body, token, ordered, start, loose, itemBody, item, checked, task, checkbox, ret;
            var l = tokens.length;
            for(i = 0; i < l; i++){
                token = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
                    ret = this.options.extensions.renderers[token.type].call({
                        parser: this
                    }, token);
                    if (ret !== false || ![
                        'space',
                        'hr',
                        'heading',
                        'code',
                        'table',
                        'blockquote',
                        'list',
                        'html',
                        'paragraph',
                        'text'
                    ].includes(token.type)) {
                        out += ret || '';
                        continue;
                    }
                }
                switch(token.type){
                    case 'space':
                        continue;
                    case 'hr':
                        out += this.renderer.hr();
                        continue;
                    case 'heading':
                        out += this.renderer.heading(this.parseInline(token.tokens), token.depth, unescape(this.parseInline(token.tokens, this.textRenderer)), this.slugger);
                        continue;
                    case 'code':
                        out += this.renderer.code(token.text, token.lang, token.escaped);
                        continue;
                    case 'table':
                        header = '';
                        // header
                        cell = '';
                        l2 = token.header.length;
                        for(j = 0; j < l2; j++)cell += this.renderer.tablecell(this.parseInline(token.header[j].tokens), {
                            header: true,
                            align: token.align[j]
                        });
                        header += this.renderer.tablerow(cell);
                        body = '';
                        l2 = token.rows.length;
                        for(j = 0; j < l2; j++){
                            row = token.rows[j];
                            cell = '';
                            l3 = row.length;
                            for(k = 0; k < l3; k++)cell += this.renderer.tablecell(this.parseInline(row[k].tokens), {
                                header: false,
                                align: token.align[k]
                            });
                            body += this.renderer.tablerow(cell);
                        }
                        out += this.renderer.table(header, body);
                        continue;
                    case 'blockquote':
                        body = this.parse(token.tokens);
                        out += this.renderer.blockquote(body);
                        continue;
                    case 'list':
                        ordered = token.ordered;
                        start = token.start;
                        loose = token.loose;
                        l2 = token.items.length;
                        body = '';
                        for(j = 0; j < l2; j++){
                            item = token.items[j];
                            checked = item.checked;
                            task = item.task;
                            itemBody = '';
                            if (item.task) {
                                checkbox = this.renderer.checkbox(checked);
                                if (loose) {
                                    if (item.tokens.length > 0 && item.tokens[0].type === 'paragraph') {
                                        item.tokens[0].text = checkbox + ' ' + item.tokens[0].text;
                                        if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === 'text') item.tokens[0].tokens[0].text = checkbox + ' ' + item.tokens[0].tokens[0].text;
                                    } else item.tokens.unshift({
                                        type: 'text',
                                        text: checkbox
                                    });
                                } else itemBody += checkbox;
                            }
                            itemBody += this.parse(item.tokens, loose);
                            body += this.renderer.listitem(itemBody, task, checked);
                        }
                        out += this.renderer.list(body, ordered, start);
                        continue;
                    case 'html':
                        // TODO parse inline content if parameter markdown=1
                        out += this.renderer.html(token.text);
                        continue;
                    case 'paragraph':
                        out += this.renderer.paragraph(this.parseInline(token.tokens));
                        continue;
                    case 'text':
                        body = token.tokens ? this.parseInline(token.tokens) : token.text;
                        while(i + 1 < l && tokens[i + 1].type === 'text'){
                            token = tokens[++i];
                            body += '\n' + (token.tokens ? this.parseInline(token.tokens) : token.text);
                        }
                        out += top ? this.renderer.paragraph(body) : body;
                        continue;
                    default:
                        var errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return;
                        } else throw new Error(errMsg);
                }
            }
            return out;
        };
        _proto.parseInline = function parseInline(tokens, renderer) {
            renderer = renderer || this.renderer;
            var out = '', i, token, ret;
            var l = tokens.length;
            for(i = 0; i < l; i++){
                token = tokens[i];
                // Run any renderer extensions
                if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
                    ret = this.options.extensions.renderers[token.type].call({
                        parser: this
                    }, token);
                    if (ret !== false || ![
                        'escape',
                        'html',
                        'link',
                        'image',
                        'strong',
                        'em',
                        'codespan',
                        'br',
                        'del',
                        'text'
                    ].includes(token.type)) {
                        out += ret || '';
                        continue;
                    }
                }
                switch(token.type){
                    case 'escape':
                        out += renderer.text(token.text);
                        break;
                    case 'html':
                        out += renderer.html(token.text);
                        break;
                    case 'link':
                        out += renderer.link(token.href, token.title, this.parseInline(token.tokens, renderer));
                        break;
                    case 'image':
                        out += renderer.image(token.href, token.title, token.text);
                        break;
                    case 'strong':
                        out += renderer.strong(this.parseInline(token.tokens, renderer));
                        break;
                    case 'em':
                        out += renderer.em(this.parseInline(token.tokens, renderer));
                        break;
                    case 'codespan':
                        out += renderer.codespan(token.text);
                        break;
                    case 'br':
                        out += renderer.br();
                        break;
                    case 'del':
                        out += renderer.del(this.parseInline(token.tokens, renderer));
                        break;
                    case 'text':
                        out += renderer.text(token.text);
                        break;
                    default:
                        var errMsg = 'Token with "' + token.type + '" type was not found.';
                        if (this.options.silent) {
                            console.error(errMsg);
                            return;
                        } else throw new Error(errMsg);
                }
            }
            return out;
        };
        return Parser;
    }();
    var Hooks = /*#__PURE__*/ function() {
        function Hooks(options) {
            this.options = options || exports1.defaults;
        }
        var _proto = Hooks.prototype;
        /**
     * Process markdown before marked
     */ _proto.preprocess = function preprocess(markdown) {
            return markdown;
        };
        _proto.postprocess = function postprocess(html) {
            return html;
        };
        return Hooks;
    }();
    Hooks.passThroughHooks = new Set([
        'preprocess',
        'postprocess'
    ]);
    function onError(silent, async, callback) {
        return function(e) {
            e.message += '\nPlease report this to https://github.com/markedjs/marked.';
            if (silent) {
                var msg = '<p>An error occurred:</p><pre>' + escape(e.message + '', true) + '</pre>';
                if (async) return Promise.resolve(msg);
                if (callback) {
                    callback(null, msg);
                    return;
                }
                return msg;
            }
            if (async) return Promise.reject(e);
            if (callback) {
                callback(e);
                return;
            }
            throw e;
        };
    }
    function parseMarkdown(lexer, parser) {
        return function(src, opt, callback) {
            if (typeof opt === 'function') {
                callback = opt;
                opt = null;
            }
            var origOpt = _extends({}, opt);
            opt = _extends({}, marked.defaults, origOpt);
            var throwError = onError(opt.silent, opt.async, callback);
            // throw error in case of non string input
            if (typeof src === 'undefined' || src === null) return throwError(new Error('marked(): input parameter is undefined or null'));
            if (typeof src !== 'string') return throwError(new Error('marked(): input parameter is of type ' + Object.prototype.toString.call(src) + ', string expected'));
            checkSanitizeDeprecation(opt);
            if (opt.hooks) opt.hooks.options = opt;
            if (callback) {
                var highlight = opt.highlight;
                var tokens;
                try {
                    if (opt.hooks) src = opt.hooks.preprocess(src);
                    tokens = lexer(src, opt);
                } catch (e) {
                    return throwError(e);
                }
                var done = function done(err) {
                    var out;
                    if (!err) try {
                        if (opt.walkTokens) marked.walkTokens(tokens, opt.walkTokens);
                        out = parser(tokens, opt);
                        if (opt.hooks) out = opt.hooks.postprocess(out);
                    } catch (e) {
                        err = e;
                    }
                    opt.highlight = highlight;
                    return err ? throwError(err) : callback(null, out);
                };
                if (!highlight || highlight.length < 3) return done();
                delete opt.highlight;
                if (!tokens.length) return done();
                var pending = 0;
                marked.walkTokens(tokens, function(token) {
                    if (token.type === 'code') {
                        pending++;
                        setTimeout(function() {
                            highlight(token.text, token.lang, function(err, code) {
                                if (err) return done(err);
                                if (code != null && code !== token.text) {
                                    token.text = code;
                                    token.escaped = true;
                                }
                                pending--;
                                if (pending === 0) done();
                            });
                        }, 0);
                    }
                });
                if (pending === 0) done();
                return;
            }
            if (opt.async) return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then(function(src) {
                return lexer(src, opt);
            }).then(function(tokens) {
                return opt.walkTokens ? Promise.all(marked.walkTokens(tokens, opt.walkTokens)).then(function() {
                    return tokens;
                }) : tokens;
            }).then(function(tokens) {
                return parser(tokens, opt);
            }).then(function(html) {
                return opt.hooks ? opt.hooks.postprocess(html) : html;
            })["catch"](throwError);
            try {
                if (opt.hooks) src = opt.hooks.preprocess(src);
                var _tokens = lexer(src, opt);
                if (opt.walkTokens) marked.walkTokens(_tokens, opt.walkTokens);
                var html = parser(_tokens, opt);
                if (opt.hooks) html = opt.hooks.postprocess(html);
                return html;
            } catch (e) {
                return throwError(e);
            }
        };
    }
    /**
   * Marked
   */ function marked(src, opt, callback) {
        return parseMarkdown(Lexer.lex, Parser.parse)(src, opt, callback);
    }
    /**
   * Options
   */ marked.options = marked.setOptions = function(opt) {
        marked.defaults = _extends({}, marked.defaults, opt);
        changeDefaults(marked.defaults);
        return marked;
    };
    marked.getDefaults = getDefaults;
    marked.defaults = exports1.defaults;
    /**
   * Use Extension
   */ marked.use = function() {
        var extensions = marked.defaults.extensions || {
            renderers: {},
            childTokens: {}
        };
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        args.forEach(function(pack) {
            // copy options to new object
            var opts = _extends({}, pack);
            // set async to true if it was set to true before
            opts.async = marked.defaults.async || opts.async || false;
            // ==-- Parse "addon" extensions --== //
            if (pack.extensions) {
                pack.extensions.forEach(function(ext) {
                    if (!ext.name) throw new Error('extension name required');
                    if (ext.renderer) {
                        // Renderer extensions
                        var prevRenderer = extensions.renderers[ext.name];
                        if (prevRenderer) // Replace extension with func to run new extension but fall back if false
                        extensions.renderers[ext.name] = function() {
                            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                            var ret = ext.renderer.apply(this, args);
                            if (ret === false) ret = prevRenderer.apply(this, args);
                            return ret;
                        };
                        else extensions.renderers[ext.name] = ext.renderer;
                    }
                    if (ext.tokenizer) {
                        // Tokenizer Extensions
                        if (!ext.level || ext.level !== 'block' && ext.level !== 'inline') throw new Error("extension level must be 'block' or 'inline'");
                        if (extensions[ext.level]) extensions[ext.level].unshift(ext.tokenizer);
                        else extensions[ext.level] = [
                            ext.tokenizer
                        ];
                        if (ext.start) {
                            // Function to check for start of token
                            if (ext.level === 'block') {
                                if (extensions.startBlock) extensions.startBlock.push(ext.start);
                                else extensions.startBlock = [
                                    ext.start
                                ];
                            } else if (ext.level === 'inline') {
                                if (extensions.startInline) extensions.startInline.push(ext.start);
                                else extensions.startInline = [
                                    ext.start
                                ];
                            }
                        }
                    }
                    if (ext.childTokens) // Child tokens to be visited by walkTokens
                    extensions.childTokens[ext.name] = ext.childTokens;
                });
                opts.extensions = extensions;
            }
            // ==-- Parse "overwrite" extensions --== //
            if (pack.renderer) (function() {
                var renderer = marked.defaults.renderer || new Renderer();
                var _loop = function _loop(prop) {
                    var prevRenderer = renderer[prop];
                    // Replace renderer with func to run extension, but fall back if false
                    renderer[prop] = function() {
                        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                        var ret = pack.renderer[prop].apply(renderer, args);
                        if (ret === false) ret = prevRenderer.apply(renderer, args);
                        return ret;
                    };
                };
                for(var prop in pack.renderer)_loop(prop);
                opts.renderer = renderer;
            })();
            if (pack.tokenizer) (function() {
                var tokenizer = marked.defaults.tokenizer || new Tokenizer();
                var _loop2 = function _loop2(prop) {
                    var prevTokenizer = tokenizer[prop];
                    // Replace tokenizer with func to run extension, but fall back if false
                    tokenizer[prop] = function() {
                        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                        var ret = pack.tokenizer[prop].apply(tokenizer, args);
                        if (ret === false) ret = prevTokenizer.apply(tokenizer, args);
                        return ret;
                    };
                };
                for(var prop in pack.tokenizer)_loop2(prop);
                opts.tokenizer = tokenizer;
            })();
            // ==-- Parse Hooks extensions --== //
            if (pack.hooks) (function() {
                var hooks = marked.defaults.hooks || new Hooks();
                var _loop3 = function _loop3(prop) {
                    var prevHook = hooks[prop];
                    if (Hooks.passThroughHooks.has(prop)) hooks[prop] = function(arg) {
                        if (marked.defaults.async) return Promise.resolve(pack.hooks[prop].call(hooks, arg)).then(function(ret) {
                            return prevHook.call(hooks, ret);
                        });
                        var ret = pack.hooks[prop].call(hooks, arg);
                        return prevHook.call(hooks, ret);
                    };
                    else hooks[prop] = function() {
                        for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
                        var ret = pack.hooks[prop].apply(hooks, args);
                        if (ret === false) ret = prevHook.apply(hooks, args);
                        return ret;
                    };
                };
                for(var prop in pack.hooks)_loop3(prop);
                opts.hooks = hooks;
            })();
            // ==-- Parse WalkTokens extensions --== //
            if (pack.walkTokens) {
                var _walkTokens = marked.defaults.walkTokens;
                opts.walkTokens = function(token) {
                    var values = [];
                    values.push(pack.walkTokens.call(this, token));
                    if (_walkTokens) values = values.concat(_walkTokens.call(this, token));
                    return values;
                };
            }
            marked.setOptions(opts);
        });
    };
    /**
   * Run callback for every token
   */ marked.walkTokens = function(tokens, callback) {
        var values = [];
        var _loop4 = function _loop4() {
            var token = _step.value;
            values = values.concat(callback.call(marked, token));
            switch(token.type){
                case 'table':
                    for(var _iterator2 = _createForOfIteratorHelperLoose(token.header), _step2; !(_step2 = _iterator2()).done;){
                        var cell = _step2.value;
                        values = values.concat(marked.walkTokens(cell.tokens, callback));
                    }
                    for(var _iterator3 = _createForOfIteratorHelperLoose(token.rows), _step3; !(_step3 = _iterator3()).done;){
                        var row = _step3.value;
                        for(var _iterator4 = _createForOfIteratorHelperLoose(row), _step4; !(_step4 = _iterator4()).done;){
                            var _cell = _step4.value;
                            values = values.concat(marked.walkTokens(_cell.tokens, callback));
                        }
                    }
                    break;
                case 'list':
                    values = values.concat(marked.walkTokens(token.items, callback));
                    break;
                default:
                    if (marked.defaults.extensions && marked.defaults.extensions.childTokens && marked.defaults.extensions.childTokens[token.type]) // Walk any extensions
                    marked.defaults.extensions.childTokens[token.type].forEach(function(childTokens) {
                        values = values.concat(marked.walkTokens(token[childTokens], callback));
                    });
                    else if (token.tokens) values = values.concat(marked.walkTokens(token.tokens, callback));
            }
        };
        for(var _iterator = _createForOfIteratorHelperLoose(tokens), _step; !(_step = _iterator()).done;)_loop4();
        return values;
    };
    /**
   * Parse Inline
   * @param {string} src
   */ marked.parseInline = parseMarkdown(Lexer.lexInline, Parser.parseInline);
    /**
   * Expose
   */ marked.Parser = Parser;
    marked.parser = Parser.parse;
    marked.Renderer = Renderer;
    marked.TextRenderer = TextRenderer;
    marked.Lexer = Lexer;
    marked.lexer = Lexer.lex;
    marked.Tokenizer = Tokenizer;
    marked.Slugger = Slugger;
    marked.Hooks = Hooks;
    marked.parse = marked;
    var options = marked.options;
    var setOptions = marked.setOptions;
    var use = marked.use;
    var walkTokens = marked.walkTokens;
    var parseInline = marked.parseInline;
    var parse = marked;
    var parser = Parser.parse;
    var lexer = Lexer.lex;
    exports1.Hooks = Hooks;
    exports1.Lexer = Lexer;
    exports1.Parser = Parser;
    exports1.Renderer = Renderer;
    exports1.Slugger = Slugger;
    exports1.TextRenderer = TextRenderer;
    exports1.Tokenizer = Tokenizer;
    exports1.getDefaults = getDefaults;
    exports1.lexer = lexer;
    exports1.marked = marked;
    exports1.options = options;
    exports1.parse = parse;
    exports1.parseInline = parseInline;
    exports1.parser = parser;
    exports1.setOptions = setOptions;
    exports1.use = use;
    exports1.walkTokens = walkTokens;
});

});


parcelRegister("bkA54", function(module, exports) {
'use strict';

var $jjnZg = parcelRequire("jjnZg");
var $83fd8cd682cc0cb3$require$obj = $jjnZg.obj;
var $83fd8cd682cc0cb3$require$fn = $jjnZg.fn;
const $83fd8cd682cc0cb3$var$getParent = (el, tagName)=>[].concat(tagName).indexOf(el.tagName) === -1 ? $83fd8cd682cc0cb3$var$getParent(el.parentNode, tagName) : el;
const $83fd8cd682cc0cb3$var$getElIndex = (el)=>$83fd8cd682cc0cb3$require$fn.pipe(()=>Array.from(el.parentNode.children).indexOf(el), // index => (console.log(index, el, Array.from(el.parentNode.children)), index),
    (index)=>el.tagName === 'LI' ? $83fd8cd682cc0cb3$var$getElIndex(el.parentNode) + index + 1 : Array.from(el.parentNode.children).slice(0, index + ([
            'UL',
            'OL'
        ].indexOf(el.tagName) > -1 ? 0 : 1)).reduce((arr, item)=>[].concat(arr, [
                'UL',
                'OL'
            ].indexOf(item.tagName) > -1 ? Array.from(item.children) : [
                item
            ]), [])// .map(item => (console.log(item), item))
        .length - 1)();
const $83fd8cd682cc0cb3$var$getRangePoint = (el, offset)=>el.nodeType === 3 || el.childNodes.length === 0 ? {
        el: el,
        offset: el.textContent.length < offset ? el.textContent.length : offset
    } : Array.from(el.childNodes).reduce((rp, child)=>rp.el !== el ? rp : child.textContent.length >= rp.offset ? $83fd8cd682cc0cb3$var$getRangePoint(child, rp.offset) : {
            el: el,
            offset: rp.offset - child.textContent.length
        }, {
        el: el,
        offset: (el.tagName.match(/H[0-9]{1}/) || el.tagName === 'LI') && el.parentNode.children.length === 1 ? el.textContent.length < offset ? el.textContent.length : offset : offset
    });
const $83fd8cd682cc0cb3$var$trim = (s)=>s.trim();
const $83fd8cd682cc0cb3$var$toUpper = (s)=>s.toUpperCase();
const $83fd8cd682cc0cb3$var$get = (el, q = 'p, li, div')=>{
    let range = window.getSelection().getRangeAt(0);
    // console.log(range);
    // start
    let startLi = q.split(',').map($83fd8cd682cc0cb3$var$trim).map($83fd8cd682cc0cb3$var$toUpper).indexOf(range.startContainer.tagName) > -1 ? range.startContainer : $83fd8cd682cc0cb3$var$getParent(range.startContainer, q.split(',').map($83fd8cd682cc0cb3$var$trim).map($83fd8cd682cc0cb3$var$toUpper));
    let startColRange = document.createRange();
    startColRange.setStart(startLi, 0);
    startColRange.setEnd(range.startContainer, range.startOffset);
    // end
    let endLi = q.split(',').map($83fd8cd682cc0cb3$var$trim).map($83fd8cd682cc0cb3$var$toUpper).indexOf(range.endContainer.tagName) > -1 ? range.endContainer : $83fd8cd682cc0cb3$var$getParent(range.endContainer, q.split(',').map($83fd8cd682cc0cb3$var$trim).map($83fd8cd682cc0cb3$var$toUpper));
    let endColRange = document.createRange();
    endColRange.setStart(endLi, 0);
    endColRange.setEnd(range.endContainer, range.endOffset);
    console.log({
        start: {
            row: $83fd8cd682cc0cb3$var$getElIndex(startLi),
            col: startColRange.toString().replace('\n', '').length
        },
        end: {
            row: $83fd8cd682cc0cb3$var$getElIndex(endLi),
            col: endColRange.toString().replace('\n', '').length
        }
    });
    return {
        start: {
            row: $83fd8cd682cc0cb3$var$getElIndex(startLi),
            col: startColRange.toString().replace('\n', '\n\n ').length
        },
        end: {
            row: $83fd8cd682cc0cb3$var$getElIndex(endLi),
            col: endColRange.toString().replace('\n', '\n\n ').length
        }
    };
};
const $83fd8cd682cc0cb3$var$set = (el, pos, q = 'p, li, div')=>{
    if (!el) return;
    console.log(pos, Array.from(el.querySelectorAll(q)), Array.from(el.querySelectorAll(q))[pos.start.row]);
    const startLi = Array.from(el.querySelectorAll(q))[pos.start.row];
    const endLi = Array.from(el.querySelectorAll(q))[pos.end.row];
    if (!startLi) return;
    const startRp = $83fd8cd682cc0cb3$var$getRangePoint(startLi, pos.start.col);
    const endRp = $83fd8cd682cc0cb3$var$getRangePoint(endLi || startLi, pos.end.col);
    console.log(startRp, endRp);
    let range = document.createRange();
    try {
        range.setStart(startRp.el, startRp.offset);
        range.setEnd(endRp.el, endRp.offset);
    } catch (e) {
        // console.log(e);
        range.setStart(startRp.el, 0);
        range.setEnd(endRp.el, 0);
    }
    const sel = window.getSelection();
    sel.removeAllRanges();
    sel.addRange(range);
};
const $83fd8cd682cc0cb3$var$indent = (el, direction = 'right', q = 'p, li, div')=>{
    let range = window.getSelection().getRangeAt(0);
    let startLi = q.split(',').map($83fd8cd682cc0cb3$var$trim).map($83fd8cd682cc0cb3$var$toUpper).indexOf(range.startContainer.tagName) > -1 ? range.startContainer : $83fd8cd682cc0cb3$var$getParent(range.startContainer, q.toUpperCase());
    let startIndex = $83fd8cd682cc0cb3$var$getElIndex(startLi);
    let endLi = q.split(',').map($83fd8cd682cc0cb3$var$trim).map($83fd8cd682cc0cb3$var$toUpper).indexOf(range.endContainer.tagName) > -1 ? range.endContainer : $83fd8cd682cc0cb3$var$getParent(range.endContainer, q.toUpperCase());
    let endIndex = $83fd8cd682cc0cb3$var$getElIndex(endLi);
    if (startIndex === endIndex && direction === 'right') document.execCommand('insertHTML', false, '&#009');
    else Array.from(startLi.parentNode.children).filter((li, i)=>i >= startIndex && i <= endIndex).forEach((li)=>{
        if (direction === 'right') {
            let tabSpan = document.createElement('span');
            tabSpan.innerHTML = '\t';
            li.prepend(tabSpan);
        } else {
            // console.log(`>${li.children[0].innerHTML}<`);
            Array.from(li.children).forEach((spEl)=>spEl.innerHTML === '' && spEl.remove());
            li.children[0].innerHTML = li.children[0].innerHTML.replace(/^\t/, '');
        }
    });
};
module.exports = {
    get: $83fd8cd682cc0cb3$var$get,
    set: $83fd8cd682cc0cb3$var$set,
    indent: $83fd8cd682cc0cb3$var$indent
};

});


parcelRegister("8vHB3", function(module, exports) {
'use strict';

var $2Z6Kw = parcelRequire("2Z6Kw");
var $6323095bd5e840f1$require$div = $2Z6Kw.div;
var $6323095bd5e840f1$require$button = $2Z6Kw.button;
var $6323095bd5e840f1$require$input = $2Z6Kw.input;
var $6323095bd5e840f1$require$label = $2Z6Kw.label;
var $6323095bd5e840f1$require$select = $2Z6Kw.select;
var $6323095bd5e840f1$require$option = $2Z6Kw.option;

var $jjnZg = parcelRequire("jjnZg");
var $6323095bd5e840f1$require$obj = $jjnZg.obj;
var $6323095bd5e840f1$require$str = $jjnZg.str;

var $8k6FZ = parcelRequire("8k6FZ");

var $ehn3l = parcelRequire("ehn3l");
var $6323095bd5e840f1$require$fieldLabel = $ehn3l.fieldLabel;
var $6323095bd5e840f1$require$enumLabel = $ehn3l.enumLabel;
const $6323095bd5e840f1$var$remove = (list, index)=>[].concat(list.slice(0, index), list.slice(index + 1));
const $6323095bd5e840f1$var$setAt = (list, index, key, value)=>[].concat(list.slice(0, index), [
        {
            ...list[index],
            [key]: value
        }
    ], index < list.length - 1 ? list.slice(index + 1) : []);
const $6323095bd5e840f1$var$patchAt = (list, index, patch)=>[].concat(list.slice(0, index), [
        {
            ...list[index],
            ...patch
        }
    ], index < list.length - 1 ? list.slice(index + 1) : []);
const $6323095bd5e840f1$var$coerce = (type, value)=>{
    if (type === 'Number') {
        const n = Number(value);
        return Number.isNaN(n) ? 0 : n;
    }
    return value;
};
const $6323095bd5e840f1$var$colTrack = (col)=>{
    if (col.type === 'Number') return 'minmax(0, 4.5rem)';
    if (col.enum instanceof Array) return 'minmax(0, 7rem)';
    if (col.key === 'url') return 'minmax(0, 2fr)';
    return 'minmax(0, 1fr)';
};
const $6323095bd5e840f1$var$gridStyle = (columns)=>({
        display: 'grid',
        gridTemplateColumns: columns.map($6323095bd5e840f1$var$colTrack).concat('1.75rem').join(' '),
        gap: '6px',
        alignItems: 'center',
        width: '100%',
        boxSizing: 'border-box'
    });
const $6323095bd5e840f1$var$urlKind = (item)=>item._urlKind || (item.source === 'upload' || item._file ? 'file' : 'url');
const $6323095bd5e840f1$var$blankItem = (newItem)=>typeof newItem === 'function' ? newItem() : {
        ...newItem
    };
const $6323095bd5e840f1$var$titleFromFile = (file)=>String(file.name || '').replace(/\.[^.]+$/, '') || file.name;
const $6323095bd5e840f1$var$itemFromFile = (base, file, hasTitle)=>Object.assign({}, base, {
        _urlKind: 'file',
        source: 'upload',
        _file: file,
        _fileName: file.name,
        url: ''
    }, hasTitle ? {
        title: $6323095bd5e840f1$var$titleFromFile(file)
    } : {});
module.exports = ({ path: path, columns: columns, newItem: newItem, state: state, actions: actions, i18n: i18n = {} })=>{
    const list = $6323095bd5e840f1$require$obj.sub(state, path) || [];
    const rowStyle = $6323095bd5e840f1$var$gridStyle(columns);
    const hasSource = columns.some((col)=>col.key === 'source');
    const hasTitle = columns.some((col)=>col.key === 'title');
    return $6323095bd5e840f1$require$div('.form-items', [].concat(list.length ? [
        $6323095bd5e840f1$require$div('.form-items-header', {
            style: rowStyle
        }, [].concat(columns.map((col)=>$6323095bd5e840f1$require$div('.col', [
                $6323095bd5e840f1$require$label(col.label || $6323095bd5e840f1$require$fieldLabel(i18n, col.key))
            ])), $6323095bd5e840f1$require$div('.col.col-actions', [
            $6323095bd5e840f1$require$label("\xd7")
        ]))),
        $6323095bd5e840f1$require$div('.form-items-list', list.map((item, k)=>$6323095bd5e840f1$require$div('.form-items-row', {
                style: rowStyle,
                attrs: {
                    'data-index': String(k)
                }
            }, [].concat(columns.map((col)=>$6323095bd5e840f1$require$div('.col', [
                    col.enum instanceof Array ? $6323095bd5e840f1$require$select('.form-control', {
                        on: {
                            change: (ev)=>{
                                const source = ev.target.value;
                                const patch = col.key === 'source' ? {
                                    source: source,
                                    _urlKind: source === 'upload' ? 'file' : 'url',
                                    _file: source === 'upload' ? item._file : undefined,
                                    _fileName: source === 'upload' ? item._fileName : undefined
                                } : {
                                    [col.key]: source
                                };
                                actions.set(path, $6323095bd5e840f1$var$patchAt(list, k, patch));
                            }
                        }
                    }, col.enum.map((val)=>$6323095bd5e840f1$require$option({
                            attrs: {
                                value: val,
                                selected: (item[col.key] !== undefined ? item[col.key] : col.enum[0]) === val
                            },
                            props: {
                                value: val,
                                selected: (item[col.key] !== undefined ? item[col.key] : col.enum[0]) === val
                            }
                        }, $6323095bd5e840f1$require$enumLabel(i18n, col.key, val)))) : col.key === 'url' && hasSource ? $8k6FZ({
                        kind: $6323095bd5e840f1$var$urlKind(item),
                        url: item.url || '',
                        fileName: item._fileName || '',
                        multiple: true,
                        onKind: (kind)=>actions.set(path, $6323095bd5e840f1$var$patchAt(list, k, {
                                _urlKind: kind,
                                source: kind === 'file' ? 'upload' : item.source === 'upload' ? 'external' : item.source,
                                _file: kind === 'file' ? item._file : undefined,
                                _fileName: kind === 'file' ? item._fileName : undefined
                            })),
                        onUrl: (v)=>actions.set(path, $6323095bd5e840f1$var$patchAt(list, k, {
                                url: v,
                                _urlKind: 'url'
                            })),
                        onFile: (files)=>{
                            const first = Object.assign({}, item, {
                                _urlKind: 'file',
                                source: 'upload',
                                _file: files[0],
                                _fileName: files[0].name,
                                url: ''
                            });
                            if (hasTitle && !item.title) first.title = $6323095bd5e840f1$var$titleFromFile(files[0]);
                            const rest = files.slice(1).map((f)=>$6323095bd5e840f1$var$itemFromFile($6323095bd5e840f1$var$blankItem(newItem), f, hasTitle));
                            actions.set(path, [].concat(list.slice(0, k), [
                                first
                            ], rest, list.slice(k + 1)));
                        },
                        onClear: ()=>actions.set(path, $6323095bd5e840f1$var$patchAt(list, k, {
                                url: '',
                                _file: undefined,
                                _fileName: undefined
                            }))
                    }) : $6323095bd5e840f1$require$input('.form-control', {
                        attrs: {
                            type: col.type === 'Number' ? 'number' : 'text',
                            step: col.type === 'Number' ? 0.01 : undefined,
                            value: item[col.key] !== undefined ? item[col.key] : '',
                            size: 1
                        },
                        on: {
                            input: (ev)=>actions.set(path, $6323095bd5e840f1$var$setAt(list, k, col.key, $6323095bd5e840f1$var$coerce(col.type, ev.target.value)))
                        }
                    })
                ])), $6323095bd5e840f1$require$div('.col.col-actions', [
                $6323095bd5e840f1$require$button('.fa.fa-minus[type="button"]', {
                    on: {
                        click: ()=>actions.set(path, $6323095bd5e840f1$var$remove(list, k))
                    }
                })
            ])))))
    ] : [], $6323095bd5e840f1$require$button('.form-items-add.btn[type="button"]', {
        on: {
            click: ()=>actions.set(path, [].concat(list, [
                    $6323095bd5e840f1$var$blankItem(newItem)
                ]))
        }
    }, i18n.common && i18n.common.actions && i18n.common.actions.add || 'Add')));
};

});
parcelRegister("8k6FZ", function(module, exports) {
'use strict';

var $2Z6Kw = parcelRequire("2Z6Kw");
var $60f55ebd9fc6627c$require$div = $2Z6Kw.div;
var $60f55ebd9fc6627c$require$button = $2Z6Kw.button;
var $60f55ebd9fc6627c$require$input = $2Z6Kw.input;
var $60f55ebd9fc6627c$require$select = $2Z6Kw.select;
var $60f55ebd9fc6627c$require$option = $2Z6Kw.option;
const $60f55ebd9fc6627c$var$kinds = [
    'url',
    'file'
];
module.exports = ({ kind: kind = 'url', url: url = '', fileName: fileName = '', accept: accept, multiple: multiple = false, onKind: onKind, onUrl: onUrl, onFile: onFile, onClear: onClear })=>$60f55ebd9fc6627c$require$div('.form-url-file', [
        $60f55ebd9fc6627c$require$select('.form-control.form-url-file-kind', {
            on: {
                change: (ev)=>onKind(ev.target.value)
            }
        }, $60f55ebd9fc6627c$var$kinds.map((k)=>$60f55ebd9fc6627c$require$option({
                attrs: {
                    value: k,
                    selected: kind === k
                },
                props: {
                    value: k,
                    selected: kind === k
                }
            }, k))),
        kind === 'file' ? $60f55ebd9fc6627c$require$div('.form-url-file-pick', [
            fileName ? $60f55ebd9fc6627c$require$input('.form-control.form-url-file-name', {
                attrs: {
                    type: 'text',
                    value: fileName,
                    readonly: true,
                    size: 1,
                    title: fileName
                },
                on: {
                    click: (ev)=>{
                        const el = ev.target.parentNode.querySelector('input[type=file]');
                        if (el) el.click();
                    }
                }
            }) : null,
            $60f55ebd9fc6627c$require$input(fileName ? '.form-url-file-native' : '.form-control.form-url-file-value', {
                key: fileName || 'pick',
                attrs: {
                    type: 'file',
                    accept: accept || undefined,
                    multiple: multiple || undefined,
                    title: fileName || 'Choose file'
                },
                style: fileName ? {
                    display: 'none'
                } : {},
                on: {
                    change: (ev)=>{
                        const files = Array.from(ev.target.files && ev.target.files || []);
                        ev.target.value = '';
                        if (files.length) onFile(files);
                    }
                }
            })
        ].filter(Boolean)) : $60f55ebd9fc6627c$require$input('.form-control.form-url-file-value', {
            attrs: {
                type: 'text',
                value: url || '',
                size: 1,
                placeholder: 'url'
            },
            on: {
                input: (ev)=>onUrl(ev.target.value)
            }
        }),
        $60f55ebd9fc6627c$require$button('.form-url-file-clear.fa.fa-times[type="button"]', {
            attrs: {
                title: 'Clear'
            },
            on: {
                click: ()=>onClear()
            }
        })
    ]);

});





parcelRegister("6SF7B", function(module, exports) {
'use strict';

var $2Z6Kw = parcelRequire("2Z6Kw");
var $5027af247fe5c74c$require$div = $2Z6Kw.div;

var $6hyCw = parcelRequire("6hyCw");

var $8s7CY = parcelRequire("8s7CY");
module.exports = ({ state: state, actions: actions, i18n: i18n })=>$5027af247fe5c74c$require$div('.admin-resources', [].concat(!state.router.pageId ? $6hyCw({
        state: state,
        actions: actions,
        i18n: i18n
    }) : $8s7CY({
        state: state,
        actions: actions,
        i18n: i18n
    })));

});
parcelRegister("8s7CY", function(module, exports) {
'use strict';

var $2Z6Kw = parcelRequire("2Z6Kw");
var $6276daf18ba4186a$require$div = $2Z6Kw.div;
var $6276daf18ba4186a$require$form = $2Z6Kw.form;
var $6276daf18ba4186a$require$label = $2Z6Kw.label;
var $6276daf18ba4186a$require$input = $2Z6Kw.input;
var $6276daf18ba4186a$require$select = $2Z6Kw.select;
var $6276daf18ba4186a$require$option = $2Z6Kw.option;
var $6276daf18ba4186a$require$button = $2Z6Kw.button;

var $jjnZg = parcelRequire("jjnZg");
var $6276daf18ba4186a$require$obj = $jjnZg.obj;

var $bLEu3 = parcelRequire("bLEu3");

var $ehn3l = parcelRequire("ehn3l");
var $6276daf18ba4186a$require$fieldLabel = $ehn3l.fieldLabel;
var $6276daf18ba4186a$require$enumLabel = $ehn3l.enumLabel;
module.exports = ({ state: state, actions: actions, i18n: i18n })=>{
    const doc = state.users.doc || {};
    const pageId = state.router.pageId;
    const ready = pageId === 'new' || doc._id === pageId;
    if (!ready) return '';
    const roles = Object.keys(i18n.enums && i18n.enums.role || {
        user: 'User',
        admin: 'Admin'
    });
    const statuses = [
        'new',
        'active',
        'inactive'
    ];
    return $6276daf18ba4186a$require$form(pageId === 'new' ? '.create' : '.edit', {
        on: {
            submit: (ev)=>{
                ev.preventDefault();
                let data = Object.assign({}, doc, $bLEu3.toData(ev.target));
                if (data.password !== '' && data.password === data.passwordConfirm) data = $6276daf18ba4186a$require$obj.filter(data, (key)=>!key.match('passwordConfirm'));
                else data = $6276daf18ba4186a$require$obj.filter(data, (key)=>!key.match('password'));
                actions.users.save(data, state.auth.token, ()=>actions.router.go('admin.users'));
            }
        }
    }, [
        $6276daf18ba4186a$require$div('.field', [
            $6276daf18ba4186a$require$label([
                $6276daf18ba4186a$require$fieldLabel(i18n, 'fullName'),
                ': '
            ]),
            $6276daf18ba4186a$require$input('[type="text"][name="fullName"]', {
                props: {
                    value: doc.fullName || ''
                }
            })
        ]),
        $6276daf18ba4186a$require$div('.field', [
            $6276daf18ba4186a$require$label([
                $6276daf18ba4186a$require$fieldLabel(i18n, 'email'),
                ': '
            ]),
            $6276daf18ba4186a$require$input('[type="email"][name="email"]', {
                props: {
                    value: doc.email || ''
                }
            })
        ]),
        $6276daf18ba4186a$require$div('.field', [
            $6276daf18ba4186a$require$label([
                $6276daf18ba4186a$require$fieldLabel(i18n, 'role'),
                ': '
            ]),
            $6276daf18ba4186a$require$select('[name="role"]', {
                props: {
                    value: doc.role || 'user'
                }
            }, roles.map((role)=>$6276daf18ba4186a$require$option(`[value="${role}"]`, {
                    attrs: {
                        selected: (doc.role || 'user') === role
                    }
                }, $6276daf18ba4186a$require$enumLabel(i18n, 'role', role))))
        ]),
        $6276daf18ba4186a$require$div('.field', [
            $6276daf18ba4186a$require$label([
                $6276daf18ba4186a$require$fieldLabel(i18n, 'status'),
                ': '
            ]),
            $6276daf18ba4186a$require$select('[name="status"]', {
                props: {
                    value: doc.status || 'active'
                }
            }, statuses.map((status)=>$6276daf18ba4186a$require$option(`[value="${status}"]`, {
                    attrs: {
                        selected: (doc.status || 'active') === status
                    }
                }, $6276daf18ba4186a$require$enumLabel(i18n, 'status', status))))
        ]),
        $6276daf18ba4186a$require$div('.field', [
            $6276daf18ba4186a$require$label([
                $6276daf18ba4186a$require$fieldLabel(i18n, 'password'),
                ': '
            ]),
            $6276daf18ba4186a$require$input('[type="password"][name="password"][autocomplete="new-password"]')
        ]),
        $6276daf18ba4186a$require$div('.field', [
            $6276daf18ba4186a$require$label([
                $6276daf18ba4186a$require$fieldLabel(i18n, 'passwordConfirm'),
                ': '
            ]),
            $6276daf18ba4186a$require$input('[type="password"][name="passwordConfirm"][autocomplete="new-password"]')
        ]),
        $6276daf18ba4186a$require$div('.buttons', [
            $6276daf18ba4186a$require$button('#edit-cancel.btn.btn-white[type="button"]', {
                on: {
                    click: ()=>actions.router.go('admin.users')
                }
            }, i18n.common.actions.cancel),
            ' ',
            $6276daf18ba4186a$require$button('#edit-save.btn.btn-primary[type="submit"]', i18n.common.actions.save)
        ])
    ]);
};

});



parcelRegister("eAbd1", function(module, exports) {
'use strict';

var $2Z6Kw = parcelRequire("2Z6Kw");
var $a9dd1f57ec553511$require$h1 = $2Z6Kw.h1;
var $a9dd1f57ec553511$require$a = $2Z6Kw.a;
var $a9dd1f57ec553511$require$div = $2Z6Kw.div;
var $a9dd1f57ec553511$require$header = $2Z6Kw.header;
var $a9dd1f57ec553511$require$p = $2Z6Kw.p;
var $a9dd1f57ec553511$require$section = $2Z6Kw.section;
var $a9dd1f57ec553511$require$button = $2Z6Kw.button;
var $a9dd1f57ec553511$require$span = $2Z6Kw.span;
module.exports = ({ state: state, actions: actions })=>$a9dd1f57ec553511$require$section('.home', $a9dd1f57ec553511$require$p('Articles'));

});

parcelRegister("gtEcv", function(module, exports) {
'use strict';

var $2Z6Kw = parcelRequire("2Z6Kw");
var $bfee89cc2c839e92$require$h2 = $2Z6Kw.h2;
var $bfee89cc2c839e92$require$h3 = $2Z6Kw.h3;
var $bfee89cc2c839e92$require$a = $2Z6Kw.a;
var $bfee89cc2c839e92$require$div = $2Z6Kw.div;
var $bfee89cc2c839e92$require$p = $2Z6Kw.p;
var $bfee89cc2c839e92$require$section = $2Z6Kw.section;
var $bfee89cc2c839e92$require$span = $2Z6Kw.span;
var $bfee89cc2c839e92$require$img = $2Z6Kw.img;
var $bfee89cc2c839e92$require$ul = $2Z6Kw.ul;
var $bfee89cc2c839e92$require$li = $2Z6Kw.li;
var $bfee89cc2c839e92$require$hr = $2Z6Kw.hr;
var $bfee89cc2c839e92$require$header = $2Z6Kw.header;
var $bfee89cc2c839e92$require$button = $2Z6Kw.button;
var $bfee89cc2c839e92$require$i = $2Z6Kw.i;

var $jjnZg = parcelRequire("jjnZg");
var $bfee89cc2c839e92$require$arr = $jjnZg.arr;

var $1zDll = parcelRequire("1zDll");
parcelRequire("12DVH");

var $4rZD9 = parcelRequire("4rZD9");

var $g10CX = parcelRequire("g10CX");
$1zDll.extend($4rZD9);
$1zDll.extend($g10CX);

var $4hyaE = parcelRequire("4hyaE");

var $amJim = parcelRequire("amJim");

var $3QJuk = parcelRequire("3QJuk");
const { resolveLocalized: $bfee89cc2c839e92$var$resolveLocalized, DEFAULT_LOCALE: $bfee89cc2c839e92$var$DEFAULT_LOCALE } = $3QJuk.default || $3QJuk;
const $bfee89cc2c839e92$var$WHEN_KEYS = [
    'upcoming',
    'past'
];
const $bfee89cc2c839e92$var$LINK_ICONS = {
    facebook: 'facebook',
    instagram: 'instagram',
    soundcloud: 'soundcloud',
    mixcloud: 'mixcloud',
    github: 'github',
    bandcamp: 'bandcamp',
    youtube: 'youtube-play',
    website: 'globe',
    other: 'link'
};
const $bfee89cc2c839e92$var$linkTypeFromUrl = (url = '')=>{
    if (/soundcloud\.com/i.test(url)) return 'soundcloud';
    if (/mixcloud\.com/i.test(url)) return 'mixcloud';
    if (/github\.com/i.test(url)) return 'github';
    if (/instagram\.com/i.test(url)) return 'instagram';
    if (/facebook\.com|fb\.com/i.test(url)) return 'facebook';
    if (/youtube\.com|youtu\.be/i.test(url)) return 'youtube';
    if (/bandcamp\.com/i.test(url)) return 'bandcamp';
    return 'website';
};
const $bfee89cc2c839e92$var$linkHostLabel = (url = '')=>{
    try {
        return String(new URL(url).hostname || '').replace(/^www\./i, '') || url;
    } catch (err) {
        return String(url).replace(/^https?:\/\//i, '').split('/')[0] || url;
    }
};
const $bfee89cc2c839e92$var$linkMeta = (link, i18n)=>{
    const url = typeof link === 'string' ? link : link && link.url || '';
    const type = link && link.type || $bfee89cc2c839e92$var$linkTypeFromUrl(url);
    const icon = $bfee89cc2c839e92$var$LINK_ICONS[type] || $bfee89cc2c839e92$var$LINK_ICONS.other;
    const labels = i18n && i18n.enums && i18n.enums.type || {};
    const label = type === 'website' || type === 'other' ? $bfee89cc2c839e92$var$linkHostLabel(url) : labels[type] || type;
    return {
        url: url,
        type: type,
        icon: icon,
        label: label
    };
};
const $bfee89cc2c839e92$var$pageCopy = (i18n, key, fallback)=>i18n && i18n.pages && i18n.pages.calendar && i18n.pages.calendar[key] || fallback;
const $bfee89cc2c839e92$var$typeLabel = (i18n, type)=>{
    const labels = i18n && i18n.enums && i18n.enums.type || {};
    return type && labels[type] || type || '';
};
const $bfee89cc2c839e92$var$eventTitle = (event, lang, i18n)=>$bfee89cc2c839e92$var$resolveLocalized(event && event.title, lang) || $bfee89cc2c839e92$var$pageCopy(i18n, 'untitled', 'Untitled event');
const $bfee89cc2c839e92$var$eventTz = (event)=>event && event.timezone || $4hyaE.DEFAULT_TZ;
const $bfee89cc2c839e92$var$formatWhen = (event, lang)=>{
    $1zDll.locale(lang === 'en' ? 'en' : 'bg');
    const tz = $bfee89cc2c839e92$var$eventTz(event);
    const start = $4hyaE.parse(event && event.startDateTime, tz);
    if (!start) return '';
    const end = $4hyaE.parse(event && event.endDateTime, tz);
    if (end && !end.isSame(start, 'day')) return `${start.format('ll HH:mm')} \u{2013} ${end.format('ll HH:mm')}`;
    if (end) return `${start.format('ll HH:mm')} \u{2013} ${end.format('HH:mm')}`;
    return start.format('ll HH:mm');
};
/** Date + time parts for the detail header (stacked under a calendar icon). */ const $bfee89cc2c839e92$var$formatWhenParts = (event, lang)=>{
    $1zDll.locale(lang === 'en' ? 'en' : 'bg');
    const tz = $bfee89cc2c839e92$var$eventTz(event);
    const start = $4hyaE.parse(event && event.startDateTime, tz);
    if (!start) return null;
    const end = $4hyaE.parse(event && event.endDateTime, tz);
    if (end && !end.isSame(start, 'day')) return {
        date: `${start.format('ll')} \u{2013} ${end.format('ll')}`,
        time: `${start.format('HH:mm')} \u{2013} ${end.format('HH:mm')}`
    };
    return {
        date: start.format('ll'),
        time: end ? `${start.format('HH:mm')} \u{2013} ${end.format('HH:mm')}` : start.format('HH:mm')
    };
};
const $bfee89cc2c839e92$var$startMs = (event)=>new Date(event.startDateTime || 0).getTime();
const $bfee89cc2c839e92$var$sortDesc = (a, b)=>$bfee89cc2c839e92$var$startMs(b) - $bfee89cc2c839e92$var$startMs(a);
const $bfee89cc2c839e92$var$sortAsc = (a, b)=>$bfee89cc2c839e92$var$startMs(a) - $bfee89cc2c839e92$var$startMs(b);
const $bfee89cc2c839e92$var$isUpcoming = (event)=>{
    const end = event.endDateTime || event.startDateTime;
    return new Date(end || 0).getTime() >= Date.now();
};
const $bfee89cc2c839e92$var$eventPath = (event)=>event.slug || event._id;
const $bfee89cc2c839e92$var$readFilters = (state)=>{
    const f = state.events && state.events.filters || {};
    return {
        // unset → both; explicit [] → none
        when: Array.isArray(f.when) ? f.when : $bfee89cc2c839e92$var$WHEN_KEYS.slice(),
        // empty → all types
        types: Array.isArray(f.types) ? f.types : []
    };
};
const $bfee89cc2c839e92$var$toggleFilter = (actions, key, value, fallback)=>{
    actions.set([
        'events',
        'filters',
        key
    ], (cur)=>{
        const list = Array.isArray(cur) ? cur : fallback || [];
        return $bfee89cc2c839e92$require$arr.toggle(list, value);
    });
};
const $bfee89cc2c839e92$var$uniqueTypes = (list)=>list.reduce((types, ev)=>{
        if (ev.type && types.indexOf(ev.type) === -1) types.push(ev.type);
        return types;
    }, []);
const $bfee89cc2c839e92$var$matchesType = (event, types)=>!types.length || event.type && types.indexOf(event.type) > -1;
const $bfee89cc2c839e92$var$eventListItem = ({ event: event, lang: lang, i18n: i18n, actions: actions })=>{
    const path = $bfee89cc2c839e92$var$eventPath(event);
    return $bfee89cc2c839e92$require$li([
        $bfee89cc2c839e92$require$a(`[href="/calendar/${path}"]`, {
            on: {
                click: (ev)=>{
                    ev.preventDefault();
                    actions.router.go(`calendar.${path}`);
                }
            }
        }, [
            event.poster ? $bfee89cc2c839e92$require$img('.poster', {
                attrs: {
                    src: event.poster,
                    alt: ''
                }
            }) : $bfee89cc2c839e92$require$span('.poster.placeholder'),
            $bfee89cc2c839e92$require$span('.event-meta', [
                $bfee89cc2c839e92$require$span('.name', $bfee89cc2c839e92$var$eventTitle(event, lang, i18n)),
                $bfee89cc2c839e92$require$span('.event-meta-row', [
                    event.type ? $bfee89cc2c839e92$require$span('.tag.type', $bfee89cc2c839e92$var$typeLabel(i18n, event.type)) : '',
                    $bfee89cc2c839e92$require$span('.when', $bfee89cc2c839e92$var$formatWhen(event, lang))
                ])
            ])
        ])
    ]);
};
const $bfee89cc2c839e92$var$eventGroup = ({ title: title, events: events, lang: lang, i18n: i18n, actions: actions })=>events.length === 0 ? '' : $bfee89cc2c839e92$require$div('.event-group', [
        $bfee89cc2c839e92$require$h3('.event-group-title', title),
        $bfee89cc2c839e92$require$ul('.event-list', events.map((event)=>$bfee89cc2c839e92$var$eventListItem({
                event: event,
                lang: lang,
                i18n: i18n,
                actions: actions
            })))
    ]);
const $bfee89cc2c839e92$var$toggleGroup = ({ className: className, items: items, active: active, onToggle: onToggle })=>$bfee89cc2c839e92$require$ul(`.toggle-group${className ? '.' + className : ''}`, items.map(({ key: key, label: label })=>$bfee89cc2c839e92$require$li([
            $bfee89cc2c839e92$require$button({
                attrs: {
                    type: 'button'
                },
                class: {
                    active: active.indexOf(key) > -1
                },
                on: {
                    click: ()=>onToggle(key)
                }
            }, label)
        ])));
const $bfee89cc2c839e92$var$listView = ({ state: state, actions: actions, i18n: i18n })=>{
    const lang = state.lang || $bfee89cc2c839e92$var$DEFAULT_LOCALE;
    const filters = $bfee89cc2c839e92$var$readFilters(state);
    const list = (state.events.list || []).filter((ev)=>!ev.status || ev.status === 'published');
    const types = $bfee89cc2c839e92$var$uniqueTypes(list);
    const typed = list.filter((ev)=>$bfee89cc2c839e92$var$matchesType(ev, filters.types));
    const showUpcoming = filters.when.indexOf('upcoming') > -1;
    const showPast = filters.when.indexOf('past') > -1;
    const upcoming = showUpcoming ? typed.filter($bfee89cc2c839e92$var$isUpcoming).slice().sort($bfee89cc2c839e92$var$sortAsc) : [];
    const past = showPast ? typed.filter((ev)=>!$bfee89cc2c839e92$var$isUpcoming(ev)).slice().sort($bfee89cc2c839e92$var$sortDesc) : [];
    const empty = list.length === 0 || upcoming.length === 0 && past.length === 0;
    const feedHost = typeof location !== 'undefined' && location.host ? location.host : 'musictech.bg';
    return $bfee89cc2c839e92$require$section('.events', [
        $bfee89cc2c839e92$require$header('.events-bar', [
            $bfee89cc2c839e92$require$h2('.events-title', $bfee89cc2c839e92$var$pageCopy(i18n, 'title', 'Calendar')),
            $bfee89cc2c839e92$require$div('.events-feeds', [
                $bfee89cc2c839e92$require$a('.events-feed.rss', {
                    attrs: {
                        href: '/api/events.rss',
                        title: $bfee89cc2c839e92$var$pageCopy(i18n, 'rss', 'RSS feed'),
                        target: '_blank',
                        rel: 'noopener alternate',
                        type: 'application/rss+xml'
                    }
                }, [
                    $bfee89cc2c839e92$require$i('.fa.fa-rss')
                ]),
                $bfee89cc2c839e92$require$a('.events-feed.ics', {
                    attrs: {
                        href: `webcal://${feedHost}/api/events.ics`,
                        title: $bfee89cc2c839e92$var$pageCopy(i18n, 'ics', 'Subscribe in calendar (iCal)')
                    }
                }, [
                    $bfee89cc2c839e92$require$i('.fa.fa-calendar')
                ])
            ]),
            $bfee89cc2c839e92$require$div('.events-filters', [
                $bfee89cc2c839e92$var$toggleGroup({
                    className: 'when',
                    items: [
                        {
                            key: 'upcoming',
                            label: $bfee89cc2c839e92$var$pageCopy(i18n, 'upcoming', 'Upcoming')
                        },
                        {
                            key: 'past',
                            label: $bfee89cc2c839e92$var$pageCopy(i18n, 'past', 'Past')
                        }
                    ],
                    active: filters.when,
                    onToggle: (key)=>$bfee89cc2c839e92$var$toggleFilter(actions, 'when', key, $bfee89cc2c839e92$var$WHEN_KEYS.slice())
                }),
                types.length ? $bfee89cc2c839e92$var$toggleGroup({
                    className: 'types',
                    items: types.map((type)=>({
                            key: type,
                            label: $bfee89cc2c839e92$var$typeLabel(i18n, type)
                        })),
                    active: filters.types,
                    onToggle: (key)=>$bfee89cc2c839e92$var$toggleFilter(actions, 'types', key, [])
                }) : ''
            ])
        ]),
        $bfee89cc2c839e92$require$div('.events-panel', [
            $bfee89cc2c839e92$require$div('.events-scroll', [
                empty ? $bfee89cc2c839e92$require$p('.events-empty', $bfee89cc2c839e92$var$pageCopy(i18n, 'empty', 'No published events yet.')) : $bfee89cc2c839e92$require$div('.event-groups', [
                    $bfee89cc2c839e92$var$eventGroup({
                        title: $bfee89cc2c839e92$var$pageCopy(i18n, 'upcoming', 'Upcoming'),
                        events: upcoming,
                        lang: lang,
                        i18n: i18n,
                        actions: actions
                    }),
                    upcoming.length && past.length ? $bfee89cc2c839e92$require$hr('.event-split') : '',
                    $bfee89cc2c839e92$var$eventGroup({
                        title: $bfee89cc2c839e92$var$pageCopy(i18n, 'past', 'Past'),
                        events: past,
                        lang: lang,
                        i18n: i18n,
                        actions: actions
                    })
                ])
            ])
        ])
    ]);
};
const $bfee89cc2c839e92$var$detailView = ({ state: state, actions: actions, i18n: i18n })=>{
    const lang = state.lang || $bfee89cc2c839e92$var$DEFAULT_LOCALE;
    const event = state.events.doc || {};
    const title = $bfee89cc2c839e92$var$eventTitle(event, lang, i18n);
    const text = $bfee89cc2c839e92$var$resolveLocalized(event.text, lang);
    const links = event.links || [];
    const whenParts = $bfee89cc2c839e92$var$formatWhenParts(event, lang);
    const type = $bfee89cc2c839e92$var$typeLabel(i18n, event.type);
    const icsHref = event.slug || event._id ? `/api/events/${event.slug || event._id}.ics` : '';
    const goList = (ev)=>{
        ev.preventDefault();
        actions.router.go('calendar');
    };
    return $bfee89cc2c839e92$require$section('.events.event-detail', [
        $bfee89cc2c839e92$require$div('.event-layout', [
            $bfee89cc2c839e92$require$section('.event-block', [
                $bfee89cc2c839e92$require$div('.event-block-header', [
                    $bfee89cc2c839e92$require$div('.event-block-heading', [
                        $bfee89cc2c839e92$require$h2('.event-block-name', [
                            $bfee89cc2c839e92$require$a('.event-name-path[href="/calendar"]', {
                                on: {
                                    click: goList
                                }
                            }, $bfee89cc2c839e92$var$pageCopy(i18n, 'title', 'Calendar')),
                            $bfee89cc2c839e92$require$span('.event-name-sep', ' / '),
                            $bfee89cc2c839e92$require$span('.event-name-current', title)
                        ])
                    ]),
                    whenParts ? $bfee89cc2c839e92$require$div('.event-when', [
                        $bfee89cc2c839e92$require$span('.event-when-body', [
                            $bfee89cc2c839e92$require$span('.event-when-date', [
                                $bfee89cc2c839e92$require$i('.fa.fa-calendar'),
                                $bfee89cc2c839e92$require$span(whenParts.date)
                            ]),
                            whenParts.time ? $bfee89cc2c839e92$require$span('.event-when-time', whenParts.time) : ''
                        ])
                    ]) : ''
                ]),
                $bfee89cc2c839e92$require$div('.event-summary', [
                    $bfee89cc2c839e92$require$div('.event-summary-start', [
                        type ? $bfee89cc2c839e92$require$span('.tag.event-type', type) : ''
                    ]),
                    links.length ? $bfee89cc2c839e92$require$ul('.event-links', links.map((link)=>{
                        const { url: url, icon: icon, label: label } = $bfee89cc2c839e92$var$linkMeta(link, i18n);
                        if (!url) return '';
                        return $bfee89cc2c839e92$require$li([
                            $bfee89cc2c839e92$require$a('.event-link[target="_blank"][rel="noopener"]', {
                                attrs: {
                                    href: url,
                                    title: label
                                }
                            }, [
                                $bfee89cc2c839e92$require$span(`.event-link-icon.fa.fa-${icon}`),
                                $bfee89cc2c839e92$require$span('.event-link-label', label)
                            ])
                        ]);
                    })) : $bfee89cc2c839e92$require$div('.event-summary-mid'),
                    icsHref ? $bfee89cc2c839e92$require$a('.event-ics', {
                        attrs: {
                            href: icsHref,
                            download: `${event.slug || event._id}.ics`,
                            title: $bfee89cc2c839e92$var$pageCopy(i18n, 'addToCalendar', 'Add to calendar')
                        }
                    }, [
                        $bfee89cc2c839e92$require$i('.fa.fa-calendar-plus-o'),
                        $bfee89cc2c839e92$require$span($bfee89cc2c839e92$var$pageCopy(i18n, 'addToCalendar', 'Add to calendar'))
                    ]) : $bfee89cc2c839e92$require$div('.event-summary-end')
                ]),
                $bfee89cc2c839e92$require$div('.event-block-scroll', [
                    $bfee89cc2c839e92$require$div('.event-body', [
                        text ? $bfee89cc2c839e92$require$div('.event-text', {
                            props: {
                                innerHTML: $amJim.toDisplayHTML(text)
                            }
                        }) : ''
                    ])
                ])
            ])
        ])
    ]);
};
module.exports = ({ state: state, actions: actions, i18n: i18n })=>state.router.path[1] ? $bfee89cc2c839e92$var$detailView({
        state: state,
        actions: actions,
        i18n: i18n
    }) : $bfee89cc2c839e92$var$listView({
        state: state,
        actions: actions,
        i18n: i18n
    });

});
parcelRegister("12DVH", function(module, exports) {

!function(e, _) {
    module.exports = _((parcelRequire("1zDll")));
}(module.exports, function(e) {
    "use strict";
    function _(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var t = _(e), d = {
        name: "bg",
        weekdays: "\u043D\u0435\u0434\u0435\u043B\u044F_\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A_\u0432\u0442\u043E\u0440\u043D\u0438\u043A_\u0441\u0440\u044F\u0434\u0430_\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A_\u043F\u0435\u0442\u044A\u043A_\u0441\u044A\u0431\u043E\u0442\u0430".split("_"),
        weekdaysShort: "\u043D\u0435\u0434_\u043F\u043E\u043D_\u0432\u0442\u043E_\u0441\u0440\u044F_\u0447\u0435\u0442_\u043F\u0435\u0442_\u0441\u044A\u0431".split("_"),
        weekdaysMin: "\u043D\u0434_\u043F\u043D_\u0432\u0442_\u0441\u0440_\u0447\u0442_\u043F\u0442_\u0441\u0431".split("_"),
        months: "\u044F\u043D\u0443\u0430\u0440\u0438_\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438_\u043C\u0430\u0440\u0442_\u0430\u043F\u0440\u0438\u043B_\u043C\u0430\u0439_\u044E\u043D\u0438_\u044E\u043B\u0438_\u0430\u0432\u0433\u0443\u0441\u0442_\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438_\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438_\u043D\u043E\u0435\u043C\u0432\u0440\u0438_\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438".split("_"),
        monthsShort: "\u044F\u043D\u0443_\u0444\u0435\u0432_\u043C\u0430\u0440_\u0430\u043F\u0440_\u043C\u0430\u0439_\u044E\u043D\u0438_\u044E\u043B\u0438_\u0430\u0432\u0433_\u0441\u0435\u043F_\u043E\u043A\u0442_\u043D\u043E\u0435_\u0434\u0435\u043A".split("_"),
        weekStart: 1,
        ordinal: function(e) {
            var _ = e % 100;
            if (_ > 10 && _ < 20) return e + "-\u0442\u0438";
            var t = e % 10;
            return 1 === t ? e + "-\u0432\u0438" : 2 === t ? e + "-\u0440\u0438" : 7 === t || 8 === t ? e + "-\u043C\u0438" : e + "-\u0442\u0438";
        },
        formats: {
            LT: "H:mm",
            LTS: "H:mm:ss",
            L: "D.MM.YYYY",
            LL: "D MMMM YYYY",
            LLL: "D MMMM YYYY H:mm",
            LLLL: "dddd, D MMMM YYYY H:mm"
        },
        relativeTime: {
            future: "\u0441\u043B\u0435\u0434 %s",
            past: "\u043F\u0440\u0435\u0434\u0438 %s",
            s: "\u043D\u044F\u043A\u043E\u043B\u043A\u043E \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            m: "\u043C\u0438\u043D\u0443\u0442\u0430",
            mm: "%d \u043C\u0438\u043D\u0443\u0442\u0438",
            h: "\u0447\u0430\u0441",
            hh: "%d \u0447\u0430\u0441\u0430",
            d: "\u0434\u0435\u043D",
            dd: "%d \u0434\u0435\u043D\u0430",
            M: "\u043C\u0435\u0441\u0435\u0446",
            MM: "%d \u043C\u0435\u0441\u0435\u0446\u0430",
            y: "\u0433\u043E\u0434\u0438\u043D\u0430",
            yy: "%d \u0433\u043E\u0434\u0438\u043D\u0438"
        }
    };
    return t.default.locale(d, null, !0), d;
});

});


parcelRegister("823PN", function(module, exports) {
'use strict';

var $2Z6Kw = parcelRequire("2Z6Kw");
var $5d917c14652bd5d1$require$h1 = $2Z6Kw.h1;
var $5d917c14652bd5d1$require$a = $2Z6Kw.a;
var $5d917c14652bd5d1$require$div = $2Z6Kw.div;
var $5d917c14652bd5d1$require$header = $2Z6Kw.header;
var $5d917c14652bd5d1$require$p = $2Z6Kw.p;
var $5d917c14652bd5d1$require$section = $2Z6Kw.section;
var $5d917c14652bd5d1$require$button = $2Z6Kw.button;
var $5d917c14652bd5d1$require$span = $2Z6Kw.span;
module.exports = ({ state: state, actions: actions })=>$5d917c14652bd5d1$require$section('.home', $5d917c14652bd5d1$require$p('Projects'));

});

parcelRegister("eRGgr", function(module, exports) {
'use strict';

var $2Z6Kw = parcelRequire("2Z6Kw");
var $ad26ccb7e0e6e37f$require$h2 = $2Z6Kw.h2;
var $ad26ccb7e0e6e37f$require$a = $2Z6Kw.a;
var $ad26ccb7e0e6e37f$require$div = $2Z6Kw.div;
var $ad26ccb7e0e6e37f$require$p = $2Z6Kw.p;
var $ad26ccb7e0e6e37f$require$section = $2Z6Kw.section;
var $ad26ccb7e0e6e37f$require$span = $2Z6Kw.span;
var $ad26ccb7e0e6e37f$require$img = $2Z6Kw.img;
var $ad26ccb7e0e6e37f$require$ul = $2Z6Kw.ul;
var $ad26ccb7e0e6e37f$require$li = $2Z6Kw.li;

var $jjnZg = parcelRequire("jjnZg");
var $ad26ccb7e0e6e37f$require$fn = $jjnZg.fn;

var $amJim = parcelRequire("amJim");

var $cDQjg = parcelRequire("cDQjg");

var $b9lWd = parcelRequire("b9lWd");
var $ad26ccb7e0e6e37f$require$youtubeId = $b9lWd.youtubeId;

var $fFCx8 = parcelRequire("fFCx8");
const $ad26ccb7e0e6e37f$var$trackList = $fFCx8.default || $fFCx8;

var $6QkUD = parcelRequire("6QkUD");

var $3QJuk = parcelRequire("3QJuk");
const { resolveLocalized: $ad26ccb7e0e6e37f$var$resolveLocalized, DEFAULT_LOCALE: $ad26ccb7e0e6e37f$var$DEFAULT_LOCALE } = $3QJuk.default || $3QJuk;
const $ad26ccb7e0e6e37f$var$isVenueProfile = (profile)=>Array.isArray(profile && profile.roles) && profile.roles.indexOf('venue') > -1;
const $ad26ccb7e0e6e37f$var$mediaSrc = (item)=>item && item.url || '';
const $ad26ccb7e0e6e37f$var$LINK_ICONS = {
    facebook: 'facebook',
    instagram: 'instagram',
    soundcloud: 'soundcloud',
    mixcloud: 'mixcloud',
    github: 'github',
    bandcamp: 'bandcamp',
    youtube: 'youtube-play',
    website: 'globe',
    other: 'link'
};
const $ad26ccb7e0e6e37f$var$linkTypeFromUrl = (url = '')=>{
    if (/soundcloud\.com/i.test(url)) return 'soundcloud';
    if (/mixcloud\.com/i.test(url)) return 'mixcloud';
    if (/github\.com/i.test(url)) return 'github';
    if (/instagram\.com/i.test(url)) return 'instagram';
    if (/facebook\.com|fb\.com/i.test(url)) return 'facebook';
    if (/youtube\.com|youtu\.be/i.test(url)) return 'youtube';
    if (/bandcamp\.com/i.test(url)) return 'bandcamp';
    return 'website';
};
const $ad26ccb7e0e6e37f$var$linkMeta = (link, i18n)=>{
    const type = link && link.type || $ad26ccb7e0e6e37f$var$linkTypeFromUrl(link && link.url);
    const icon = $ad26ccb7e0e6e37f$var$LINK_ICONS[type] || $ad26ccb7e0e6e37f$var$LINK_ICONS.other;
    const labels = i18n && i18n.enums && i18n.enums.type || {};
    const label = labels[type] || link.type || type;
    return {
        type: type,
        icon: icon,
        label: label
    };
};
const $ad26ccb7e0e6e37f$var$displayName = (profile, lang)=>$ad26ccb7e0e6e37f$var$resolveLocalized(profile && profile.fullName, lang) || '';
const $ad26ccb7e0e6e37f$var$roleLabel = (i18n, role)=>{
    if (!role) return '';
    const enums = i18n && i18n.enums || {};
    const labels = enums.roles || enums.type || {};
    return labels[role] || role;
};
const $ad26ccb7e0e6e37f$var$rolesEl = (roles, i18n)=>{
    const tags = (roles || []).map((r)=>$ad26ccb7e0e6e37f$var$roleLabel(i18n, r)).filter(Boolean).map((label)=>$ad26ccb7e0e6e37f$require$span('.tag', label));
    return tags.length ? $ad26ccb7e0e6e37f$require$div('.roles', tags) : '';
};
const $ad26ccb7e0e6e37f$var$avatarEl = (profile, size, lang)=>$ad26ccb7e0e6e37f$require$fn.pipe(()=>$cDQjg.src(profile, size), (src)=>src ? $ad26ccb7e0e6e37f$require$img('.avatar', {
            attrs: {
                src: src,
                alt: ''
            }
        }) : $ad26ccb7e0e6e37f$require$span('.avatar.placeholder', ($ad26ccb7e0e6e37f$var$displayName(profile, lang) || '?').slice(0, 1)))();
const $ad26ccb7e0e6e37f$var$videoThumb = (vid)=>{
    const yt = $ad26ccb7e0e6e37f$require$youtubeId(vid && vid.url);
    if (yt) return $ad26ccb7e0e6e37f$require$img({
        attrs: {
            src: `https://img.youtube.com/vi/${yt}/hqdefault.jpg`,
            alt: vid.title || ''
        }
    });
    return $ad26ccb7e0e6e37f$require$span('.video-thumb-placeholder');
};
const $ad26ccb7e0e6e37f$var$isListed = (profile)=>!profile.status || profile.status === 'published';
const $ad26ccb7e0e6e37f$var$listView = ({ state: state, actions: actions, i18n: i18n })=>{
    const lang = state.lang || $ad26ccb7e0e6e37f$var$DEFAULT_LOCALE;
    // Drafts stay out of Общност but remain open via /profiles/:slug
    const list = (state.profiles.list || []).filter($ad26ccb7e0e6e37f$var$isListed);
    return $ad26ccb7e0e6e37f$require$section('.profiles.profiles-list', [
        $ad26ccb7e0e6e37f$require$h2("\u041E\u0431\u0449\u043D\u043E\u0441\u0442"),
        $ad26ccb7e0e6e37f$require$div([
            list.length === 0 ? $ad26ccb7e0e6e37f$require$p('.profiles-empty', "\u041D\u044F\u043C\u0430 \u043F\u0443\u0431\u043B\u0438\u043A\u0443\u0432\u0430\u043D\u0438 \u043F\u0440\u043E\u0444\u0438\u043B\u0438 \u0437\u0430\u0441\u0435\u0433\u0430.") : $ad26ccb7e0e6e37f$require$ul('.profile-list', list.map((profile)=>{
                const path = profile.slug || profile._id;
                return $ad26ccb7e0e6e37f$require$li([
                    $ad26ccb7e0e6e37f$require$a(`[href="/profiles/${path}"]`, {
                        on: {
                            click: (ev)=>{
                                ev.preventDefault();
                                actions.router.go(`profiles.${path}`);
                            }
                        }
                    }, [
                        $ad26ccb7e0e6e37f$var$avatarEl(profile, 96, lang),
                        $ad26ccb7e0e6e37f$require$span('.name', $ad26ccb7e0e6e37f$var$displayName(profile, lang) || "\u0411\u0435\u0437 \u0438\u043C\u0435"),
                        $ad26ccb7e0e6e37f$var$rolesEl(profile.roles, i18n)
                    ])
                ]);
            }))
        ])
    ]);
};
/**
 * Profile detail layout:
 *   row 1: profile block | aside (tracks → address → pictures-if-empty-else)
 *   row 2: videos
 *   row 3: pictures (full width when tracks already took the aside)
 */ const $ad26ccb7e0e6e37f$var$picturesSection = ({ pictures: pictures, i18n: i18n })=>$ad26ccb7e0e6e37f$require$section('.profile-pictures', [
        $ad26ccb7e0e6e37f$require$h2(i18n.widget && i18n.widget.pictureList || "\u0421\u043D\u0438\u043C\u043A\u0438"),
        $ad26ccb7e0e6e37f$require$ul('.picture-gallery', pictures.map((src, i)=>$ad26ccb7e0e6e37f$require$li('.picture-gallery-item', [
                $ad26ccb7e0e6e37f$require$a('.picture-gallery-link[target="_blank"][rel="noopener"]', {
                    attrs: {
                        href: src,
                        title: `photo ${i + 1}`
                    }
                }, [
                    $ad26ccb7e0e6e37f$require$img('.picture-gallery-img', {
                        attrs: {
                            src: src,
                            alt: ''
                        }
                    })
                ])
            ])))
    ]);
const $ad26ccb7e0e6e37f$var$detailView = ({ state: state, actions: actions, i18n: i18n })=>{
    const lang = state.lang || $ad26ccb7e0e6e37f$var$DEFAULT_LOCALE;
    const profile = state.profiles.doc || {};
    const name = $ad26ccb7e0e6e37f$var$displayName(profile, lang);
    const about = $ad26ccb7e0e6e37f$var$resolveLocalized(profile.about, lang);
    const links = profile.links || [];
    const tracks = profile.tracks || [];
    const videos = profile.videos || [];
    const pictures = profile.pictures || [];
    const playing = state.profiles.playing || {};
    const trackIndex = typeof playing.track === 'number' && playing.track < tracks.length ? playing.track : tracks.length ? 0 : -1;
    const showAddress = $ad26ccb7e0e6e37f$var$isVenueProfile(profile) && $6QkUD.addressHasContent(profile.address);
    const picturesInAside = !tracks.length && pictures.length;
    const aside = [
        tracks.length ? $ad26ccb7e0e6e37f$var$trackList({
            list: tracks,
            activeIndex: trackIndex,
            paused: playing.paused !== false,
            shuffle: Boolean(playing.shuffle),
            repeat: playing.repeat === true ? 'all' : playing.repeat || 'off',
            i18n: i18n,
            onSelect: (i)=>actions.set([
                    'profiles',
                    'playing',
                    'track'
                ], i),
            onPlayback: (patch)=>actions.set([
                    'profiles',
                    'playing'
                ], (cur = {})=>Object.assign({}, cur, patch))
        }) : '',
        showAddress ? $6QkUD({
            address: profile.address,
            i18n: i18n
        }) : '',
        picturesInAside ? $ad26ccb7e0e6e37f$var$picturesSection({
            pictures: pictures,
            i18n: i18n
        }) : ''
    ].filter(Boolean);
    const goProfiles = (ev)=>{
        ev.preventDefault();
        actions.router.go('profiles');
    };
    return $ad26ccb7e0e6e37f$require$section('.profiles.profile-detail', [
        $ad26ccb7e0e6e37f$require$div('.profile-layout', [
            $ad26ccb7e0e6e37f$require$div('.profile-row.profile-row-main', [
                $ad26ccb7e0e6e37f$require$section('.profile-block', [
                    $ad26ccb7e0e6e37f$require$div('.profile-block-header', [
                        $ad26ccb7e0e6e37f$require$div('.profile-block-heading', [
                            $ad26ccb7e0e6e37f$require$h2('.profile-block-name', [
                                $ad26ccb7e0e6e37f$require$a('.profile-name-path[href="/profiles"]', {
                                    on: {
                                        click: goProfiles
                                    }
                                }, "\u041E\u0431\u0449\u043D\u043E\u0441\u0442"),
                                $ad26ccb7e0e6e37f$require$span('.profile-name-sep', ' / '),
                                $ad26ccb7e0e6e37f$require$span('.profile-name-current', name || "\u041F\u0440\u043E\u0444\u0438\u043B")
                            ]),
                            $ad26ccb7e0e6e37f$var$rolesEl(profile.roles, i18n)
                        ]),
                        links.length ? $ad26ccb7e0e6e37f$require$ul('.profile-links', links.map((link)=>{
                            const { icon: icon, label: label } = $ad26ccb7e0e6e37f$var$linkMeta(link, i18n);
                            return $ad26ccb7e0e6e37f$require$li([
                                $ad26ccb7e0e6e37f$require$a('.profile-link[target="_blank"][rel="noopener"]', {
                                    attrs: {
                                        href: link.url,
                                        title: label
                                    }
                                }, [
                                    $ad26ccb7e0e6e37f$require$span(`.profile-link-icon.fa.fa-${icon}`),
                                    $ad26ccb7e0e6e37f$require$span('.profile-link-label', label)
                                ])
                            ]);
                        })) : ''
                    ]),
                    $ad26ccb7e0e6e37f$require$div('.about', [
                        $ad26ccb7e0e6e37f$var$avatarEl(profile, 280, lang),
                        about ? $ad26ccb7e0e6e37f$require$div('.about-body', {
                            props: {
                                innerHTML: $amJim.toDisplayHTML(about)
                            }
                        }) : ''
                    ])
                ]),
                aside.length ? $ad26ccb7e0e6e37f$require$div('.profile-aside', aside) : ''
            ]),
            videos.length ? $ad26ccb7e0e6e37f$require$div('.profile-row.profile-row-media', [
                $ad26ccb7e0e6e37f$require$section('.profile-videos', [
                    $ad26ccb7e0e6e37f$require$h2(i18n.widget && i18n.widget.videoList || "\u0412\u0438\u0434\u0435\u043E"),
                    $ad26ccb7e0e6e37f$require$ul('.video-gallery', videos.map((vid)=>{
                        const href = $ad26ccb7e0e6e37f$var$mediaSrc(vid);
                        const title = vid.title || href || 'video';
                        return $ad26ccb7e0e6e37f$require$li('.video-gallery-item', [
                            $ad26ccb7e0e6e37f$require$a('.video-gallery-link[target="_blank"][rel="noopener"]', {
                                attrs: {
                                    href: href,
                                    title: title
                                }
                            }, [
                                $ad26ccb7e0e6e37f$require$span('.video-gallery-thumb', [
                                    $ad26ccb7e0e6e37f$var$videoThumb(vid),
                                    $ad26ccb7e0e6e37f$require$span('.video-gallery-play.fa.fa-external-link')
                                ]),
                                $ad26ccb7e0e6e37f$require$span('.video-gallery-title', title)
                            ])
                        ]);
                    }))
                ])
            ]) : '',
            tracks.length && pictures.length ? $ad26ccb7e0e6e37f$require$div('.profile-row.profile-row-pictures', [
                $ad26ccb7e0e6e37f$var$picturesSection({
                    pictures: pictures,
                    i18n: i18n
                })
            ]) : ''
        ])
    ]);
};
module.exports = ({ state: state, actions: actions, i18n: i18n })=>state.router.path[1] ? $ad26ccb7e0e6e37f$var$detailView({
        state: state,
        actions: actions,
        i18n: i18n
    }) : $ad26ccb7e0e6e37f$var$listView({
        state: state,
        actions: actions,
        i18n: i18n
    });

});
parcelRegister("cDQjg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "emailOk", () => $9341b431518c3d80$export$b20e128c5f6bdc9e);
$parcel$export(module.exports, "url", () => $9341b431518c3d80$export$128fa18b7194ef);
$parcel$export(module.exports, "src", () => $9341b431518c3d80$export$2e40c9e35e9506f4);
$parcel$export(module.exports, "default", () => $9341b431518c3d80$export$2e2bcd8739ae039);

var $4EDSG = parcelRequire("4EDSG");
const $9341b431518c3d80$export$b20e128c5f6bdc9e = (email)=>/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());
const $9341b431518c3d80$export$128fa18b7194ef = (email, size = 160)=>{
    const hash = (0, $4EDSG.default)(String(email).trim().toLowerCase());
    return `https://www.gravatar.com/avatar/${hash}?s=${size}&d=identicon`;
};
const $9341b431518c3d80$export$2e40c9e35e9506f4 = (profile = {}, size = 160)=>{
    if (profile.avatar) return profile.avatar;
    if ($9341b431518c3d80$export$b20e128c5f6bdc9e(profile.email)) return $9341b431518c3d80$export$128fa18b7194ef(profile.email, size);
    return '';
};
var $9341b431518c3d80$export$2e2bcd8739ae039 = {
    url: $9341b431518c3d80$export$128fa18b7194ef,
    src: $9341b431518c3d80$export$2e40c9e35e9506f4,
    emailOk: $9341b431518c3d80$export$b20e128c5f6bdc9e
};

});
parcelRegister("4EDSG", function(module, exports) {

$parcel$export(module.exports, "default", () => $3639d562693712db$export$2e2bcd8739ae039);
/* Minimal MD5 (RFC 1321) for Gravatar hashes — not for crypto use. */ const $3639d562693712db$var$cmn = (q, a, b, x, s, t)=>{
    a = a + q + x + t | 0;
    return (a << s | a >>> 32 - s) + b | 0;
};
const $3639d562693712db$var$ff = (a, b, c, d, x, s, t)=>$3639d562693712db$var$cmn(b & c | ~b & d, a, b, x, s, t);
const $3639d562693712db$var$gg = (a, b, c, d, x, s, t)=>$3639d562693712db$var$cmn(b & d | c & ~d, a, b, x, s, t);
const $3639d562693712db$var$hh = (a, b, c, d, x, s, t)=>$3639d562693712db$var$cmn(b ^ c ^ d, a, b, x, s, t);
const $3639d562693712db$var$ii = (a, b, c, d, x, s, t)=>$3639d562693712db$var$cmn(c ^ (b | ~d), a, b, x, s, t);
const $3639d562693712db$var$toUtf8 = (str)=>unescape(encodeURIComponent(str));
const $3639d562693712db$var$md5cycle = (x, k)=>{
    let [a, b, c, d] = x;
    a = $3639d562693712db$var$ff(a, b, c, d, k[0], 7, -680876936);
    d = $3639d562693712db$var$ff(d, a, b, c, k[1], 12, -389564586);
    c = $3639d562693712db$var$ff(c, d, a, b, k[2], 17, 606105819);
    b = $3639d562693712db$var$ff(b, c, d, a, k[3], 22, -1044525330);
    a = $3639d562693712db$var$ff(a, b, c, d, k[4], 7, -176418897);
    d = $3639d562693712db$var$ff(d, a, b, c, k[5], 12, 1200080426);
    c = $3639d562693712db$var$ff(c, d, a, b, k[6], 17, -1473231341);
    b = $3639d562693712db$var$ff(b, c, d, a, k[7], 22, -45705983);
    a = $3639d562693712db$var$ff(a, b, c, d, k[8], 7, 1770035416);
    d = $3639d562693712db$var$ff(d, a, b, c, k[9], 12, -1958414417);
    c = $3639d562693712db$var$ff(c, d, a, b, k[10], 17, -42063);
    b = $3639d562693712db$var$ff(b, c, d, a, k[11], 22, -1990404162);
    a = $3639d562693712db$var$ff(a, b, c, d, k[12], 7, 1804603682);
    d = $3639d562693712db$var$ff(d, a, b, c, k[13], 12, -40341101);
    c = $3639d562693712db$var$ff(c, d, a, b, k[14], 17, -1502002290);
    b = $3639d562693712db$var$ff(b, c, d, a, k[15], 22, 1236535329);
    a = $3639d562693712db$var$gg(a, b, c, d, k[1], 5, -165796510);
    d = $3639d562693712db$var$gg(d, a, b, c, k[6], 9, -1069501632);
    c = $3639d562693712db$var$gg(c, d, a, b, k[11], 14, 643717713);
    b = $3639d562693712db$var$gg(b, c, d, a, k[0], 20, -373897302);
    a = $3639d562693712db$var$gg(a, b, c, d, k[5], 5, -701558691);
    d = $3639d562693712db$var$gg(d, a, b, c, k[10], 9, 38016083);
    c = $3639d562693712db$var$gg(c, d, a, b, k[15], 14, -660478335);
    b = $3639d562693712db$var$gg(b, c, d, a, k[4], 20, -405537848);
    a = $3639d562693712db$var$gg(a, b, c, d, k[9], 5, 568446438);
    d = $3639d562693712db$var$gg(d, a, b, c, k[14], 9, -1019803690);
    c = $3639d562693712db$var$gg(c, d, a, b, k[3], 14, -187363961);
    b = $3639d562693712db$var$gg(b, c, d, a, k[8], 20, 1163531501);
    a = $3639d562693712db$var$gg(a, b, c, d, k[13], 5, -1444681467);
    d = $3639d562693712db$var$gg(d, a, b, c, k[2], 9, -51403784);
    c = $3639d562693712db$var$gg(c, d, a, b, k[7], 14, 1735328473);
    b = $3639d562693712db$var$gg(b, c, d, a, k[12], 20, -1926607734);
    a = $3639d562693712db$var$hh(a, b, c, d, k[5], 4, -378558);
    d = $3639d562693712db$var$hh(d, a, b, c, k[8], 11, -2022574463);
    c = $3639d562693712db$var$hh(c, d, a, b, k[11], 16, 1839030562);
    b = $3639d562693712db$var$hh(b, c, d, a, k[14], 23, -35309556);
    a = $3639d562693712db$var$hh(a, b, c, d, k[1], 4, -1530992060);
    d = $3639d562693712db$var$hh(d, a, b, c, k[4], 11, 1272893353);
    c = $3639d562693712db$var$hh(c, d, a, b, k[7], 16, -155497632);
    b = $3639d562693712db$var$hh(b, c, d, a, k[10], 23, -1094730640);
    a = $3639d562693712db$var$hh(a, b, c, d, k[13], 4, 681279174);
    d = $3639d562693712db$var$hh(d, a, b, c, k[0], 11, -358537222);
    c = $3639d562693712db$var$hh(c, d, a, b, k[3], 16, -722521979);
    b = $3639d562693712db$var$hh(b, c, d, a, k[6], 23, 76029189);
    a = $3639d562693712db$var$hh(a, b, c, d, k[9], 4, -640364487);
    d = $3639d562693712db$var$hh(d, a, b, c, k[12], 11, -421815835);
    c = $3639d562693712db$var$hh(c, d, a, b, k[15], 16, 530742520);
    b = $3639d562693712db$var$hh(b, c, d, a, k[2], 23, -995338651);
    a = $3639d562693712db$var$ii(a, b, c, d, k[0], 6, -198630844);
    d = $3639d562693712db$var$ii(d, a, b, c, k[7], 10, 1126891415);
    c = $3639d562693712db$var$ii(c, d, a, b, k[14], 15, -1416354905);
    b = $3639d562693712db$var$ii(b, c, d, a, k[5], 21, -57434055);
    a = $3639d562693712db$var$ii(a, b, c, d, k[12], 6, 1700485571);
    d = $3639d562693712db$var$ii(d, a, b, c, k[3], 10, -1894986606);
    c = $3639d562693712db$var$ii(c, d, a, b, k[10], 15, -1051523);
    b = $3639d562693712db$var$ii(b, c, d, a, k[1], 21, -2054922799);
    a = $3639d562693712db$var$ii(a, b, c, d, k[8], 6, 1873313359);
    d = $3639d562693712db$var$ii(d, a, b, c, k[15], 10, -30611744);
    c = $3639d562693712db$var$ii(c, d, a, b, k[6], 15, -1560198380);
    b = $3639d562693712db$var$ii(b, c, d, a, k[13], 21, 1309151649);
    a = $3639d562693712db$var$ii(a, b, c, d, k[4], 6, -145523070);
    d = $3639d562693712db$var$ii(d, a, b, c, k[11], 10, -1120210379);
    c = $3639d562693712db$var$ii(c, d, a, b, k[2], 15, 718787259);
    b = $3639d562693712db$var$ii(b, c, d, a, k[9], 21, -343485551);
    x[0] = a + x[0] | 0;
    x[1] = b + x[1] | 0;
    x[2] = c + x[2] | 0;
    x[3] = d + x[3] | 0;
};
const $3639d562693712db$var$md5blk = (s)=>{
    const blks = [];
    for(let i = 0; i < 64; i += 4)blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
    return blks;
};
const $3639d562693712db$var$rhex = (n)=>{
    const hex = '0123456789abcdef';
    let s = '';
    for(let j = 0; j < 4; j++)s += hex.charAt(n >> j * 8 + 4 & 0x0f) + hex.charAt(n >> j * 8 & 0x0f);
    return s;
};
const $3639d562693712db$var$md5 = (str)=>{
    const raw = $3639d562693712db$var$toUtf8(String(str || ''));
    const n = raw.length;
    const state = [
        1732584193,
        -271733879,
        -1732584194,
        271733878
    ];
    let i;
    for(i = 64; i <= n; i += 64)$3639d562693712db$var$md5cycle(state, $3639d562693712db$var$md5blk(raw.substring(i - 64, i)));
    const tail = raw.substring(i - 64);
    const tmp = new Array(16).fill(0);
    for(i = 0; i < tail.length; i++)tmp[i >> 2] |= tail.charCodeAt(i) << (i % 4 << 3);
    tmp[i >> 2] |= 0x80 << (i % 4 << 3);
    if (i > 55) {
        $3639d562693712db$var$md5cycle(state, tmp);
        for(i = 0; i < 16; i++)tmp[i] = 0;
    }
    tmp[14] = n * 8;
    $3639d562693712db$var$md5cycle(state, tmp);
    return state.map($3639d562693712db$var$rhex).join('');
};
var $3639d562693712db$export$2e2bcd8739ae039 = $3639d562693712db$var$md5;

});


parcelRegister("b9lWd", function(module, exports) {
'use strict';
const $81e18d62ec46f704$var$youtubeId = (url)=>{
    if (!url) return '';
    const m = String(url).match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/))([A-Za-z0-9_-]{6,})/);
    return m ? m[1] : '';
};
const $81e18d62ec46f704$var$vimeoId = (url)=>{
    if (!url) return '';
    const m = String(url).match(/vimeo\.com\/(?:video\/)?(\d+)/);
    return m ? m[1] : '';
};
const $81e18d62ec46f704$var$isDirectFile = (url)=>/\.(mp3|wav|ogg|flac|m4a|aac|mp4|webm|ogv)(\?|#|$)/i.test(String(url || '')) || String(url || '').indexOf('/api/content/') === 0;
module.exports = {
    youtubeId: $81e18d62ec46f704$var$youtubeId,
    vimeoId: $81e18d62ec46f704$var$vimeoId,
    isDirectFile: $81e18d62ec46f704$var$isDirectFile
};

});

parcelRegister("fFCx8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b688934fd3fa3e2f$export$2e2bcd8739ae039);

var $2Z6Kw = parcelRequire("2Z6Kw");

var $cBxnd = parcelRequire("cBxnd");

var $dgw34 = parcelRequire("dgw34");
const $b688934fd3fa3e2f$var$audioPlayer = (0, (/*@__PURE__*/$parcel$interopDefault($cBxnd))).default || (0, (/*@__PURE__*/$parcel$interopDefault($cBxnd)));
const $b688934fd3fa3e2f$var$ROW_WAVE_HEIGHT = 63;
const $b688934fd3fa3e2f$var$formatTime = (sec)=>{
    if (!Number.isFinite(sec) || sec < 0) return '0:00';
    const s = Math.floor(sec);
    const m = Math.floor(s / 60);
    const r = s % 60;
    return `${m}:${r < 10 ? `0${r}` : r}`;
};
const $b688934fd3fa3e2f$var$rootOf = (el)=>el && el.closest && el.closest('.widget-track-list') || null;
const $b688934fd3fa3e2f$var$mediaElAt = (root, index)=>{
    if (!root || index < 0) return null;
    const rows = root.querySelectorAll('.widget-track-list-row');
    return rows[index] && rows[index].querySelector('.media-player') || null;
};
const $b688934fd3fa3e2f$var$playerAt = (root, index)=>{
    const el = $b688934fd3fa3e2f$var$mediaElAt(root, index);
    if (!el) return null;
    if (el.__ws) return {
        kind: 'ws',
        api: el.__ws,
        el: el
    };
    if (el.__sc) return {
        kind: 'sc',
        api: el.__sc,
        el: el
    };
    if (el.__mc) return {
        kind: 'mc',
        api: el.__mc,
        el: el
    };
    return null;
};
const $b688934fd3fa3e2f$var$activePlayer = (root)=>{
    if (!root) return null;
    const el = root.querySelector('.widget-track-list-row.is-active .media-player');
    if (!el) return null;
    if (el.__ws) return {
        kind: 'ws',
        api: el.__ws,
        el: el
    };
    if (el.__sc) return {
        kind: 'sc',
        api: el.__sc,
        el: el
    };
    if (el.__mc) return {
        kind: 'mc',
        api: el.__mc,
        el: el
    };
    return null;
};
const $b688934fd3fa3e2f$var$resetPlayer = (player)=>{
    if (!player) return;
    if (player.kind === 'ws') {
        if (typeof player.api.setTime === 'function') player.api.setTime(0);
        else {
            const media = player.api.getMediaElement && player.api.getMediaElement();
            if (media) media.currentTime = 0;
        }
        return;
    }
    if (player.kind === 'sc' && typeof player.api.seekTo === 'function') player.api.seekTo(0);
    if (player.kind === 'mc' && typeof player.api.seek === 'function') player.api.seek(0).catch(()=>{});
};
const $b688934fd3fa3e2f$var$setPlayhead = (player, on)=>{
    if (!player || player.kind !== 'ws' || typeof player.api.setOptions !== 'function') return;
    player.api.setOptions({
        cursorWidth: on ? 1 : 0,
        cursorColor: on ? '#111' : 'transparent',
        progressColor: on ? '#333' : '#8a8a8a'
    });
};
const $b688934fd3fa3e2f$var$pausePlayer = (player)=>{
    if (!player || !player.api) return;
    const result = player.api.pause && player.api.pause();
    if (result && typeof result.catch === 'function') result.catch(()=>{});
};
const $b688934fd3fa3e2f$var$waveRatioFromEvent = (ev, el)=>{
    const rect = el.getBoundingClientRect();
    if (!rect.width) return 0;
    return Math.max(0, Math.min(1, (ev.clientX - rect.left) / rect.width));
};
const $b688934fd3fa3e2f$var$withScReady = (el, fn)=>{
    if (!el || !el.__sc) return false;
    const run = ()=>{
        fn(el.__sc);
    };
    if (el.__scReady) {
        run();
        return true;
    }
    const Widget = typeof window !== 'undefined' && window.SC && window.SC.Widget;
    if (Widget && Widget.Events) el.__sc.bind(Widget.Events.READY, run);
    try {
        run();
    } catch (err) {
    // wait for READY
    }
    return true;
};
const $b688934fd3fa3e2f$var$withMcReady = (el, fn)=>{
    if (!el || !el.__mc) return false;
    const run = (api)=>{
        fn(api || el.__mc);
    };
    if (el.__mcReady && typeof el.__mc.play === 'function') {
        run(el.__mc);
        return true;
    }
    if (el.__mc.ready && typeof el.__mc.ready.then === 'function') {
        el.__mc.ready.then((api)=>{
            el.__mc = api || el.__mc;
            el.__mcReady = true;
            run(el.__mc);
        }).catch(()=>{});
        return true;
    }
    return false;
};
const $b688934fd3fa3e2f$var$seekAt = (root, index, ratio)=>{
    const el = $b688934fd3fa3e2f$var$mediaElAt(root, index);
    if (!el || ratio == null) return;
    const r = Math.max(0, Math.min(1, Number(ratio) || 0));
    if (el.__ws) {
        const ws = el.__ws;
        const dur = typeof ws.getDuration === 'function' ? ws.getDuration() : 0;
        if (dur > 0 && typeof ws.setTime === 'function') ws.setTime(r * dur);
        return;
    }
    if (el.__mc) {
        $b688934fd3fa3e2f$var$withMcReady(el, (mc)=>{
            if (typeof mc.getDuration !== 'function' || typeof mc.seek !== 'function') return;
            mc.getDuration().then((durationSec)=>{
                if (durationSec > 0) mc.seek(r * durationSec);
            }).catch(()=>{});
        });
        return;
    }
    $b688934fd3fa3e2f$var$withScReady(el, (sc)=>{
        if (typeof sc.getDuration !== 'function' || typeof sc.seekTo !== 'function') return;
        sc.getDuration((durationMs)=>{
            if (durationMs > 0) sc.seekTo(r * durationMs);
        });
    });
};
/** Play row player; optional seekRatio (0–1). SC seeks while paused, then plays. */ const $b688934fd3fa3e2f$var$playAt = (root, index, setPaused, seekRatio = null)=>{
    const el = $b688934fd3fa3e2f$var$mediaElAt(root, index);
    if (!el) return;
    const markPlaying = ()=>{
        if (typeof setPaused === 'function') setPaused(false);
    };
    if (el.__ws) {
        const ws = el.__ws;
        const go = ()=>{
            if (seekRatio != null) {
                const dur = typeof ws.getDuration === 'function' ? ws.getDuration() : 0;
                if (dur > 0 && typeof ws.setTime === 'function') ws.setTime(Math.max(0, Math.min(1, seekRatio)) * dur);
            }
            ws.play();
            markPlaying();
        };
        if (typeof ws.getDuration === 'function' && ws.getDuration() > 0) go();
        else if (typeof ws.once === 'function') ws.once('ready', go);
        else go();
        return;
    }
    const trySc = ()=>{
        if (!el.__sc) return false;
        const start = ()=>{
            el.__sc.play();
            markPlaying();
        };
        const run = ()=>{
            if (seekRatio == null || typeof el.__sc.getDuration !== 'function' || typeof el.__sc.seekTo !== 'function') {
                start();
                return;
            }
            const r = Math.max(0, Math.min(1, seekRatio));
            el.__sc.getDuration((durationMs)=>{
                if (durationMs > 0) el.__sc.seekTo(r * durationMs);
                // Let the paused seek land before starting playback
                setTimeout(start, 40);
            });
        };
        if (el.__scReady) {
            run();
            return true;
        }
        const Widget = typeof window !== 'undefined' && window.SC && window.SC.Widget;
        if (Widget && Widget.Events) el.__sc.bind(Widget.Events.READY, run);
        try {
            run();
        } catch (err) {
        // ignore until READY
        }
        return true;
    };
    const tryMc = ()=>{
        if (!el.__mc) return false;
        const start = (mc)=>{
            if (!mc || typeof mc.play !== 'function') {
                el.__mcPendingPlay = true;
                if (typeof console !== 'undefined') console.log("[mtbg:mixcloud] play() deferred \u2014 API not ready");
                return;
            }
            if (typeof console !== 'undefined') console.log('[mtbg:mixcloud] parent play()', {
                unlocked: Boolean(el.__mcUnlocked),
                ready: Boolean(el.__mcReady)
            });
            mc.play().then(()=>{
                if (typeof mc.getIsPaused !== 'function') return;
                return mc.getIsPaused().then((paused)=>{
                    if (typeof console !== 'undefined') console.log('[mtbg:mixcloud] after parent play()', {
                        paused: paused,
                        unlocked: Boolean(el.__mcUnlocked)
                    });
                });
            }).catch((err)=>{
                el.__mcPendingPlay = true;
                if (typeof console !== 'undefined') console.log('[mtbg:mixcloud] play() rejected', String(err));
            });
        };
        const run = (mc)=>{
            const api = mc || el.__mc;
            if (seekRatio == null || typeof api.getDuration !== 'function' || typeof api.seek !== 'function') {
                start(api);
                return;
            }
            const r = Math.max(0, Math.min(1, seekRatio));
            api.getDuration().then((durationSec)=>{
                if (durationSec > 0) return api.seek(r * durationSec).then(()=>start(api));
                start(api);
            }).catch(()=>start(api));
        };
        if (el.__mcReady && typeof el.__mc.play === 'function') {
            run(el.__mc);
            return true;
        }
        if (el.__mc.ready && typeof el.__mc.ready.then === 'function') {
            el.__mcPendingPlay = true;
            el.__mc.ready.then((api)=>{
                el.__mc = api || el.__mc;
                el.__mcReady = true;
                run(el.__mc);
            }).catch(()=>{});
            return true;
        }
        return false;
    };
    if (trySc() || tryMc()) return;
    let n = 0;
    const id = setInterval(()=>{
        if (trySc() || tryMc() || ++n > 50) clearInterval(id);
    }, 100);
};
const $b688934fd3fa3e2f$var$playPlayer = (player, setPaused)=>{
    if (!player || !player.el) return;
    const root = player.el.closest('.widget-track-list');
    const rows = root ? root.querySelectorAll('.widget-track-list-row') : [];
    let index = -1;
    rows.forEach((row, i)=>{
        if (row.contains(player.el)) index = i;
    });
    if (index >= 0) $b688934fd3fa3e2f$var$playAt(root, index, setPaused);
};
const $b688934fd3fa3e2f$var$isPlayerPlaying = (player)=>{
    if (!player) return false;
    if (player.kind === 'ws') return Boolean(player.api.isPlaying && player.api.isPlaying());
    return false;
};
const $b688934fd3fa3e2f$var$leaveRows = (root, keepIndex = -1)=>{
    if (!root) return;
    root.querySelectorAll('.widget-track-list-row').forEach((row, i)=>{
        const el = row.querySelector('.media-player');
        if (!el) return;
        const player = el.__ws ? {
            kind: 'ws',
            api: el.__ws,
            el: el
        } : el.__sc ? {
            kind: 'sc',
            api: el.__sc,
            el: el
        } : el.__mc ? {
            kind: 'mc',
            api: el.__mc,
            el: el
        } : null;
        if (!player) return;
        $b688934fd3fa3e2f$var$pausePlayer(player);
        if (i !== keepIndex) {
            $b688934fd3fa3e2f$var$resetPlayer(player);
            $b688934fd3fa3e2f$var$setPlayhead(player, false);
        } else $b688934fd3fa3e2f$var$setPlayhead(player, true);
    });
};
const $b688934fd3fa3e2f$var$bindMediaEvents = (media, root)=>{
    if (!media || media.__mtbgBound) return;
    media.__mtbgBound = true;
    media.addEventListener('play', ()=>{
        if (root && typeof root.__mtbgSetPaused === 'function') root.__mtbgSetPaused(false);
    });
    media.addEventListener('pause', ()=>{
        if (media.ended) return;
        if (root && typeof root.__mtbgSetPaused === 'function') root.__mtbgSetPaused(true);
    });
    media.addEventListener('ended', ()=>{
        if (root && typeof root.__mtbgOnEnded === 'function') root.__mtbgOnEnded();
        else if (root && typeof root.__mtbgSetPaused === 'function') root.__mtbgSetPaused(true);
    });
};
const $b688934fd3fa3e2f$var$getListVolume = (rootOrTransport)=>{
    const root = rootOrTransport && rootOrTransport.classList && rootOrTransport.classList.contains('widget-track-list') ? rootOrTransport : rootOrTransport && rootOrTransport.closest && rootOrTransport.closest('.widget-track-list');
    if (!root) return 100;
    const v = Number(root.__mtbgVolume);
    return Number.isFinite(v) ? Math.max(0, Math.min(100, v)) : 100;
};
const $b688934fd3fa3e2f$var$setListVolume = (rootOrTransport, value)=>{
    const root = rootOrTransport && rootOrTransport.classList && rootOrTransport.classList.contains('widget-track-list') ? rootOrTransport : rootOrTransport && rootOrTransport.closest && rootOrTransport.closest('.widget-track-list');
    if (!root) return 100;
    const v = Math.max(0, Math.min(100, Number(value)));
    root.__mtbgVolume = Number.isFinite(v) ? v : 100;
    return root.__mtbgVolume;
};
const $b688934fd3fa3e2f$var$applyVolumeToPlayer = (player, volume100)=>{
    if (!player || !player.api) return;
    const v = Math.max(0, Math.min(100, Number(volume100)));
    if (player.kind === 'sc' && typeof player.api.setVolume === 'function') {
        player.api.setVolume(v);
        return;
    }
    if (player.kind === 'mc' && typeof player.api.setVolume === 'function') {
        player.api.setVolume(v / 100).catch(()=>{});
        return;
    }
    if (player.kind === 'ws') {
        const media = player.api.getMediaElement && player.api.getMediaElement();
        if (media) media.volume = v / 100;
    }
};
/** Park active WaveSurfer media, or wire SC/Mixcloud seek+volume into the transport. */ const $b688934fd3fa3e2f$var$stopEmbedTransport = (transportEl)=>{
    if (!transportEl) return;
    if (typeof transportEl.__mtbgEmbedCleanup === 'function') {
        transportEl.__mtbgEmbedCleanup();
        transportEl.__mtbgEmbedCleanup = null;
    }
    transportEl.__mtbgEmbedKey = null;
};
const $b688934fd3fa3e2f$var$updateEmbedSeekUi = (transportEl, positionSec, durationSec)=>{
    if (!transportEl || transportEl.__mtbgSeeking) return;
    const seek = transportEl.querySelector('.widget-track-list-seek');
    const time = transportEl.querySelector('.widget-track-list-time');
    if (time) time.textContent = `${$b688934fd3fa3e2f$var$formatTime(positionSec)} / ${$b688934fd3fa3e2f$var$formatTime(durationSec)}`;
    if (seek && durationSec > 0) {
        const pct = Math.max(0, Math.min(100, positionSec / durationSec * 100));
        seek.value = String(Math.round(positionSec / durationSec * 1000));
        seek.style.setProperty('--mtbg-fill', `${pct}%`);
    } else if (seek) {
        seek.value = '0';
        seek.style.setProperty('--mtbg-fill', '0%');
    }
};
const $b688934fd3fa3e2f$var$wireEmbedTransport = (transportEl, player)=>{
    const seek = transportEl.querySelector('.widget-track-list-seek');
    const volume = transportEl.querySelector('.widget-track-list-volume');
    const time = transportEl.querySelector('.widget-track-list-time');
    if (!seek || !volume || !player || !player.api) return;
    const frame = player.el && player.el.querySelector && player.el.querySelector('iframe');
    const mediaHint = player.kind === 'ws' && player.api.getMediaElement && player.api.getMediaElement();
    const key = `${player.kind}:${frame && frame.src || mediaHint && mediaHint.src || ''}`;
    if (transportEl.__mtbgEmbedKey === key && transportEl.__mtbgEmbedCleanup) return;
    $b688934fd3fa3e2f$var$stopEmbedTransport(transportEl);
    transportEl.__mtbgEmbedKey = key;
    let durationSec = 0;
    const cleanups = [];
    const listVolume = $b688934fd3fa3e2f$var$getListVolume(transportEl);
    volume.value = String(listVolume);
    volume.style.setProperty('--mtbg-fill', `${listVolume}%`);
    $b688934fd3fa3e2f$var$applyVolumeToPlayer(player, listVolume);
    const onSeekInput = ()=>{
        transportEl.__mtbgSeeking = true;
        const ratio = Math.max(0, Math.min(1, Number(seek.value) / 1000));
        seek.style.setProperty('--mtbg-fill', `${ratio * 100}%`);
        if (time && durationSec > 0) time.textContent = `${$b688934fd3fa3e2f$var$formatTime(ratio * durationSec)} / ${$b688934fd3fa3e2f$var$formatTime(durationSec)}`;
    };
    const onSeekCommit = ()=>{
        const ratio = Math.max(0, Math.min(1, Number(seek.value) / 1000));
        if (player.kind === 'sc' && typeof player.api.seekTo === 'function') player.api.seekTo(ratio * durationSec * 1000);
        else if (player.kind === 'mc' && typeof player.api.seek === 'function') player.api.seek(ratio * durationSec).catch(()=>{});
        else if (player.kind === 'ws') {
            const ws = player.api;
            if (typeof ws.setTime === 'function') ws.setTime(ratio * durationSec);
            else {
                const media = ws.getMediaElement && ws.getMediaElement();
                if (media) media.currentTime = ratio * durationSec;
            }
        }
        transportEl.__mtbgSeeking = false;
    };
    seek.addEventListener('input', onSeekInput);
    seek.addEventListener('change', onSeekCommit);
    cleanups.push(()=>{
        seek.removeEventListener('input', onSeekInput);
        seek.removeEventListener('change', onSeekCommit);
    });
    const onVolume = ()=>{
        const v = $b688934fd3fa3e2f$var$setListVolume(transportEl, volume.value);
        volume.style.setProperty('--mtbg-fill', `${v}%`);
        $b688934fd3fa3e2f$var$applyVolumeToPlayer(player, v);
    };
    volume.addEventListener('input', onVolume);
    volume.addEventListener('change', onVolume);
    cleanups.push(()=>{
        volume.removeEventListener('input', onVolume);
        volume.removeEventListener('change', onVolume);
    });
    if (player.kind === 'sc') {
        const api = player.api;
        api.getDuration((ms)=>{
            durationSec = (ms || 0) / 1000;
            $b688934fd3fa3e2f$var$updateEmbedSeekUi(transportEl, 0, durationSec);
            if (typeof api.getPosition === 'function') api.getPosition((posMs)=>{
                $b688934fd3fa3e2f$var$updateEmbedSeekUi(transportEl, (posMs || 0) / 1000, durationSec);
            });
        });
        const Widget = typeof window !== 'undefined' && window.SC && window.SC.Widget;
        if (Widget && Widget.Events && Widget.Events.PLAY_PROGRESS) {
            const onProgress = (data)=>{
                const ms = data && typeof data.currentPosition === 'number' ? data.currentPosition : 0;
                $b688934fd3fa3e2f$var$updateEmbedSeekUi(transportEl, ms / 1000, durationSec);
            };
            api.bind(Widget.Events.PLAY_PROGRESS, onProgress);
            cleanups.push(()=>{
                if (typeof api.unbind === 'function') api.unbind(Widget.Events.PLAY_PROGRESS, onProgress);
            });
        }
    } else if (player.kind === 'mc') {
        const api = player.api;
        const refresh = ()=>{
            Promise.all([
                typeof api.getDuration === 'function' ? api.getDuration() : Promise.resolve(0),
                typeof api.getPosition === 'function' ? api.getPosition() : Promise.resolve(0)
            ]).then(([d, p])=>{
                durationSec = Number(d) || 0;
                $b688934fd3fa3e2f$var$updateEmbedSeekUi(transportEl, Number(p) || 0, durationSec);
            }).catch(()=>{});
        };
        refresh();
        if (api.events && api.events.progress && typeof api.events.progress.on === 'function') {
            const onProgress = (position, duration)=>{
                durationSec = Number(duration) || durationSec;
                $b688934fd3fa3e2f$var$updateEmbedSeekUi(transportEl, Number(position) || 0, durationSec);
            };
            api.events.progress.on(onProgress);
            cleanups.push(()=>{
                if (api.events.progress.off) api.events.progress.off(onProgress);
            });
        } else {
            const id = setInterval(refresh, 500);
            cleanups.push(()=>clearInterval(id));
        }
    } else if (player.kind === 'ws') {
        const ws = player.api;
        const media = ws.getMediaElement && ws.getMediaElement();
        const root = transportEl.closest('.widget-track-list');
        const refresh = ()=>{
            durationSec = typeof ws.getDuration === 'function' ? ws.getDuration() : 0;
            const pos = typeof ws.getCurrentTime === 'function' ? ws.getCurrentTime() : media && media.currentTime || 0;
            $b688934fd3fa3e2f$var$updateEmbedSeekUi(transportEl, pos, durationSec);
        };
        refresh();
        if (media) {
            media.controls = false;
            $b688934fd3fa3e2f$var$bindMediaEvents(media, root);
            media.addEventListener('timeupdate', refresh);
            media.addEventListener('loadedmetadata', refresh);
            media.addEventListener('durationchange', refresh);
            cleanups.push(()=>{
                media.removeEventListener('timeupdate', refresh);
                media.removeEventListener('loadedmetadata', refresh);
                media.removeEventListener('durationchange', refresh);
            });
        }
        if (typeof ws.on === 'function') {
            ws.on('audioprocess', refresh);
            ws.on('seeking', refresh);
            ws.on('ready', refresh);
            cleanups.push(()=>{
                if (typeof ws.un === 'function') {
                    ws.un('audioprocess', refresh);
                    ws.un('seeking', refresh);
                    ws.un('ready', refresh);
                }
            });
        }
    }
    transportEl.__mtbgEmbedCleanup = ()=>{
        transportEl.__mtbgSeeking = false;
        cleanups.forEach((fn)=>fn());
    };
};
const $b688934fd3fa3e2f$var$returnParkedAudio = (root, transportEl)=>{
    Array.from(transportEl.querySelectorAll('audio')).forEach((audio)=>{
        const wave = root.querySelector('.media-player.wavesurfer');
        if (wave && audio.parentElement === transportEl) {
            audio.controls = false;
            wave.appendChild(audio);
        }
    });
};
const $b688934fd3fa3e2f$var$syncTransport = (transportEl)=>{
    const root = transportEl && transportEl.closest('.widget-track-list');
    if (!root || !transportEl) return;
    $b688934fd3fa3e2f$var$returnParkedAudio(root, transportEl);
    const player = $b688934fd3fa3e2f$var$activePlayer(root);
    const ui = transportEl.querySelector('.widget-track-list-embed-transport');
    if (player && ui && (player.kind === 'sc' || player.kind === 'mc' || player.kind === 'ws')) {
        $b688934fd3fa3e2f$var$wireEmbedTransport(transportEl, player);
        return;
    }
    $b688934fd3fa3e2f$var$stopEmbedTransport(transportEl);
};
const $b688934fd3fa3e2f$var$CONTROLS = [
    {
        icon: 'random',
        action: 'shuffle'
    },
    {
        icon: 'step-backward',
        action: 'previous'
    },
    {
        icon: 'play',
        action: 'play'
    },
    {
        icon: 'step-forward',
        action: 'next'
    },
    {
        icon: 'repeat',
        action: 'repeat'
    }
];
const $b688934fd3fa3e2f$var$REPEAT_CYCLE = [
    'off',
    'all',
    'one'
];
const $b688934fd3fa3e2f$var$normalizeRepeat = (value)=>{
    if (value === 'all' || value === 'one') return value;
    // legacy boolean: on meant loop playlist
    if (value === true) return 'all';
    return 'off';
};
const $b688934fd3fa3e2f$var$nextRepeat = (value)=>{
    const cur = $b688934fd3fa3e2f$var$normalizeRepeat(value);
    const i = Math.max(0, $b688934fd3fa3e2f$var$REPEAT_CYCLE.indexOf(cur));
    return $b688934fd3fa3e2f$var$REPEAT_CYCLE[(i + 1) % $b688934fd3fa3e2f$var$REPEAT_CYCLE.length];
};
const $b688934fd3fa3e2f$var$pickIndex = (listLength, from, delta, shuffle)=>{
    if (listLength <= 0) return -1;
    if (listLength === 1) return 0;
    if (shuffle) {
        let i = from;
        while(i === from)i = Math.floor(Math.random() * listLength);
        return i;
    }
    const base = from < 0 ? 0 : from;
    return (base + delta + listLength) % listLength;
};
var /**
 * Track list — header · transport · rows.
 * WaveSurfer owns seek on click; we only move play/pause between rows.
 *
 * Important: keep `li` / play `button` selectors stable — putting `.is-active` /
 * `.fa-pause` in the sel string makes snabbdom destroy+recreate the node (and
 * WaveSurfer with it) on every selection change.
 */ $b688934fd3fa3e2f$export$2e2bcd8739ae039 = ({ node: node, i18n: i18n, list: list = [], activeIndex: activeIndex = 0, paused: paused = true, shuffle: shuffle = false, repeat: repeat = 'off', onSelect: onSelect, onPlayback: onPlayback })=>{
    if (!list.length) return [];
    const title = (0, $dgw34.resolveContent)(node && (node.title || node.content) || 'i18n.widget.trackList', i18n || {}) || "\u0422\u0440\u0430\u043A\u043E\u0432\u0435";
    const select = typeof onSelect === 'function' ? onSelect : ()=>{};
    const patchPlayback = (patch)=>{
        if (typeof onPlayback === 'function') onPlayback(patch);
    };
    const setPaused = (value)=>patchPlayback({
            paused: value
        });
    const isPlaying = paused === false;
    const repeatMode = $b688934fd3fa3e2f$var$normalizeRepeat(repeat);
    const selectRow = (root, index, { play: play = false, seekRatio: seekRatio = null } = {})=>{
        $b688934fd3fa3e2f$var$leaveRows(root, index);
        if (play) // one patch so paused:false cannot clobber a just-updated track
        patchPlayback({
            track: index,
            paused: false
        });
        else select(index);
        requestAnimationFrame(()=>{
            if (play) $b688934fd3fa3e2f$var$playAt(root, index, setPaused, seekRatio);
            else if (seekRatio != null) $b688934fd3fa3e2f$var$seekAt(root, index, seekRatio);
        });
    };
    const step = (delta, el)=>{
        if (!list.length) return;
        const i = $b688934fd3fa3e2f$var$pickIndex(list.length, activeIndex, delta, shuffle);
        selectRow($b688934fd3fa3e2f$var$rootOf(el), i, {
            play: true
        });
    };
    const onTrackEnded = (root)=>{
        if (!root) return;
        const ctx = root.__mtbgCtx || {};
        const idx = typeof ctx.activeIndex === 'number' ? ctx.activeIndex : 0;
        const len = typeof ctx.listLength === 'number' ? ctx.listLength : 0;
        const mode = $b688934fd3fa3e2f$var$normalizeRepeat(ctx.repeat);
        const doShuffle = Boolean(ctx.shuffle);
        if (mode === 'one') {
            const player = $b688934fd3fa3e2f$var$activePlayer(root);
            $b688934fd3fa3e2f$var$resetPlayer(player);
            $b688934fd3fa3e2f$var$playAt(root, idx, setPaused);
            return;
        }
        // off: stop after last; all / shuffle: wrap via pickIndex
        if (mode === 'off' && !doShuffle && idx >= len - 1) {
            setPaused(true);
            return;
        }
        const i = $b688934fd3fa3e2f$var$pickIndex(len, idx, 1, doShuffle);
        selectRow(root, i, {
            play: true
        });
    };
    const bindRootCtx = (elm)=>{
        if (!elm) return;
        elm.__mtbgSetPaused = setPaused;
        elm.__mtbgOnEnded = ()=>onTrackEnded(elm);
        elm.__mtbgCtx = {
            activeIndex: activeIndex,
            listLength: list.length,
            shuffle: shuffle,
            repeat: repeatMode
        };
    };
    return (0, $2Z6Kw.section)('.widget.widget-track-list', {
        hook: {
            insert: (vnode)=>bindRootCtx(vnode.elm),
            update: (oldVnode, vnode)=>bindRootCtx(vnode.elm)
        },
        on: {
            mtbgPlayback: (ev)=>{
                if (!ev || !ev.detail) return;
                const root = $b688934fd3fa3e2f$var$rootOf(ev.currentTarget) || ev.currentTarget;
                if (ev.detail.ended) {
                    onTrackEnded(root);
                    return;
                }
                if (typeof ev.detail.paused === 'boolean') setPaused(ev.detail.paused);
            }
        }
    }, [
        (0, $2Z6Kw.header)('.widget-header.widget-track-list-header', [
            (0, $2Z6Kw.h2)('.widget-title', title),
            (0, $2Z6Kw.ul)('.widget-track-list-controls', $b688934fd3fa3e2f$var$CONTROLS.map((control)=>{
                const icon = control.action === 'play' && isPlaying ? 'pause' : control.icon;
                const isOn = control.action === 'shuffle' && shuffle || control.action === 'repeat' && repeatMode !== 'off' || control.action === 'play' && isPlaying;
                const repeatTitle = repeatMode === 'one' ? 'repeat one' : repeatMode === 'all' ? 'repeat all' : 'repeat off';
                return (0, $2Z6Kw.li)([
                    (0, $2Z6Kw.button)('.fa', {
                        class: {
                            [`fa-${icon}`]: true,
                            'is-on': isOn,
                            'is-repeat-one': control.action === 'repeat' && repeatMode === 'one'
                        },
                        attrs: {
                            type: 'button',
                            title: control.action === 'repeat' ? repeatTitle : control.action
                        },
                        on: {
                            click: (ev)=>{
                                const root = $b688934fd3fa3e2f$var$rootOf(ev.currentTarget);
                                const player = $b688934fd3fa3e2f$var$activePlayer(root);
                                if (control.action === 'shuffle') {
                                    patchPlayback({
                                        shuffle: !shuffle
                                    });
                                    return;
                                }
                                if (control.action === 'repeat') {
                                    patchPlayback({
                                        repeat: $b688934fd3fa3e2f$var$nextRepeat(repeatMode)
                                    });
                                    return;
                                }
                                if (control.action === 'play') {
                                    if (!player) {
                                        if (activeIndex >= 0) $b688934fd3fa3e2f$var$playAt(root, activeIndex, setPaused);
                                        return;
                                    }
                                    if (isPlaying || $b688934fd3fa3e2f$var$isPlayerPlaying(player)) {
                                        $b688934fd3fa3e2f$var$pausePlayer(player);
                                        setPaused(true);
                                    } else $b688934fd3fa3e2f$var$playPlayer(player, setPaused);
                                    return;
                                }
                                if (control.action === 'previous') step(-1, ev.currentTarget);
                                else if (control.action === 'next') step(1, ev.currentTarget);
                            }
                        }
                    })
                ]);
            }))
        ]),
        (0, $2Z6Kw.div)('.widget-track-list-transport.is-embed', {
            hook: {
                insert: (vnode)=>{
                    const onWsReady = ()=>$b688934fd3fa3e2f$var$syncTransport(vnode.elm);
                    vnode.elm.__mtbgOnWsReady = onWsReady;
                    vnode.elm.addEventListener('mtbgWsReady', onWsReady);
                    $b688934fd3fa3e2f$var$syncTransport(vnode.elm);
                },
                postpatch: (oldVnode, vnode)=>{
                    vnode.elm.__mtbgOnWsReady = oldVnode.elm.__mtbgOnWsReady;
                    $b688934fd3fa3e2f$var$syncTransport(vnode.elm);
                },
                destroy: (vnode)=>{
                    if (vnode.elm.__mtbgOnWsReady) {
                        vnode.elm.removeEventListener('mtbgWsReady', vnode.elm.__mtbgOnWsReady);
                        delete vnode.elm.__mtbgOnWsReady;
                    }
                    $b688934fd3fa3e2f$var$stopEmbedTransport(vnode.elm);
                }
            }
        }, [
            (0, $2Z6Kw.div)('.widget-track-list-embed-transport', [
                (0, $2Z6Kw.span)('.widget-track-list-time', '0:00 / 0:00'),
                (0, $2Z6Kw.input)('.widget-track-list-seek', {
                    attrs: {
                        type: 'range',
                        min: '0',
                        max: '1000',
                        value: '0',
                        step: '1',
                        'aria-label': 'Seek'
                    }
                }),
                (0, $2Z6Kw.div)('.widget-track-list-vol', [
                    (0, $2Z6Kw.input)('.widget-track-list-volume', {
                        attrs: {
                            type: 'range',
                            min: '0',
                            max: '100',
                            value: '100',
                            step: '1',
                            'aria-label': 'Volume'
                        }
                    }),
                    (0, $2Z6Kw.span)('.widget-track-list-vol-icon.fa.fa-volume-up')
                ])
            ])
        ]),
        (0, $2Z6Kw.ul)('.widget-body.widget-track-list-rows', list.map((track, i)=>{
            const active = i === activeIndex;
            const rowPlaying = active && isPlaying;
            const isSc = track.source === 'soundcloud' || /soundcloud\.com/.test(track.url || '');
            const isMc = track.source === 'mixcloud' || /mixcloud\.com/.test(track.url || '');
            return (0, $2Z6Kw.li)('.widget-track-list-row', {
                key: track.url || String(i),
                class: {
                    'is-active': active,
                    'is-soundcloud': isSc,
                    'is-mixcloud': isMc
                },
                on: {
                    click: (ev)=>{
                        if (ev.target.closest && ev.target.closest('.widget-track-list-play')) return;
                        if (ev.target.closest && ev.target.closest('.widget-track-list-sc-hit')) return;
                        const root = $b688934fd3fa3e2f$var$rootOf(ev.currentTarget);
                        // Row click selects + plays (global playback state)
                        if (!active) {
                            selectRow(root, i, {
                                play: true
                            });
                            return;
                        }
                        if (!isPlaying) $b688934fd3fa3e2f$var$playAt(root, i, setPaused);
                    }
                }
            }, [
                (0, $2Z6Kw.button)('.widget-track-list-play.fa', {
                    class: {
                        'fa-play': !rowPlaying,
                        'fa-pause': rowPlaying
                    },
                    attrs: {
                        type: 'button'
                    },
                    on: {
                        click: (ev)=>{
                            ev.stopPropagation();
                            const root = $b688934fd3fa3e2f$var$rootOf(ev.currentTarget);
                            if (active) {
                                const player = $b688934fd3fa3e2f$var$playerAt(root, i);
                                if (!player) {
                                    if (isPlaying) setPaused(true);
                                    else $b688934fd3fa3e2f$var$playAt(root, i, setPaused);
                                    return;
                                }
                                if (isPlaying || $b688934fd3fa3e2f$var$isPlayerPlaying(player)) {
                                    $b688934fd3fa3e2f$var$pausePlayer(player);
                                    setPaused(true);
                                } else $b688934fd3fa3e2f$var$playPlayer(player, setPaused);
                                return;
                            }
                            selectRow(root, i, {
                                play: true
                            });
                        }
                    }
                }),
                (0, $2Z6Kw.div)('.widget-track-list-wave', [
                    $b688934fd3fa3e2f$var$audioPlayer({
                        track: track,
                        height: $b688934fd3fa3e2f$var$ROW_WAVE_HEIGHT,
                        mediaControls: false,
                        interact: true
                    }),
                    // SC + Mixcloud: capture clicks above the embed for seek + play.
                    // Mixcloud iframe is pointer-events:none so links never open a new tab.
                    isSc || isMc ? (0, $2Z6Kw.div)('.widget-track-list-sc-hit', {
                        on: {
                            click: (ev)=>{
                                ev.stopPropagation();
                                const root = $b688934fd3fa3e2f$var$rootOf(ev.currentTarget);
                                const ratio = $b688934fd3fa3e2f$var$waveRatioFromEvent(ev, ev.currentTarget);
                                if (!active) {
                                    selectRow(root, i, {
                                        play: true,
                                        seekRatio: ratio
                                    });
                                    return;
                                }
                                $b688934fd3fa3e2f$var$seekAt(root, i, ratio);
                                if (!isPlaying) $b688934fd3fa3e2f$var$playAt(root, i, setPaused, ratio);
                            }
                        }
                    }) : '',
                    (0, $2Z6Kw.span)('.widget-track-list-meta', [
                        isSc ? (0, $2Z6Kw.span)('.widget-track-list-source.fa.fa-soundcloud') : '',
                        isMc ? (0, $2Z6Kw.span)('.widget-track-list-source.fa.fa-mixcloud') : '',
                        (0, $2Z6Kw.span)('.widget-track-list-title', track.title || track.url || 'track')
                    ])
                ])
            ]);
        }))
    ]);
};

});
parcelRegister("cBxnd", function(module, exports) {
'use strict';

var $2Z6Kw = parcelRequire("2Z6Kw");
var $92d2d40512eda1a9$require$div = $2Z6Kw.div;
var $92d2d40512eda1a9$require$iframe = $2Z6Kw.iframe;
var $92d2d40512eda1a9$require$canvas = $2Z6Kw.canvas;


const $92d2d40512eda1a9$var$WaveSurfer = (parcelRequire("hrfRP")).default || (parcelRequire("hrfRP"));

var $b9lWd = parcelRequire("b9lWd");
var $92d2d40512eda1a9$require$isDirectFile = $b9lWd.isDirectFile;
const $92d2d40512eda1a9$var$soundcloudEmbed = (url, { strip: strip = false } = {})=>{
    const base = `https://w.soundcloud.com/player/?url=${encodeURIComponent(url)}` + '&color=%232B95D6' + '&auto_play=false' + '&hide_related=true' + '&show_comments=false' + '&show_reposts=false' + '&visual=false' + '&show_teaser=false';
    if (strip) // Classic widget (not mini) so the waveform is expanded; chrome stripped.
    return base + '&show_artwork=false' + '&show_user=false' + '&show_playcount=false' + '&buying=false' + '&sharing=false' + '&download=false';
    return base + '&show_user=true';
};
// `*` is required: Mixcloud nests player-widget.mixcloud.com (different origin).
// Without it, parent Widget API play() stays autoplay-blocked until an iframe gesture.
const $92d2d40512eda1a9$var$MC_IFRAME_ALLOW = 'autoplay *; encrypted-media *; fullscreen *; clipboard-write *';
// Always log Mixcloud in/out triggers while we debug unlock; tighten later.
const $92d2d40512eda1a9$var$MC_DEBUG = true;
const $92d2d40512eda1a9$var$mcLog = (hostEl, msg, extra)=>{
    if (!$92d2d40512eda1a9$var$MC_DEBUG && !(hostEl && hostEl.__mcDebug)) return;
    const line = `[mtbg:mixcloud] ${msg}`;
    if (extra !== undefined) console.log(line, extra);
    else console.log(line);
};
const $92d2d40512eda1a9$var$mixcloudEmbed = (url, { strip: strip = false } = {})=>{
    const feed = encodeURIComponent(url);
    const opts = 'hide_cover=1&hide_artwork=1&light=1';
    if (strip) return `https://www.mixcloud.com/widget/iframe/?${opts}&mini=1&feed=${feed}`;
    return `https://www.mixcloud.com/widget/iframe/?${opts}&feed=${feed}`;
};
let $92d2d40512eda1a9$var$scApiPromise = null;
const $92d2d40512eda1a9$var$loadScWidgetApi = ()=>{
    if (typeof window === 'undefined') return Promise.resolve(null);
    if (window.SC && window.SC.Widget) return Promise.resolve(window.SC.Widget);
    if ($92d2d40512eda1a9$var$scApiPromise) return $92d2d40512eda1a9$var$scApiPromise;
    $92d2d40512eda1a9$var$scApiPromise = new Promise((resolve, reject)=>{
        const existing = document.querySelector('script[data-mtbg-sc-widget]');
        if (existing) {
            existing.addEventListener('load', ()=>resolve(window.SC && window.SC.Widget));
            existing.addEventListener('error', reject);
            return;
        }
        const script = document.createElement('script');
        script.src = 'https://w.soundcloud.com/player/api.js';
        script.async = true;
        script.dataset.mtbgScWidget = '1';
        script.onload = ()=>resolve(window.SC && window.SC.Widget);
        script.onerror = reject;
        document.head.appendChild(script);
    });
    return $92d2d40512eda1a9$var$scApiPromise;
};
let $92d2d40512eda1a9$var$mcApiPromise = null;
const $92d2d40512eda1a9$var$loadMcWidgetApi = ()=>{
    if (typeof window === 'undefined') return Promise.resolve(null);
    if (window.Mixcloud && window.Mixcloud.PlayerWidget) return Promise.resolve(window.Mixcloud.PlayerWidget);
    if ($92d2d40512eda1a9$var$mcApiPromise) return $92d2d40512eda1a9$var$mcApiPromise;
    $92d2d40512eda1a9$var$mcApiPromise = new Promise((resolve, reject)=>{
        const existing = document.querySelector('script[data-mtbg-mc-widget]');
        if (existing) {
            existing.addEventListener('load', ()=>resolve(window.Mixcloud && window.Mixcloud.PlayerWidget));
            existing.addEventListener('error', reject);
            return;
        }
        const script = document.createElement('script');
        script.src = 'https://widget.mixcloud.com/media/js/widgetApi.js';
        script.async = true;
        script.dataset.mtbgMcWidget = '1';
        script.onload = ()=>resolve(window.Mixcloud && window.Mixcloud.PlayerWidget);
        script.onerror = reject;
        document.head.appendChild(script);
    });
    return $92d2d40512eda1a9$var$mcApiPromise;
};
const $92d2d40512eda1a9$var$bindScWidget = (iframeEl, hostEl)=>{
    if (!iframeEl || !hostEl) return;
    $92d2d40512eda1a9$var$loadScWidgetApi().then((Widget)=>{
        if (!Widget || !iframeEl.isConnected) return;
        const widget = Widget(iframeEl);
        hostEl.__sc = widget;
        hostEl.__scReady = false;
        const emit = (paused, extra = {})=>{
            hostEl.dispatchEvent(new CustomEvent('mtbgPlayback', {
                bubbles: true,
                detail: Object.assign({
                    paused: paused
                }, extra)
            }));
        };
        widget.bind(Widget.Events.READY, ()=>{
            hostEl.__scReady = true;
        });
        widget.bind(Widget.Events.PLAY, ()=>emit(false));
        widget.bind(Widget.Events.PAUSE, ()=>emit(true));
        widget.bind(Widget.Events.FINISH, ()=>emit(true, {
                ended: true
            }));
    }).catch(()=>{});
};
const $92d2d40512eda1a9$var$bindMcWidget = (iframeEl, hostEl)=>{
    if (!iframeEl || !hostEl || hostEl.__mcBound) return;
    hostEl.__mcBound = true;
    hostEl.__mcDebug = $92d2d40512eda1a9$var$MC_DEBUG;
    let attachGen = 0;
    const setArmed = (armed)=>{
        const next = Boolean(armed);
        if (hostEl.__mcUnlocked === next) return;
        hostEl.__mcUnlocked = next;
        hostEl.classList.toggle('is-mc-unlocked', next);
        $92d2d40512eda1a9$var$mcLog(hostEl, next ? 'armed' : 'disarmed');
    };
    const attach = ()=>{
        const gen = ++attachGen;
        $92d2d40512eda1a9$var$mcLog(hostEl, "iframe load \u2192 attach PlayerWidget", {
            gen: gen
        });
        $92d2d40512eda1a9$var$loadMcWidgetApi().then((PlayerWidget)=>{
            if (!PlayerWidget || !iframeEl.isConnected || gen !== attachGen) return;
            const widget = PlayerWidget(iframeEl);
            hostEl.__mc = widget;
            hostEl.__mcReady = false;
            const emit = (paused, extra = {})=>{
                $92d2d40512eda1a9$var$mcLog(hostEl, paused ? "event \u2192 pause" : "event \u2192 play", extra);
                hostEl.dispatchEvent(new CustomEvent('mtbgPlayback', {
                    bubbles: true,
                    detail: Object.assign({
                        paused: paused
                    }, extra)
                }));
            };
            const setProgress = (position, duration)=>{
                if (!duration) return;
                hostEl.__mcProgress = Math.max(0, Math.min(1, position / duration));
                if (typeof hostEl.__mcPaintWave === 'function') hostEl.__mcPaintWave();
            };
            const onReady = (api)=>{
                if (gen !== attachGen) return;
                hostEl.__mc = api || widget;
                hostEl.__mcReady = true;
                $92d2d40512eda1a9$var$mcLog(hostEl, 'READY', {
                    methods: Object.keys(hostEl.__mc).filter((k)=>typeof hostEl.__mc[k] === 'function')
                });
                const mc = hostEl.__mc;
                if (mc.events) {
                    if (mc.events.play) mc.events.play.on(()=>{
                        setArmed(true);
                        emit(false);
                    });
                    if (mc.events.pause) mc.events.pause.on(()=>emit(true));
                    if (mc.events.ended) mc.events.ended.on(()=>{
                        hostEl.__mcProgress = 0;
                        if (typeof hostEl.__mcPaintWave === 'function') hostEl.__mcPaintWave();
                        emit(true, {
                            ended: true
                        });
                    });
                    if (mc.events.progress) mc.events.progress.on((position, duration)=>{
                        setProgress(position, duration);
                    });
                }
                // Arm immediately: with allow="autoplay *" parent play/seek work without
                // an iframe gesture. Keep the wave capturing clicks so Mixcloud links
                // underneath never open a new tab.
                setArmed(true);
                if (typeof mc.getDuration === 'function') mc.getDuration().then((d)=>$92d2d40512eda1a9$var$mcLog(hostEl, 'armed duration', d)).catch(()=>{});
                if (hostEl.__mcPendingPlay && typeof mc.play === 'function') {
                    hostEl.__mcPendingPlay = false;
                    $92d2d40512eda1a9$var$mcLog(hostEl, 'flush pending play()');
                    mc.play().then(()=>$92d2d40512eda1a9$var$mcLog(hostEl, 'pending play() resolved')).catch((err)=>{
                        hostEl.__mcPendingPlay = true;
                        $92d2d40512eda1a9$var$mcLog(hostEl, 'pending play() failed', String(err));
                    });
                }
            };
            if (widget.ready && typeof widget.ready.then === 'function') widget.ready.then(onReady).catch((err)=>$92d2d40512eda1a9$var$mcLog(hostEl, 'ready failed', String(err)));
            else onReady(widget);
        }).catch((err)=>$92d2d40512eda1a9$var$mcLog(hostEl, 'Widget API load failed', String(err)));
    };
    iframeEl.addEventListener('load', attach);
};
const $92d2d40512eda1a9$var$hashSeed = (str = '')=>{
    let h = 2166136261;
    for(let i = 0; i < str.length; i++){
        h ^= str.charCodeAt(i);
        h = Math.imul(h, 16777619);
    }
    return h >>> 0;
};
/** Decorative bars — Mixcloud has no public peaks; real unlock is iframe gesture. */ const $92d2d40512eda1a9$var$paintMixcloudWave = (canvas, seedStr, progress = 0)=>{
    if (!canvas || !canvas.getContext) return;
    const dpr = typeof window !== 'undefined' && window.devicePixelRatio || 1;
    const cssW = Math.max(1, canvas.clientWidth || canvas.parentElement && canvas.parentElement.clientWidth || 300);
    const cssH = Math.max(1, canvas.clientHeight || 63);
    canvas.width = Math.floor(cssW * dpr);
    canvas.height = Math.floor(cssH * dpr);
    const ctx = canvas.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.fillStyle = '#f6f6f6';
    ctx.fillRect(0, 0, cssW, cssH);
    const barW = 2;
    const gap = 1;
    const step = barW + gap;
    const split = Math.max(0, Math.min(1, progress)) * cssW;
    let seed = $92d2d40512eda1a9$var$hashSeed(seedStr);
    const rand = ()=>{
        seed = Math.imul(seed, 1664525) + 1013904223 >>> 0;
        return seed / 4294967296;
    };
    for(let x = 0; x < cssW; x += step){
        const amp = 0.18 + rand() * 0.72;
        const h = Math.max(2, cssH * amp * 0.85);
        const y = (cssH - h) / 2;
        ctx.fillStyle = x < split ? '#333' : '#8a8a8a';
        ctx.fillRect(x, y, barW, h);
    }
};
const $92d2d40512eda1a9$var$mountMixcloudWave = (hostEl, url)=>{
    const canvasEl = hostEl && hostEl.querySelector('.mixcloud-wave-canvas');
    if (!canvasEl) return;
    const paint = ()=>$92d2d40512eda1a9$var$paintMixcloudWave(canvasEl, url, hostEl.__mcProgress || 0);
    hostEl.__mcPaintWave = paint;
    paint();
    if (typeof ResizeObserver === 'undefined') return;
    if (hostEl.__mcWaveRo) hostEl.__mcWaveRo.disconnect();
    hostEl.__mcWaveRo = new ResizeObserver(()=>paint());
    hostEl.__mcWaveRo.observe(hostEl);
};
module.exports = ({ track: track = {}, height: height = 72, mediaControls: mediaControls = true, interact: interact = true })=>{
    const url = track.url || '';
    const source = track.source || '';
    const strip = height < 48 || mediaControls === false;
    const isSoundcloud = source === 'soundcloud' || /soundcloud\.com/.test(url);
    const isMixcloud = source === 'mixcloud' || /mixcloud\.com/.test(url);
    if (isSoundcloud && strip) return $92d2d40512eda1a9$require$div('.media-player.audio.soundcloud.soundcloud-strip', {
        key: `sc-strip:${url}`,
        hook: {
            insert: (vnode)=>{
                const frame = vnode.elm.querySelector('iframe');
                $92d2d40512eda1a9$var$bindScWidget(frame, vnode.elm);
            },
            update: (oldVnode, vnode)=>{
                vnode.elm.__sc = oldVnode.elm.__sc;
                vnode.elm.__scReady = oldVnode.elm.__scReady;
            },
            destroy: (vnode)=>{
                delete vnode.elm.__sc;
                delete vnode.elm.__scReady;
            }
        }
    }, [
        $92d2d40512eda1a9$require$iframe({
            attrs: {
                src: $92d2d40512eda1a9$var$soundcloudEmbed(url, {
                    strip: true
                }),
                width: '100%',
                // Full classic height — CSS clips to the waveform band at row height
                height: '166',
                frameborder: 'no',
                scrolling: 'no',
                allow: 'autoplay'
            }
        })
    ]);
    if (!strip && isSoundcloud) return $92d2d40512eda1a9$require$div('.media-player.audio.soundcloud', {
        key: url
    }, [
        $92d2d40512eda1a9$require$iframe({
            attrs: {
                src: $92d2d40512eda1a9$var$soundcloudEmbed(url),
                frameborder: 'no',
                scrolling: 'no',
                allow: 'autoplay'
            }
        })
    ]);
    if (isMixcloud && strip) // Wave overlay always captures clicks (iframe is pointer-events:none).
    // Tracks arm on Widget ready so seek/play go through our API, not Mixcloud links.
    return $92d2d40512eda1a9$require$div('.media-player.audio.mixcloud.mixcloud-strip.is-mc-unlocked', {
        key: `mc-strip:${url}`,
        hook: {
            insert: (vnode)=>{
                vnode.elm.__mcUnlocked = true;
                $92d2d40512eda1a9$var$mountMixcloudWave(vnode.elm, url);
                const frame = vnode.elm.querySelector('iframe');
                $92d2d40512eda1a9$var$bindMcWidget(frame, vnode.elm);
                $92d2d40512eda1a9$var$mcLog(vnode.elm, 'strip mounted (pre-armed)', {
                    url: url
                });
            },
            update: (oldVnode, vnode)=>{
                vnode.elm.__mc = oldVnode.elm.__mc;
                vnode.elm.__mcReady = oldVnode.elm.__mcReady;
                vnode.elm.__mcPendingPlay = oldVnode.elm.__mcPendingPlay;
                vnode.elm.__mcProgress = oldVnode.elm.__mcProgress;
                vnode.elm.__mcWaveRo = oldVnode.elm.__mcWaveRo;
                vnode.elm.__mcPaintWave = oldVnode.elm.__mcPaintWave;
                vnode.elm.__mcBound = oldVnode.elm.__mcBound;
                vnode.elm.__mcUnlocked = oldVnode.elm.__mcUnlocked;
                vnode.elm.__mcDebug = oldVnode.elm.__mcDebug;
                vnode.elm.classList.toggle('is-mc-unlocked', Boolean(oldVnode.elm.__mcUnlocked));
                $92d2d40512eda1a9$var$mountMixcloudWave(vnode.elm, url);
            },
            destroy: (vnode)=>{
                if (vnode.elm.__mcWaveRo) {
                    vnode.elm.__mcWaveRo.disconnect();
                    delete vnode.elm.__mcWaveRo;
                }
                delete vnode.elm.__mc;
                delete vnode.elm.__mcReady;
                delete vnode.elm.__mcPendingPlay;
                delete vnode.elm.__mcProgress;
                delete vnode.elm.__mcPaintWave;
                delete vnode.elm.__mcBound;
                delete vnode.elm.__mcUnlocked;
                delete vnode.elm.__mcDebug;
            }
        }
    }, [
        $92d2d40512eda1a9$require$div('.mixcloud-wave', [
            $92d2d40512eda1a9$require$canvas('.mixcloud-wave-canvas', {
                attrs: {
                    width: '300',
                    height: '63'
                }
            })
        ]),
        $92d2d40512eda1a9$require$iframe({
            attrs: {
                src: $92d2d40512eda1a9$var$mixcloudEmbed(url, {
                    strip: true
                }),
                width: '100%',
                height: '60',
                frameborder: '0',
                scrolling: 'no',
                allow: $92d2d40512eda1a9$var$MC_IFRAME_ALLOW
            }
        })
    ]);
    if (!strip && isMixcloud) return $92d2d40512eda1a9$require$div('.media-player.audio.mixcloud', {
        key: url,
        hook: {
            insert: (vnode)=>{
                const frame = vnode.elm.querySelector('iframe');
                $92d2d40512eda1a9$var$bindMcWidget(frame, vnode.elm);
            },
            update: (oldVnode, vnode)=>{
                vnode.elm.__mc = oldVnode.elm.__mc;
                vnode.elm.__mcReady = oldVnode.elm.__mcReady;
                vnode.elm.__mcPendingPlay = oldVnode.elm.__mcPendingPlay;
                vnode.elm.__mcBound = oldVnode.elm.__mcBound;
            },
            destroy: (vnode)=>{
                delete vnode.elm.__mc;
                delete vnode.elm.__mcReady;
                delete vnode.elm.__mcPendingPlay;
                delete vnode.elm.__mcBound;
            }
        }
    }, [
        $92d2d40512eda1a9$require$iframe({
            attrs: {
                src: $92d2d40512eda1a9$var$mixcloudEmbed(url),
                width: '100%',
                height: '120',
                frameborder: '0',
                scrolling: 'no',
                allow: $92d2d40512eda1a9$var$MC_IFRAME_ALLOW
            }
        })
    ]);
    if (source === 'upload' || $92d2d40512eda1a9$require$isDirectFile(url)) return $92d2d40512eda1a9$require$div('.media-player.audio.wavesurfer', {
        // stable key — do not remount on selection changes
        key: `${url}:${height}`,
        hook: {
            insert: (vnode)=>{
                // Skip re-init if snabbdom reused the elm (shouldn't destroy, but be safe)
                if (vnode.elm.__ws) return;
                const ws = $92d2d40512eda1a9$var$WaveSurfer.create({
                    container: vnode.elm,
                    url: url,
                    height: height,
                    waveColor: '#8a8a8a',
                    progressColor: '#333',
                    cursorColor: 'transparent',
                    cursorWidth: 0,
                    barWidth: 2,
                    barGap: 1,
                    normalize: true,
                    mediaControls: false,
                    interact: interact
                });
                vnode.elm.__ws = ws;
                ws.on('ready', ()=>{
                    const row = vnode.elm.closest('.widget-track-list-row');
                    const root = vnode.elm.closest('.widget-track-list');
                    if (!row || !root) return;
                    const active = row.classList.contains('is-active');
                    if (active && typeof ws.setOptions === 'function') ws.setOptions({
                        cursorWidth: 1,
                        cursorColor: '#111'
                    });
                    const media = ws.getMediaElement && ws.getMediaElement();
                    if (media) media.controls = false;
                    const slot = root.querySelector('.widget-track-list-transport');
                    if (slot) {
                        slot.__mtbgEmbedKey = null;
                        slot.dispatchEvent(new CustomEvent('mtbgWsReady'));
                    }
                });
            },
            update: (oldVnode, vnode)=>{
                vnode.elm.__ws = oldVnode.elm.__ws;
            },
            destroy: (vnode)=>{
                if (vnode.elm && vnode.elm.__ws) {
                    vnode.elm.__ws.destroy();
                    delete vnode.elm.__ws;
                }
            }
        }
    });
    if (strip) return $92d2d40512eda1a9$require$div('.media-player.audio.wavesurfer');
    return $92d2d40512eda1a9$require$div('.media-player.audio.external', [
        $92d2d40512eda1a9$require$iframe({
            attrs: {
                src: url,
                frameborder: '0'
            }
        })
    ]);
};

});

parcelRegister("dgw34", function(module, exports) {

$parcel$export(module.exports, "resolveContent", () => $9a85a128b5c57a83$export$1a8c564cdcafcb4a);
$parcel$export(module.exports, "default", () => $9a85a128b5c57a83$export$2e2bcd8739ae039);

var $2Z6Kw = parcelRequire("2Z6Kw");

var $jjnZg = parcelRequire("jjnZg");
const $9a85a128b5c57a83$var$TAGS = {
    h1: $2Z6Kw.h1,
    h2: $2Z6Kw.h2,
    h3: $2Z6Kw.h3,
    h4: $2Z6Kw.h4,
    p: $2Z6Kw.p,
    div: $2Z6Kw.div,
    article: $2Z6Kw.article,
    section: $2Z6Kw.section,
    span: $2Z6Kw.span
};
const $9a85a128b5c57a83$export$1a8c564cdcafcb4a = (spec, i18n)=>{
    if (spec == null) return '';
    if (typeof spec !== 'string') return String(spec);
    if (spec.indexOf('i18n.') === 0) {
        const path = spec.slice(5).split('.').filter(Boolean);
        const value = (0, $jjnZg.obj).sub(i18n, path);
        return value == null ? '' : value;
    }
    return spec;
};
const $9a85a128b5c57a83$var$toParagraphs = (text)=>String(text || '').split(/\n\s*\n/).map((chunk)=>chunk.replace(/\n/g, ' ').trim()).filter(Boolean).map((chunk)=>(0, $2Z6Kw.p)(chunk));
var /**
 * Static layout widget: `content` is an i18n path or literal.
 * Body copy (article / multi-line) becomes a div of `<p>`s for `.content` CSS.
 */ $9a85a128b5c57a83$export$2e2bcd8739ae039 = ({ node: node, i18n: i18n })=>{
    const text = $9a85a128b5c57a83$export$1a8c564cdcafcb4a(node && node.content, i18n);
    const tagName = (node && node.tag || 'div').toLowerCase();
    const tag = $9a85a128b5c57a83$var$TAGS[tagName] || (0, $2Z6Kw.div);
    const bodyTags = tagName === 'article' || tagName === 'div';
    if (bodyTags) {
        const paras = $9a85a128b5c57a83$var$toParagraphs(text);
        return (0, $2Z6Kw.div)(paras.length ? paras : []);
    }
    return tag(text);
};

});


parcelRegister("6QkUD", function(module, exports) {
'use strict';

var $2Z6Kw = parcelRequire("2Z6Kw");
var $4fb7d22f69d93ce0$require$section = $2Z6Kw.section;
var $4fb7d22f69d93ce0$require$h2 = $2Z6Kw.h2;
var $4fb7d22f69d93ce0$require$a = $2Z6Kw.a;
var $4fb7d22f69d93ce0$require$div = $2Z6Kw.div;
var $4fb7d22f69d93ce0$require$iframe = $2Z6Kw.iframe;
var $4fb7d22f69d93ce0$require$img = $2Z6Kw.img;

var $lKDLg = parcelRequire("lKDLg");

var $amJim = parcelRequire("amJim");

var $3QJuk = parcelRequire("3QJuk");
const { resolveLocalized: $4fb7d22f69d93ce0$var$resolveLocalized, DEFAULT_LOCALE: $4fb7d22f69d93ce0$var$DEFAULT_LOCALE } = $3QJuk.default || $3QJuk;
const $4fb7d22f69d93ce0$var$t = (i18n, key, fallback)=>i18n && i18n.widget && i18n.widget.addressMap && i18n.widget.addressMap[key] || fallback;
const $4fb7d22f69d93ce0$var$actionLabel = (i18n, key, fallback)=>i18n && i18n.common && i18n.common.actions && i18n.common.actions[key] || fallback;
const $4fb7d22f69d93ce0$var$hasGeo = (address)=>{
    const geo = address && address.geo;
    if (!geo || geo.lat == null || geo.lng == null) return false;
    const lat = Number(geo.lat);
    const lng = Number(geo.lng);
    if (Number.isNaN(lat) || Number.isNaN(lng)) return false;
    // (0, 0) is an empty sentinel from forms / unset venue overrides
    if (lat === 0 && lng === 0) return false;
    return true;
};
const $4fb7d22f69d93ce0$var$formatAddressLine = (address)=>{
    if (!address) return '';
    const cityZip = [
        address.city,
        address.zip
    ].filter(Boolean).join(' ').trim();
    return [
        address.street,
        cityZip,
        address.country
    ].filter(Boolean).join(', ');
};
const $4fb7d22f69d93ce0$var$addressHasContent = (address)=>{
    if (!address) return false;
    return Boolean(address.street || address.city || address.zip || address.country || address.geo && (address.geo.lat != null || address.geo.lng != null));
};
const $4fb7d22f69d93ce0$var$osmEmbedSrc = (lat, lng, delta = 0.004)=>{
    const la = Number(lat);
    const lo = Number(lng);
    const bbox = [
        lo - delta,
        la - delta,
        lo + delta,
        la + delta
    ].join('%2C');
    return `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${encodeURIComponent(la)}%2C${encodeURIComponent(lo)}`;
};
const $4fb7d22f69d93ce0$var$osmLink = (lat, lng)=>`https://www.openstreetmap.org/?mlat=${encodeURIComponent(lat)}&mlon=${encodeURIComponent(lng)}#map=17/${encodeURIComponent(lat)}/${encodeURIComponent(lng)}`;
const $4fb7d22f69d93ce0$var$osmSearchLink = (addressLine)=>`https://www.openstreetmap.org/search?query=${encodeURIComponent(addressLine)}`;
const $4fb7d22f69d93ce0$var$titleText = (title, i18n, lang)=>{
    const resolved = $4fb7d22f69d93ce0$var$resolveLocalized(title, lang || $4fb7d22f69d93ce0$var$DEFAULT_LOCALE);
    return resolved || $4fb7d22f69d93ce0$var$t(i18n, 'title', 'Address');
};
const $4fb7d22f69d93ce0$var$isExternalUrl = (url)=>/^https?:\/\//i.test(String(url || ''));
const $4fb7d22f69d93ce0$var$linkAttrs = (url)=>{
    const attrs = {
        href: url
    };
    if ($4fb7d22f69d93ce0$var$isExternalUrl(url)) {
        attrs.target = '_blank';
        attrs.rel = 'noopener';
    }
    return attrs;
};
const $4fb7d22f69d93ce0$var$avatarEl = (avatar)=>$4fb7d22f69d93ce0$require$img('.widget-address-map-avatar', {
        attrs: {
            src: avatar,
            alt: ''
        }
    });
const $4fb7d22f69d93ce0$var$headingEl = ({ title: title, url: url, i18n: i18n, lang: lang })=>{
    const label = $4fb7d22f69d93ce0$var$titleText(title, i18n, lang);
    return url ? $4fb7d22f69d93ce0$require$a('.widget-address-map-title', {
        attrs: $4fb7d22f69d93ce0$var$linkAttrs(url)
    }, label) : $4fb7d22f69d93ce0$require$h2('.widget-address-map-title', label);
};
/**
 * Lightweight venue address + OSM embed (no JS map library).
 * Optional `avatar`, `url`, and `description` enrich the header (e.g. linked venue profile).
 * Renders only when address has content.
 */ const $4fb7d22f69d93ce0$var$addressMap = ({ address: address, title: title, i18n: i18n, avatar: avatar, url: url, description: description, lang: lang })=>{
    if (!$4fb7d22f69d93ce0$var$addressHasContent(address)) return '';
    const locale = lang || $4fb7d22f69d93ce0$var$DEFAULT_LOCALE;
    const line = $4fb7d22f69d93ce0$var$formatAddressLine(address);
    const geoOk = $4fb7d22f69d93ce0$var$hasGeo(address);
    const lat = geoOk ? address.geo.lat : null;
    const lng = geoOk ? address.geo.lng : null;
    const mapHref = geoOk ? $4fb7d22f69d93ce0$var$osmLink(lat, lng) : line ? $4fb7d22f69d93ce0$var$osmSearchLink(line) : null;
    const enriched = Boolean(avatar || url || description);
    const heading = $4fb7d22f69d93ce0$var$titleText(title, i18n, locale);
    const header = enriched ? [
        $4fb7d22f69d93ce0$require$div('.widget-address-map-header', [
            avatar ? url ? $4fb7d22f69d93ce0$require$a('.widget-address-map-avatar-link', {
                attrs: Object.assign($4fb7d22f69d93ce0$var$linkAttrs(url), {
                    title: heading
                })
            }, [
                $4fb7d22f69d93ce0$var$avatarEl(avatar)
            ]) : $4fb7d22f69d93ce0$var$avatarEl(avatar) : '',
            $4fb7d22f69d93ce0$require$div('.widget-address-map-heading', [
                $4fb7d22f69d93ce0$var$headingEl({
                    title: title,
                    url: url,
                    i18n: i18n,
                    lang: locale
                })
            ])
        ]),
        description ? $4fb7d22f69d93ce0$require$div('.widget-address-map-desc', {
            props: {
                innerHTML: $amJim.toDisplayHTML(description)
            }
        }) : ''
    ] : $4fb7d22f69d93ce0$require$h2(heading);
    return $4fb7d22f69d93ce0$require$section('.widget-address-map', [
        ...Array.isArray(header) ? header : [
            header
        ],
        line ? $lKDLg({
            text: line,
            title: $4fb7d22f69d93ce0$var$actionLabel(i18n, 'copy', 'Copy'),
            copiedLabel: $4fb7d22f69d93ce0$var$actionLabel(i18n, 'copied', 'Copied')
        }) : '',
        geoOk ? $4fb7d22f69d93ce0$require$div('.widget-address-map-frame', [
            $4fb7d22f69d93ce0$require$iframe({
                attrs: {
                    src: $4fb7d22f69d93ce0$var$osmEmbedSrc(lat, lng),
                    title: $4fb7d22f69d93ce0$var$t(i18n, 'mapTitle', 'Map'),
                    loading: 'lazy',
                    referrerpolicy: 'no-referrer-when-downgrade'
                }
            })
        ]) : '',
        mapHref ? $4fb7d22f69d93ce0$require$a('.widget-address-map-open[target="_blank"][rel="noopener"]', {
            attrs: {
                href: mapHref
            }
        }, $4fb7d22f69d93ce0$var$t(i18n, 'openOsm', 'Open in OpenStreetMap')) : ''
    ]);
};
module.exports = $4fb7d22f69d93ce0$var$addressMap;
module.exports.addressHasContent = $4fb7d22f69d93ce0$var$addressHasContent;
module.exports.formatAddressLine = $4fb7d22f69d93ce0$var$formatAddressLine;
module.exports.hasGeo = $4fb7d22f69d93ce0$var$hasGeo;

});
parcelRegister("lKDLg", function(module, exports) {
'use strict';

var $2Z6Kw = parcelRequire("2Z6Kw");
var $fd5cbc9a4afaec8c$require$button = $2Z6Kw.button;
var $fd5cbc9a4afaec8c$require$i = $2Z6Kw.i;
const $fd5cbc9a4afaec8c$var$fallbackCopy = (text)=>{
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.left = '-9999px';
    document.body.appendChild(ta);
    ta.select();
    let ok = false;
    try {
        ok = document.execCommand('copy');
    } catch (err) {
        ok = false;
    }
    document.body.removeChild(ta);
    return ok;
};
const $fd5cbc9a4afaec8c$var$flashCopied = (el, label)=>{
    if (!el) return;
    el.classList.add('is-copied');
    el.setAttribute('data-copied', label || 'Copied');
    clearTimeout(el._copyableTimer);
    el._copyableTimer = setTimeout(()=>{
        el.classList.remove('is-copied');
        el.removeAttribute('data-copied');
    }, 1400);
};
/**
 * Click-to-copy text control.
 * Markup: button > text + optional icon. Feedback via [data-copied]::after.
 */ module.exports = ({ text: text, sel: sel = '', title: title = 'Copy', copiedLabel: copiedLabel = 'Copied', icon: icon = true })=>{
    const value = text == null ? '' : String(text);
    if (!value) return '';
    return $fd5cbc9a4afaec8c$require$button(`.comp-copyable${sel}`, {
        attrs: {
            type: 'button',
            title: title,
            'aria-label': title
        },
        on: {
            click: (ev)=>{
                ev.preventDefault();
                const el = ev.currentTarget;
                const done = ()=>$fd5cbc9a4afaec8c$var$flashCopied(el, copiedLabel);
                if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
                    navigator.clipboard.writeText(value).then(done).catch(()=>{
                        if ($fd5cbc9a4afaec8c$var$fallbackCopy(value)) done();
                    });
                    return;
                }
                if ($fd5cbc9a4afaec8c$var$fallbackCopy(value)) done();
            }
        }
    }, [].concat(value, icon ? $fd5cbc9a4afaec8c$require$i('.fa.fa-clipboard') : []));
};

});



parcelRegister("aAvSU", function(module, exports) {
'use strict';

var $2Z6Kw = parcelRequire("2Z6Kw");
var $7b55ffcec06c8710$require$h1 = $2Z6Kw.h1;
var $7b55ffcec06c8710$require$a = $2Z6Kw.a;
var $7b55ffcec06c8710$require$div = $2Z6Kw.div;
var $7b55ffcec06c8710$require$header = $2Z6Kw.header;
var $7b55ffcec06c8710$require$p = $2Z6Kw.p;
var $7b55ffcec06c8710$require$section = $2Z6Kw.section;
var $7b55ffcec06c8710$require$button = $2Z6Kw.button;
var $7b55ffcec06c8710$require$span = $2Z6Kw.span;
module.exports = ({ state: state, actions: actions })=>$7b55ffcec06c8710$require$section('.home', $7b55ffcec06c8710$require$p('Links'));

});

parcelRegister("2yONn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1dd628aa7f177df4$export$2e2bcd8739ae039);

var $2Z6Kw = parcelRequire("2Z6Kw");

var $jjnZg = parcelRequire("jjnZg");

var $1zDll = parcelRequire("1zDll");
parcelRequire("12DVH");

var $4rZD9 = parcelRequire("4rZD9");

var $1i1BJ = parcelRequire("1i1BJ");

var $3QJuk = parcelRequire("3QJuk");

var $4hyaE = parcelRequire("4hyaE");
(0, (/*@__PURE__*/$parcel$interopDefault($1zDll))).extend((0, (/*@__PURE__*/$parcel$interopDefault($4rZD9))));
const $1dd628aa7f177df4$var$pageCopy = (i18n, key, fallback)=>{
    const root = i18n && i18n.pages && i18n.pages.contact;
    if (!root || root[key] == null || root[key] === '') return fallback;
    return root[key];
};
const $1dd628aa7f177df4$var$isUpcoming = (event)=>{
    const end = event && event.endDateTime || event && event.startDateTime;
    return new Date(end || 0).getTime() >= Date.now();
};
const $1dd628aa7f177df4$var$isPublished = (event)=>!event.status || event.status === 'published';
const $1dd628aa7f177df4$var$eventLabel = (event, lang)=>{
    const title = (0, $3QJuk.resolveLocalized)(event && event.title, lang) || $1dd628aa7f177df4$var$pageCopy({
        pages: {
            contact: {}
        }
    }, 'untitled', 'Event');
    const tz = event && event.timezone || (0, (/*@__PURE__*/$parcel$interopDefault($4hyaE))).DEFAULT_TZ;
    const start = (0, (/*@__PURE__*/$parcel$interopDefault($4hyaE))).parse(event && event.startDateTime, tz);
    const when = start && start.isValid() ? start.locale(lang === 'en' ? 'en' : 'bg').format('ll HH:mm') : '';
    return when ? `${title} \u{2014} ${when}` : title;
};
const $1dd628aa7f177df4$var$upcomingFrom = (list)=>(list || []).filter((ev)=>ev && $1dd628aa7f177df4$var$isPublished(ev) && $1dd628aa7f177df4$var$isUpcoming(ev)).slice().sort((a, b)=>new Date(a.startDateTime || 0) - new Date(b.startDateTime || 0));
/** Deep-link prefill: /contact?reason=event&event=<slug-or-id> */ const $1dd628aa7f177df4$var$contactQuery = ()=>{
    if (typeof location === 'undefined' || !location.search) return {
        reason: '',
        event: ''
    };
    const qs = new URLSearchParams(location.search);
    return {
        reason: String(qs.get('reason') || '').trim(),
        event: String(qs.get('event') || '').trim()
    };
};
const $1dd628aa7f177df4$var$matchUpcoming = (upcoming, key)=>{
    const k = String(key || '').trim();
    if (!k) return null;
    return (upcoming || []).find((ev)=>String(ev._id) === k || String(ev.slug || '') === k) || null;
};
var $1dd628aa7f177df4$export$2e2bcd8739ae039 = ({ state: state, actions: actions, i18n: i18n })=>(0, $jjnZg.fn).pipe(()=>{
        const q = $1dd628aa7f177df4$var$contactQuery();
        const upcoming = $1dd628aa7f177df4$var$upcomingFrom(state.events && state.events.list || []);
        const contact = state.contact || {};
        const eventKey = contact.event || q.event || '';
        const matched = $1dd628aa7f177df4$var$matchUpcoming(upcoming, eventKey);
        const reason = contact.reason || (q.reason === 'event' || q.reason === 'general' ? q.reason : '') || (q.event ? 'event' : '') || 'general';
        return {
            lang: state.lang || (0, $3QJuk.DEFAULT_LOCALE),
            reason: reason,
            eventKey: eventKey,
            selectedEventId: matched ? String(matched._id) : '',
            sent: !!contact.sent,
            error: contact.error || '',
            sending: !!contact.sending,
            upcoming: // events list is loaded by resource.hook for /contact (publicPathForNs)
            upcoming
        };
    }, ({ lang: lang, reason: reason, eventKey: eventKey, selectedEventId: selectedEventId, sent: sent, error: error, sending: sending, upcoming: upcoming })=>(0, $2Z6Kw.section)('.contact', [
            (0, $2Z6Kw.h2)($1dd628aa7f177df4$var$pageCopy(i18n, 'title', 'Contact')),
            (0, $2Z6Kw.div)([].concat($1dd628aa7f177df4$var$pageCopy(i18n, 'intro', '') ? (0, $2Z6Kw.p)('.contact-intro', $1dd628aa7f177df4$var$pageCopy(i18n, 'intro', '')) : [], sent ? (0, $2Z6Kw.p)('.contact-thanks', $1dd628aa7f177df4$var$pageCopy(i18n, 'thanks', "Thanks \u2014 we will get back to you.")) : (0, $2Z6Kw.form)('.edit.contact-form', {
                on: {
                    submit: (ev)=>{
                        ev.preventDefault();
                        if (sending) return;
                        // FormData — reliable with snabbdom; formUtil/toData can miss
                        // live DOM values when inputs were patched via props.value.
                        const formEl = ev.currentTarget || ev.target;
                        const fd = new FormData(formEl);
                        const data = {
                            name: String(fd.get('name') || '').trim(),
                            email: String(fd.get('email') || '').trim(),
                            reason: String(fd.get('reason') || 'general'),
                            event: String(fd.get('event') || ''),
                            message: String(fd.get('message') || '').trim()
                        };
                        actions.set([
                            'contact',
                            'sending'
                        ], true);
                        actions.set([
                            'contact',
                            'error'
                        ], '');
                        (0, (/*@__PURE__*/$parcel$interopDefault($1i1BJ))).post('/api/contact').send(data).then(()=>{
                            actions.set([
                                'contact'
                            ], {
                                reason: 'general',
                                sent: true,
                                sending: false,
                                error: ''
                            });
                        }).catch((err)=>{
                            const msg = err && err.response && err.response.body && err.response.body.err || $1dd628aa7f177df4$var$pageCopy(i18n, 'error', 'Could not send. Please try again.');
                            actions.set([
                                'contact',
                                'sending'
                            ], false);
                            actions.set([
                                'contact',
                                'error'
                            ], msg);
                        });
                    }
                }
            }, [].concat((0, $2Z6Kw.div)('.field', [
                (0, $2Z6Kw.label)([
                    $1dd628aa7f177df4$var$pageCopy(i18n, 'name', 'Name'),
                    ': '
                ]),
                // Put `required` in attrs — boolean `[required]` in the selector is not
                // parsed by iblokz-snabbdom-helpers and breaks h() arg order (name never set).
                (0, $2Z6Kw.input)({
                    attrs: {
                        type: 'text',
                        name: 'name',
                        required: 'required',
                        autocomplete: 'name'
                    }
                })
            ]), (0, $2Z6Kw.div)('.field', [
                (0, $2Z6Kw.label)([
                    $1dd628aa7f177df4$var$pageCopy(i18n, 'email', 'Email'),
                    ': '
                ]),
                (0, $2Z6Kw.input)({
                    attrs: {
                        type: 'email',
                        name: 'email',
                        required: 'required',
                        autocomplete: 'email'
                    }
                })
            ]), (0, $2Z6Kw.div)('.field', [
                (0, $2Z6Kw.label)([
                    $1dd628aa7f177df4$var$pageCopy(i18n, 'reason', 'Reason'),
                    ': '
                ]),
                (0, $2Z6Kw.select)({
                    attrs: {
                        name: 'reason'
                    },
                    on: {
                        change: (ev)=>actions.set([
                                'contact',
                                'reason'
                            ], ev.target.value)
                    }
                }, [
                    (0, $2Z6Kw.option)({
                        attrs: {
                            value: 'general',
                            selected: reason === 'general'
                        }
                    }, $1dd628aa7f177df4$var$pageCopy(i18n, 'reasonGeneral', 'General')),
                    (0, $2Z6Kw.option)({
                        attrs: {
                            value: 'event',
                            selected: reason === 'event'
                        }
                    }, $1dd628aa7f177df4$var$pageCopy(i18n, 'reasonEvent', 'Event enquiry'))
                ])
            ]), reason === 'event' ? [].concat((0, $2Z6Kw.div)('.field', [
                (0, $2Z6Kw.label)([
                    $1dd628aa7f177df4$var$pageCopy(i18n, 'event', 'Event'),
                    ': '
                ]),
                (0, $2Z6Kw.select)('.contact-event-select', {
                    key: `contact-event-${upcoming.map((e)=>e._id).join('-') || 'empty'}-${selectedEventId || eventKey || 'none'}`,
                    attrs: {
                        name: 'event',
                        required: 'required'
                    },
                    on: {
                        change: (ev)=>actions.set([
                                'contact',
                                'event'
                            ], ev.target.value)
                    }
                }, [].concat((0, $2Z6Kw.option)({
                    attrs: {
                        value: '',
                        selected: !selectedEventId
                    }
                }, upcoming.length ? $1dd628aa7f177df4$var$pageCopy(i18n, 'eventPlaceholder', "Select an upcoming event\u2026") : $1dd628aa7f177df4$var$pageCopy(i18n, 'eventEmpty', 'No upcoming events')), upcoming.map((ev)=>(0, $2Z6Kw.option)({
                        key: String(ev._id),
                        attrs: {
                            value: String(ev._id),
                            selected: selectedEventId === String(ev._id)
                        }
                    }, $1dd628aa7f177df4$var$eventLabel(ev, lang)))))
            ]), upcoming.length === 0 ? (0, $2Z6Kw.p)('.contact-hint', $1dd628aa7f177df4$var$pageCopy(i18n, 'eventEmptyHint', 'No published upcoming events right now.')) : []) : [], (0, $2Z6Kw.div)('.field', [
                (0, $2Z6Kw.label)([
                    $1dd628aa7f177df4$var$pageCopy(i18n, 'message', 'Message'),
                    ': '
                ]),
                (0, $2Z6Kw.textarea)({
                    attrs: {
                        name: 'message',
                        required: 'required',
                        rows: '6'
                    }
                })
            ]), error ? (0, $2Z6Kw.p)('.contact-error', error) : [], (0, $2Z6Kw.div)('.buttons', [
                (0, $2Z6Kw.button)('.btn.btn-primary', {
                    attrs: {
                        type: 'submit'
                    },
                    props: {
                        disabled: sending
                    }
                }, sending ? $1dd628aa7f177df4$var$pageCopy(i18n, 'sending', "Sending\u2026") : $1dd628aa7f177df4$var$pageCopy(i18n, 'send', 'Send'))
            ])))))
        ]))();

});
parcelRegister("1i1BJ", function(module, exports) {
"use strict";
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function _typeof(obj) {
        return typeof obj;
    };
    else _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
/**
 * Root reference for iframes.
 */ var root;
if (typeof window !== 'undefined') // Browser window
root = window;
else if (typeof self === 'undefined') {
    // Other environments
    console.warn('Using browser-only version of superagent in non-browser environment');
    root = void 0;
} else // Web Worker
root = self;

var $jiPGG = parcelRequire("jiPGG");

var $eY713 = parcelRequire("eY713");

var $jD27N = parcelRequire("jD27N");

var $87ccA = parcelRequire("87ccA");

var $5FA8u = parcelRequire("5FA8u");

var $5w7q4 = parcelRequire("5w7q4");

var $baedc = parcelRequire("baedc");
/**
 * Noop.
 */ function noop() {}
/**
 * Expose `request`.
 */ module.exports = function(method, url) {
    // callback
    if (typeof url === 'function') return new exports.Request('GET', method).end(url);
     // url first
    if (arguments.length === 1) return new exports.Request('GET', method);
    return new exports.Request(method, url);
};
exports = module.exports;
var request = exports;
exports.Request = Request;
/**
 * Determine XHR.
 */ request.getXHR = function() {
    if (root.XMLHttpRequest && (!root.location || root.location.protocol !== 'file:' || !root.ActiveXObject)) return new XMLHttpRequest();
    try {
        return new ActiveXObject('Microsoft.XMLHTTP');
    } catch (_unused) {}
    try {
        return new ActiveXObject('Msxml2.XMLHTTP.6.0');
    } catch (_unused2) {}
    try {
        return new ActiveXObject('Msxml2.XMLHTTP.3.0');
    } catch (_unused3) {}
    try {
        return new ActiveXObject('Msxml2.XMLHTTP');
    } catch (_unused4) {}
    throw new Error('Browser-only version of superagent could not find XHR');
};
/**
 * Removes leading and trailing whitespace, added to support IE.
 *
 * @param {String} s
 * @return {String}
 * @api private
 */ var trim = ''.trim ? function(s) {
    return s.trim();
} : function(s) {
    return s.replace(/(^\s*|\s*$)/g, '');
};
/**
 * Serialize the given `obj`.
 *
 * @param {Object} obj
 * @return {String}
 * @api private
 */ function serialize(obj) {
    if (!$5FA8u(obj)) return obj;
    var pairs = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) pushEncodedKeyValuePair(pairs, key, obj[key]);
    return pairs.join('&');
}
/**
 * Helps 'serialize' with serializing arrays.
 * Mutates the pairs array.
 *
 * @param {Array} pairs
 * @param {String} key
 * @param {Mixed} val
 */ function pushEncodedKeyValuePair(pairs, key, val) {
    if (val === undefined) return;
    if (val === null) {
        pairs.push(encodeURI(key));
        return;
    }
    if (Array.isArray(val)) val.forEach(function(v) {
        pushEncodedKeyValuePair(pairs, key, v);
    });
    else if ($5FA8u(val)) {
        for(var subkey in val)if (Object.prototype.hasOwnProperty.call(val, subkey)) pushEncodedKeyValuePair(pairs, "".concat(key, "[").concat(subkey, "]"), val[subkey]);
    } else pairs.push(encodeURI(key) + '=' + encodeURIComponent(val));
}
/**
 * Expose serialization method.
 */ request.serializeObject = serialize;
/**
 * Parse the given x-www-form-urlencoded `str`.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */ function parseString(str) {
    var obj = {};
    var pairs = str.split('&');
    var pair;
    var pos;
    for(var i = 0, len = pairs.length; i < len; ++i){
        pair = pairs[i];
        pos = pair.indexOf('=');
        if (pos === -1) obj[decodeURIComponent(pair)] = '';
        else obj[decodeURIComponent(pair.slice(0, pos))] = decodeURIComponent(pair.slice(pos + 1));
    }
    return obj;
}
/**
 * Expose parser.
 */ request.parseString = parseString;
/**
 * Default MIME type map.
 *
 *     superagent.types.xml = 'application/xml';
 *
 */ request.types = {
    html: 'text/html',
    json: 'application/json',
    xml: 'text/xml',
    urlencoded: 'application/x-www-form-urlencoded',
    form: 'application/x-www-form-urlencoded',
    'form-data': 'application/x-www-form-urlencoded'
};
/**
 * Default serialization map.
 *
 *     superagent.serialize['application/xml'] = function(obj){
 *       return 'generated xml here';
 *     };
 *
 */ request.serialize = {
    'application/x-www-form-urlencoded': $jD27N.stringify,
    'application/json': $eY713
};
/**
 * Default parsers.
 *
 *     superagent.parse['application/xml'] = function(str){
 *       return { object parsed from str };
 *     };
 *
 */ request.parse = {
    'application/x-www-form-urlencoded': parseString,
    'application/json': JSON.parse
};
/**
 * Parse the given header `str` into
 * an object containing the mapped fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */ function parseHeader(str) {
    var lines = str.split(/\r?\n/);
    var fields = {};
    var index;
    var line;
    var field;
    var val;
    for(var i = 0, len = lines.length; i < len; ++i){
        line = lines[i];
        index = line.indexOf(':');
        if (index === -1) continue;
        field = line.slice(0, index).toLowerCase();
        val = trim(line.slice(index + 1));
        fields[field] = val;
    }
    return fields;
}
/**
 * Check if `mime` is json or has +json structured syntax suffix.
 *
 * @param {String} mime
 * @return {Boolean}
 * @api private
 */ function isJSON(mime) {
    // should match /json or +json
    // but not /json-seq
    return /[/+]json($|[^-\w])/i.test(mime);
}
/**
 * Initialize a new `Response` with the given `xhr`.
 *
 *  - set flags (.ok, .error, etc)
 *  - parse header
 *
 * Examples:
 *
 *  Aliasing `superagent` as `request` is nice:
 *
 *      request = superagent;
 *
 *  We can use the promise-like API, or pass callbacks:
 *
 *      request.get('/').end(function(res){});
 *      request.get('/', function(res){});
 *
 *  Sending data can be chained:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' })
 *        .end(function(res){});
 *
 *  Or passed to `.send()`:
 *
 *      request
 *        .post('/user')
 *        .send({ name: 'tj' }, function(res){});
 *
 *  Or passed to `.post()`:
 *
 *      request
 *        .post('/user', { name: 'tj' })
 *        .end(function(res){});
 *
 * Or further reduced to a single call for simple cases:
 *
 *      request
 *        .post('/user', { name: 'tj' }, function(res){});
 *
 * @param {XMLHTTPRequest} xhr
 * @param {Object} options
 * @api private
 */ function Response(req) {
    this.req = req;
    this.xhr = this.req.xhr; // responseText is accessible only if responseType is '' or 'text' and on older browsers
    this.text = this.req.method !== 'HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text') || typeof this.xhr.responseType === 'undefined' ? this.xhr.responseText : null;
    this.statusText = this.req.xhr.statusText;
    var status = this.xhr.status; // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
    if (status === 1223) status = 204;
    this._setStatusProperties(status);
    this.headers = parseHeader(this.xhr.getAllResponseHeaders());
    this.header = this.headers; // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
    // getResponseHeader still works. so we get content-type even if getting
    // other headers fails.
    this.header['content-type'] = this.xhr.getResponseHeader('content-type');
    this._setHeaderProperties(this.header);
    if (this.text === null && req._responseType) this.body = this.xhr.response;
    else this.body = this.req.method === 'HEAD' ? null : this._parseBody(this.text ? this.text : this.xhr.response);
} // eslint-disable-next-line new-cap
$5w7q4(Response.prototype);
/**
 * Parse the given body `str`.
 *
 * Used for auto-parsing of bodies. Parsers
 * are defined on the `superagent.parse` object.
 *
 * @param {String} str
 * @return {Mixed}
 * @api private
 */ Response.prototype._parseBody = function(str) {
    var parse = request.parse[this.type];
    if (this.req._parser) return this.req._parser(this, str);
    if (!parse && isJSON(this.type)) parse = request.parse['application/json'];
    return parse && str && (str.length > 0 || str instanceof Object) ? parse(str) : null;
};
/**
 * Return an `Error` representative of this response.
 *
 * @return {Error}
 * @api public
 */ Response.prototype.toError = function() {
    var req = this.req;
    var method = req.method;
    var url = req.url;
    var msg = "cannot ".concat(method, " ").concat(url, " (").concat(this.status, ")");
    var err = new Error(msg);
    err.status = this.status;
    err.method = method;
    err.url = url;
    return err;
};
/**
 * Expose `Response`.
 */ request.Response = Response;
/**
 * Initialize a new `Request` with the given `method` and `url`.
 *
 * @param {String} method
 * @param {String} url
 * @api public
 */ function Request(method, url) {
    var self1 = this;
    this._query = this._query || [];
    this.method = method;
    this.url = url;
    this.header = {}; // preserves header name case
    this._header = {}; // coerces header names to lowercase
    this.on('end', function() {
        var err = null;
        var res = null;
        try {
            res = new Response(self1);
        } catch (err_) {
            err = new Error('Parser is unable to parse the response');
            err.parse = true;
            err.original = err_; // issue #675: return the raw response if the response parsing fails
            if (self1.xhr) {
                // ie9 doesn't have 'response' property
                err.rawResponse = typeof self1.xhr.responseType === 'undefined' ? self1.xhr.responseText : self1.xhr.response; // issue #876: return the http status code if the response parsing fails
                err.status = self1.xhr.status ? self1.xhr.status : null;
                err.statusCode = err.status; // backwards-compat only
            } else {
                err.rawResponse = null;
                err.status = null;
            }
            return self1.callback(err);
        }
        self1.emit('response', res);
        var new_err;
        try {
            if (!self1._isResponseOK(res)) new_err = new Error(res.statusText || res.text || 'Unsuccessful HTTP response');
        } catch (err_) {
            new_err = err_; // ok() callback can throw
        } // #1000 don't catch errors from the callback to avoid double calling it
        if (new_err) {
            new_err.original = err;
            new_err.response = res;
            new_err.status = res.status;
            self1.callback(new_err, res);
        } else self1.callback(null, res);
    });
}
/**
 * Mixin `Emitter` and `RequestBase`.
 */ // eslint-disable-next-line new-cap
$jiPGG(Request.prototype); // eslint-disable-next-line new-cap
$87ccA(Request.prototype);
/**
 * Set Content-Type to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.xml = 'application/xml';
 *
 *      request.post('/')
 *        .type('xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 *      request.post('/')
 *        .type('application/xml')
 *        .send(xmlstring)
 *        .end(callback);
 *
 * @param {String} type
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.type = function(type) {
    this.set('Content-Type', request.types[type] || type);
    return this;
};
/**
 * Set Accept to `type`, mapping values from `request.types`.
 *
 * Examples:
 *
 *      superagent.types.json = 'application/json';
 *
 *      request.get('/agent')
 *        .accept('json')
 *        .end(callback);
 *
 *      request.get('/agent')
 *        .accept('application/json')
 *        .end(callback);
 *
 * @param {String} accept
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.accept = function(type) {
    this.set('Accept', request.types[type] || type);
    return this;
};
/**
 * Set Authorization field value with `user` and `pass`.
 *
 * @param {String} user
 * @param {String} [pass] optional in case of using 'bearer' as type
 * @param {Object} options with 'type' property 'auto', 'basic' or 'bearer' (default 'basic')
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.auth = function(user, pass, options) {
    if (arguments.length === 1) pass = '';
    if (_typeof(pass) === 'object' && pass !== null) {
        // pass is optional and can be replaced with options
        options = pass;
        pass = '';
    }
    if (!options) options = {
        type: typeof btoa === 'function' ? 'basic' : 'auto'
    };
    var encoder = function encoder(string) {
        if (typeof btoa === 'function') return btoa(string);
        throw new Error('Cannot use basic auth, btoa is not a function');
    };
    return this._auth(user, pass, options, encoder);
};
/**
 * Add query-string `val`.
 *
 * Examples:
 *
 *   request.get('/shoes')
 *     .query('size=10')
 *     .query({ color: 'blue' })
 *
 * @param {Object|String} val
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.query = function(val) {
    if (typeof val !== 'string') val = serialize(val);
    if (val) this._query.push(val);
    return this;
};
/**
 * Queue the given `file` as an attachment to the specified `field`,
 * with optional `options` (or filename).
 *
 * ``` js
 * request.post('/upload')
 *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
 *   .end(callback);
 * ```
 *
 * @param {String} field
 * @param {Blob|File} file
 * @param {String|Object} options
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.attach = function(field, file, options) {
    if (file) {
        if (this._data) throw new Error("superagent can't mix .send() and .attach()");
        this._getFormData().append(field, file, options || file.name);
    }
    return this;
};
Request.prototype._getFormData = function() {
    if (!this._formData) this._formData = new root.FormData();
    return this._formData;
};
/**
 * Invoke the callback with `err` and `res`
 * and handle arity check.
 *
 * @param {Error} err
 * @param {Response} res
 * @api private
 */ Request.prototype.callback = function(err, res) {
    if (this._shouldRetry(err, res)) return this._retry();
    var fn = this._callback;
    this.clearTimeout();
    if (err) {
        if (this._maxRetries) err.retries = this._retries - 1;
        this.emit('error', err);
    }
    fn(err, res);
};
/**
 * Invoke callback with x-domain error.
 *
 * @api private
 */ Request.prototype.crossDomainError = function() {
    var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
    err.crossDomain = true;
    err.status = this.status;
    err.method = this.method;
    err.url = this.url;
    this.callback(err);
}; // This only warns, because the request is still likely to work
Request.prototype.agent = function() {
    console.warn('This is not supported in browser version of superagent');
    return this;
};
Request.prototype.ca = Request.prototype.agent;
Request.prototype.buffer = Request.prototype.ca; // This throws, because it can't send/receive data as expected
Request.prototype.write = function() {
    throw new Error('Streaming is not supported in browser version of superagent');
};
Request.prototype.pipe = Request.prototype.write;
/**
 * Check if `obj` is a host object,
 * we don't want to serialize these :)
 *
 * @param {Object} obj host object
 * @return {Boolean} is a host object
 * @api private
 */ Request.prototype._isHost = function(obj) {
    // Native objects stringify to [object File], [object Blob], [object FormData], etc.
    return obj && _typeof(obj) === 'object' && !Array.isArray(obj) && Object.prototype.toString.call(obj) !== '[object Object]';
};
/**
 * Initiate request, invoking callback `fn(res)`
 * with an instanceof `Response`.
 *
 * @param {Function} fn
 * @return {Request} for chaining
 * @api public
 */ Request.prototype.end = function(fn) {
    if (this._endCalled) console.warn('Warning: .end() was called twice. This is not supported in superagent');
    this._endCalled = true; // store callback
    this._callback = fn || noop; // querystring
    this._finalizeQueryString();
    this._end();
};
Request.prototype._setUploadTimeout = function() {
    var self1 = this; // upload timeout it's wokrs only if deadline timeout is off
    if (this._uploadTimeout && !this._uploadTimeoutTimer) this._uploadTimeoutTimer = setTimeout(function() {
        self1._timeoutError('Upload timeout of ', self1._uploadTimeout, 'ETIMEDOUT');
    }, this._uploadTimeout);
}; // eslint-disable-next-line complexity
Request.prototype._end = function() {
    if (this._aborted) return this.callback(new Error('The request has been aborted even before .end() was called'));
    var self1 = this;
    this.xhr = request.getXHR();
    var xhr = this.xhr;
    var data = this._formData || this._data;
    this._setTimeouts(); // state change
    xhr.onreadystatechange = function() {
        var readyState = xhr.readyState;
        if (readyState >= 2 && self1._responseTimeoutTimer) clearTimeout(self1._responseTimeoutTimer);
        if (readyState !== 4) return;
         // In IE9, reads to any property (e.g. status) off of an aborted XHR will
        // result in the error "Could not complete the operation due to error c00c023f"
        var status;
        try {
            status = xhr.status;
        } catch (_unused5) {
            status = 0;
        }
        if (!status) {
            if (self1.timedout || self1._aborted) return;
            return self1.crossDomainError();
        }
        self1.emit('end');
    }; // progress
    var handleProgress = function handleProgress(direction, e) {
        if (e.total > 0) {
            e.percent = e.loaded / e.total * 100;
            if (e.percent === 100) clearTimeout(self1._uploadTimeoutTimer);
        }
        e.direction = direction;
        self1.emit('progress', e);
    };
    if (this.hasListeners('progress')) try {
        xhr.addEventListener('progress', handleProgress.bind(null, 'download'));
        if (xhr.upload) xhr.upload.addEventListener('progress', handleProgress.bind(null, 'upload'));
    } catch (_unused6) {
    // Reported here:
    // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
    }
    if (xhr.upload) this._setUploadTimeout();
     // initiate request
    try {
        if (this.username && this.password) xhr.open(this.method, this.url, true, this.username, this.password);
        else xhr.open(this.method, this.url, true);
    } catch (err) {
        // see #1149
        return this.callback(err);
    } // CORS
    if (this._withCredentials) xhr.withCredentials = true; // body
    if (!this._formData && this.method !== 'GET' && this.method !== 'HEAD' && typeof data !== 'string' && !this._isHost(data)) {
        // serialize stuff
        var contentType = this._header['content-type'];
        var _serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
        if (!_serialize && isJSON(contentType)) _serialize = request.serialize['application/json'];
        if (_serialize) data = _serialize(data);
    } // set header fields
    for(var field in this.header){
        if (this.header[field] === null) continue;
        if (Object.prototype.hasOwnProperty.call(this.header, field)) xhr.setRequestHeader(field, this.header[field]);
    }
    if (this._responseType) xhr.responseType = this._responseType;
     // send stuff
    this.emit('request', this); // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
    // We need null here if data is undefined
    xhr.send(typeof data === 'undefined' ? null : data);
};
request.agent = function() {
    return new $baedc();
};
[
    'GET',
    'POST',
    'OPTIONS',
    'PATCH',
    'PUT',
    'DELETE'
].forEach(function(method) {
    $baedc.prototype[method.toLowerCase()] = function(url, fn) {
        var req = new request.Request(method, url);
        this._setDefaults(req);
        if (fn) req.end(fn);
        return req;
    };
});
$baedc.prototype.del = $baedc.prototype.delete;
/**
 * GET `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.get = function(url, data, fn) {
    var req = request('GET', url);
    if (typeof data === 'function') {
        fn = data;
        data = null;
    }
    if (data) req.query(data);
    if (fn) req.end(fn);
    return req;
};
/**
 * HEAD `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.head = function(url, data, fn) {
    var req = request('HEAD', url);
    if (typeof data === 'function') {
        fn = data;
        data = null;
    }
    if (data) req.query(data);
    if (fn) req.end(fn);
    return req;
};
/**
 * OPTIONS query to `url` with optional callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.options = function(url, data, fn) {
    var req = request('OPTIONS', url);
    if (typeof data === 'function') {
        fn = data;
        data = null;
    }
    if (data) req.send(data);
    if (fn) req.end(fn);
    return req;
};
/**
 * DELETE `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ function del(url, data, fn) {
    var req = request('DELETE', url);
    if (typeof data === 'function') {
        fn = data;
        data = null;
    }
    if (data) req.send(data);
    if (fn) req.end(fn);
    return req;
}
request.del = del;
request.delete = del;
/**
 * PATCH `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.patch = function(url, data, fn) {
    var req = request('PATCH', url);
    if (typeof data === 'function') {
        fn = data;
        data = null;
    }
    if (data) req.send(data);
    if (fn) req.end(fn);
    return req;
};
/**
 * POST `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed} [data]
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.post = function(url, data, fn) {
    var req = request('POST', url);
    if (typeof data === 'function') {
        fn = data;
        data = null;
    }
    if (data) req.send(data);
    if (fn) req.end(fn);
    return req;
};
/**
 * PUT `url` with optional `data` and callback `fn(res)`.
 *
 * @param {String} url
 * @param {Mixed|Function} [data] or fn
 * @param {Function} [fn]
 * @return {Request}
 * @api public
 */ request.put = function(url, data, fn) {
    var req = request('PUT', url);
    if (typeof data === 'function') {
        fn = data;
        data = null;
    }
    if (data) req.send(data);
    if (fn) req.end(fn);
    return req;
};

});
parcelRegister("jiPGG", function(module, exports) {
/**
 * Expose `Emitter`.
 */ module.exports = $e0d7cacdc7b22537$var$Emitter;
/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $e0d7cacdc7b22537$var$Emitter(obj) {
    if (obj) return $e0d7cacdc7b22537$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $e0d7cacdc7b22537$var$mixin(obj) {
    for(var key in $e0d7cacdc7b22537$var$Emitter.prototype)obj[key] = $e0d7cacdc7b22537$var$Emitter.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $e0d7cacdc7b22537$var$Emitter.prototype.on = $e0d7cacdc7b22537$var$Emitter.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $e0d7cacdc7b22537$var$Emitter.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $e0d7cacdc7b22537$var$Emitter.prototype.off = $e0d7cacdc7b22537$var$Emitter.prototype.removeListener = $e0d7cacdc7b22537$var$Emitter.prototype.removeAllListeners = $e0d7cacdc7b22537$var$Emitter.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $e0d7cacdc7b22537$var$Emitter.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $e0d7cacdc7b22537$var$Emitter.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $e0d7cacdc7b22537$var$Emitter.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};

});

parcelRegister("eY713", function(module, exports) {
module.exports = $ae5c1c8a24f71c38$var$stringify;
$ae5c1c8a24f71c38$var$stringify.default = $ae5c1c8a24f71c38$var$stringify;
$ae5c1c8a24f71c38$var$stringify.stable = $ae5c1c8a24f71c38$var$deterministicStringify;
$ae5c1c8a24f71c38$var$stringify.stableStringify = $ae5c1c8a24f71c38$var$deterministicStringify;
var $ae5c1c8a24f71c38$var$LIMIT_REPLACE_NODE = '[...]';
var $ae5c1c8a24f71c38$var$CIRCULAR_REPLACE_NODE = '[Circular]';
var $ae5c1c8a24f71c38$var$arr = [];
var $ae5c1c8a24f71c38$var$replacerStack = [];
function $ae5c1c8a24f71c38$var$defaultOptions() {
    return {
        depthLimit: Number.MAX_SAFE_INTEGER,
        edgesLimit: Number.MAX_SAFE_INTEGER
    };
}
// Regular stringify
function $ae5c1c8a24f71c38$var$stringify(obj, replacer, spacer, options) {
    if (typeof options === 'undefined') options = $ae5c1c8a24f71c38$var$defaultOptions();
    $ae5c1c8a24f71c38$var$decirc(obj, '', 0, [], undefined, 0, options);
    var res;
    try {
        if ($ae5c1c8a24f71c38$var$replacerStack.length === 0) res = JSON.stringify(obj, replacer, spacer);
        else res = JSON.stringify(obj, $ae5c1c8a24f71c38$var$replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify('[unable to serialize, circular reference is too complex to analyze]');
    } finally{
        while($ae5c1c8a24f71c38$var$arr.length !== 0){
            var part = $ae5c1c8a24f71c38$var$arr.pop();
            if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
            else part[0][part[1]] = part[2];
        }
    }
    return res;
}
function $ae5c1c8a24f71c38$var$setReplace(replace, val, k, parent) {
    var propertyDescriptor = Object.getOwnPropertyDescriptor(parent, k);
    if (propertyDescriptor.get !== undefined) {
        if (propertyDescriptor.configurable) {
            Object.defineProperty(parent, k, {
                value: replace
            });
            $ae5c1c8a24f71c38$var$arr.push([
                parent,
                k,
                val,
                propertyDescriptor
            ]);
        } else $ae5c1c8a24f71c38$var$replacerStack.push([
            val,
            k,
            replace
        ]);
    } else {
        parent[k] = replace;
        $ae5c1c8a24f71c38$var$arr.push([
            parent,
            k,
            val
        ]);
    }
}
function $ae5c1c8a24f71c38$var$decirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === 'object' && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            $ae5c1c8a24f71c38$var$setReplace($ae5c1c8a24f71c38$var$CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.depthLimit !== 'undefined' && depth > options.depthLimit) {
            $ae5c1c8a24f71c38$var$setReplace($ae5c1c8a24f71c38$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== 'undefined' && edgeIndex + 1 > options.edgesLimit) {
            $ae5c1c8a24f71c38$var$setReplace($ae5c1c8a24f71c38$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)$ae5c1c8a24f71c38$var$decirc(val[i], i, i, stack, val, depth, options);
        else {
            var keys = Object.keys(val);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                $ae5c1c8a24f71c38$var$decirc(val[key], key, i, stack, val, depth, options);
            }
        }
        stack.pop();
    }
}
// Stable-stringify
function $ae5c1c8a24f71c38$var$compareFunction(a, b) {
    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
}
function $ae5c1c8a24f71c38$var$deterministicStringify(obj, replacer, spacer, options) {
    if (typeof options === 'undefined') options = $ae5c1c8a24f71c38$var$defaultOptions();
    var tmp = $ae5c1c8a24f71c38$var$deterministicDecirc(obj, '', 0, [], undefined, 0, options) || obj;
    var res;
    try {
        if ($ae5c1c8a24f71c38$var$replacerStack.length === 0) res = JSON.stringify(tmp, replacer, spacer);
        else res = JSON.stringify(tmp, $ae5c1c8a24f71c38$var$replaceGetterValues(replacer), spacer);
    } catch (_) {
        return JSON.stringify('[unable to serialize, circular reference is too complex to analyze]');
    } finally{
        // Ensure that we restore the object as it was.
        while($ae5c1c8a24f71c38$var$arr.length !== 0){
            var part = $ae5c1c8a24f71c38$var$arr.pop();
            if (part.length === 4) Object.defineProperty(part[0], part[1], part[3]);
            else part[0][part[1]] = part[2];
        }
    }
    return res;
}
function $ae5c1c8a24f71c38$var$deterministicDecirc(val, k, edgeIndex, stack, parent, depth, options) {
    depth += 1;
    var i;
    if (typeof val === 'object' && val !== null) {
        for(i = 0; i < stack.length; i++)if (stack[i] === val) {
            $ae5c1c8a24f71c38$var$setReplace($ae5c1c8a24f71c38$var$CIRCULAR_REPLACE_NODE, val, k, parent);
            return;
        }
        try {
            if (typeof val.toJSON === 'function') return;
        } catch (_) {
            return;
        }
        if (typeof options.depthLimit !== 'undefined' && depth > options.depthLimit) {
            $ae5c1c8a24f71c38$var$setReplace($ae5c1c8a24f71c38$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        if (typeof options.edgesLimit !== 'undefined' && edgeIndex + 1 > options.edgesLimit) {
            $ae5c1c8a24f71c38$var$setReplace($ae5c1c8a24f71c38$var$LIMIT_REPLACE_NODE, val, k, parent);
            return;
        }
        stack.push(val);
        // Optimize for Arrays. Big arrays could kill the performance otherwise!
        if (Array.isArray(val)) for(i = 0; i < val.length; i++)$ae5c1c8a24f71c38$var$deterministicDecirc(val[i], i, i, stack, val, depth, options);
        else {
            // Create a temporary object in the required way
            var tmp = {};
            var keys = Object.keys(val).sort($ae5c1c8a24f71c38$var$compareFunction);
            for(i = 0; i < keys.length; i++){
                var key = keys[i];
                $ae5c1c8a24f71c38$var$deterministicDecirc(val[key], key, i, stack, val, depth, options);
                tmp[key] = val[key];
            }
            if (typeof parent !== 'undefined') {
                $ae5c1c8a24f71c38$var$arr.push([
                    parent,
                    k,
                    val
                ]);
                parent[k] = tmp;
            } else return tmp;
        }
        stack.pop();
    }
}
// wraps replacer function to handle values we couldn't replace
// and mark them as replaced value
function $ae5c1c8a24f71c38$var$replaceGetterValues(replacer) {
    replacer = typeof replacer !== 'undefined' ? replacer : function(k, v) {
        return v;
    };
    return function(key, val) {
        if ($ae5c1c8a24f71c38$var$replacerStack.length > 0) for(var i = 0; i < $ae5c1c8a24f71c38$var$replacerStack.length; i++){
            var part = $ae5c1c8a24f71c38$var$replacerStack[i];
            if (part[1] === key && part[0] === val) {
                val = part[2];
                $ae5c1c8a24f71c38$var$replacerStack.splice(i, 1);
                break;
            }
        }
        return replacer.call(this, key, val);
    };
}

});

parcelRegister("jD27N", function(module, exports) {
'use strict';

var $3MPka = parcelRequire("3MPka");

var $gD0W8 = parcelRequire("gD0W8");

var $2YCNQ = parcelRequire("2YCNQ");
module.exports = {
    formats: $2YCNQ,
    parse: $gD0W8,
    stringify: $3MPka
};

});
parcelRegister("3MPka", function(module, exports) {
'use strict';

var $3NX8A = parcelRequire("3NX8A");

var $8cmw8 = parcelRequire("8cmw8");

var $2YCNQ = parcelRequire("2YCNQ");
var $2c1daabe1a90f4a6$var$has = Object.prototype.hasOwnProperty;
var $2c1daabe1a90f4a6$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $2c1daabe1a90f4a6$var$isArray = Array.isArray;
var $2c1daabe1a90f4a6$var$push = Array.prototype.push;
var $2c1daabe1a90f4a6$var$pushToArray = function(arr, valueOrArray) {
    $2c1daabe1a90f4a6$var$push.apply(arr, $2c1daabe1a90f4a6$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $2c1daabe1a90f4a6$var$toISO = Date.prototype.toISOString;
var $2c1daabe1a90f4a6$var$defaultFormat = $2YCNQ.default;
var $2c1daabe1a90f4a6$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    depth: Infinity,
    encode: true,
    encodeDotInKeys: false,
    encoder: $8cmw8.encode,
    encodeValuesOnly: false,
    filter: void 0,
    format: $2c1daabe1a90f4a6$var$defaultFormat,
    formatter: $2YCNQ.formatters[$2c1daabe1a90f4a6$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $2c1daabe1a90f4a6$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $2c1daabe1a90f4a6$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $2c1daabe1a90f4a6$var$sentinel = {};
var $2c1daabe1a90f4a6$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel, depth, currentDepth) {
    var obj = object;
    if (currentDepth > depth) throw new RangeError('Input depth exceeded depth option of ' + depth);
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($2c1daabe1a90f4a6$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($2c1daabe1a90f4a6$var$sentinel) === 'undefined') step = 0;
    }
    obj = typeof filter === 'function' ? filter(prefix, obj) : obj;
    if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $2c1daabe1a90f4a6$var$isArray(obj)) obj = $8cmw8.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return formatter(encoder && !encodeValuesOnly ? encoder(prefix, $2c1daabe1a90f4a6$var$defaults.encoder, charset, 'key', format) : prefix);
        obj = '';
    }
    if ($2c1daabe1a90f4a6$var$isNonNullishPrimitive(obj) || $8cmw8.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $2c1daabe1a90f4a6$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $2c1daabe1a90f4a6$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $2c1daabe1a90f4a6$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $8cmw8.maybeMap(obj, function(v) {
            return v == null ? v : encoder(v);
        });
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($2c1daabe1a90f4a6$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);
    var adjustedPrefix = commaRoundTrip && $2c1daabe1a90f4a6$var$isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
    if (allowEmptyArrays && $2c1daabe1a90f4a6$var$isArray(obj) && obj.length === 0 && Object.keys(obj).length === 0) return adjustedPrefix + '[]';
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = $2c1daabe1a90f4a6$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $3NX8A();
        valueSideChannel.set($2c1daabe1a90f4a6$var$sentinel, sideChannel);
        $2c1daabe1a90f4a6$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === 'comma' && encodeValuesOnly && $2c1daabe1a90f4a6$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel, depth, currentDepth + 1));
    }
    return values;
};
var $2c1daabe1a90f4a6$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $2c1daabe1a90f4a6$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $2c1daabe1a90f4a6$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $2YCNQ.default;
    if (typeof opts.format !== 'undefined') {
        if (!$2c1daabe1a90f4a6$var$has.call($2YCNQ.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $2YCNQ.formatters[format];
    var filter = $2c1daabe1a90f4a6$var$defaults.filter;
    if (typeof opts.filter === 'function' || $2c1daabe1a90f4a6$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $2c1daabe1a90f4a6$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ('indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = $2c1daabe1a90f4a6$var$defaults.arrayFormat;
    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : $2c1daabe1a90f4a6$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $2c1daabe1a90f4a6$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $2c1daabe1a90f4a6$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $2c1daabe1a90f4a6$var$defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? $2c1daabe1a90f4a6$var$defaults.delimiter : opts.delimiter,
        depth: typeof opts.depth === 'number' ? opts.depth : $2c1daabe1a90f4a6$var$defaults.depth,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $2c1daabe1a90f4a6$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : $2c1daabe1a90f4a6$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $2c1daabe1a90f4a6$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $2c1daabe1a90f4a6$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $2c1daabe1a90f4a6$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $2c1daabe1a90f4a6$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $2c1daabe1a90f4a6$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $2c1daabe1a90f4a6$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($2c1daabe1a90f4a6$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var generateArrayPrefix = $2c1daabe1a90f4a6$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $3NX8A();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (typeof key === 'undefined' || key === null) continue;
        var value = obj[key];
        if (options.skipNulls && value === null) continue;
        var encodedKey = options.encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        $2c1daabe1a90f4a6$var$pushToArray(keys, $2c1daabe1a90f4a6$var$stringify(value, encodedKey, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel, options.depth, 0));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B' + options.delimiter;
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93' + options.delimiter;
    }
    return joined.length > 0 ? prefix + joined : '';
};

});
parcelRegister("3NX8A", function(module, exports) {
'use strict';

var $jQFIR = parcelRequire("jQFIR");

var $Pcuuz = parcelRequire("Pcuuz");

var $jXnFP = parcelRequire("jXnFP");

var $01X5B = parcelRequire("01X5B");

var $8st4X = parcelRequire("8st4X");
var $2c53d227d7fc6187$var$makeChannel = $8st4X || $01X5B || $jXnFP;
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) {
                var keyDesc = key && Object(key) === key ? 'the given object key' : $Pcuuz(key);
                throw new $jQFIR('Side channel does not contain ' + keyDesc);
            }
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $2c53d227d7fc6187$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    return channel;
};

});
parcelRegister("jQFIR", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("Pcuuz", function(module, exports) {
var $099e73f2f1d394e5$var$hasMap = typeof Map === 'function' && Map.prototype;
var $099e73f2f1d394e5$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $099e73f2f1d394e5$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $099e73f2f1d394e5$var$mapSize = $099e73f2f1d394e5$var$hasMap && $099e73f2f1d394e5$var$mapSizeDescriptor && typeof $099e73f2f1d394e5$var$mapSizeDescriptor.get === 'function' ? $099e73f2f1d394e5$var$mapSizeDescriptor.get : null;
var $099e73f2f1d394e5$var$mapForEach = $099e73f2f1d394e5$var$hasMap && Map.prototype.forEach;
var $099e73f2f1d394e5$var$hasSet = typeof Set === 'function' && Set.prototype;
var $099e73f2f1d394e5$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $099e73f2f1d394e5$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $099e73f2f1d394e5$var$setSize = $099e73f2f1d394e5$var$hasSet && $099e73f2f1d394e5$var$setSizeDescriptor && typeof $099e73f2f1d394e5$var$setSizeDescriptor.get === 'function' ? $099e73f2f1d394e5$var$setSizeDescriptor.get : null;
var $099e73f2f1d394e5$var$setForEach = $099e73f2f1d394e5$var$hasSet && Set.prototype.forEach;
var $099e73f2f1d394e5$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $099e73f2f1d394e5$var$weakMapHas = $099e73f2f1d394e5$var$hasWeakMap ? WeakMap.prototype.has : null;
var $099e73f2f1d394e5$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $099e73f2f1d394e5$var$weakSetHas = $099e73f2f1d394e5$var$hasWeakSet ? WeakSet.prototype.has : null;
var $099e73f2f1d394e5$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $099e73f2f1d394e5$var$weakRefDeref = $099e73f2f1d394e5$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $099e73f2f1d394e5$var$booleanValueOf = Boolean.prototype.valueOf;
var $099e73f2f1d394e5$var$objectToString = Object.prototype.toString;
var $099e73f2f1d394e5$var$functionToString = Function.prototype.toString;
var $099e73f2f1d394e5$var$$match = String.prototype.match;
var $099e73f2f1d394e5$var$$slice = String.prototype.slice;
var $099e73f2f1d394e5$var$$replace = String.prototype.replace;
var $099e73f2f1d394e5$var$$toUpperCase = String.prototype.toUpperCase;
var $099e73f2f1d394e5$var$$toLowerCase = String.prototype.toLowerCase;
var $099e73f2f1d394e5$var$$test = RegExp.prototype.test;
var $099e73f2f1d394e5$var$$concat = Array.prototype.concat;
var $099e73f2f1d394e5$var$$join = Array.prototype.join;
var $099e73f2f1d394e5$var$$arrSlice = Array.prototype.slice;
var $099e73f2f1d394e5$var$$floor = Math.floor;
var $099e73f2f1d394e5$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $099e73f2f1d394e5$var$gOPS = Object.getOwnPropertySymbols;
var $099e73f2f1d394e5$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $099e73f2f1d394e5$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $099e73f2f1d394e5$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $099e73f2f1d394e5$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $099e73f2f1d394e5$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $099e73f2f1d394e5$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $099e73f2f1d394e5$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $099e73f2f1d394e5$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$099e73f2f1d394e5$var$$floor(-num) : $099e73f2f1d394e5$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $099e73f2f1d394e5$var$$slice.call(str, intStr.length + 1);
            return $099e73f2f1d394e5$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $099e73f2f1d394e5$var$$replace.call($099e73f2f1d394e5$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $099e73f2f1d394e5$var$$replace.call(str, sepRegex, '$&_');
}

var $jIjd8 = parcelRequire("jIjd8");
var $099e73f2f1d394e5$var$inspectCustom = $jIjd8.custom;
var $099e73f2f1d394e5$var$inspectSymbol = $099e73f2f1d394e5$var$isSymbol($099e73f2f1d394e5$var$inspectCustom) ? $099e73f2f1d394e5$var$inspectCustom : null;
var $099e73f2f1d394e5$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $099e73f2f1d394e5$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($099e73f2f1d394e5$var$has(opts, 'quoteStyle') && !$099e73f2f1d394e5$var$has($099e73f2f1d394e5$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($099e73f2f1d394e5$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $099e73f2f1d394e5$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($099e73f2f1d394e5$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($099e73f2f1d394e5$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $099e73f2f1d394e5$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $099e73f2f1d394e5$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $099e73f2f1d394e5$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $099e73f2f1d394e5$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $099e73f2f1d394e5$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($099e73f2f1d394e5$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $099e73f2f1d394e5$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($099e73f2f1d394e5$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$099e73f2f1d394e5$var$isRegExp(obj)) {
        var name = $099e73f2f1d394e5$var$nameOf(obj);
        var keys = $099e73f2f1d394e5$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $099e73f2f1d394e5$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($099e73f2f1d394e5$var$isSymbol(obj)) {
        var symString = $099e73f2f1d394e5$var$hasShammedSymbols ? $099e73f2f1d394e5$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $099e73f2f1d394e5$var$symToString.call(obj);
        return typeof obj === 'object' && !$099e73f2f1d394e5$var$hasShammedSymbols ? $099e73f2f1d394e5$var$markBoxed(symString) : symString;
    }
    if ($099e73f2f1d394e5$var$isElement(obj)) {
        var s = '<' + $099e73f2f1d394e5$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $099e73f2f1d394e5$var$wrapQuotes($099e73f2f1d394e5$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $099e73f2f1d394e5$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($099e73f2f1d394e5$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $099e73f2f1d394e5$var$arrObjKeys(obj, inspect);
        if (indent && !$099e73f2f1d394e5$var$singleLineValues(xs)) return '[' + $099e73f2f1d394e5$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $099e73f2f1d394e5$var$$join.call(xs, ', ') + ' ]';
    }
    if ($099e73f2f1d394e5$var$isError(obj)) {
        var parts = $099e73f2f1d394e5$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$099e73f2f1d394e5$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $099e73f2f1d394e5$var$$join.call($099e73f2f1d394e5$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $099e73f2f1d394e5$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($099e73f2f1d394e5$var$inspectSymbol && typeof obj[$099e73f2f1d394e5$var$inspectSymbol] === 'function' && $jIjd8) return $jIjd8(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($099e73f2f1d394e5$var$isMap(obj)) {
        var mapParts = [];
        if ($099e73f2f1d394e5$var$mapForEach) $099e73f2f1d394e5$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $099e73f2f1d394e5$var$collectionOf('Map', $099e73f2f1d394e5$var$mapSize.call(obj), mapParts, indent);
    }
    if ($099e73f2f1d394e5$var$isSet(obj)) {
        var setParts = [];
        if ($099e73f2f1d394e5$var$setForEach) $099e73f2f1d394e5$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $099e73f2f1d394e5$var$collectionOf('Set', $099e73f2f1d394e5$var$setSize.call(obj), setParts, indent);
    }
    if ($099e73f2f1d394e5$var$isWeakMap(obj)) return $099e73f2f1d394e5$var$weakCollectionOf('WeakMap');
    if ($099e73f2f1d394e5$var$isWeakSet(obj)) return $099e73f2f1d394e5$var$weakCollectionOf('WeakSet');
    if ($099e73f2f1d394e5$var$isWeakRef(obj)) return $099e73f2f1d394e5$var$weakCollectionOf('WeakRef');
    if ($099e73f2f1d394e5$var$isNumber(obj)) return $099e73f2f1d394e5$var$markBoxed(inspect(Number(obj)));
    if ($099e73f2f1d394e5$var$isBigInt(obj)) return $099e73f2f1d394e5$var$markBoxed(inspect($099e73f2f1d394e5$var$bigIntValueOf.call(obj)));
    if ($099e73f2f1d394e5$var$isBoolean(obj)) return $099e73f2f1d394e5$var$markBoxed($099e73f2f1d394e5$var$booleanValueOf.call(obj));
    if ($099e73f2f1d394e5$var$isString(obj)) return $099e73f2f1d394e5$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$099e73f2f1d394e5$var$isDate(obj) && !$099e73f2f1d394e5$var$isRegExp(obj)) {
        var ys = $099e73f2f1d394e5$var$arrObjKeys(obj, inspect);
        var isPlainObject = $099e73f2f1d394e5$var$gPO ? $099e73f2f1d394e5$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $099e73f2f1d394e5$var$toStringTag && Object(obj) === obj && $099e73f2f1d394e5$var$toStringTag in obj ? $099e73f2f1d394e5$var$$slice.call($099e73f2f1d394e5$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $099e73f2f1d394e5$var$$join.call($099e73f2f1d394e5$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $099e73f2f1d394e5$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $099e73f2f1d394e5$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $099e73f2f1d394e5$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $099e73f2f1d394e5$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $099e73f2f1d394e5$var$quote(s) {
    return $099e73f2f1d394e5$var$$replace.call(String(s), /"/g, '&quot;');
}
function $099e73f2f1d394e5$var$canTrustToString(obj) {
    return !$099e73f2f1d394e5$var$toStringTag || !(typeof obj === 'object' && ($099e73f2f1d394e5$var$toStringTag in obj || typeof obj[$099e73f2f1d394e5$var$toStringTag] !== 'undefined'));
}
function $099e73f2f1d394e5$var$isArray(obj) {
    return $099e73f2f1d394e5$var$toStr(obj) === '[object Array]' && $099e73f2f1d394e5$var$canTrustToString(obj);
}
function $099e73f2f1d394e5$var$isDate(obj) {
    return $099e73f2f1d394e5$var$toStr(obj) === '[object Date]' && $099e73f2f1d394e5$var$canTrustToString(obj);
}
function $099e73f2f1d394e5$var$isRegExp(obj) {
    return $099e73f2f1d394e5$var$toStr(obj) === '[object RegExp]' && $099e73f2f1d394e5$var$canTrustToString(obj);
}
function $099e73f2f1d394e5$var$isError(obj) {
    return $099e73f2f1d394e5$var$toStr(obj) === '[object Error]' && $099e73f2f1d394e5$var$canTrustToString(obj);
}
function $099e73f2f1d394e5$var$isString(obj) {
    return $099e73f2f1d394e5$var$toStr(obj) === '[object String]' && $099e73f2f1d394e5$var$canTrustToString(obj);
}
function $099e73f2f1d394e5$var$isNumber(obj) {
    return $099e73f2f1d394e5$var$toStr(obj) === '[object Number]' && $099e73f2f1d394e5$var$canTrustToString(obj);
}
function $099e73f2f1d394e5$var$isBoolean(obj) {
    return $099e73f2f1d394e5$var$toStr(obj) === '[object Boolean]' && $099e73f2f1d394e5$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $099e73f2f1d394e5$var$isSymbol(obj) {
    if ($099e73f2f1d394e5$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$099e73f2f1d394e5$var$symToString) return false;
    try {
        $099e73f2f1d394e5$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $099e73f2f1d394e5$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$099e73f2f1d394e5$var$bigIntValueOf) return false;
    try {
        $099e73f2f1d394e5$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $099e73f2f1d394e5$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $099e73f2f1d394e5$var$has(obj, key) {
    return $099e73f2f1d394e5$var$hasOwn.call(obj, key);
}
function $099e73f2f1d394e5$var$toStr(obj) {
    return $099e73f2f1d394e5$var$objectToString.call(obj);
}
function $099e73f2f1d394e5$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $099e73f2f1d394e5$var$$match.call($099e73f2f1d394e5$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $099e73f2f1d394e5$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $099e73f2f1d394e5$var$isMap(x) {
    if (!$099e73f2f1d394e5$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $099e73f2f1d394e5$var$mapSize.call(x);
        try {
            $099e73f2f1d394e5$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $099e73f2f1d394e5$var$isWeakMap(x) {
    if (!$099e73f2f1d394e5$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $099e73f2f1d394e5$var$weakMapHas.call(x, $099e73f2f1d394e5$var$weakMapHas);
        try {
            $099e73f2f1d394e5$var$weakSetHas.call(x, $099e73f2f1d394e5$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $099e73f2f1d394e5$var$isWeakRef(x) {
    if (!$099e73f2f1d394e5$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $099e73f2f1d394e5$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $099e73f2f1d394e5$var$isSet(x) {
    if (!$099e73f2f1d394e5$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $099e73f2f1d394e5$var$setSize.call(x);
        try {
            $099e73f2f1d394e5$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $099e73f2f1d394e5$var$isWeakSet(x) {
    if (!$099e73f2f1d394e5$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $099e73f2f1d394e5$var$weakSetHas.call(x, $099e73f2f1d394e5$var$weakSetHas);
        try {
            $099e73f2f1d394e5$var$weakMapHas.call(x, $099e73f2f1d394e5$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $099e73f2f1d394e5$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $099e73f2f1d394e5$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $099e73f2f1d394e5$var$inspectString($099e73f2f1d394e5$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $099e73f2f1d394e5$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $099e73f2f1d394e5$var$$replace.call($099e73f2f1d394e5$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $099e73f2f1d394e5$var$lowbyte);
    return $099e73f2f1d394e5$var$wrapQuotes(s, 'single', opts);
}
function $099e73f2f1d394e5$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $099e73f2f1d394e5$var$$toUpperCase.call(n.toString(16));
}
function $099e73f2f1d394e5$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $099e73f2f1d394e5$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $099e73f2f1d394e5$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $099e73f2f1d394e5$var$indentedJoin(entries, indent) : $099e73f2f1d394e5$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $099e73f2f1d394e5$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($099e73f2f1d394e5$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $099e73f2f1d394e5$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $099e73f2f1d394e5$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $099e73f2f1d394e5$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $099e73f2f1d394e5$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $099e73f2f1d394e5$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $099e73f2f1d394e5$var$arrObjKeys(obj, inspect) {
    var isArr = $099e73f2f1d394e5$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $099e73f2f1d394e5$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $099e73f2f1d394e5$var$gOPS === 'function' ? $099e73f2f1d394e5$var$gOPS(obj) : [];
    var symMap;
    if ($099e73f2f1d394e5$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$099e73f2f1d394e5$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($099e73f2f1d394e5$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($099e73f2f1d394e5$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $099e73f2f1d394e5$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($099e73f2f1d394e5$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});

parcelRegister("jXnFP", function(module, exports) {
'use strict';

var $Pcuuz = parcelRequire("Pcuuz");

var $jQFIR = parcelRequire("jQFIR");
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $e875e4199dffa647$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $e875e4199dffa647$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $e875e4199dffa647$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $e875e4199dffa647$var$listSet = function(objects, key, value) {
    var node = $e875e4199dffa647$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $e875e4199dffa647$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$e875e4199dffa647$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $e875e4199dffa647$var$listDelete = function(objects, key) {
    if (objects) return $e875e4199dffa647$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ module.exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $jQFIR('Side channel does not contain ' + $Pcuuz(key));
        },
        'delete': function(key) {
            var deletedNode = $e875e4199dffa647$var$listDelete($o, key);
            if (deletedNode && $o && !$o.next) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $e875e4199dffa647$var$listGet($o, key);
        },
        has: function(key) {
            return $e875e4199dffa647$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $e875e4199dffa647$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    return channel;
};

});

parcelRegister("01X5B", function(module, exports) {
'use strict';

var $4YUXM = parcelRequire("4YUXM");

var $exvo0 = parcelRequire("exvo0");

var $Pcuuz = parcelRequire("Pcuuz");

var $jQFIR = parcelRequire("jQFIR");
var $005dee0701e4a773$var$$Map = $4YUXM('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $005dee0701e4a773$var$$mapGet = $exvo0('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $005dee0701e4a773$var$$mapSet = $exvo0('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $005dee0701e4a773$var$$mapHas = $exvo0('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $005dee0701e4a773$var$$mapDelete = $exvo0('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $005dee0701e4a773$var$$mapSize = $exvo0('Map.prototype.size', true);
/** @type {import('.')} */ module.exports = !!$005dee0701e4a773$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $jQFIR('Side channel does not contain ' + $Pcuuz(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $005dee0701e4a773$var$$mapDelete($m, key);
                if ($005dee0701e4a773$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $005dee0701e4a773$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $005dee0701e4a773$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $005dee0701e4a773$var$$Map();
            $005dee0701e4a773$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};

});
parcelRegister("4YUXM", function(module, exports) {
'use strict';
var $3a08f3b93b399588$var$undefined1;

var $39Ldl = parcelRequire("39Ldl");

var $2DlCe = parcelRequire("2DlCe");

var $TtWO0 = parcelRequire("TtWO0");

var $aG0Ti = parcelRequire("aG0Ti");

var $cwaZa = parcelRequire("cwaZa");

var $1rcCL = parcelRequire("1rcCL");

var $jQFIR = parcelRequire("jQFIR");

var $6Unty = parcelRequire("6Unty");

var $38UJ9 = parcelRequire("38UJ9");

var $iGzt4 = parcelRequire("iGzt4");

var $dWJBO = parcelRequire("dWJBO");

var $i9udS = parcelRequire("i9udS");

var $hE7Bh = parcelRequire("hE7Bh");

var $gJSpD = parcelRequire("gJSpD");

var $8xHx6 = parcelRequire("8xHx6");
var $3a08f3b93b399588$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $3a08f3b93b399588$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $3a08f3b93b399588$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $7SE9t = parcelRequire("7SE9t");

var $cILf7 = parcelRequire("cILf7");
var $3a08f3b93b399588$var$throwTypeError = function() {
    throw new $jQFIR();
};
var $3a08f3b93b399588$var$ThrowTypeError = $7SE9t ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $3a08f3b93b399588$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $7SE9t(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $3a08f3b93b399588$var$throwTypeError;
        }
    }
}() : $3a08f3b93b399588$var$throwTypeError;

var $3a08f3b93b399588$var$hasSymbols = (parcelRequire("fa2Fq"))();

var $cKjXh = parcelRequire("cKjXh");

var $5O4uz = parcelRequire("5O4uz");

var $bOsTQ = parcelRequire("bOsTQ");

var $4G4X6 = parcelRequire("4G4X6");

var $9ttrx = parcelRequire("9ttrx");
var $3a08f3b93b399588$var$needsEval = {};
var $3a08f3b93b399588$var$TypedArray = typeof Uint8Array === 'undefined' || !$cKjXh ? undefined : $cKjXh(Uint8Array);
var $3a08f3b93b399588$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $3a08f3b93b399588$var$hasSymbols && $cKjXh ? $cKjXh([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $3a08f3b93b399588$var$needsEval,
    '%AsyncGenerator%': $3a08f3b93b399588$var$needsEval,
    '%AsyncGeneratorFunction%': $3a08f3b93b399588$var$needsEval,
    '%AsyncIteratorPrototype%': $3a08f3b93b399588$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $2DlCe,
    '%eval%': eval,
    '%EvalError%': $TtWO0,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $3a08f3b93b399588$var$$Function,
    '%GeneratorFunction%': $3a08f3b93b399588$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $3a08f3b93b399588$var$hasSymbols && $cKjXh ? $cKjXh($cKjXh([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$3a08f3b93b399588$var$hasSymbols || !$cKjXh ? undefined : $cKjXh(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $39Ldl,
    '%Object.getOwnPropertyDescriptor%': $7SE9t,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $aG0Ti,
    '%ReferenceError%': $cwaZa,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$3a08f3b93b399588$var$hasSymbols || !$cKjXh ? undefined : $cKjXh(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $3a08f3b93b399588$var$hasSymbols && $cKjXh ? $cKjXh(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $3a08f3b93b399588$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $1rcCL,
    '%ThrowTypeError%': $3a08f3b93b399588$var$ThrowTypeError,
    '%TypedArray%': $3a08f3b93b399588$var$TypedArray,
    '%TypeError%': $jQFIR,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $6Unty,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $9ttrx,
    '%Function.prototype.apply%': $4G4X6,
    '%Object.defineProperty%': $cILf7,
    '%Object.getPrototypeOf%': $5O4uz,
    '%Math.abs%': $38UJ9,
    '%Math.floor%': $iGzt4,
    '%Math.max%': $dWJBO,
    '%Math.min%': $i9udS,
    '%Math.pow%': $hE7Bh,
    '%Math.round%': $gJSpD,
    '%Math.sign%': $8xHx6,
    '%Reflect.getPrototypeOf%': $bOsTQ
};
if ($cKjXh) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $3a08f3b93b399588$var$errorProto = $cKjXh($cKjXh(e));
    $3a08f3b93b399588$var$INTRINSICS['%Error.prototype%'] = $3a08f3b93b399588$var$errorProto;
}
var $3a08f3b93b399588$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $3a08f3b93b399588$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $3a08f3b93b399588$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $3a08f3b93b399588$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $cKjXh) value = $cKjXh(gen.prototype);
    }
    $3a08f3b93b399588$var$INTRINSICS[name] = value;
    return value;
};
var $3a08f3b93b399588$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $1rs7J = parcelRequire("1rs7J");

var $bSXfZ = parcelRequire("bSXfZ");
var $3a08f3b93b399588$var$$concat = $1rs7J.call($9ttrx, Array.prototype.concat);
var $3a08f3b93b399588$var$$spliceApply = $1rs7J.call($4G4X6, Array.prototype.splice);
var $3a08f3b93b399588$var$$replace = $1rs7J.call($9ttrx, String.prototype.replace);
var $3a08f3b93b399588$var$$strSlice = $1rs7J.call($9ttrx, String.prototype.slice);
var $3a08f3b93b399588$var$$exec = $1rs7J.call($9ttrx, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $3a08f3b93b399588$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $3a08f3b93b399588$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $3a08f3b93b399588$var$stringToPath = function stringToPath(string) {
    var first = $3a08f3b93b399588$var$$strSlice(string, 0, 1);
    var last = $3a08f3b93b399588$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $1rcCL('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $1rcCL('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $3a08f3b93b399588$var$$replace(string, $3a08f3b93b399588$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $3a08f3b93b399588$var$$replace(subString, $3a08f3b93b399588$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $3a08f3b93b399588$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($bSXfZ($3a08f3b93b399588$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $3a08f3b93b399588$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($bSXfZ($3a08f3b93b399588$var$INTRINSICS, intrinsicName)) {
        var value = $3a08f3b93b399588$var$INTRINSICS[intrinsicName];
        if (value === $3a08f3b93b399588$var$needsEval) value = $3a08f3b93b399588$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $jQFIR('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $1rcCL('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $jQFIR('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $jQFIR('"allowMissing" argument must be a boolean');
    if ($3a08f3b93b399588$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $1rcCL('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $3a08f3b93b399588$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $3a08f3b93b399588$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $3a08f3b93b399588$var$$spliceApply(parts, $3a08f3b93b399588$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $3a08f3b93b399588$var$$strSlice(part, 0, 1);
        var last = $3a08f3b93b399588$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $1rcCL('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($bSXfZ($3a08f3b93b399588$var$INTRINSICS, intrinsicRealName)) value = $3a08f3b93b399588$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $jQFIR('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($7SE9t && i + 1 >= parts.length) {
                var desc = $7SE9t(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $bSXfZ(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $3a08f3b93b399588$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("39Ldl", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("2DlCe", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("TtWO0", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("aG0Ti", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("cwaZa", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("1rcCL", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("6Unty", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("38UJ9", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("iGzt4", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("dWJBO", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("i9udS", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("hE7Bh", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("gJSpD", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("8xHx6", function(module, exports) {
'use strict';

var $io64q = parcelRequire("io64q");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($io64q(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("io64q", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("7SE9t", function(module, exports) {
'use strict';

var $8rLHf = parcelRequire("8rLHf");
var $5bccb8dbb44f329c$require$$gOPD = $8rLHf;
if ($5bccb8dbb44f329c$require$$gOPD) try {
    $5bccb8dbb44f329c$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $5bccb8dbb44f329c$require$$gOPD = null;
}
module.exports = $5bccb8dbb44f329c$require$$gOPD;

});
parcelRegister("8rLHf", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("cILf7", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $942e3d902bcc477c$var$$defineProperty = Object.defineProperty || false;
if ($942e3d902bcc477c$var$$defineProperty) try {
    $942e3d902bcc477c$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $942e3d902bcc477c$var$$defineProperty = false;
}
module.exports = $942e3d902bcc477c$var$$defineProperty;

});

parcelRegister("fa2Fq", function(module, exports) {
'use strict';
var $b099dbd68238d6ce$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $9VQ4N = parcelRequire("9VQ4N");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $b099dbd68238d6ce$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $b099dbd68238d6ce$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $9VQ4N();
};

});
parcelRegister("9VQ4N", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("cKjXh", function(module, exports) {
'use strict';

var $bOsTQ = parcelRequire("bOsTQ");

var $5O4uz = parcelRequire("5O4uz");

var $dv9TT = parcelRequire("dv9TT");
/** @type {import('.')} */ module.exports = $bOsTQ ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $bOsTQ(O);
} : $5O4uz ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $5O4uz(O);
} : $dv9TT ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $dv9TT(O);
} : null;

});
parcelRegister("bOsTQ", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("5O4uz", function(module, exports) {
'use strict';

var $39Ldl = parcelRequire("39Ldl");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $39Ldl.getPrototypeOf || null;

});

parcelRegister("dv9TT", function(module, exports) {
'use strict';

var $lH1kJ = parcelRequire("lH1kJ");

var $7SE9t = parcelRequire("7SE9t");
var $9d45d9abe8425603$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $9d45d9abe8425603$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $9d45d9abe8425603$var$desc = !!$9d45d9abe8425603$var$hasProtoAccessor && $7SE9t && $7SE9t(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $9d45d9abe8425603$var$$Object = Object;
var $9d45d9abe8425603$var$$getPrototypeOf = $9d45d9abe8425603$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $9d45d9abe8425603$var$desc && typeof $9d45d9abe8425603$var$desc.get === 'function' ? $lH1kJ([
    $9d45d9abe8425603$var$desc.get
]) : typeof $9d45d9abe8425603$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $9d45d9abe8425603$var$$getPrototypeOf(value == null ? value : $9d45d9abe8425603$var$$Object(value));
} : false;

});
parcelRegister("lH1kJ", function(module, exports) {
'use strict';

var $1rs7J = parcelRequire("1rs7J");

var $jQFIR = parcelRequire("jQFIR");

var $9ttrx = parcelRequire("9ttrx");

var $9LBpG = parcelRequire("9LBpG");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $jQFIR('a function is required');
    return $9LBpG($1rs7J, $9ttrx, args);
};

});
parcelRegister("1rs7J", function(module, exports) {
'use strict';

var $eXzJr = parcelRequire("eXzJr");
module.exports = Function.prototype.bind || $eXzJr;

});
parcelRegister("eXzJr", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $ae424afb5f8fb4e2$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $ae424afb5f8fb4e2$var$toStr = Object.prototype.toString;
var $ae424afb5f8fb4e2$var$max = Math.max;
var $ae424afb5f8fb4e2$var$funcType = '[object Function]';
var $ae424afb5f8fb4e2$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $ae424afb5f8fb4e2$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $ae424afb5f8fb4e2$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $ae424afb5f8fb4e2$var$toStr.apply(target) !== $ae424afb5f8fb4e2$var$funcType) throw new TypeError($ae424afb5f8fb4e2$var$ERROR_MESSAGE + target);
    var args = $ae424afb5f8fb4e2$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $ae424afb5f8fb4e2$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $ae424afb5f8fb4e2$var$concatty(args, arguments));
    };
    var boundLength = $ae424afb5f8fb4e2$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $ae424afb5f8fb4e2$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("9ttrx", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("9LBpG", function(module, exports) {
'use strict';

var $1rs7J = parcelRequire("1rs7J");

var $4G4X6 = parcelRequire("4G4X6");

var $9ttrx = parcelRequire("9ttrx");

var $4cvMh = parcelRequire("4cvMh");
/** @type {import('./actualApply')} */ module.exports = $4cvMh || $1rs7J.call($9ttrx, $4G4X6);

});
parcelRegister("4G4X6", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("4cvMh", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("bSXfZ", function(module, exports) {
'use strict';
var $8a72b41011bcef66$var$call = Function.prototype.call;
var $8a72b41011bcef66$var$$hasOwn = Object.prototype.hasOwnProperty;

var $1rs7J = parcelRequire("1rs7J");
/** @type {import('.')} */ module.exports = $1rs7J.call($8a72b41011bcef66$var$call, $8a72b41011bcef66$var$$hasOwn);

});


parcelRegister("exvo0", function(module, exports) {
'use strict';

var $4YUXM = parcelRequire("4YUXM");

var $lH1kJ = parcelRequire("lH1kJ");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $a95c7e6883bd7de8$var$$indexOf = $lH1kJ([
    $4YUXM('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $4YUXM(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $a95c7e6883bd7de8$var$$indexOf(name, '.prototype.') > -1) return $lH1kJ(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});


parcelRegister("8st4X", function(module, exports) {
'use strict';

var $4YUXM = parcelRequire("4YUXM");

var $exvo0 = parcelRequire("exvo0");

var $Pcuuz = parcelRequire("Pcuuz");

var $01X5B = parcelRequire("01X5B");

var $jQFIR = parcelRequire("jQFIR");
var $62877eb4813076bf$var$$WeakMap = $4YUXM('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $62877eb4813076bf$var$$weakMapGet = $exvo0('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $62877eb4813076bf$var$$weakMapSet = $exvo0('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $62877eb4813076bf$var$$weakMapHas = $exvo0('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $62877eb4813076bf$var$$weakMapDelete = $exvo0('WeakMap.prototype.delete', true);
/** @type {import('.')} */ module.exports = $62877eb4813076bf$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $jQFIR('Side channel does not contain ' + $Pcuuz(key));
        },
        'delete': function(key) {
            if ($62877eb4813076bf$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $62877eb4813076bf$var$$weakMapDelete($wm, key);
            } else if ($01X5B) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($62877eb4813076bf$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $62877eb4813076bf$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($62877eb4813076bf$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $62877eb4813076bf$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($62877eb4813076bf$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $62877eb4813076bf$var$$WeakMap();
                $62877eb4813076bf$var$$weakMapSet($wm, key, value);
            } else if ($01X5B) {
                if (!$m) $m = $01X5B();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $01X5B;

});


parcelRegister("8cmw8", function(module, exports) {
'use strict';

var $2YCNQ = parcelRequire("2YCNQ");

var $3NX8A = parcelRequire("3NX8A");

var $cILf7 = parcelRequire("cILf7");
var $018a56577438975a$var$has = Object.prototype.hasOwnProperty;
var $018a56577438975a$var$isArray = Array.isArray;
// Track objects created from arrayLimit overflow using side-channel
// Stores the current max numeric index for O(1) lookup
var $018a56577438975a$var$overflowChannel = $3NX8A();
var $018a56577438975a$var$markOverflow = function markOverflow(obj, maxIndex) {
    $018a56577438975a$var$overflowChannel.set(obj, maxIndex);
    return obj;
};
var $018a56577438975a$var$isOverflow = function isOverflow(obj) {
    return $018a56577438975a$var$overflowChannel.has(obj);
};
var $018a56577438975a$var$getMaxIndex = function getMaxIndex(obj) {
    return $018a56577438975a$var$overflowChannel.get(obj);
};
var $018a56577438975a$var$setMaxIndex = function setMaxIndex(obj, maxIndex) {
    $018a56577438975a$var$overflowChannel.set(obj, maxIndex);
};
var $018a56577438975a$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array[array.length] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
    return array;
}();
var $018a56577438975a$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($018a56577438975a$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted[compacted.length] = obj[j];
            item.obj[item.prop] = compacted;
        }
    }
};
var $018a56577438975a$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? {
        __proto__: null
    } : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $018a56577438975a$var$setProperty = function setProperty(obj, key, value) {
    if (key === '__proto__' && $cILf7) $cILf7(obj, key, {
        configurable: true,
        enumerable: true,
        value: value,
        writable: true
    });
    else obj[key] = value;
};
var $018a56577438975a$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object' && typeof source !== 'function') {
        if ($018a56577438975a$var$isArray(target)) {
            var nextIndex = target.length;
            if (options && typeof options.arrayLimit === 'number' && nextIndex >= options.arrayLimit) {
                if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
                return $018a56577438975a$var$markOverflow($018a56577438975a$var$arrayToObject(target.concat(source), options), nextIndex);
            }
            target[nextIndex] = source;
        } else if (target && typeof target === 'object') {
            if ($018a56577438975a$var$isOverflow(target)) {
                // Add at next numeric index for overflow objects
                var newIndex = $018a56577438975a$var$getMaxIndex(target) + 1;
                target[newIndex] = source;
                $018a56577438975a$var$setMaxIndex(target, newIndex);
            } else if (options && options.strictMerge) return [
                target,
                source
            ];
            else if (options && (options.plainObjects || options.allowPrototypes) || !$018a56577438975a$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') {
        if ($018a56577438975a$var$isOverflow(source)) {
            // Create new object with target at 0, source values shifted by 1
            var sourceKeys = Object.keys(source);
            var result = options && options.plainObjects ? {
                __proto__: null,
                0: target
            } : {
                0: target
            };
            for(var m = 0; m < sourceKeys.length; m++){
                var oldKey = parseInt(sourceKeys[m], 10);
                result[oldKey + 1] = source[sourceKeys[m]];
            }
            return $018a56577438975a$var$markOverflow(result, $018a56577438975a$var$getMaxIndex(source) + 1);
        }
        var combined = [
            target
        ].concat(source);
        if (options && typeof options.arrayLimit === 'number' && combined.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            return $018a56577438975a$var$markOverflow($018a56577438975a$var$arrayToObject(combined, options), combined.length - 1);
        }
        return combined;
    }
    var mergeTarget = target;
    if ($018a56577438975a$var$isArray(target) && !$018a56577438975a$var$isArray(source)) mergeTarget = $018a56577438975a$var$arrayToObject(target, options);
    if ($018a56577438975a$var$isArray(target) && $018a56577438975a$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($018a56577438975a$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target[target.length] = item;
            } else target[i] = item;
        });
        if (options && typeof options.arrayLimit === 'number' && target.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            return $018a56577438975a$var$markOverflow($018a56577438975a$var$arrayToObject(target, options), target.length - 1);
        }
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($018a56577438975a$var$has.call(acc, key)) $018a56577438975a$var$setProperty(acc, key, merge(acc[key], value, options));
        else $018a56577438975a$var$setProperty(acc, key, value);
        if ($018a56577438975a$var$isOverflow(source) && !$018a56577438975a$var$isOverflow(acc)) $018a56577438975a$var$markOverflow(acc, $018a56577438975a$var$getMaxIndex(source));
        if ($018a56577438975a$var$isOverflow(acc)) {
            var keyNum = parseInt(key, 10);
            if (String(keyNum) === key && keyNum >= 0 && keyNum > $018a56577438975a$var$getMaxIndex(acc)) $018a56577438975a$var$setMaxIndex(acc, keyNum);
        }
        return acc;
    }, mergeTarget);
};
var $018a56577438975a$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        $018a56577438975a$var$setProperty(acc, key, source[key]);
        return acc;
    }, target);
};
var $018a56577438975a$var$decode = function(str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $018a56577438975a$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $018a56577438975a$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var j = 0; j < string.length; j += $018a56577438975a$var$limit){
        var segment = string.length >= $018a56577438975a$var$limit ? string.slice(j, j + $018a56577438975a$var$limit) : string;
        if (j + $018a56577438975a$var$limit < string.length) {
            var last = segment.charCodeAt(segment.length - 1);
            if (last >= 0xD800 && last <= 0xDBFF) {
                segment = segment.slice(0, -1);
                j -= 1;
            }
        }
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $2YCNQ.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $018a56577438975a$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $018a56577438975a$var$hexTable[0xC0 | c >> 6] + $018a56577438975a$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $018a56577438975a$var$hexTable[0xE0 | c >> 12] + $018a56577438975a$var$hexTable[0x80 | c >> 6 & 0x3F] + $018a56577438975a$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $018a56577438975a$var$hexTable[0xF0 | c >> 18] + $018a56577438975a$var$hexTable[0x80 | c >> 12 & 0x3F] + $018a56577438975a$var$hexTable[0x80 | c >> 6 & 0x3F] + $018a56577438975a$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join('');
    }
    return out;
};
var $018a56577438975a$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = $3NX8A();
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && !refs.has(val)) {
                queue[queue.length] = {
                    obj: obj,
                    prop: key
                };
                refs.set(val, true);
            }
        }
    }
    $018a56577438975a$var$compactQueue(queue);
    return value;
};
var $018a56577438975a$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $018a56577438975a$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj));
};
var $018a56577438975a$var$combine = function combine(a, b, arrayLimit, plainObjects, throwOnLimitExceeded) {
    // If 'a' is already an overflow object, add to it
    if ($018a56577438975a$var$isOverflow(a)) {
        if (throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + arrayLimit + ' element' + (arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
        // spread `b` one level, matching the `[].concat(a, b)` used below, so a
        // collection appended to an already-overflowed object is flattened
        // rather than nested under a single index
        var bValues = $018a56577438975a$var$isArray(b) ? b : [
            b
        ];
        var newIndex = $018a56577438975a$var$getMaxIndex(a);
        for(var i = 0; i < bValues.length; ++i){
            newIndex += 1;
            a[newIndex] = bValues[i];
        }
        $018a56577438975a$var$setMaxIndex(a, newIndex);
        return a;
    }
    var result = [].concat(a, b);
    if (result.length > arrayLimit) {
        if (throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + arrayLimit + ' element' + (arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
        return $018a56577438975a$var$markOverflow($018a56577438975a$var$arrayToObject(result, {
            plainObjects: plainObjects
        }), result.length - 1);
    }
    return result;
};
var $018a56577438975a$var$maybeMap = function maybeMap(val, fn) {
    if ($018a56577438975a$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped[mapped.length] = fn(val[i]);
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $018a56577438975a$var$arrayToObject,
    assign: $018a56577438975a$var$assign,
    combine: $018a56577438975a$var$combine,
    compact: $018a56577438975a$var$compact,
    decode: $018a56577438975a$var$decode,
    encode: $018a56577438975a$var$encode,
    isBuffer: $018a56577438975a$var$isBuffer,
    isOverflow: $018a56577438975a$var$isOverflow,
    isRegExp: $018a56577438975a$var$isRegExp,
    markOverflow: $018a56577438975a$var$markOverflow,
    maybeMap: $018a56577438975a$var$maybeMap,
    merge: $018a56577438975a$var$merge
};

});
parcelRegister("2YCNQ", function(module, exports) {
'use strict';
var $22af48d3ca4adc39$var$replace = String.prototype.replace;
var $22af48d3ca4adc39$var$percentTwenties = /%20/g;
var $22af48d3ca4adc39$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
module.exports = {
    'default': $22af48d3ca4adc39$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $22af48d3ca4adc39$var$replace.call(value, $22af48d3ca4adc39$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $22af48d3ca4adc39$var$Format.RFC1738,
    RFC3986: $22af48d3ca4adc39$var$Format.RFC3986
};

});



parcelRegister("gD0W8", function(module, exports) {
'use strict';

var $8cmw8 = parcelRequire("8cmw8");
var $c1b103d7c2b03359$var$has = Object.prototype.hasOwnProperty;
var $c1b103d7c2b03359$var$isArray = Array.isArray;
var $c1b103d7c2b03359$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $8cmw8.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictMerge: true,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};
var $c1b103d7c2b03359$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $c1b103d7c2b03359$var$parseArrayValue = function(val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        if (options.throwOnLimitExceeded) {
            var commaCount = 0;
            var commaIndex = val.indexOf(',');
            while(commaIndex > -1){
                commaCount += 1;
                if (commaCount >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
                commaIndex = val.indexOf(',', commaIndex + 1);
            }
        }
        return val.split(',');
    }
    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $c1b103d7c2b03359$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $c1b103d7c2b03359$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $c1b103d7c2b03359$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
    var limit = options.parameterLimit === Infinity ? void 0 : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, options.throwOnLimitExceeded && typeof limit !== 'undefined' ? limit + 1 : limit);
    if (options.throwOnLimitExceeded && typeof limit !== 'undefined' && parts.length > limit) throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $c1b103d7c2b03359$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $c1b103d7c2b03359$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, $c1b103d7c2b03359$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $c1b103d7c2b03359$var$defaults.decoder, charset, 'key');
            if (key !== null) val = $8cmw8.maybeMap($c1b103d7c2b03359$var$parseArrayValue(part.slice(pos + 1), options, $c1b103d7c2b03359$var$isArray(obj[key]) ? obj[key].length : 0), function(encodedVal) {
                return options.decoder(encodedVal, $c1b103d7c2b03359$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $c1b103d7c2b03359$var$interpretNumericEntities(String(val));
        if (part.indexOf('[]=') > -1) val = $c1b103d7c2b03359$var$isArray(val) ? [
            val
        ] : val;
        if (options.comma && $c1b103d7c2b03359$var$isArray(val) && val.length > options.arrayLimit) val = $8cmw8.combine([], val, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
        if (key !== null) {
            var existing = $c1b103d7c2b03359$var$has.call(obj, key);
            if (existing && (options.duplicates === 'combine' || part.indexOf('[]=') > -1)) obj[key] = $8cmw8.combine(obj[key], val, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
            else if (!existing || options.duplicates === 'last') obj[key] = val;
        }
    }
    return obj;
};
var $c1b103d7c2b03359$var$parseObject = function(chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }
    var leaf = valuesParsed ? val : $c1b103d7c2b03359$var$parseArrayValue(val, options, currentArrayLength);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) {
            if ($8cmw8.isOverflow(leaf)) // leaf is already an overflow object, preserve it
            obj = leaf;
            else obj = options.allowEmptyArrays && (leaf === '' || options.strictNullHandling && leaf === null) ? [] : $8cmw8.combine([], leaf, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
        } else {
            obj = options.plainObjects ? {
                __proto__: null
            } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            var isValidArrayIndex = !isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays;
            if (!options.parseArrays && decodedRoot === '') obj = {
                0: leaf
            };
            else if (isValidArrayIndex && index < options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (isValidArrayIndex && options.throwOnLimitExceeded) throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            else if (isValidArrayIndex) {
                obj[index] = leaf;
                $8cmw8.markOverflow(obj, index);
            } else if (decodedRoot !== '__proto__') obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
// Split a key like "a[b][c[]]" into ['a', '[b]', '[c[]]'] while preserving
// qs parse semantics for depth/prototype guards.
var $c1b103d7c2b03359$var$splitKeyIntoSegments = function splitKeyIntoSegments(originalKey, options) {
    var key = options.allowDots ? originalKey.replace(/\.([^.[]+)/g, '[$1]') : originalKey;
    // depth <= 0 keeps the whole key as one segment
    if (options.depth <= 0) {
        if (!options.plainObjects && $c1b103d7c2b03359$var$has.call(Object.prototype, key)) {
            if (!options.allowPrototypes) return;
        }
        return [
            key
        ];
    }
    var segments = [];
    // parent before the first '[' (may be empty if key starts with '[')
    var first = key.indexOf('[');
    var parent = first >= 0 ? key.slice(0, first) : key;
    if (parent) {
        if (!options.plainObjects && $c1b103d7c2b03359$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        segments[segments.length] = parent;
    }
    var n = key.length;
    var open = first;
    var collected = 0;
    while(open >= 0 && collected < options.depth){
        var level = 1;
        var i = open + 1;
        var close = -1;
        // balance nested '[' and ']' inside this bracket group using a nesting level counter
        while(i < n && close < 0){
            var cu = key.charCodeAt(i);
            if (cu === 0x5B) level += 1;
            else if (cu === 0x5D) {
                level -= 1;
                if (level === 0) close = i; // found matching close; loop will exit by condition
            }
            i += 1;
        }
        if (close < 0) {
            // Unterminated group: wrap the raw remainder in one bracket pair so it stays
            // a single literal segment (e.g. "[[]b" -> "[[]b]"); we do not infer missing ']'.
            segments[segments.length] = '[' + key.slice(open) + ']';
            return segments;
        }
        var seg = key.slice(open, close + 1);
        // prototype guard for the content of this group
        var content = seg.slice(1, -1);
        if (!options.plainObjects && $c1b103d7c2b03359$var$has.call(Object.prototype, content) && !options.allowPrototypes) return;
        segments[segments.length] = seg;
        collected += 1;
        // find the next '[' after this balanced group
        open = key.indexOf('[', close + 1);
    }
    if (open >= 0) {
        if (options.strictDepth === true) throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        segments[segments.length] = '[' + key.slice(open) + ']';
    }
    return segments;
};
var $c1b103d7c2b03359$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    var keys = $c1b103d7c2b03359$var$splitKeyIntoSegments(givenKey, options);
    if (!keys) return;
    return $c1b103d7c2b03359$var$parseObject(keys, val, options, valuesParsed);
};
var $c1b103d7c2b03359$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $c1b103d7c2b03359$var$defaults;
    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    var charset = typeof opts.charset === 'undefined' ? $c1b103d7c2b03359$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === 'undefined' ? $c1b103d7c2b03359$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') throw new TypeError('The duplicates option must be either combine, first, or last');
    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : $c1b103d7c2b03359$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : $c1b103d7c2b03359$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $c1b103d7c2b03359$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $c1b103d7c2b03359$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $c1b103d7c2b03359$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $c1b103d7c2b03359$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $c1b103d7c2b03359$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : $c1b103d7c2b03359$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $c1b103d7c2b03359$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $8cmw8.isRegExp(opts.delimiter) ? opts.delimiter : $c1b103d7c2b03359$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $c1b103d7c2b03359$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $c1b103d7c2b03359$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $c1b103d7c2b03359$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $c1b103d7c2b03359$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : $c1b103d7c2b03359$var$defaults.strictDepth,
        strictMerge: typeof opts.strictMerge === 'boolean' ? !!opts.strictMerge : $c1b103d7c2b03359$var$defaults.strictMerge,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $c1b103d7c2b03359$var$defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};
module.exports = function(str, opts) {
    var options = $c1b103d7c2b03359$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? {
        __proto__: null
    } : {};
    var tempObj = typeof str === 'string' ? $c1b103d7c2b03359$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? {
        __proto__: null
    } : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $c1b103d7c2b03359$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $8cmw8.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $8cmw8.compact(obj);
};

});


parcelRegister("87ccA", function(module, exports) {
"use strict";
function $5e88713f52453955$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $5e88713f52453955$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $5e88713f52453955$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $5e88713f52453955$var$_typeof(obj);
}

var $5FA8u = parcelRequire("5FA8u");
/**
 * Expose `RequestBase`.
 */ module.exports = $5e88713f52453955$var$RequestBase;
/**
 * Initialize a new `RequestBase`.
 *
 * @api public
 */ function $5e88713f52453955$var$RequestBase(object) {
    if (object) return $5e88713f52453955$var$mixin(object);
}
/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $5e88713f52453955$var$mixin(object) {
    for(var key in $5e88713f52453955$var$RequestBase.prototype)if (Object.prototype.hasOwnProperty.call($5e88713f52453955$var$RequestBase.prototype, key)) object[key] = $5e88713f52453955$var$RequestBase.prototype[key];
    return object;
}
/**
 * Clear previous timeout.
 *
 * @return {Request} for chaining
 * @api public
 */ $5e88713f52453955$var$RequestBase.prototype.clearTimeout = function() {
    clearTimeout(this._timer);
    clearTimeout(this._responseTimeoutTimer);
    clearTimeout(this._uploadTimeoutTimer);
    delete this._timer;
    delete this._responseTimeoutTimer;
    delete this._uploadTimeoutTimer;
    return this;
};
/**
 * Override default response body parser
 *
 * This function will be called to convert incoming data into request.body
 *
 * @param {Function}
 * @api public
 */ $5e88713f52453955$var$RequestBase.prototype.parse = function(fn) {
    this._parser = fn;
    return this;
};
/**
 * Set format of binary response body.
 * In browser valid formats are 'blob' and 'arraybuffer',
 * which return Blob and ArrayBuffer, respectively.
 *
 * In Node all values result in Buffer.
 *
 * Examples:
 *
 *      req.get('/')
 *        .responseType('blob')
 *        .end(callback);
 *
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */ $5e88713f52453955$var$RequestBase.prototype.responseType = function(value) {
    this._responseType = value;
    return this;
};
/**
 * Override default request body serializer
 *
 * This function will be called to convert data set via .send or .attach into payload to send
 *
 * @param {Function}
 * @api public
 */ $5e88713f52453955$var$RequestBase.prototype.serialize = function(fn) {
    this._serializer = fn;
    return this;
};
/**
 * Set timeouts.
 *
 * - response timeout is time between sending request and receiving the first byte of the response. Includes DNS and connection time.
 * - deadline is the time from start of the request to receiving response body in full. If the deadline is too short large files may not load at all on slow connections.
 * - upload is the time  since last bit of data was sent or received. This timeout works only if deadline timeout is off
 *
 * Value of 0 or false means no timeout.
 *
 * @param {Number|Object} ms or {response, deadline}
 * @return {Request} for chaining
 * @api public
 */ $5e88713f52453955$var$RequestBase.prototype.timeout = function(options) {
    if (!options || $5e88713f52453955$var$_typeof(options) !== 'object') {
        this._timeout = options;
        this._responseTimeout = 0;
        this._uploadTimeout = 0;
        return this;
    }
    for(var option in options)if (Object.prototype.hasOwnProperty.call(options, option)) switch(option){
        case 'deadline':
            this._timeout = options.deadline;
            break;
        case 'response':
            this._responseTimeout = options.response;
            break;
        case 'upload':
            this._uploadTimeout = options.upload;
            break;
        default:
            console.warn('Unknown timeout option', option);
    }
    return this;
};
/**
 * Set number of retry attempts on error.
 *
 * Failed requests will be retried 'count' times if timeout or err.code >= 500.
 *
 * @param {Number} count
 * @param {Function} [fn]
 * @return {Request} for chaining
 * @api public
 */ $5e88713f52453955$var$RequestBase.prototype.retry = function(count, fn) {
    // Default to 1 if no count passed or true
    if (arguments.length === 0 || count === true) count = 1;
    if (count <= 0) count = 0;
    this._maxRetries = count;
    this._retries = 0;
    this._retryCallback = fn;
    return this;
}; //
// NOTE: we do not include ESOCKETTIMEDOUT because that is from `request` package
//       <https://github.com/sindresorhus/got/pull/537>
//
// NOTE: we do not include EADDRINFO because it was removed from libuv in 2014
//       <https://github.com/libuv/libuv/commit/02e1ebd40b807be5af46343ea873331b2ee4e9c1>
//       <https://github.com/request/request/search?q=ESOCKETTIMEDOUT&unscoped_q=ESOCKETTIMEDOUT>
//
//
// TODO: expose these as configurable defaults
//
var $5e88713f52453955$var$ERROR_CODES = new Set([
    'ETIMEDOUT',
    'ECONNRESET',
    'EADDRINUSE',
    'ECONNREFUSED',
    'EPIPE',
    'ENOTFOUND',
    'ENETUNREACH',
    'EAI_AGAIN'
]);
var $5e88713f52453955$var$STATUS_CODES = new Set([
    408,
    413,
    429,
    500,
    502,
    503,
    504,
    521,
    522,
    524
]); // TODO: we would need to make this easily configurable before adding it in (e.g. some might want to add POST)
// const METHODS = new Set(['GET', 'PUT', 'HEAD', 'DELETE', 'OPTIONS', 'TRACE']);
/**
 * Determine if a request should be retried.
 * (Inspired by https://github.com/sindresorhus/got#retry)
 *
 * @param {Error} err an error
 * @param {Response} [res] response
 * @returns {Boolean} if segment should be retried
 */ $5e88713f52453955$var$RequestBase.prototype._shouldRetry = function(err, res) {
    if (!this._maxRetries || this._retries++ >= this._maxRetries) return false;
    if (this._retryCallback) try {
        var override = this._retryCallback(err, res);
        if (override === true) return true;
        if (override === false) return false; // undefined falls back to defaults
    } catch (err_) {
        console.error(err_);
    }
     // TODO: we would need to make this easily configurable before adding it in (e.g. some might want to add POST)
    /*
  if (
    this.req &&
    this.req.method &&
    !METHODS.has(this.req.method.toUpperCase())
  )
    return false;
  */ if (res && res.status && $5e88713f52453955$var$STATUS_CODES.has(res.status)) return true;
    if (err) {
        if (err.code && $5e88713f52453955$var$ERROR_CODES.has(err.code)) return true; // Superagent timeout
        if (err.timeout && err.code === 'ECONNABORTED') return true;
        if (err.crossDomain) return true;
    }
    return false;
};
/**
 * Retry request
 *
 * @return {Request} for chaining
 * @api private
 */ $5e88713f52453955$var$RequestBase.prototype._retry = function() {
    this.clearTimeout(); // node
    if (this.req) {
        this.req = null;
        this.req = this.request();
    }
    this._aborted = false;
    this.timedout = false;
    this.timedoutError = null;
    return this._end();
};
/**
 * Promise support
 *
 * @param {Function} resolve
 * @param {Function} [reject]
 * @return {Request}
 */ $5e88713f52453955$var$RequestBase.prototype.then = function(resolve, reject) {
    var _this = this;
    if (!this._fullfilledPromise) {
        var self = this;
        if (this._endCalled) console.warn('Warning: superagent request was sent twice, because both .end() and .then() were called. Never call .end() if you use promises');
        this._fullfilledPromise = new Promise(function(resolve, reject) {
            self.on('abort', function() {
                if (_this._maxRetries && _this._maxRetries > _this._retries) return;
                if (_this.timedout && _this.timedoutError) {
                    reject(_this.timedoutError);
                    return;
                }
                var err = new Error('Aborted');
                err.code = 'ABORTED';
                err.status = _this.status;
                err.method = _this.method;
                err.url = _this.url;
                reject(err);
            });
            self.end(function(err, res) {
                if (err) reject(err);
                else resolve(res);
            });
        });
    }
    return this._fullfilledPromise.then(resolve, reject);
};
$5e88713f52453955$var$RequestBase.prototype.catch = function(cb) {
    return this.then(undefined, cb);
};
/**
 * Allow for extension
 */ $5e88713f52453955$var$RequestBase.prototype.use = function(fn) {
    fn(this);
    return this;
};
$5e88713f52453955$var$RequestBase.prototype.ok = function(cb) {
    if (typeof cb !== 'function') throw new Error('Callback required');
    this._okCallback = cb;
    return this;
};
$5e88713f52453955$var$RequestBase.prototype._isResponseOK = function(res) {
    if (!res) return false;
    if (this._okCallback) return this._okCallback(res);
    return res.status >= 200 && res.status < 300;
};
/**
 * Get request header `field`.
 * Case-insensitive.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */ $5e88713f52453955$var$RequestBase.prototype.get = function(field) {
    return this._header[field.toLowerCase()];
};
/**
 * Get case-insensitive header `field` value.
 * This is a deprecated internal API. Use `.get(field)` instead.
 *
 * (getHeader is no longer used internally by the superagent code base)
 *
 * @param {String} field
 * @return {String}
 * @api private
 * @deprecated
 */ $5e88713f52453955$var$RequestBase.prototype.getHeader = $5e88713f52453955$var$RequestBase.prototype.get;
/**
 * Set header `field` to `val`, or multiple fields with one object.
 * Case-insensitive.
 *
 * Examples:
 *
 *      req.get('/')
 *        .set('Accept', 'application/json')
 *        .set('X-API-Key', 'foobar')
 *        .end(callback);
 *
 *      req.get('/')
 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
 *        .end(callback);
 *
 * @param {String|Object} field
 * @param {String} val
 * @return {Request} for chaining
 * @api public
 */ $5e88713f52453955$var$RequestBase.prototype.set = function(field, value) {
    if ($5FA8u(field)) {
        for(var key in field)if (Object.prototype.hasOwnProperty.call(field, key)) this.set(key, field[key]);
        return this;
    }
    this._header[field.toLowerCase()] = value;
    this.header[field] = value;
    return this;
};
/**
 * Remove header `field`.
 * Case-insensitive.
 *
 * Example:
 *
 *      req.get('/')
 *        .unset('User-Agent')
 *        .end(callback);
 *
 * @param {String} field field name
 */ $5e88713f52453955$var$RequestBase.prototype.unset = function(field) {
    delete this._header[field.toLowerCase()];
    delete this.header[field];
    return this;
};
/**
 * Write the field `name` and `val`, or multiple fields with one object
 * for "multipart/form-data" request bodies.
 *
 * ``` js
 * request.post('/upload')
 *   .field('foo', 'bar')
 *   .end(callback);
 *
 * request.post('/upload')
 *   .field({ foo: 'bar', baz: 'qux' })
 *   .end(callback);
 * ```
 *
 * @param {String|Object} name name of field
 * @param {String|Blob|File|Buffer|fs.ReadStream} val value of field
 * @return {Request} for chaining
 * @api public
 */ $5e88713f52453955$var$RequestBase.prototype.field = function(name, value) {
    // name should be either a string or an object.
    if (name === null || undefined === name) throw new Error('.field(name, val) name can not be empty');
    if (this._data) throw new Error(".field() can't be used if .send() is used. Please use only .send() or only .field() & .attach()");
    if ($5FA8u(name)) {
        for(var key in name)if (Object.prototype.hasOwnProperty.call(name, key)) this.field(key, name[key]);
        return this;
    }
    if (Array.isArray(value)) {
        for(var i in value)if (Object.prototype.hasOwnProperty.call(value, i)) this.field(name, value[i]);
        return this;
    } // val should be defined now
    if (value === null || undefined === value) throw new Error('.field(name, val) val can not be empty');
    if (typeof value === 'boolean') value = String(value);
    this._getFormData().append(name, value);
    return this;
};
/**
 * Abort the request, and clear potential timeout.
 *
 * @return {Request} request
 * @api public
 */ $5e88713f52453955$var$RequestBase.prototype.abort = function() {
    if (this._aborted) return this;
    this._aborted = true;
    if (this.xhr) this.xhr.abort(); // browser
    if (this.req) this.req.abort(); // node
    this.clearTimeout();
    this.emit('abort');
    return this;
};
$5e88713f52453955$var$RequestBase.prototype._auth = function(user, pass, options, base64Encoder) {
    switch(options.type){
        case 'basic':
            this.set('Authorization', "Basic ".concat(base64Encoder("".concat(user, ":").concat(pass))));
            break;
        case 'auto':
            this.username = user;
            this.password = pass;
            break;
        case 'bearer':
            // usage would be .auth(accessToken, { type: 'bearer' })
            this.set('Authorization', "Bearer ".concat(user));
            break;
        default:
            break;
    }
    return this;
};
/**
 * Enable transmission of cookies with x-domain requests.
 *
 * Note that for this to work the origin must not be
 * using "Access-Control-Allow-Origin" with a wildcard,
 * and also must set "Access-Control-Allow-Credentials"
 * to "true".
 *
 * @api public
 */ $5e88713f52453955$var$RequestBase.prototype.withCredentials = function(on) {
    // This is browser-only functionality. Node side is no-op.
    if (on === undefined) on = true;
    this._withCredentials = on;
    return this;
};
/**
 * Set the max redirects to `n`. Does nothing in browser XHR implementation.
 *
 * @param {Number} n
 * @return {Request} for chaining
 * @api public
 */ $5e88713f52453955$var$RequestBase.prototype.redirects = function(n) {
    this._maxRedirects = n;
    return this;
};
/**
 * Maximum size of buffered response body, in bytes. Counts uncompressed size.
 * Default 200MB.
 *
 * @param {Number} n number of bytes
 * @return {Request} for chaining
 */ $5e88713f52453955$var$RequestBase.prototype.maxResponseSize = function(n) {
    if (typeof n !== 'number') throw new TypeError('Invalid argument');
    this._maxResponseSize = n;
    return this;
};
/**
 * Convert to a plain javascript object (not JSON string) of scalar properties.
 * Note as this method is designed to return a useful non-this value,
 * it cannot be chained.
 *
 * @return {Object} describing method, url, and data of this request
 * @api public
 */ $5e88713f52453955$var$RequestBase.prototype.toJSON = function() {
    return {
        method: this.method,
        url: this.url,
        data: this._data,
        headers: this._header
    };
};
/**
 * Send `data` as the request body, defaulting the `.type()` to "json" when
 * an object is given.
 *
 * Examples:
 *
 *       // manual json
 *       request.post('/user')
 *         .type('json')
 *         .send('{"name":"tj"}')
 *         .end(callback)
 *
 *       // auto json
 *       request.post('/user')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // manual x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send('name=tj')
 *         .end(callback)
 *
 *       // auto x-www-form-urlencoded
 *       request.post('/user')
 *         .type('form')
 *         .send({ name: 'tj' })
 *         .end(callback)
 *
 *       // defaults to x-www-form-urlencoded
 *      request.post('/user')
 *        .send('name=tobi')
 *        .send('species=ferret')
 *        .end(callback)
 *
 * @param {String|Object} data
 * @return {Request} for chaining
 * @api public
 */ // eslint-disable-next-line complexity
$5e88713f52453955$var$RequestBase.prototype.send = function(data) {
    var isObject_ = $5FA8u(data);
    var type = this._header['content-type'];
    if (this._formData) throw new Error(".send() can't be used if .attach() or .field() is used. Please use only .send() or only .field() & .attach()");
    if (isObject_ && !this._data) {
        if (Array.isArray(data)) this._data = [];
        else if (!this._isHost(data)) this._data = {};
    } else if (data && this._data && this._isHost(this._data)) throw new Error("Can't merge these send calls");
     // merge
    if (isObject_ && $5FA8u(this._data)) {
        for(var key in data)if (Object.prototype.hasOwnProperty.call(data, key)) this._data[key] = data[key];
    } else if (typeof data === 'string') {
        // default to x-www-form-urlencoded
        if (!type) this.type('form');
        type = this._header['content-type'];
        if (type) type = type.toLowerCase().trim();
        if (type === 'application/x-www-form-urlencoded') this._data = this._data ? "".concat(this._data, "&").concat(data) : data;
        else this._data = (this._data || '') + data;
    } else this._data = data;
    if (!isObject_ || this._isHost(data)) return this;
     // default to json
    if (!type) this.type('json');
    return this;
};
/**
 * Sort `querystring` by the sort function
 *
 *
 * Examples:
 *
 *       // default order
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery()
 *         .end(callback)
 *
 *       // customized sort function
 *       request.get('/user')
 *         .query('name=Nick')
 *         .query('search=Manny')
 *         .sortQuery(function(a, b){
 *           return a.length - b.length;
 *         })
 *         .end(callback)
 *
 *
 * @param {Function} sort
 * @return {Request} for chaining
 * @api public
 */ $5e88713f52453955$var$RequestBase.prototype.sortQuery = function(sort) {
    // _sort default to true but otherwise can be a function or boolean
    this._sort = typeof sort === 'undefined' ? true : sort;
    return this;
};
/**
 * Compose querystring to append to req.url
 *
 * @api private
 */ $5e88713f52453955$var$RequestBase.prototype._finalizeQueryString = function() {
    var query = this._query.join('&');
    if (query) this.url += (this.url.includes('?') ? '&' : '?') + query;
    this._query.length = 0; // Makes the call idempotent
    if (this._sort) {
        var index = this.url.indexOf('?');
        if (index >= 0) {
            var queryArray = this.url.slice(index + 1).split('&');
            if (typeof this._sort === 'function') queryArray.sort(this._sort);
            else queryArray.sort();
            this.url = this.url.slice(0, index) + '?' + queryArray.join('&');
        }
    }
}; // For backwards compat only
$5e88713f52453955$var$RequestBase.prototype._appendQueryString = function() {
    console.warn('Unsupported');
};
/**
 * Invoke callback with timeout error.
 *
 * @api private
 */ $5e88713f52453955$var$RequestBase.prototype._timeoutError = function(reason, timeout, errno) {
    if (this._aborted) return;
    var err = new Error("".concat(reason + timeout, "ms exceeded"));
    err.timeout = timeout;
    err.code = 'ECONNABORTED';
    err.errno = errno;
    this.timedout = true;
    this.timedoutError = err;
    this.abort();
    this.callback(err);
};
$5e88713f52453955$var$RequestBase.prototype._setTimeouts = function() {
    var self = this; // deadline
    if (this._timeout && !this._timer) this._timer = setTimeout(function() {
        self._timeoutError('Timeout of ', self._timeout, 'ETIME');
    }, this._timeout);
     // response timeout
    if (this._responseTimeout && !this._responseTimeoutTimer) this._responseTimeoutTimer = setTimeout(function() {
        self._timeoutError('Response timeout of ', self._responseTimeout, 'ETIMEDOUT');
    }, this._responseTimeout);
};

});
parcelRegister("5FA8u", function(module, exports) {
"use strict";
function $420ccfeaec93f19c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $420ccfeaec93f19c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $420ccfeaec93f19c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $420ccfeaec93f19c$var$_typeof(obj);
}
/**
 * Check if `obj` is an object.
 *
 * @param {Object} obj
 * @return {Boolean}
 * @api private
 */ function $420ccfeaec93f19c$var$isObject(obj) {
    return obj !== null && $420ccfeaec93f19c$var$_typeof(obj) === 'object';
}
module.exports = $420ccfeaec93f19c$var$isObject;

});


parcelRegister("5w7q4", function(module, exports) {
"use strict";

var $bHirz = parcelRequire("bHirz");
/**
 * Expose `ResponseBase`.
 */ module.exports = $4045b24947ba24e2$var$ResponseBase;
/**
 * Initialize a new `ResponseBase`.
 *
 * @api public
 */ function $4045b24947ba24e2$var$ResponseBase(obj) {
    if (obj) return $4045b24947ba24e2$var$mixin(obj);
}
/**
 * Mixin the prototype properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $4045b24947ba24e2$var$mixin(obj) {
    for(var key in $4045b24947ba24e2$var$ResponseBase.prototype)if (Object.prototype.hasOwnProperty.call($4045b24947ba24e2$var$ResponseBase.prototype, key)) obj[key] = $4045b24947ba24e2$var$ResponseBase.prototype[key];
    return obj;
}
/**
 * Get case-insensitive `field` value.
 *
 * @param {String} field
 * @return {String}
 * @api public
 */ $4045b24947ba24e2$var$ResponseBase.prototype.get = function(field) {
    return this.header[field.toLowerCase()];
};
/**
 * Set header related properties:
 *
 *   - `.type` the content type without params
 *
 * A response of "Content-Type: text/plain; charset=utf-8"
 * will provide you with a `.type` of "text/plain".
 *
 * @param {Object} header
 * @api private
 */ $4045b24947ba24e2$var$ResponseBase.prototype._setHeaderProperties = function(header) {
    // TODO: moar!
    // TODO: make this a util
    // content-type
    var ct = header['content-type'] || '';
    this.type = $bHirz.type(ct); // params
    var params = $bHirz.params(ct);
    for(var key in params)if (Object.prototype.hasOwnProperty.call(params, key)) this[key] = params[key];
    this.links = {}; // links
    try {
        if (header.link) this.links = $bHirz.parseLinks(header.link);
    } catch (_unused) {}
};
/**
 * Set flags such as `.ok` based on `status`.
 *
 * For example a 2xx response will give you a `.ok` of __true__
 * whereas 5xx will be __false__ and `.error` will be __true__. The
 * `.clientError` and `.serverError` are also available to be more
 * specific, and `.statusType` is the class of error ranging from 1..5
 * sometimes useful for mapping respond colors etc.
 *
 * "sugar" properties are also defined for common cases. Currently providing:
 *
 *   - .noContent
 *   - .badRequest
 *   - .unauthorized
 *   - .notAcceptable
 *   - .notFound
 *
 * @param {Number} status
 * @api private
 */ $4045b24947ba24e2$var$ResponseBase.prototype._setStatusProperties = function(status) {
    var type = status / 100 | 0; // status / class
    this.statusCode = status;
    this.status = this.statusCode;
    this.statusType = type; // basics
    this.info = type === 1;
    this.ok = type === 2;
    this.redirect = type === 3;
    this.clientError = type === 4;
    this.serverError = type === 5;
    this.error = type === 4 || type === 5 ? this.toError() : false; // sugar
    this.created = status === 201;
    this.accepted = status === 202;
    this.noContent = status === 204;
    this.badRequest = status === 400;
    this.unauthorized = status === 401;
    this.notAcceptable = status === 406;
    this.forbidden = status === 403;
    this.notFound = status === 404;
    this.unprocessableEntity = status === 422;
};

});
parcelRegister("bHirz", function(module, exports) {

$parcel$export(module.exports, "type", () => $8842045ff4068555$export$bf9fb029d174d554, (v) => $8842045ff4068555$export$bf9fb029d174d554 = v);
$parcel$export(module.exports, "params", () => $8842045ff4068555$export$281ad3752a540efe, (v) => $8842045ff4068555$export$281ad3752a540efe = v);
$parcel$export(module.exports, "parseLinks", () => $8842045ff4068555$export$255722312ba7ba74, (v) => $8842045ff4068555$export$255722312ba7ba74 = v);
/**
 * Return the mime type for the given `str`.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */ var $8842045ff4068555$export$bf9fb029d174d554;
/**
 * Return header field parameters.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */ var $8842045ff4068555$export$281ad3752a540efe;
/**
 * Parse Link header fields.
 *
 * @param {String} str
 * @return {Object}
 * @api private
 */ var $8842045ff4068555$export$255722312ba7ba74;
/**
 * Strip content related fields from `header`.
 *
 * @param {Object} header
 * @return {Object} header
 * @api private
 */ var $8842045ff4068555$export$bbc652556e2dc9ed;
"use strict";
function $8842045ff4068555$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = $8842045ff4068555$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = o[Symbol.iterator]();
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $8842045ff4068555$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8842045ff4068555$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8842045ff4068555$var$_arrayLikeToArray(o, minLen);
}
function $8842045ff4068555$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$8842045ff4068555$export$bf9fb029d174d554 = function(str) {
    return str.split(/ *; */).shift();
};
$8842045ff4068555$export$281ad3752a540efe = function(val) {
    var obj = {};
    var _iterator = $8842045ff4068555$var$_createForOfIteratorHelper(val.split(/ *; */)), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var str = _step.value;
            var parts = str.split(/ *= */);
            var key = parts.shift();
            var _val = parts.shift();
            if (key && _val) obj[key] = _val;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return obj;
};
$8842045ff4068555$export$255722312ba7ba74 = function(val) {
    var obj = {};
    var _iterator2 = $8842045ff4068555$var$_createForOfIteratorHelper(val.split(/ *, */)), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var str = _step2.value;
            var parts = str.split(/ *; */);
            var url = parts[0].slice(1, -1);
            var rel = parts[1].split(/ *= */)[1].slice(1, -1);
            obj[rel] = url;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return obj;
};
$8842045ff4068555$export$bbc652556e2dc9ed = function(header, changesOrigin) {
    delete header['content-type'];
    delete header['content-length'];
    delete header['transfer-encoding'];
    delete header.host; // secuirty
    if (changesOrigin) {
        delete header.authorization;
        delete header.cookie;
    }
    return header;
};

});


parcelRegister("baedc", function(module, exports) {
"use strict";
function $820ba70b8fa1d91b$var$_toConsumableArray(arr) {
    return $820ba70b8fa1d91b$var$_arrayWithoutHoles(arr) || $820ba70b8fa1d91b$var$_iterableToArray(arr) || $820ba70b8fa1d91b$var$_unsupportedIterableToArray(arr) || $820ba70b8fa1d91b$var$_nonIterableSpread();
}
function $820ba70b8fa1d91b$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $820ba70b8fa1d91b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $820ba70b8fa1d91b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $820ba70b8fa1d91b$var$_arrayLikeToArray(o, minLen);
}
function $820ba70b8fa1d91b$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $820ba70b8fa1d91b$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $820ba70b8fa1d91b$var$_arrayLikeToArray(arr);
}
function $820ba70b8fa1d91b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $820ba70b8fa1d91b$var$Agent() {
    this._defaults = [];
}
[
    'use',
    'on',
    'once',
    'set',
    'query',
    'type',
    'accept',
    'auth',
    'withCredentials',
    'sortQuery',
    'retry',
    'ok',
    'redirects',
    'timeout',
    'buffer',
    'serialize',
    'parse',
    'ca',
    'key',
    'pfx',
    'cert',
    'disableTLSCerts'
].forEach(function(fn) {
    // Default setting for all requests from this agent
    $820ba70b8fa1d91b$var$Agent.prototype[fn] = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        this._defaults.push({
            fn: fn,
            args: args
        });
        return this;
    };
});
$820ba70b8fa1d91b$var$Agent.prototype._setDefaults = function(req) {
    this._defaults.forEach(function(def) {
        req[def.fn].apply(req, $820ba70b8fa1d91b$var$_toConsumableArray(def.args));
    });
};
module.exports = $820ba70b8fa1d91b$var$Agent;

});



parcelRegister("lsr9y", function(module, exports) {
module.exports = JSON.parse('{"bg":{"breadcrumb":{"admin":"\u0410\u0434\u043C\u0438\u043D","home":"\u041D\u0430\u0447\u0430\u043B\u043E","pages":"\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0438","articles":"\u0421\u0442\u0430\u0442\u0438\u0438","events":"\u0421\u044A\u0431\u0438\u0442\u0438\u044F","calendar":"\u041A\u0430\u043B\u0435\u043D\u0434\u0430\u0440","media":"\u041C\u0435\u0434\u0438\u044F","users":"\u041F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0438","profiles":"\u041F\u0440\u043E\u0444\u0438\u043B\u0438","contacts":"\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u0438","contact":"\u041A\u043E\u043D\u0442\u0430\u043A\u0442","new":"\u041D\u043E\u0432","configure":"\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438"},"common":{"login":{"email":"\u041F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0441\u043A\u043E \u0438\u043C\u0435","password":"\u041F\u0430\u0440\u043E\u043B\u0430"},"actions":{"save":"\u0417\u0430\u043F\u0430\u0437\u0438","cancel":"\u041E\u0442\u043A\u0430\u0437","create":"\u0421\u044A\u0437\u0434\u0430\u0439","add":"\u0414\u043E\u0431\u0430\u0432\u0438","actions":"\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u044F","na":"\u043D/\u0434","copy":"\u041A\u043E\u043F\u0438\u0440\u0430\u0439","copied":"\u041A\u043E\u043F\u0438\u0440\u0430\u043D\u043E"},"titles":{"home":"\u041D\u0430\u0447\u0430\u043B\u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430","admin":"\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F"}},"enums":{"status":{"draft":"\u0427\u0435\u0440\u043D\u043E\u0432\u0430","published":"\u041F\u0443\u0431\u043B\u0438\u043A\u0443\u0432\u0430\u043D","archived":"\u0410\u0440\u0445\u0438\u0432","canceled":"\u041E\u0442\u043C\u0435\u043D\u0435\u043D","new":"\u041D\u043E\u0432","read":"\u041F\u0440\u043E\u0447\u0435\u0442\u0435\u043D","active":"\u0410\u043A\u0442\u0438\u0432\u0435\u043D","inactive":"\u041D\u0435\u0430\u043A\u0442\u0438\u0432\u0435\u043D"},"reason":{"general":"\u041E\u0431\u0449\u043E","event":"\u0417\u0430\u043F\u0438\u0442\u0432\u0430\u043D\u0435 \u0437\u0430 \u0441\u044A\u0431\u0438\u0442\u0438\u0435"},"role":{"user":"\u041F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B","admin":"\u0410\u0434\u043C\u0438\u043D","editor":"\u0420\u0435\u0434\u0430\u043A\u0442\u043E\u0440","organizer":"\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440","lecturer":"\u041B\u0435\u043A\u0442\u043E\u0440","performer":"\u0418\u0437\u043F\u044A\u043B\u043D\u0438\u0442\u0435\u043B"},"roles":{"organizer":"\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440","lecturer":"\u041B\u0435\u043A\u0442\u043E\u0440","performer":"\u0418\u0437\u043F\u044A\u043B\u043D\u0438\u0442\u0435\u043B","venue":"\u041C\u044F\u0441\u0442\u043E","community":"\u041E\u0431\u0449\u043D\u043E\u0441\u0442","musician":"\u041C\u0443\u0437\u0438\u043A\u0430\u043D\u0442","maker":"\u041C\u0435\u0439\u043A\u044A\u0440","developer":"\u0420\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A","graphics artist":"\u0413\u0440\u0430\u0444\u0438\u0447\u0435\u043D \u0434\u0438\u0437\u0430\u0439\u043D\u0435\u0440","vibe coder":"Vibe coder"},"type":{"jam-session":"\u0414\u0436\u0435\u043C \u0441\u0435\u0441\u0438\u044F","festival":"\u0424\u0435\u0441\u0442\u0438\u0432\u0430\u043B","performance":"\u041F\u044A\u0440\u0444\u043E\u0440\u043C\u0430\u043D\u0441","talks":"\u0414\u0438\u0441\u043A\u0443\u0441\u0438\u044F","conference":"\u041A\u043E\u043D\u0444\u0435\u0440\u0435\u043D\u0446\u0438\u044F","lecture":"\u041B\u0435\u043A\u0446\u0438\u044F","tinkering":"\u0422\u0438\u043D\u043A\u044A\u0440\u0438\u043D\u0433","workshop":"\u0423\u043E\u0440\u043A\u0448\u043E\u043F","facebook":"Facebook","instagram":"Instagram","soundcloud":"SoundCloud","mixcloud":"Mixcloud","github":"GitHub","bandcamp":"Bandcamp","youtube":"YouTube","website":"\u0423\u0435\u0431\u0441\u0430\u0439\u0442","other":"\u0414\u0440\u0443\u0433\u043E","organizer":"\u041E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0442\u043E\u0440","lecturer":"\u041B\u0435\u043A\u0442\u043E\u0440","performer":"\u0418\u0437\u043F\u044A\u043B\u043D\u0438\u0442\u0435\u043B","venue":"\u041C\u044F\u0441\u0442\u043E","community":"\u041E\u0431\u0449\u043D\u043E\u0441\u0442","musician":"\u041C\u0443\u0437\u0438\u043A\u0430\u043D\u0442","maker":"\u041C\u0435\u0439\u043A\u044A\u0440","developer":"\u0420\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u0447\u0438\u043A","graphics artist":"\u0413\u0440\u0430\u0444\u0438\u0447\u0435\u043D \u0434\u0438\u0437\u0430\u0439\u043D\u0435\u0440","vibe coder":"Vibe coder"},"source":{"upload":"\u041A\u0430\u0447\u0432\u0430\u043D\u0435","soundcloud":"SoundCloud","mixcloud":"Mixcloud","youtube":"YouTube","vimeo":"Vimeo","external":"\u0412\u044A\u043D\u0448\u0435\u043D"}},"fields":{"_id":"#","fullName":"\u0418\u043C\u0435","email":"\u0418\u043C\u0435\u0439\u043B","role":"\u0420\u043E\u043B\u044F","slug":"\u0421\u043B\u044A\u0433","avatar":"\u0410\u0432\u0430\u0442\u0430\u0440","about":"\u0417\u0430 \u043C\u0435\u043D","roles":"\u0420\u043E\u043B\u0438","status":"\u0421\u0442\u0430\u0442\u0443\u0441","links":"\u0412\u0440\u044A\u0437\u043A\u0438","tracks":"\u041F\u0430\u0440\u0447\u0435\u0442\u0430","videos":"\u0412\u0438\u0434\u0435\u0430","pictures":"\u0421\u043D\u0438\u043C\u043A\u0438","user":"\u041F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B","title":"\u0417\u0430\u0433\u043B\u0430\u0432\u0438\u0435","path":"\u041F\u044A\u0442","content":"\u0421\u044A\u0434\u044A\u0440\u0436\u0430\u043D\u0438\u0435","text":"\u0422\u0435\u043A\u0441\u0442","author":"\u0410\u0432\u0442\u043E\u0440","categories":"\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438","pinned":"\u0417\u0430\u043A\u0430\u0447\u0435\u043D","type":"\u0422\u0438\u043F","source":"\u0418\u0437\u0442\u043E\u0447\u043D\u0438\u043A","url":"URL","duration":"\u041F\u0440\u043E\u0434\u044A\u043B\u0436\u0438\u0442\u0435\u043B\u043D\u043E\u0441\u0442","startDateTime":"\u041D\u0430\u0447\u0430\u043B\u043E","endDateTime":"\u041A\u0440\u0430\u0439","poster":"\u041F\u043E\u0441\u0442\u0435\u0440","timezone":"\u0427\u0430\u0441\u043E\u0432\u0430 \u0437\u043E\u043D\u0430","venue":"\u041C\u044F\u0441\u0442\u043E","address":"\u0410\u0434\u0440\u0435\u0441","street":"\u0423\u043B\u0438\u0446\u0430","city":"\u0413\u0440\u0430\u0434","zip":"\u041F\u041A","country":"\u0414\u044A\u0440\u0436\u0430\u0432\u0430","geo":"\u041A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442\u0438","lat":"\u0413\u0435\u043E\u0433\u0440\u0430\u0444\u0441\u043A\u0430 \u0448\u0438\u0440\u0438\u043D\u0430","lng":"\u0413\u0435\u043E\u0433\u0440\u0430\u0444\u0441\u043A\u0430 \u0434\u044A\u043B\u0436\u0438\u043D\u0430","name":"\u0418\u043C\u0435","participants":"\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u0446\u0438","subEvents":"\u041F\u043E\u0434\u0441\u044A\u0431\u0438\u0442\u0438\u044F","profile":"\u041F\u0440\u043E\u0444\u0438\u043B","reason":"\u041F\u043E\u0432\u043E\u0434","event":"\u0421\u044A\u0431\u0438\u0442\u0438\u0435","eventTitle":"\u0421\u044A\u0431\u0438\u0442\u0438\u0435","message":"\u0421\u044A\u043E\u0431\u0449\u0435\u043D\u0438\u0435","emailSent":"\u0418\u043C\u0435\u0439\u043B \u0438\u0437\u043F\u0440\u0430\u0442\u0435\u043D","createdBy":"\u0421\u044A\u0437\u0434\u0430\u0434\u0435\u043D\u043E \u043E\u0442","createdOn":"\u0421\u044A\u0437\u0434\u0430\u0434\u0435\u043D\u043E \u043D\u0430","registerDate":"\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F","lastLoginDate":"\u041F\u043E\u0441\u043B\u0435\u0434\u0435\u043D \u0432\u0445\u043E\u0434","password":"\u041F\u0430\u0440\u043E\u043B\u0430","passwordConfirm":"\u041F\u043E\u0442\u0432\u044A\u0440\u0434\u0438 \u043F\u0430\u0440\u043E\u043B\u0430"},"menu":{"front":[{"page":"home","href":"/","title":"\u041D\u0430\u0447\u0430\u043B\u043E"},{"page":"about","href":"/about","title":"\u0417\u0430 \u041D\u0430\u0441"},{"page":"calendar","href":"/calendar","title":"\u041A\u0430\u043B\u0435\u043D\u0434\u0430\u0440"},{"page":"profiles","href":"/profiles","title":"\u041E\u0431\u0449\u043D\u043E\u0441\u0442"},{"page":"contact","href":"/contact","title":"\u041A\u043E\u043D\u0442\u0430\u043A\u0442"}],"admin":[{"page":"admin.home","href":"/admin","title":"\u0422\u0430\u0431\u043B\u043E"},{"page":"admin.pages","href":"/admin/pages","title":"\u0421\u0442\u0440\u0430\u043D\u0438\u0446\u0438"},{"page":"admin.articles","href":"/admin/articles","title":"\u0421\u0442\u0430\u0442\u0438\u0438"},{"page":"admin.events","href":"/admin/events","title":"\u0421\u044A\u0431\u0438\u0442\u0438\u044F"},{"page":"admin.contacts","href":"/admin/contacts","title":"\u041A\u043E\u043D\u0442\u0430\u043A\u0442\u0438"},{"page":"admin.media","href":"/admin/media","title":"\u0421\u043D\u0438\u043C\u043A\u0438 \u0438 \u0412\u0438\u0434\u0435\u043E"},{"page":"admin.users","href":"/admin/users","title":"\u041F\u043E\u0442\u0440\u0435\u0431\u0438\u0442\u0435\u043B\u0438"},{"page":"admin.profiles","href":"/admin/profiles","title":"\u041F\u0440\u043E\u0444\u0438\u043B\u0438"}]},"pages":{"about":{"title":"\u0417\u0430 \u041D\u0430\u0441","text":"MusicTechBG \u0435 \u043E\u0431\u0449\u043D\u043E\u0441\u0442 \u043E\u043A\u043E\u043B\u043E \u043C\u0443\u0437\u0438\u043A\u0430\u043B\u043D\u0438\u0442\u0435 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0438 \u2014 \u0441\u0438\u043D\u0442\u0435\u0437, \u0437\u0432\u0443\u043A, \u0438\u043D\u0441\u0442\u0440\u0443\u043C\u0435\u043D\u0442\u0438 \u0438 \u0441\u043F\u043E\u0434\u0435\u043B\u044F\u043D\u0435 \u043D\u0430 \u0437\u043D\u0430\u043D\u0438\u044F."},"calendar":{"title":"\u041A\u0430\u043B\u0435\u043D\u0434\u0430\u0440","empty":"\u041D\u044F\u043C\u0430 \u043F\u0443\u0431\u043B\u0438\u043A\u0443\u0432\u0430\u043D\u0438 \u0441\u044A\u0431\u0438\u0442\u0438\u044F \u0437\u0430\u0441\u0435\u0433\u0430.","untitled":"\u0421\u044A\u0431\u0438\u0442\u0438\u0435 \u0431\u0435\u0437 \u0437\u0430\u0433\u043B\u0430\u0432\u0438\u0435","upcoming":"\u041F\u0440\u0435\u0434\u0441\u0442\u043E\u044F\u0449\u0438","past":"\u041C\u0438\u043D\u0430\u043B\u0438","rss":"RSS \u0435\u043C\u0438\u0441\u0438\u044F","ics":"\u0410\u0431\u043E\u043D\u0438\u0440\u0430\u0439 \u0441\u0435 \u0432 \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440 (iCal)","addToCalendar":"\u0414\u043E\u0431\u0430\u0432\u0438 \u0432 \u043A\u0430\u043B\u0435\u043D\u0434\u0430\u0440"},"contact":{"title":"\u041A\u043E\u043D\u0442\u0430\u043A\u0442","intro":"\u041F\u0438\u0448\u0435\u0442\u0435 \u043D\u0438 \u2014 \u043E\u0431\u0449\u0438 \u0432\u044A\u043F\u0440\u043E\u0441\u0438 \u0438\u043B\u0438 \u043E\u0442\u043D\u043E\u0441\u043D\u043E \u043F\u0440\u0435\u0434\u0441\u0442\u043E\u044F\u0449\u043E \u0441\u044A\u0431\u0438\u0442\u0438\u0435.","name":"\u0418\u043C\u0435","email":"\u0418\u043C\u0435\u0439\u043B","reason":"\u041F\u043E\u0432\u043E\u0434","reasonGeneral":"\u041E\u0431\u0449\u043E","reasonEvent":"\u0417\u0430\u043F\u0438\u0442\u0432\u0430\u043D\u0435 \u0437\u0430 \u0441\u044A\u0431\u0438\u0442\u0438\u0435","event":"\u0421\u044A\u0431\u0438\u0442\u0438\u0435","eventPlaceholder":"\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u043F\u0440\u0435\u0434\u0441\u0442\u043E\u044F\u0449\u043E \u0441\u044A\u0431\u0438\u0442\u0438\u0435\u2026","eventEmpty":"\u041D\u044F\u043C\u0430 \u043F\u0440\u0435\u0434\u0441\u0442\u043E\u044F\u0449\u0438 \u0441\u044A\u0431\u0438\u0442\u0438\u044F","eventEmptyHint":"\u041D\u044F\u043C\u0430 \u043F\u0443\u0431\u043B\u0438\u043A\u0443\u0432\u0430\u043D\u0438 \u043F\u0440\u0435\u0434\u0441\u0442\u043E\u044F\u0449\u0438 \u0441\u044A\u0431\u0438\u0442\u0438\u044F \u0432 \u043C\u043E\u043C\u0435\u043D\u0442\u0430.","message":"\u0421\u044A\u043E\u0431\u0449\u0435\u043D\u0438\u0435","send":"\u0418\u0437\u043F\u0440\u0430\u0442\u0438","sending":"\u0418\u0437\u043F\u0440\u0430\u0449\u0430\u043D\u0435\u2026","thanks":"\u0411\u043B\u0430\u0433\u043E\u0434\u0430\u0440\u0438\u043C \u2014 \u0449\u0435 \u0441\u0435 \u0441\u0432\u044A\u0440\u0436\u0435\u043C \u0441 \u0432\u0430\u0441.","error":"\u041D\u0435\u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0438\u0437\u043F\u0440\u0430\u0449\u0430\u043D\u0435. \u041E\u043F\u0438\u0442\u0430\u0439\u0442\u0435 \u043E\u0442\u043D\u043E\u0432\u043E.","untitled":"\u0421\u044A\u0431\u0438\u0442\u0438\u0435 \u0431\u0435\u0437 \u0437\u0430\u0433\u043B\u0430\u0432\u0438\u0435"},"home":{"title":"\u0414\u043E\u0431\u0440\u0435 \u0434\u043E\u0448\u043B\u0438 \u0432 MusicTechBG","text":"\u0414\u043E\u0431\u0440\u0435 \u0434\u043E\u0448\u043B\u0438 \u0432 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0430\u0442\u0430 \u043D\u0430 MusicTechBG.\\n\\n\u0422\u0443\u043A \u0449\u0435 \u043D\u0430\u043C\u0435\u0440\u0438\u0442\u0435 \u043F\u043E\u043B\u0435\u0437\u043D\u0438 \u0441\u0442\u0430\u0442\u0438\u0438, \u0443\u0440\u043E\u0446\u0438, \u0432\u0440\u044A\u0437\u043A\u0438 \u043D\u0430 \u0440\u0430\u0437\u043B\u0438\u0447\u043D\u0438 \u0442\u0435\u043C\u0438, \u0441\u0432\u044A\u0440\u0437\u0430\u043D\u0438 \u0441 \u043C\u0443\u0437\u0438\u043A\u0430\u043B\u043D\u0438\u0442\u0435 \u0442\u0435\u0445\u043D\u043E\u043B\u043E\u0433\u0438\u0438.\\n\\n\u0414\u043E\u0441\u0442\u0430 \u0447\u0435\u0441\u0442\u043E \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0438\u0440\u0430\u043C\u0435 \u0438 \u0441\u044A\u0431\u0438\u0442\u0438\u044F, \u043D\u0430 \u043A\u043E\u0438\u0442\u043E \u0441\u0435 \u0441\u044A\u0431\u0438\u0440\u0430\u043C\u0435 \u0438 \u0434\u0438\u0441\u043A\u0443\u0442\u0438\u0440\u0430\u043C\u0435 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u0438 \u043D\u043E\u0432\u043E\u0441\u0442\u0438, \u043D\u044F\u043A\u043E\u0439 \u043C\u043E\u0436\u0435 \u0434\u0430 \u0440\u0430\u0437\u043A\u0430\u0436\u0435 \u0437\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0442\u0435 \u0441\u0438 \u0434\u0440\u044A\u0437\u043D\u043E\u0432\u0435\u043D\u0438\u044F. \u041D\u043E\u0441\u0438\u043C\u0435 \u0441\u0438 \u043D\u043E\u0432\u0438 \u0438 \u043D\u0435 \u0442\u043E\u043B\u043A\u043E\u0432\u0430 \u043D\u043E\u0432\u0438 \u0434\u0436\u0430\u0434\u0436\u0438 \u0438 \u043F\u043E\u043D\u044F\u043A\u043E\u0433\u0430 \u0441\u0442\u0430\u0432\u0430 \u0434\u0436\u0435\u043C."}},"widget":{"addressMap":{"title":"\u0410\u0434\u0440\u0435\u0441","mapTitle":"\u041A\u0430\u0440\u0442\u0430","openOsm":"\u041E\u0442\u0432\u043E\u0440\u0438 \u0432 OpenStreetMap"},"eventsCarousel":{"cta":{"talks":"\u043A\u044A\u043C \u043B\u0435\u043A\u0446\u0438\u044F\u0442\u0430","lecture":"\u043A\u044A\u043C \u043B\u0435\u043A\u0446\u0438\u044F\u0442\u0430","festival":"\u043A\u044A\u043C \u0444\u0435\u0441\u0442\u0438\u0432\u0430\u043B\u0430","tinkering":"\u043A\u044A\u043C Tinkerday","jam-session":"\u043A\u044A\u043C \u0434\u0436\u0435\u043C\u0430","default":"\u043A\u044A\u043C \u0441\u044A\u0431\u0438\u0442\u0438\u0435\u0442\u043E"},"regular":"\u0440\u0435\u0433\u0443\u043B\u044F\u0440\u0435\u043D","empty":"\u041D\u044F\u043C\u0430 \u043F\u0440\u0435\u0434\u0441\u0442\u043E\u044F\u0449\u0438 \u0441\u044A\u0431\u0438\u0442\u0438\u044F \u0437\u0430\u0441\u0435\u0433\u0430.","prev":"\u041F\u0440\u0435\u0434\u0438\u0448\u043D\u043E","next":"\u0421\u043B\u0435\u0434\u0432\u0430\u0449\u043E"},"pictureList":"\u0421\u043D\u0438\u043C\u043A\u0438","recentEvents":"\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438 \u0441\u044A\u0431\u0438\u0442\u0438\u044F","trackList":"\u0422\u0440\u0430\u043A\u043E\u0432\u0435","upcomingEvents":"\u041F\u0440\u0435\u0434\u0441\u0442\u043E\u044F\u0449\u0438 \u0441\u044A\u0431\u0438\u0442\u0438\u044F","videoList":"\u0412\u0438\u0434\u0435\u043E"}},"en":{"breadcrumb":{"admin":"Admin","home":"Home","pages":"Pages","articles":"Articles","events":"Events","calendar":"Calendar","media":"Media","users":"Users","profiles":"Profiles","contacts":"Contacts","contact":"Contact","new":"New","configure":"Configure"},"common":{"login":{"email":"Username","password":"Password"},"actions":{"save":"Save","cancel":"Cancel","create":"Create","add":"Add","actions":"Actions","na":"n/a","copy":"Copy","copied":"Copied"},"titles":{"home":"Home page","admin":"Administration"}},"enums":{"status":{"draft":"Draft","published":"Published","archived":"Archived","canceled":"Canceled","new":"New","read":"Read","active":"Active","inactive":"Inactive"},"reason":{"general":"General","event":"Event enquiry"},"role":{"user":"User","admin":"Admin","editor":"Editor","organizer":"Organizer","lecturer":"Lecturer","performer":"Performer"},"roles":{"organizer":"Organizer","lecturer":"Lecturer","performer":"Performer","venue":"Venue","community":"Community","musician":"Musician","maker":"Maker","developer":"Developer","graphics artist":"Graphics artist","vibe coder":"Vibe coder"},"type":{"jam-session":"Jam session","festival":"Festival","performance":"Performance","talks":"Talks","conference":"Conference","lecture":"Lecture","tinkering":"Tinkering","workshop":"Workshop","facebook":"Facebook","instagram":"Instagram","soundcloud":"SoundCloud","mixcloud":"Mixcloud","github":"GitHub","bandcamp":"Bandcamp","youtube":"YouTube","website":"Website","other":"Other","organizer":"Organizer","lecturer":"Lecturer","performer":"Performer","venue":"Venue","community":"Community","musician":"Musician","maker":"Maker","developer":"Developer","graphics artist":"Graphics artist","vibe coder":"Vibe coder"},"source":{"upload":"Upload","soundcloud":"SoundCloud","mixcloud":"Mixcloud","youtube":"YouTube","vimeo":"Vimeo","external":"External"}},"fields":{"_id":"#","fullName":"Full Name","email":"Email","role":"Role","slug":"Slug","avatar":"Avatar","about":"About","roles":"Roles","status":"Status","links":"Links","tracks":"Tracks","videos":"Videos","pictures":"Pictures","user":"User","title":"Title","path":"Path","content":"Content","text":"Text","author":"Author","categories":"Categories","pinned":"Pinned","type":"Type","source":"Source","url":"URL","duration":"Duration","startDateTime":"Start","endDateTime":"End","poster":"Poster","timezone":"Timezone","venue":"Venue","address":"Address","street":"Street","city":"City","zip":"ZIP","country":"Country","geo":"Coordinates","lat":"Latitude","lng":"Longitude","name":"Name","participants":"Participants","subEvents":"Sub-events","profile":"Profile","reason":"Reason","event":"Event","eventTitle":"Event","message":"Message","emailSent":"Email sent","createdBy":"Created By","createdOn":"Created On","registerDate":"Registered","lastLoginDate":"Last Login","password":"Password","passwordConfirm":"Confirm Password"},"menu":{"front":[{"page":"home","href":"/","title":"Home"},{"page":"about","href":"/about","title":"About"},{"page":"calendar","href":"/calendar","title":"Calendar"},{"page":"profiles","href":"/profiles","title":"Community"},{"page":"contact","href":"/contact","title":"Contact"}],"admin":[{"page":"admin.home","href":"/admin","title":"Dashboard"},{"page":"admin.pages","href":"/admin/pages","title":"Pages"},{"page":"admin.articles","href":"/admin/articles","title":"Articles"},{"page":"admin.events","href":"/admin/events","title":"Events"},{"page":"admin.contacts","href":"/admin/contacts","title":"Contacts"},{"page":"admin.media","href":"/admin/media","title":"Photos & Video"},{"page":"admin.users","href":"/admin/users","title":"Users"},{"page":"admin.profiles","href":"/admin/profiles","title":"Profiles"}]},"pages":{"about":{"title":"About Us","text":"MusicTechBG is a community around music technology \u2014 synthesis, sound, instruments, and sharing knowledge."},"calendar":{"title":"Calendar","empty":"No published events yet.","untitled":"Untitled event","upcoming":"Upcoming","past":"Past","rss":"RSS feed","ics":"Subscribe in calendar (iCal)","addToCalendar":"Add to calendar"},"contact":{"title":"Contact","intro":"Send us a message \u2014 general questions or about an upcoming event.","name":"Name","email":"Email","reason":"Reason","reasonGeneral":"General","reasonEvent":"Event enquiry","event":"Event","eventPlaceholder":"Select an upcoming event\u2026","eventEmpty":"No upcoming events","eventEmptyHint":"No published upcoming events right now.","message":"Message","send":"Send","sending":"Sending\u2026","thanks":"Thanks \u2014 we will get back to you.","error":"Could not send. Please try again.","untitled":"Untitled event"},"home":{"title":"Welcome to MusicTechBG","text":"Welcome to the MusicTechBG site.\\n\\nHere you will find useful articles, tutorials, and links on topics related to music technology.\\n\\nWe often organize events where we meet, discuss interesting news, and share recent experiments. We bring new and not-so-new gadgets, and sometimes it turns into a jam."}},"widget":{"addressMap":{"title":"Address","mapTitle":"Map","openOsm":"Open in OpenStreetMap"},"eventsCarousel":{"cta":{"talks":"to the lecture","lecture":"to the lecture","festival":"to the festival","tinkering":"to Tinkerday","jam-session":"to the jam","default":"to the event"},"regular":"regular","empty":"No upcoming events yet.","prev":"Previous","next":"Next"},"pictureList":"Pictures","recentEvents":"Recent events","trackList":"Tracks","upcomingEvents":"Upcoming events","videoList":"Videos"}}}');

});

parcelRegister("9XpJf", function(module, exports) {
module.exports = JSON.parse("{\"views\":{\"articles\":{\"list\":{\"columns\":[\"title\",\"author\",\"categories\",\"status\",\"createdOn\",\"createdBy\"]}},\"events\":{\"list\":{\"columns\":[\"title\",\"type\",{\"name\":\"startDateTime\",\"title\":\"start\"},{\"name\":\"endDateTime\",\"title\":\"end\"},\"status\",\"createdOn\",\"createdBy\"]}},\"profiles\":{\"list\":{\"columns\":[\"fullName\",\"roles\",\"status\",\"createdOn\",\"createdBy\"]}},\"users\":{\"list\":{\"columns\":[\"fullName\",\"email\",\"role\",\"status\",\"registerDate\",\"lastLoginDate\"]}},\"contacts\":{\"list\":{\"columns\":[\"name\",\"email\",\"reason\",\"eventTitle\",\"status\",\"emailSent\",\"createdOn\"]}}},\"collections\":{\"users\":{\"model\":\"User\"},\"profiles\":{\"model\":\"Profile\",\"i18n\":[\"fullName\",\"about\"],\"schema\":{\"fullName\":\"Mixed\",\"email\":\"String\",\"slug\":\"String\",\"avatar\":\"String\",\"about\":\"Mixed\",\"roles\":[\"String\"],\"status\":{\"type\":\"String\",\"enum\":[\"draft\",\"published\",\"archived\"],\"default\":\"draft\"},\"address\":{\"street\":\"String\",\"city\":\"String\",\"zip\":\"String\",\"country\":\"String\",\"geo\":{\"lat\":\"Number\",\"lng\":\"Number\"}},\"links\":[{\"type\":{\"type\":\"String\",\"enum\":[\"facebook\",\"instagram\",\"soundcloud\",\"mixcloud\",\"github\",\"bandcamp\",\"youtube\",\"website\",\"other\"]},\"url\":\"String\"}],\"tracks\":[{\"title\":\"String\",\"source\":{\"type\":\"String\",\"enum\":[\"upload\",\"soundcloud\",\"mixcloud\",\"external\"]},\"url\":\"String\",\"duration\":\"Number\"}],\"videos\":[{\"title\":\"String\",\"source\":{\"type\":\"String\",\"enum\":[\"upload\",\"youtube\",\"vimeo\",\"external\"]},\"url\":\"String\"}],\"pictures\":[\"String\"],\"user\":{\"type\":\"ObjectId\",\"ref\":\"User\",\"required\":false},\"createdBy\":{\"type\":\"ObjectId\",\"ref\":\"User\",\"required\":false},\"createdOn\":{\"type\":\"Date\",\"default\":\"Date.now\"}}},\"articles\":{\"model\":\"Article\",\"i18n\":[\"title\",\"text\"],\"schema\":{\"title\":\"Mixed\",\"slug\":\"String\",\"text\":\"Mixed\",\"status\":{\"type\":\"String\",\"enum\":[\"draft\",\"published\"]},\"author\":\"String\",\"categories\":[\"String\"],\"pinned\":\"Boolean\",\"createdBy\":{\"type\":\"ObjectId\",\"ref\":\"User\",\"required\":false},\"createdOn\":{\"type\":\"Date\",\"default\":\"Date.now\"}}},\"events\":{\"model\":\"Event\",\"i18n\":[\"title\",\"text\"],\"schema\":{\"title\":\"Mixed\",\"slug\":\"String\",\"text\":\"Mixed\",\"type\":{\"type\":\"String\",\"enum\":[\"jam-session\",\"festival\",\"performance\",\"talks\",\"conference\",\"lecture\",\"tinkering\",\"workshop\"]},\"startDateTime\":\"Date\",\"endDateTime\":\"Date\",\"timezone\":{\"type\":\"String\",\"default\":\"Europe/Sofia\"},\"poster\":\"String\",\"links\":[\"String\"],\"status\":{\"type\":\"String\",\"enum\":[\"draft\",\"published\",\"archived\",\"canceled\"],\"default\":\"draft\"},\"venue\":{\"profile\":{\"type\":\"ObjectId\",\"ref\":\"Profile\",\"required\":false},\"name\":\"Mixed\",\"address\":{\"street\":\"String\",\"city\":\"String\",\"zip\":\"String\",\"country\":\"String\",\"geo\":{\"lat\":\"Number\",\"lng\":\"Number\"}}},\"participants\":[{\"role\":{\"type\":\"String\",\"enum\":[\"organizer\",\"lecturer\",\"performer\"]},\"profile\":{\"type\":\"ObjectId\",\"ref\":\"Profile\",\"required\":false}}],\"subEvents\":[{\"type\":\"ObjectId\",\"ref\":\"Event\"}],\"createdBy\":{\"type\":\"ObjectId\",\"ref\":\"User\",\"required\":false},\"createdOn\":{\"type\":\"Date\",\"default\":\"Date.now\"}}},\"pages\":{\"model\":\"Page\",\"i18n\":[\"title\",\"content\"],\"schema\":{\"title\":\"Mixed\",\"path\":\"String\",\"content\":\"Mixed\",\"createdBy\":{\"type\":\"ObjectId\",\"ref\":\"User\",\"required\":false},\"createdOn\":{\"type\":\"Date\",\"default\":\"Date.now\"}}},\"contacts\":{\"model\":\"Contact\",\"schema\":{\"name\":\"String\",\"email\":\"String\",\"reason\":{\"type\":\"String\",\"enum\":[\"general\",\"event\"],\"default\":\"general\"},\"event\":{\"type\":\"ObjectId\",\"ref\":\"Event\",\"required\":false},\"eventTitle\":\"String\",\"message\":\"String\",\"status\":{\"type\":\"String\",\"enum\":[\"new\",\"read\",\"archived\"],\"default\":\"new\"},\"emailSent\":\"Boolean\",\"createdOn\":{\"type\":\"Date\",\"default\":\"Date.now\"}}}},\"routes\":{\"api\":{\"_meta\":{\"virtual\":true,\"crud\":true,\"contentType\":\"json\"},\"users\":{\"_meta\":{\"access\":{\"admin\":\"all\",\"publisher\":\"own\",\"user\":\"list,read\",\"anonymous\":\"create\"}}},\"profiles\":{\"_meta\":{\"access\":{\"admin\":\"all\",\"publisher\":\"own\",\"user\":\"list,read\",\"anonymous\":\"list,read\"}}},\"articles\":{\"_meta\":{\"access\":{\"admin\":\"all\",\"publisher\":\"own\",\"user\":\"list,read\",\"anonymous\":\"list,read\"}}},\"events\":{\"_meta\":{\"access\":{\"admin\":\"all\",\"publisher\":\"own\",\"user\":\"list,read\",\"anonymous\":\"list,read\"}}},\"pages\":{\"_meta\":{\"access\":{\"admin\":\"all\",\"publisher\":\"own\",\"user\":\"list,read\",\"anonymous\":\"list,read\"}}},\"contacts\":{\"_meta\":{\"access\":{\"admin\":\"all\",\"publisher\":\"list,read\"}}}}}}");

});

parcelRegister("6gejJ", function(module, exports) {
'use strict';

var $jjnZg = parcelRequire("jjnZg");
var $48ef57ca8d8f0408$require$obj = $jjnZg.obj;
var $48ef57ca8d8f0408$require$arr = $jjnZg.arr;
// namespaces=
// initial
const $48ef57ca8d8f0408$var$initial = {
    // main, log-in, null
    menu: null,
    lang: 'bg'
};
// actions
// default
const $48ef57ca8d8f0408$var$ping = ()=>(state)=>state;
const $48ef57ca8d8f0408$var$set = (key, value)=>(state)=>$48ef57ca8d8f0408$require$obj.patch(state, key, typeof value === 'function' ? value($48ef57ca8d8f0408$require$obj.sub(state, key), state) : value);
const $48ef57ca8d8f0408$var$toggle = (key)=>(state)=>$48ef57ca8d8f0408$require$obj.patch(state, key, !$48ef57ca8d8f0408$require$obj.sub(state, key));
const $48ef57ca8d8f0408$var$arrToggle = (key, value)=>(state)=>$48ef57ca8d8f0408$require$obj.patch(state, key, $48ef57ca8d8f0408$require$arr.toggle($48ef57ca8d8f0408$require$obj.sub(state, key), value));
// custom
const $48ef57ca8d8f0408$var$toggleMenu = (menu)=>(state)=>Object.assign({}, state, {
            menu: state.menu === menu ? null : menu
        });
module.exports = {
    initial: $48ef57ca8d8f0408$var$initial,
    ping: $48ef57ca8d8f0408$var$ping,
    set: $48ef57ca8d8f0408$var$set,
    toggle: $48ef57ca8d8f0408$var$toggle,
    arrToggle: $48ef57ca8d8f0408$var$arrToggle,
    toggleMenu: $48ef57ca8d8f0408$var$toggleMenu
};

});


var $6SBin = parcelRequire("6SBin");
/**
 * @module iblokz-state
 * @description Lightweight state management utilities for JavaScript
 * @version 1.0.1
 */ /**
 * State Machine
 * @module core
 */ 
var $ceFTv = parcelRequire("ceFTv");

var $ceFTv = parcelRequire("ceFTv");

var $gN3J6 = parcelRequire("gN3J6");

var $fgwAY = parcelRequire("fgwAY");

var $jaWRE = parcelRequire("jaWRE");
var $05f7a3630bce7cef$export$f708eee25634bc80 = (0, $jaWRE.createErrorClass)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = 'ObjectUnsubscribedError';
        this.message = 'object unsubscribed';
    };
});



var $ebAl1 = parcelRequire("ebAl1");

var $iQsM4 = parcelRequire("iQsM4");
var $c9189cc69fd31ace$export$b6bbab5a9b109038 = function(_super) {
    (0, $ceFTv.__extends)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new $c9189cc69fd31ace$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, $05f7a3630bce7cef$export$f708eee25634bc80)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, $iQsM4.errorContext)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, $ceFTv.__values)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, $iQsM4.errorContext)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, $iQsM4.errorContext)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, $fgwAY.EMPTY_SUBSCRIPTION;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, $fgwAY.Subscription)(function() {
            _this.currentObservers = null;
            (0, $ebAl1.arrRemove)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $gN3J6.Observable)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $c9189cc69fd31ace$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $gN3J6.Observable));
var $c9189cc69fd31ace$export$155189cde295587d = function(_super) {
    (0, $ceFTv.__extends)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, $fgwAY.EMPTY_SUBSCRIPTION);
    };
    return AnonymousSubject;
}($c9189cc69fd31ace$export$b6bbab5a9b109038);


var $3222a525287186b1$export$cc3d42e6b2b9cf8b = function(_super) {
    (0, $ceFTv.__extends)(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        !subscription.closed && subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
        if (hasError) throw thrownError;
        this._throwIfClosed();
        return _value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}((0, $c9189cc69fd31ace$export$b6bbab5a9b109038));


var $gvBMK = parcelRequire("gvBMK");
var $6SBin = parcelRequire("6SBin");
var $f6wSa = parcelRequire("f6wSa");
var $drQX9 = parcelRequire("drQX9");

var $hYEnO = parcelRequire("hYEnO");
function $63523ba376002a40$export$18aef43295bbe906(concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, $drQX9.mergeMap)((0, $hYEnO.identity), concurrent);
}


function $7c5869f500d3725f$export$b314777ae20abca9() {
    return (0, $63523ba376002a40$export$18aef43295bbe906)(1);
}



var $6kN4i = parcelRequire("6kN4i");

var $aIPjU = parcelRequire("aIPjU");
function $7a869f5745a434e5$export$ee1b3e54f0441b22() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return (0, $7c5869f500d3725f$export$b314777ae20abca9)()((0, $aIPjU.from)(args, (0, $6kN4i.popScheduler)(args)));
}



var $6kN4i = parcelRequire("6kN4i");

var $iZT3c = parcelRequire("iZT3c");
function $7e9a8d9a25bb62cb$export$a4fe86229b0e9bdd() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    var scheduler = (0, $6kN4i.popScheduler)(values);
    return (0, $iZT3c.operate)(function(source, subscriber) {
        (scheduler ? (0, $7a869f5745a434e5$export$ee1b3e54f0441b22)(values, source, scheduler) : (0, $7a869f5745a434e5$export$ee1b3e54f0441b22)(values, source)).subscribe(subscriber);
    });
}


/**
 * Storage utilities for localStorage/sessionStorage
 * @module storage
 */ /**
 * Get item from storage with JSON parsing
 * @memberof module:storage
 * @param {Storage} storage - localStorage or sessionStorage
 * @param {string} key - Storage key
 * @param {*} defaultValue - Default value if not found
 * @return {*} Parsed value or default
 */ const $79ea37aa36b32bc9$export$3988ae62b71be9a3 = (storage, key, defaultValue)=>(storage.getItem(key) && JSON.parse(storage.getItem(key))) ?? defaultValue;
const $79ea37aa36b32bc9$export$adaa4cf7ef1b65be = (storage, key, value)=>storage.setItem(key, JSON.stringify(value));
const $79ea37aa36b32bc9$export$2cd8252107eb640b = (storage)=>storage ? {
        storage: storage,
        get: (key, defaultValue)=>$79ea37aa36b32bc9$export$3988ae62b71be9a3(storage, key, defaultValue),
        set: (key, value)=>$79ea37aa36b32bc9$export$adaa4cf7ef1b65be(storage, key, value)
    } : null;


const $0dd1b25395c80137$export$635e15bbd66f01ea = (change, namespace = 'state.changes')=>document.dispatchEvent(new CustomEvent(namespace, {
        detail: change
    }));
const $0dd1b25395c80137$export$bb44f104e3c54dae = (namespace = 'state.changes')=>(0, $gvBMK.fromEvent)(document, namespace).pipe((0, $6SBin.map)((ev)=>ev.detail));
const $0dd1b25395c80137$export$2cd8252107eb640b = (initial = {}, namespace = 'state.changes', storage = null)=>{
    const storageInstance = (0, $79ea37aa36b32bc9$export$2cd8252107eb640b)(storage);
    const initialState = storageInstance ? storageInstance.get(namespace, initial) : initial;
    const state$ = new (0, $3222a525287186b1$export$cc3d42e6b2b9cf8b)(initialState);
    storageInstance && state$.subscribe((state)=>{
        storageInstance.set(namespace, state);
    });
    $0dd1b25395c80137$export$bb44f104e3c54dae(namespace).pipe((0, $7e9a8d9a25bb62cb$export$a4fe86229b0e9bdd)(()=>initialState), (0, $f6wSa.scan)((state, change)=>change(state), {})).subscribe(state$);
    return state$;
};



/**
 * Action tree adapter - converts action trees to auto-dispatching APIs
 * @module adapt
 */ 

var $jjnZg = parcelRequire("jjnZg");

/**
 * Check if value is a Promise
 * @private
 * @param {*} value - Value to check
 * @return {boolean} True if value is a Promise
 */ const $0b23034ab663e0da$var$isPromise = (value)=>value && typeof value.then === 'function';
const $0b23034ab663e0da$export$68acc490bdb30af7 = (tree, namespace = 'state.changes', path = [])=>{
    // Create stream for this level (root creates Subject, children reuse parent's)
    const stream = path.length === 0 ? new (0, $c9189cc69fd31ace$export$b6bbab5a9b109038)() : null;
    const rootStream = stream || tree._rootStream;
    const adapted = Object.keys(tree).filter((key)=>key !== 'initial' && key !== '_rootStream').reduce((acc, key)=>{
        const value = tree[key];
        // Handle functions - wrap to auto-dispatch
        if (typeof value === 'function') acc[key] = function(...args) {
            // Call original function to get reducer
            const result = value(...args);
            // Handle async/Promise results
            const handleResult = (reducer)=>{
                // Dispatch the reducer
                (0, $0dd1b25395c80137$export$635e15bbd66f01ea)(reducer, namespace);
                // Emit metadata to stream
                rootStream && rootStream.next({
                    path: [
                        ...path,
                        key
                    ],
                    payload: args,
                    reducer: reducer
                });
            };
            if ($0b23034ab663e0da$var$isPromise(result)) result.then(handleResult);
            else handleResult(result);
        };
        else if (value && typeof value === 'object' && !Array.isArray(value)) {
            // Handle nested objects - recurse
            const nested = $0b23034ab663e0da$export$68acc490bdb30af7({
                ...value,
                _rootStream: rootStream
            }, namespace, [
                ...path,
                key
            ]);
            // Merge nested initial into parent
            if (nested.initial) acc.initial = {
                ...acc.initial,
                [key]: nested.initial
            };
            acc[key] = nested;
        } else // Handle other values (primitives, arrays)
        acc[key] = value;
        return acc;
    }, {
        initial: tree.initial || {},
        ...stream ? {
            stream: stream
        } : {}
    });
    return adapted;
};
const $0b23034ab663e0da$export$5ddf9e484e541d6f = (tree, path, node)=>{
    // Normalize path to array
    const pathArray = typeof path === 'string' ? path.split('.') : path;
    // Get namespace from tree if available
    const namespace = tree._namespace || 'state.changes';
    // Adapt the new node with the tree's root stream
    const adaptedNode = $0b23034ab663e0da$export$68acc490bdb30af7({
        ...node,
        _rootStream: tree.stream
    }, namespace, pathArray);
    // Patch the tree and initial state using iblokz-data
    return {
        ...(0, $jjnZg.obj).patch(tree, pathArray, adaptedNode),
        initial: (0, $jjnZg.obj).patch(tree.initial, pathArray, adaptedNode.initial),
        stream: tree.stream,
        _namespace: namespace
    };
};
const $0b23034ab663e0da$export$e6a0daad8304de = (tree, namespace = 'state.changes', storage = null)=>{
    const actions = $0b23034ab663e0da$export$68acc490bdb30af7(tree, namespace);
    // Store namespace for later use (e.g., with attach)
    actions._namespace = namespace;
    const state$ = (0, $0dd1b25395c80137$export$2cd8252107eb640b)(actions.initial, namespace, storage);
    return {
        actions: actions,
        state$: state$
    };
};





var $2Z6Kw = parcelRequire("2Z6Kw");

var $eQjvH = parcelRequire("eQjvH");

var $dllzs = parcelRequire("dllzs");

var $7jrlB = parcelRequire("7jrlB");
/**
 * Transforms the given attribute name into a valid dataset property key
 * according to https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/dataset#name_conversion
 *
 * @param attributeName data- attribute name, must start with data-
 */ function $668ce3ab094152ac$var$datasetKey(attributeName) {
    return attributeName.slice(5).replace(/-([a-z])/g, (_, ch)=>ch.toUpperCase());
}
function $668ce3ab094152ac$export$cd5dd3c35a2a94c7(node, domApi) {
    var _a;
    const api = domApi !== undefined ? domApi : (0, $7jrlB.htmlDomApi);
    let text;
    if (api.isElement(node)) {
        const id = node.id ? "#" + node.id : "";
        const cn = (_a = node.getAttribute("class")) === null || _a === void 0 ? void 0 : _a.match(/[^\t\r\n\f ]+/g);
        const c = cn ? "." + cn.join(".") : "";
        const sel = api.tagName(node).toLowerCase() + id + c;
        const attrs = {};
        const dataset = {};
        const data = {};
        const children = [];
        let name;
        let i, n;
        const elmAttrs = node.attributes;
        const elmChildren = node.childNodes;
        for(i = 0, n = elmAttrs.length; i < n; i++){
            name = elmAttrs[i].nodeName;
            if (name.startsWith("data-")) dataset[$668ce3ab094152ac$var$datasetKey(name)] = elmAttrs[i].nodeValue || "";
            else if (name !== "id" && name !== "class") attrs[name] = elmAttrs[i].nodeValue;
        }
        for(i = 0, n = elmChildren.length; i < n; i++)children.push($668ce3ab094152ac$export$cd5dd3c35a2a94c7(elmChildren[i], domApi));
        if (Object.keys(attrs).length > 0) data.attrs = attrs;
        if (Object.keys(dataset).length > 0) data.dataset = dataset;
        if (sel.startsWith("svg") && (sel.length === 3 || sel[3] === "." || sel[3] === "#")) (0, $eQjvH.addNS)(data, children, sel);
        return (0, $dllzs.vnode)(sel, data, children, undefined, node);
    } else if (api.isText(node)) {
        text = api.getTextContent(node);
        return (0, $dllzs.vnode)(undefined, undefined, undefined, text, node);
    } else if (api.isComment(node)) {
        text = api.getTextContent(node);
        return (0, $dllzs.vnode)("!", {}, [], text, node);
    } else return (0, $dllzs.vnode)("", {}, [], undefined, node);
}


// dom

var $2Z6Kw = parcelRequire("2Z6Kw");

var $2Z6Kw = parcelRequire("2Z6Kw");

var $bLEu3 = parcelRequire("bLEu3");
var $8070010df6d2f096$exports = {};
'use strict';

var $2Z6Kw = parcelRequire("2Z6Kw");
var $8070010df6d2f096$require$a = $2Z6Kw.a;
var $8070010df6d2f096$require$span = $2Z6Kw.span;
var $8070010df6d2f096$require$ul = $2Z6Kw.ul;
var $8070010df6d2f096$require$li = $2Z6Kw.li;
/**
 * Hover dropdown (boilerplate / thriftify-style): handle + ul > li.
 */ $8070010df6d2f096$exports = (className, { handle: handle, handleClick: handleClick, items: items = [], toLeft: toLeft = false, flags: flags = false })=>{
    const mods = [
        '.dropdown',
        className
    ];
    if (toLeft) mods.push('.to-left');
    if (flags) mods.push('.flags');
    const handleNode = flags ? $8070010df6d2f096$require$span('.flag-handle', {
        on: handleClick ? {
            click: (ev)=>{
                ev.preventDefault();
                handleClick();
            }
        } : {}
    }, handle) : $8070010df6d2f096$require$span('.handle', {
        on: handleClick ? {
            click: (ev)=>{
                ev.preventDefault();
                handleClick();
            }
        } : {}
    }, handle);
    const renderItem = (item)=>{
        if (item.content) return item.content;
        return $8070010df6d2f096$require$span(item.label);
    };
    return $8070010df6d2f096$require$a(mods.filter(Boolean).join(''), [
        handleNode,
        items.length ? $8070010df6d2f096$require$ul(items.map((item)=>$8070010df6d2f096$require$li({
                class: {
                    active: !!item.active,
                    disabled: !!item.disabled
                },
                on: item.disabled || !item.onSelect ? {} : {
                    click: (ev)=>{
                        ev.preventDefault();
                        item.onSelect();
                    }
                }
            }, renderItem(item)))) : null
    ]);
};


const $232e760e39c9a25a$var$LANGS = [
    'en',
    'bg'
];
const $232e760e39c9a25a$var$LANG_LABELS = {
    en: 'English',
    bg: "\u0411\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438"
};
const $232e760e39c9a25a$var$flagSrc = (lang)=>({
        en: '/assets/flags/gb.svg',
        bg: '/assets/flags/bg.svg'
    })[lang] || '/assets/flags/gb.svg';
const $232e760e39c9a25a$var$langOption = (code)=>(0, $2Z6Kw.span)('.lang-option', [
        (0, $2Z6Kw.span)('.flag-circle', (0, $2Z6Kw.img)({
            props: {
                src: $232e760e39c9a25a$var$flagSrc(code),
                alt: ''
            }
        })),
        (0, $2Z6Kw.span)('.lang-label', $232e760e39c9a25a$var$LANG_LABELS[code])
    ]);
var $232e760e39c9a25a$export$2e2bcd8739ae039 = ({ state: state, actions: actions, i18n: i18n })=>{
    const lang = state.lang || 'bg';
    const menuKey = state.router.path[0] === 'admin' ? 'admin' : 'front';
    const menu = i18n.menu && i18n.menu[menuKey] || [];
    return (0, $2Z6Kw.header)([
        (0, $2Z6Kw.button)('.left.menu-toggle', {
            on: {
                click: ()=>actions.toggleMenu('main')
            },
            class: {
                toggled: state.menu === 'main'
            }
        }, [
            (0, $2Z6Kw.img)(`[src="/assets/icons/${state.menu === 'main' ? 'cancel' : 'menu'}.svg"]`)
        ]),
        (0, $2Z6Kw.img)('.logo[src="/assets/mbg.svg"]'),
        !state.auth.user ? (0, $2Z6Kw.a)('.right.login-menu-toggle', {
            on: {
                click: ()=>actions.toggleMenu('log-in')
            },
            class: {
                toggled: state.menu === 'log-in'
            }
        }, [
            (0, $2Z6Kw.img)(`[src="/assets/icons/${state.menu === 'log-in' ? 'cancel' : 'write'}.svg"]`)
        ]) : (0, $2Z6Kw.button)(`.right.log-out`, {
            on: {
                click: ()=>actions.auth.logout()
            }
        }, [
            (0, $2Z6Kw.img)(`[src="/assets/icons/log-out.svg"]`)
        ]),
        // float:right stacks leftward — after login so it sits to its left
        (0, (/*@__PURE__*/$parcel$interopDefault($8070010df6d2f096$exports)))('.flags.right', {
            flags: true,
            toLeft: true,
            handle: [
                (0, $2Z6Kw.img)({
                    props: {
                        src: $232e760e39c9a25a$var$flagSrc(lang),
                        alt: '',
                        title: $232e760e39c9a25a$var$LANG_LABELS[lang]
                    }
                })
            ],
            handleClick: ()=>{
                const i = $232e760e39c9a25a$var$LANGS.indexOf(lang);
                const next = $232e760e39c9a25a$var$LANGS[(i < 0 ? 0 : i + 1) % $232e760e39c9a25a$var$LANGS.length];
                actions.set('lang', next);
            },
            items: $232e760e39c9a25a$var$LANGS.map((code)=>({
                    content: $232e760e39c9a25a$var$langOption(code),
                    active: code === lang,
                    onSelect: ()=>{
                        if (code !== lang) actions.set('lang', code);
                    }
                }))
        }),
        (0, $2Z6Kw.ul)('.main-menu', [].concat(state.auth.user && (0, $2Z6Kw.li)(state.router.admin ? (0, $2Z6Kw.a)(`[href="/"][title="${i18n.common && i18n.common.titles && i18n.common.titles.home || ''}"]`, {
            on: {
                click: (ev)=>{
                    ev.preventDefault();
                    actions.set('menu', null);
                    actions.router.go('home');
                }
            }
        }, [
            (0, $2Z6Kw.img)(`[src="/assets/icons/newspaper.svg"]`)
        ]) : (0, $2Z6Kw.a)(`[href="/admin"][title="${i18n.common && i18n.common.titles && i18n.common.titles.admin || ''}"]`, {
            on: {
                click: (ev)=>{
                    ev.preventDefault();
                    actions.set('menu', null);
                    actions.router.go('admin');
                }
            }
        }, [
            (0, $2Z6Kw.img)(`[src="/assets/icons/dashboard.svg"]`)
        ])) || '', menu.map((item)=>(0, $2Z6Kw.li)((0, $2Z6Kw.a)(`[href="${item.href}"]`, {
                class: {
                    active: item.page === state.router.page
                },
                on: {
                    click: (ev)=>{
                        ev.preventDefault();
                        actions.set('menu', null);
                        const page = item.page === 'admin.home' ? 'admin' : item.page;
                        actions.router.go(page);
                    }
                }
            }, item.title))))),
        (0, $2Z6Kw.ul)(`.right${state.auth.user ? '.user-session' : ''}`, [
            (0, $2Z6Kw.li)(!state.auth.user ? [
                state.menu === 'log-in' ? (0, $2Z6Kw.form)({
                    on: {
                        submit: (ev)=>{
                            ev.preventDefault();
                            let data = (0, (/*@__PURE__*/$parcel$interopDefault($bLEu3))).toData(ev.target);
                            actions.auth.login(data);
                        }
                    }
                }, [
                    (0, $2Z6Kw.label)('[for="login-email"]', [
                        (0, $2Z6Kw.img)(`[src="/assets/icons/user.svg"]`)
                    ]),
                    (0, $2Z6Kw.input)(`#login-email[name="email"][placeholder="${i18n.common.login.email}"]`),
                    (0, $2Z6Kw.label)('[for="login-pass"]', [
                        (0, $2Z6Kw.img)(`[src="/assets/icons/key.svg"]`)
                    ]),
                    (0, $2Z6Kw.input)(`#login-password[name="password"][type="password"][placeholder="${i18n.common.login.password}"]`),
                    (0, $2Z6Kw.button)([
                        (0, $2Z6Kw.img)(`[src="/assets/icons/log-in.svg"]`)
                    ])
                ]) : ''
            ] : [
                (0, $2Z6Kw.span)('.user-identity', state.auth.user.name || state.auth.user.email)
            ])
        ])
    ]);
};



var $2Z6Kw = parcelRequire("2Z6Kw");
var $167ae3265028d805$exports = {};
$167ae3265028d805$exports = {
    "layout": [
        {
            "type": "panel",
            "kind": "row",
            "id": "base-layout",
            "tag": "main",
            "children": [
                {
                    "type": "panel",
                    "kind": "column",
                    "id": "content",
                    "tag": "section",
                    "style": {
                        "max-width": "65%"
                    },
                    "children": null
                },
                {
                    "type": "panel",
                    "kind": "column",
                    "id": "right-pane",
                    "tag": "aside",
                    "style": {
                        "max-width": "35%"
                    },
                    "children": [
                        {
                            "type": "widget",
                            "kind": "simple-list",
                            "preset": "siteSocialLinks"
                        },
                        {
                            "type": "widget",
                            "kind": "calendar",
                            "preset": "defaultCalendar"
                        },
                        {
                            "type": "widget",
                            "kind": "simple-list",
                            "preset": "recentEvents",
                            "title": "i18n.widget.recentEvents"
                        }
                    ]
                }
            ]
        },
        {
            "type": "panel",
            "kind": "row",
            "id": "profile-detail-layout",
            "tag": "main",
            "children": [
                {
                    "type": "panel",
                    "kind": "column",
                    "id": "content",
                    "tag": "section",
                    "children": null
                }
            ]
        },
        {
            "type": "panel",
            "kind": "row",
            "id": "home-page-layout",
            "tag": "main",
            "children": [
                {
                    "type": "panel",
                    "kind": "column",
                    "id": "content",
                    "tag": "section",
                    "children": [
                        {
                            "type": "widget",
                            "kind": "events-carousel",
                            "preset": "homeUpcoming"
                        }
                    ]
                }
            ]
        },
        {
            "type": "extension",
            "id": "about-page-layout",
            "extending": "base-layout",
            "children": [
                {
                    "type": "extension",
                    "extending": "content",
                    "children": [
                        {
                            "type": "panel",
                            "id": "about",
                            "tag": "section",
                            "children": [
                                {
                                    "type": "widget",
                                    "kind": "static",
                                    "tag": "h2",
                                    "content": "i18n.pages.about.title"
                                },
                                {
                                    "type": "widget",
                                    "kind": "static",
                                    "tag": "article",
                                    "content": "i18n.pages.about.text"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "type": "extension",
            "id": "articles-list-layout",
            "extending": "base-layout",
            "children": [
                {
                    "type": "extension",
                    "extending": "content",
                    "children": [
                        {
                            "type": "widget",
                            "kind": "breadcrumb",
                            "tag": "h2"
                        },
                        {
                            "type": "widget",
                            "kind": "resource-list",
                            "tag": "ul",
                            "preset": "articlesList"
                        }
                    ]
                }
            ]
        },
        {
            "type": "extension",
            "id": "articles-details-layout",
            "extending": "base-layout",
            "children": [
                {
                    "type": "extension",
                    "extending": "content",
                    "children": [
                        {
                            "type": "widget",
                            "kind": "breadcrumb",
                            "tag": "h2"
                        },
                        {
                            "type": "widget",
                            "kind": "resource-view",
                            "tag": "article",
                            "preset": "articleDetails"
                        }
                    ]
                }
            ]
        },
        {
            "type": "panel",
            "kind": "row",
            "id": "events-list-layout",
            "tag": "main",
            "children": [
                {
                    "type": "panel",
                    "kind": "column",
                    "id": "left-pane",
                    "tag": "aside",
                    "style": {
                        "max-width": "35%"
                    },
                    "children": [
                        {
                            "type": "widget",
                            "kind": "calendar",
                            "preset": "defaultCalendar"
                        }
                    ]
                },
                {
                    "type": "panel",
                    "kind": "column",
                    "id": "content",
                    "style": {
                        "max-width": "65%"
                    },
                    "children": [
                        {
                            "type": "widget",
                            "kind": "horizontal-card-list",
                            "preset": "upcomingEvents",
                            "title": "i18n.widget.upcomingEvents"
                        },
                        {
                            "type": "widget",
                            "kind": "horizontal-search-form",
                            "preset": "eventsSearchForm",
                            "title": "i18n.widget.upcomingEvents"
                        },
                        {
                            "type": "widget",
                            "kind": "resource-list",
                            "tag": "ul",
                            "preset": "eventsList"
                        }
                    ]
                }
            ]
        }
    ]
};


const $50ca37520d8c31ef$var$clone = (value)=>JSON.parse(JSON.stringify(value));
const $50ca37520d8c31ef$export$307a547fda27f3b9 = (entries = [])=>entries.reduce((acc, entry)=>{
        if (entry && entry.id) acc[entry.id] = entry;
        return acc;
    }, {});
const $50ca37520d8c31ef$export$6486ede9e74d7d9d = (node, id)=>{
    if (!node) return null;
    if (node.id === id) return node;
    const children = node.children || [];
    for(let i = 0; i < children.length; i++){
        const found = $50ca37520d8c31ef$export$6486ede9e74d7d9d(children[i], id);
        if (found) return found;
    }
    return null;
};
const $50ca37520d8c31ef$export$17dc26048a7dd46b = (tree, extension)=>{
    const next = $50ca37520d8c31ef$var$clone(tree);
    const ops = extension.children || [];
    ops.forEach((op)=>{
        if (op.type === 'extension' && op.extending) {
            const target = $50ca37520d8c31ef$export$6486ede9e74d7d9d(next, op.extending);
            if (!target) return;
            target.children = [].concat(target.children || [], $50ca37520d8c31ef$var$clone(op.children || []));
            return;
        }
        // bare widgets/panels under extension: append to root
        next.children = [].concat(next.children || [], [
            $50ca37520d8c31ef$var$clone(op)
        ]);
    });
    return next;
};
const $50ca37520d8c31ef$export$f7ad0328861e2f03 = (entries, id)=>{
    const index = $50ca37520d8c31ef$export$307a547fda27f3b9(entries);
    const entry = index[id];
    if (!entry) return null;
    if (entry.type === 'panel') return $50ca37520d8c31ef$var$clone(entry);
    if (entry.type === 'extension' && entry.extending) {
        const base = $50ca37520d8c31ef$export$f7ad0328861e2f03(entries, entry.extending);
        if (!base) return null;
        return $50ca37520d8c31ef$export$17dc26048a7dd46b(base, entry);
    }
    return $50ca37520d8c31ef$var$clone(entry);
};
var $50ca37520d8c31ef$export$2e2bcd8739ae039 = {
    clone: $50ca37520d8c31ef$var$clone,
    indexById: $50ca37520d8c31ef$export$307a547fda27f3b9,
    findById: $50ca37520d8c31ef$export$6486ede9e74d7d9d,
    mergeExtension: $50ca37520d8c31ef$export$17dc26048a7dd46b,
    resolve: $50ca37520d8c31ef$export$f7ad0328861e2f03
};



var $dgw34 = parcelRequire("dgw34");

var $fFCx8 = parcelRequire("fFCx8");

var $2Z6Kw = parcelRequire("2Z6Kw");

var $1zDll = parcelRequire("1zDll");
parcelRequire("12DVH");

var $4rZD9 = parcelRequire("4rZD9");

var $3QJuk = parcelRequire("3QJuk");

var $4hyaE = parcelRequire("4hyaE");
(0, (/*@__PURE__*/$parcel$interopDefault($1zDll))).extend((0, (/*@__PURE__*/$parcel$interopDefault($4rZD9))));
const $fade1dd2de7865f5$var$AUTOPLAY_MS = 7000;
const $fade1dd2de7865f5$var$copy = (i18n, key, fallback)=>{
    const root = i18n && i18n.widget && i18n.widget.eventsCarousel;
    if (!root) return fallback;
    const parts = key.split('.');
    let cur = root;
    for(let i = 0; i < parts.length; i++){
        if (cur == null) return fallback;
        cur = cur[parts[i]];
    }
    return cur == null || cur === '' ? fallback : cur;
};
const $fade1dd2de7865f5$var$eventTitle = (event, lang)=>(0, $3QJuk.resolveLocalized)(event && event.title, lang) || '';
const $fade1dd2de7865f5$var$eventText = (event, lang)=>(0, $3QJuk.resolveLocalized)(event && event.text, lang) || '';
const $fade1dd2de7865f5$var$isTinker = (event)=>{
    const slug = String(event && event.slug || '');
    const title = $fade1dd2de7865f5$var$eventTitle(event, 'en') + $fade1dd2de7865f5$var$eventTitle(event, 'bg');
    return (event && event.type) === 'tinkering' || /tinker/i.test(slug) || /tinker/i.test(title);
};
const $fade1dd2de7865f5$var$startMs = (event)=>new Date(event && event.startDateTime || 0).getTime();
const $fade1dd2de7865f5$var$sortAsc = (a, b)=>$fade1dd2de7865f5$var$startMs(a) - $fade1dd2de7865f5$var$startMs(b);
const $fade1dd2de7865f5$var$sortDesc = (a, b)=>$fade1dd2de7865f5$var$startMs(b) - $fade1dd2de7865f5$var$startMs(a);
const $fade1dd2de7865f5$var$isUpcoming = (event)=>{
    const end = event && event.endDateTime || event && event.startDateTime;
    return new Date(end || 0).getTime() >= Date.now();
};
const $fade1dd2de7865f5$var$cleanPlain = (text)=>String(text || '').replace(/[#>*_`\[\]()]/g, ' ').replace(/[^\S\n]+/g, ' ').replace(/ ?\n ?/g, '\n').replace(/\n{3,}/g, '\n\n').trim();
/** Visual cost: newlines spend a bit more budget than a single char. */ const $fade1dd2de7865f5$var$NEWLINE_COST = 18;
const $fade1dd2de7865f5$var$charCost = (ch)=>ch === '\n' ? $fade1dd2de7865f5$var$NEWLINE_COST : 1;
const $fade1dd2de7865f5$var$trimAtBoundary = (str, min = 40)=>{
    const t = String(str || '').trimEnd();
    if (!t) return '';
    const at = Math.max(t.lastIndexOf('\n'), t.lastIndexOf(' '));
    return (at >= min ? t.slice(0, at) : t).trimEnd();
};
/** Truncate by visual budget; prefer breaking on newline/space; end with …. */ const $fade1dd2de7865f5$var$excerptByBudget = (text, maxUnits)=>{
    const plain = $fade1dd2de7865f5$var$cleanPlain(text);
    if (!plain) return '';
    let units = 0;
    for(let i = 0; i < plain.length; i++){
        units += $fade1dd2de7865f5$var$charCost(plain[i]);
        if (units > maxUnits) return `${$fade1dd2de7865f5$var$trimAtBoundary(plain.slice(0, i))}\u{2026}`;
    }
    return plain;
};
/**
 * Budget for body copy based on other details-panel chrome
 * (series / title / sub / meta / CTA + gaps).
 */ const $fade1dd2de7865f5$var$excerptForDetails = (text, { series: series, title: title, sub: sub, meta: meta } = {})=>{
    let maxUnits = 575;
    if (series) maxUnits -= 14;
    if (title) maxUnits -= Math.min(36, 12 + String(title).length * 0.2);
    if (sub) maxUnits -= Math.min(22, 10 + String(sub).length * 0.15);
    if (meta) maxUnits -= 10;
    maxUnits -= 20; // CTA + inner gaps
    return $fade1dd2de7865f5$var$excerptByBudget(text, Math.max(320, Math.round(maxUnits)));
};
/** Split plain text into paragraph strings (no <br> inside <p>). */ const $fade1dd2de7865f5$var$textParagraphs = (text)=>String(text || '').split(/\n+/).map((s)=>s.trim()).filter(Boolean);
const $fade1dd2de7865f5$var$eventTz = (event)=>event && event.timezone || (0, (/*@__PURE__*/$parcel$interopDefault($4hyaE))).DEFAULT_TZ;
const $fade1dd2de7865f5$var$shortDate = (event, lang)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($1zDll))).locale(lang === 'en' ? 'en' : 'bg');
    const tz = $fade1dd2de7865f5$var$eventTz(event);
    const start = (0, (/*@__PURE__*/$parcel$interopDefault($4hyaE))).parse(event && event.startDateTime, tz);
    if (!start) return '';
    const end = (0, (/*@__PURE__*/$parcel$interopDefault($4hyaE))).parse(event && event.endDateTime, tz);
    if (end && !end.isSame(start, 'day')) return `${start.format('DD.MM')}\u{2013}${end.format('DD.MM')}`;
    return start.format('DD.MM');
};
const $fade1dd2de7865f5$var$metaLine = (event, lang, kind, i18n)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($1zDll))).locale(lang === 'en' ? 'en' : 'bg');
    const start = (0, (/*@__PURE__*/$parcel$interopDefault($4hyaE))).parse(event && event.startDateTime, $fade1dd2de7865f5$var$eventTz(event));
    const bits = [];
    if (kind === 'regular') bits.push($fade1dd2de7865f5$var$copy(i18n, 'regular', "\u0440\u0435\u0433\u0443\u043B\u044F\u0440\u0435\u043D"));
    if (start) {
        bits.push(start.format('DD.MM'));
        bits.push(start.format('HH:mm'));
    }
    return bits.filter(Boolean).join(" \xb7 ");
};
const $fade1dd2de7865f5$var$thumbLabel = (item, lang, i18n)=>{
    const { event: event, kind: kind } = item;
    const title = $fade1dd2de7865f5$var$eventTitle(event, lang);
    const short = title.replace(/\s*[|/].*$/, '').replace(/^MusicTechBG\s+/i, '').trim();
    if (kind === 'regular') return `${$fade1dd2de7865f5$var$copy(i18n, 'regular', "\u0440\u0435\u0433\u0443\u043B\u044F\u0440\u0435\u043D")} ${short || 'Tinkerday'}`;
    const when = $fade1dd2de7865f5$var$shortDate(event, lang);
    return [
        when,
        short
    ].filter(Boolean).join(' ');
};
const $fade1dd2de7865f5$var$ctaLabel = (event, i18n)=>{
    const type = event && event.type || '';
    return $fade1dd2de7865f5$var$copy(i18n, `cta.${type}`, null) || $fade1dd2de7865f5$var$copy(i18n, 'cta.default', "\u043A\u044A\u043C \u0441\u044A\u0431\u0438\u0442\u0438\u0435\u0442\u043E");
};
const $fade1dd2de7865f5$var$seriesHint = (event, lang)=>{
    const title = $fade1dd2de7865f5$var$eventTitle(event, lang);
    if (/sound\s*currents/i.test(title)) return 'Sound Currents';
    if (/sofia\s*experimental/i.test(title)) return 'Sofia Experimental';
    if ($fade1dd2de7865f5$var$isTinker(event)) return 'Tinkerday';
    return '';
};
const $fade1dd2de7865f5$var$cleanTitle = (event, lang)=>{
    const title = $fade1dd2de7865f5$var$eventTitle(event, lang);
    const series = $fade1dd2de7865f5$var$seriesHint(event, lang);
    let cleaned = title.replace(/\s*[|/].*$/, '').trim() || title;
    if (series && /sound\s*currents/i.test(title)) cleaned = title.replace(/\s*[|].*Sound Currents.*$/i, '').replace(/\s*\|.*$/i, '').trim() || title;
    const split = cleaned.match(/^([^:—\-]+)[:—\-]\s*(.+)$/);
    if (split) return {
        headline: split[1].trim(),
        sub: split[2].trim()
    };
    return {
        headline: cleaned,
        sub: ''
    };
};
const $fade1dd2de7865f5$var$pickCarouselItems = (list = [])=>{
    const upcoming = list.filter($fade1dd2de7865f5$var$isUpcoming).sort($fade1dd2de7865f5$var$sortAsc);
    const tinkers = list.filter($fade1dd2de7865f5$var$isTinker).sort($fade1dd2de7865f5$var$sortDesc);
    const items = [];
    const seen = {};
    const push = (event, kind)=>{
        const id = String(event && (event._id || event.slug) || '');
        if (!event || !id || seen[id]) return;
        seen[id] = true;
        items.push({
            event: event,
            kind: kind
        });
    };
    upcoming.filter((e)=>!$fade1dd2de7865f5$var$isTinker(e)).slice(0, 2).forEach((e)=>push(e, 'upcoming'));
    upcoming.forEach((e)=>{
        if (items.length >= 3) return;
        push(e, $fade1dd2de7865f5$var$isTinker(e) ? 'regular' : 'upcoming');
    });
    const tinker = upcoming.find($fade1dd2de7865f5$var$isTinker) || tinkers[0];
    if (tinker) {
        const id = String(tinker._id || tinker.slug || '');
        const existing = items.find((i)=>String(i.event._id || i.event.slug) === id);
        if (existing) existing.kind = 'regular';
        else if (items.length < 3) push(tinker, 'regular');
        else items[items.length - 1] = {
            event: tinker,
            kind: 'regular'
        };
    }
    return items.slice(0, 3);
};
const $fade1dd2de7865f5$var$goEvent = (actions, event)=>{
    const path = event && (event.slug || event._id) || '';
    if (!path) return;
    actions.router.go(`calendar.${path}`);
};
/** Blurred letterbox layers (.media-backlight host + these children). */ const $fade1dd2de7865f5$var$mediaBacklight = (src, fg)=>[].concat((0, $2Z6Kw.div)('.media-backlight-back', {
        style: {
            backgroundImage: `url("${src}")`
        }
    }), (0, $2Z6Kw.div)('.media-backlight-scrim'), fg);
const $fade1dd2de7865f5$var$clearAutoplay = (el)=>{
    if (el && el._mtbgAutoplay) {
        clearInterval(el._mtbgAutoplay);
        el._mtbgAutoplay = null;
    }
};
const $fade1dd2de7865f5$var$startAutoplay = (el, actions, count)=>{
    $fade1dd2de7865f5$var$clearAutoplay(el);
    if (!el || count < 2) return;
    el._mtbgCount = count;
    el._mtbgActions = actions;
    el._mtbgAutoplay = setInterval(()=>{
        if (el._mtbgPaused) return;
        const total = el._mtbgCount || count;
        const act = el._mtbgActions || actions;
        act.set([
            'home'
        ], (cur)=>{
            const i = Number(cur && cur.carouselIndex) || 0;
            const n = (i + 1) % total;
            return {
                carouselIndex: n,
                carouselDir: 'next'
            };
        });
    }, $fade1dd2de7865f5$var$AUTOPLAY_MS);
};
/** Keep timer alive across patches (empty→loaded never re-fires insert). */ const $fade1dd2de7865f5$var$ensureAutoplay = (el, actions, count)=>{
    if (!el) return;
    if (count < 2) {
        $fade1dd2de7865f5$var$clearAutoplay(el);
        el._mtbgCount = count;
        return;
    }
    el._mtbgActions = actions;
    if (!el._mtbgAutoplay || el._mtbgCount !== count) $fade1dd2de7865f5$var$startAutoplay(el, actions, count);
};
const $fade1dd2de7865f5$var$rootHooks = (actions)=>({
        insert: (vnode)=>{
            const el = vnode.elm;
            const count = Number(el && el.getAttribute('data-count')) || 0;
            $fade1dd2de7865f5$var$ensureAutoplay(el, actions, count);
        },
        postpatch: (oldVnode, vnode)=>{
            const el = vnode.elm;
            const count = Number(el && el.getAttribute('data-count')) || 0;
            $fade1dd2de7865f5$var$ensureAutoplay(el, actions, count);
        },
        destroy: (vnode)=>{
            $fade1dd2de7865f5$var$clearAutoplay(vnode.elm);
        }
    });
/** Pause only while the thumb strip is hovered — not the whole hero. */ const $fade1dd2de7865f5$var$stripHooks = {
    insert: (vnode)=>{
        const strip = vnode.elm;
        const root = strip && strip.closest('.events-carousel');
        if (!root) return;
        strip._mtbgOnEnter = ()=>{
            root._mtbgPaused = true;
        };
        strip._mtbgOnLeave = ()=>{
            root._mtbgPaused = false;
        };
        strip.addEventListener('mouseenter', strip._mtbgOnEnter);
        strip.addEventListener('mouseleave', strip._mtbgOnLeave);
    },
    destroy: (vnode)=>{
        const strip = vnode.elm;
        if (strip && strip._mtbgOnEnter) {
            strip.removeEventListener('mouseenter', strip._mtbgOnEnter);
            strip.removeEventListener('mouseleave', strip._mtbgOnLeave);
        }
    }
};
var $fade1dd2de7865f5$export$2e2bcd8739ae039 = ({ state: state, actions: actions, i18n: i18n })=>{
    const lang = state.lang || (0, $3QJuk.DEFAULT_LOCALE);
    const list = state.events && state.events.list || [];
    const items = $fade1dd2de7865f5$var$pickCarouselItems(list);
    const rawIndex = Number(state.home && state.home.carouselIndex || 0);
    const index = items.length ? Math.max(0, Math.min(items.length - 1, rawIndex)) : 0;
    const dir = state.home && state.home.carouselDir || 'next';
    const setIndex = (next)=>{
        if (!items.length) return;
        const n = (next % items.length + items.length) % items.length;
        if (n === index) return;
        let resolved = 'next';
        if (index === items.length - 1 && n === 0) resolved = 'next';
        else if (index === 0 && n === items.length - 1) resolved = 'prev';
        else if (n < index) resolved = 'prev';
        actions.set([
            'home'
        ], {
            carouselIndex: n,
            carouselDir: resolved
        });
        // Restart the 7s window after manual switch
        const root = typeof document !== 'undefined' && document.querySelector('.events-carousel[data-count]');
        if (root) $fade1dd2de7865f5$var$startAutoplay(root, actions, items.length);
    };
    if (!items.length) return (0, $2Z6Kw.section)('.events-carousel.is-empty', [
        (0, $2Z6Kw.div)('.events-carousel-empty', $fade1dd2de7865f5$var$copy(i18n, 'empty', "\u041D\u044F\u043C\u0430 \u043F\u0440\u0435\u0434\u0441\u0442\u043E\u044F\u0449\u0438 \u0441\u044A\u0431\u0438\u0442\u0438\u044F \u0437\u0430\u0441\u0435\u0433\u0430."))
    ]);
    return (0, $2Z6Kw.section)('.events-carousel', {
        attrs: {
            'data-count': String(items.length)
        },
        class: {
            'is-dir-next': dir !== 'prev',
            'is-dir-prev': dir === 'prev'
        },
        hook: $fade1dd2de7865f5$var$rootHooks(actions)
    }, [
        (0, $2Z6Kw.div)('.events-carousel-stage', [
            (0, $2Z6Kw.div)('.events-carousel-poster', [
                (0, $2Z6Kw.div)('.events-carousel-poster-stack', items.map((item, i)=>{
                    const title = $fade1dd2de7865f5$var$cleanTitle(item.event, lang).headline;
                    const src = item.event.poster || '';
                    const kids = src ? $fade1dd2de7865f5$var$mediaBacklight(src, (0, $2Z6Kw.img)('.events-carousel-poster-fg', {
                        attrs: {
                            src: src,
                            alt: title,
                            draggable: 'false'
                        }
                    })) : [
                        (0, $2Z6Kw.div)('.events-carousel-poster-fallback', title)
                    ];
                    return (0, $2Z6Kw.div)('.events-carousel-poster-slide', {
                        key: `poster-${item.event.slug || item.event._id || i}`,
                        class: {
                            'is-active': i === index,
                            'media-backlight': !!src
                        }
                    }, kids);
                }))
            ]),
            (0, $2Z6Kw.div)('.events-carousel-details-panel', [
                (0, $2Z6Kw.div)('.events-carousel-details-stack', items.map((item, i)=>{
                    const ev = item.event;
                    const titles = $fade1dd2de7865f5$var$cleanTitle(ev, lang);
                    const ser = $fade1dd2de7865f5$var$seriesHint(ev, lang);
                    const when = $fade1dd2de7865f5$var$metaLine(ev, lang, item.kind, i18n);
                    const body = $fade1dd2de7865f5$var$excerptForDetails($fade1dd2de7865f5$var$eventText(ev, lang), {
                        series: ser,
                        title: titles.headline,
                        sub: titles.sub,
                        meta: when
                    });
                    const link = `/calendar/${ev.slug || ev._id}`;
                    return (0, $2Z6Kw.div)('.events-carousel-details', {
                        key: `details-${ev.slug || ev._id || i}`,
                        class: {
                            'is-active': i === index
                        }
                    }, [
                        (0, $2Z6Kw.div)('.events-carousel-details-inner', [
                            ser ? (0, $2Z6Kw.p)('.events-carousel-series', `\xab${ser}\xbb`) : '',
                            (0, $2Z6Kw.p)('.events-carousel-title', titles.headline),
                            titles.sub ? (0, $2Z6Kw.p)('.events-carousel-sub', titles.sub) : '',
                            when ? (0, $2Z6Kw.p)('.events-carousel-meta', when) : '',
                            body ? (0, $2Z6Kw.div)('.events-carousel-text-block', $fade1dd2de7865f5$var$textParagraphs(body).map((para)=>(0, $2Z6Kw.p)('.events-carousel-text', para))) : '',
                            (0, $2Z6Kw.a)('.events-carousel-cta', {
                                attrs: {
                                    href: link
                                },
                                on: {
                                    click: (evnt)=>{
                                        evnt.preventDefault();
                                        $fade1dd2de7865f5$var$goEvent(actions, ev);
                                    }
                                }
                            }, [
                                (0, $2Z6Kw.span)($fade1dd2de7865f5$var$ctaLabel(ev, i18n)),
                                (0, $2Z6Kw.span)('.events-carousel-cta-arrow', "\u2192")
                            ])
                        ])
                    ]);
                }))
            ])
        ]),
        (0, $2Z6Kw.div)('.events-carousel-strip', {
            hook: $fade1dd2de7865f5$var$stripHooks
        }, [
            (0, $2Z6Kw.div)('.events-carousel-strip-media', [
                (0, $2Z6Kw.button)('.events-carousel-nav.prev', {
                    attrs: {
                        type: 'button',
                        title: $fade1dd2de7865f5$var$copy(i18n, 'prev', "\u041F\u0440\u0435\u0434\u0438\u0448\u043D\u043E"),
                        'aria-label': $fade1dd2de7865f5$var$copy(i18n, 'prev', "\u041F\u0440\u0435\u0434\u0438\u0448\u043D\u043E")
                    },
                    on: {
                        click: ()=>setIndex(index - 1)
                    }
                }, "\u2039"),
                (0, $2Z6Kw.ul)('.events-carousel-thumbs', items.map((item, i)=>(0, $2Z6Kw.li)('.events-carousel-thumb', {
                        class: {
                            'is-active': i === index
                        }
                    }, [
                        (0, $2Z6Kw.button)({
                            attrs: {
                                type: 'button',
                                'aria-label': $fade1dd2de7865f5$var$thumbLabel(item, lang, i18n)
                            },
                            on: {
                                click: ()=>setIndex(i)
                            }
                        }, [
                            (0, $2Z6Kw.span)('.events-carousel-thumb-frame', {
                                class: {
                                    'media-backlight': !!item.event.poster
                                }
                            }, item.event.poster ? $fade1dd2de7865f5$var$mediaBacklight(item.event.poster, (0, $2Z6Kw.img)({
                                attrs: {
                                    src: item.event.poster,
                                    alt: '',
                                    draggable: 'false'
                                }
                            })) : [
                                (0, $2Z6Kw.span)('.events-carousel-thumb-ph')
                            ])
                        ])
                    ]))),
                (0, $2Z6Kw.button)('.events-carousel-nav.next', {
                    attrs: {
                        type: 'button',
                        title: $fade1dd2de7865f5$var$copy(i18n, 'next', "\u0421\u043B\u0435\u0434\u0432\u0430\u0449\u043E"),
                        'aria-label': $fade1dd2de7865f5$var$copy(i18n, 'next', "\u0421\u043B\u0435\u0434\u0432\u0430\u0449\u043E")
                    },
                    on: {
                        click: ()=>setIndex(index + 1)
                    }
                }, "\u203A")
            ]),
            (0, $2Z6Kw.ul)('.events-carousel-thumb-labels', items.map((item, i)=>(0, $2Z6Kw.li)('.events-carousel-thumb-label-item', {
                    class: {
                        'is-active': i === index
                    }
                }, [
                    (0, $2Z6Kw.button)({
                        attrs: {
                            type: 'button'
                        },
                        on: {
                            click: ()=>setIndex(i)
                        }
                    }, [
                        (0, $2Z6Kw.span)('.events-carousel-thumb-label', $fade1dd2de7865f5$var$thumbLabel(item, lang, i18n))
                    ])
                ])))
        ])
    ]);
};



var $6QkUD = parcelRequire("6QkUD");
/**
 * Widget registry by `kind`. Unknown / not-yet-ported kinds render nothing.
 */ const $5903ebdfedc1f2fa$var$registry = {
    static: (0, $dgw34.default),
    'track-list': (0, $fFCx8.default),
    'events-carousel': (0, $fade1dd2de7865f5$export$2e2bcd8739ae039),
    'address-map': (0, (/*@__PURE__*/$parcel$interopDefault($6QkUD)))
};
var $5903ebdfedc1f2fa$export$2e2bcd8739ae039 = (node, ctx)=>{
    const kind = node && node.kind;
    const render = kind && $5903ebdfedc1f2fa$var$registry[kind];
    if (!render) return [];
    return render({
        node: node,
        ...ctx
    });
};


var $c7b45421880dd70e$exports = {};
'use strict';

var $2Z6Kw = parcelRequire("2Z6Kw");
var $c7b45421880dd70e$require$section = $2Z6Kw.section;
var $c7b45421880dd70e$require$h1 = $2Z6Kw.h1;
var $c7b45421880dd70e$require$h2 = $2Z6Kw.h2;
var $c7b45421880dd70e$require$h3 = $2Z6Kw.h3;
var $c7b45421880dd70e$require$hr = $2Z6Kw.hr;
var $c7b45421880dd70e$require$header = $2Z6Kw.header;
var $c7b45421880dd70e$require$i = $2Z6Kw.i;
var $c7b45421880dd70e$require$ul = $2Z6Kw.ul;
var $c7b45421880dd70e$require$li = $2Z6Kw.li;
var $c7b45421880dd70e$require$a = $2Z6Kw.a;
var $c7b45421880dd70e$require$span = $2Z6Kw.span;
var $c7b45421880dd70e$require$img = $2Z6Kw.img;
var $c7b45421880dd70e$require$table = $2Z6Kw.table;
var $c7b45421880dd70e$require$thead = $2Z6Kw.thead;
var $c7b45421880dd70e$require$tbody = $2Z6Kw.tbody;
var $c7b45421880dd70e$require$tr = $2Z6Kw.tr;
var $c7b45421880dd70e$require$td = $2Z6Kw.td;
var $c7b45421880dd70e$require$th = $2Z6Kw.th;
var $c7b45421880dd70e$require$form = $2Z6Kw.form;
var $c7b45421880dd70e$require$input = $2Z6Kw.input;
var $c7b45421880dd70e$require$button = $2Z6Kw.button;
var $c7b45421880dd70e$require$label = $2Z6Kw.label;

var $jjnZg = parcelRequire("jjnZg");
var $c7b45421880dd70e$require$obj = $jjnZg.obj;








// home / about render via layout.yml static widgets (home-page-layout / about-page-layout)
const $c7b45421880dd70e$var$pages = {
    default: ()=>[],
    admin: (parcelRequire("gCnfA")),
    articles: (parcelRequire("eAbd1")),
    calendar: (parcelRequire("gtEcv")),
    events: (parcelRequire("gtEcv")),
    projects: (parcelRequire("823PN")),
    profiles: (parcelRequire("eRGgr")),
    links: (parcelRequire("aAvSU")),
    contact: (parcelRequire("2yONn"))
};
$c7b45421880dd70e$exports = ({ state: state, actions: actions, i18n: i18n })=>$c7b45421880dd70e$require$section('.content', [
        $c7b45421880dd70e$require$obj.switch(state.router.path, $c7b45421880dd70e$var$pages)({
            state: state,
            actions: actions,
            i18n: i18n
        })
    ]);


var $3f4aeb5dd4ac76fb$exports = {};
'use strict';

var $2Z6Kw = parcelRequire("2Z6Kw");
var $3f4aeb5dd4ac76fb$require$section = $2Z6Kw.section;
var $3f4aeb5dd4ac76fb$require$i = $2Z6Kw.i;
var $3f4aeb5dd4ac76fb$require$ul = $2Z6Kw.ul;
var $3f4aeb5dd4ac76fb$require$li = $2Z6Kw.li;
var $3f4aeb5dd4ac76fb$require$a = $2Z6Kw.a;
var $3f4aeb5dd4ac76fb$require$img = $2Z6Kw.img;
var $834f06b25d636945$exports = {};
'use strict';

var $1zDll = parcelRequire("1zDll");
parcelRequire("12DVH");
var $5a116c1a8f4c9d55$exports = {};
!function(e, t) {
    $5a116c1a8f4c9d55$exports = t();
}($5a116c1a8f4c9d55$exports, function() {
    "use strict";
    var e = "day";
    return function(t, i, s) {
        var a = function(t) {
            return t.add(4 - t.isoWeekday(), e);
        }, d = i.prototype;
        d.isoWeekYear = function() {
            return a(this).year();
        }, d.isoWeek = function(t) {
            if (!this.$utils().u(t)) return this.add(7 * (t - this.isoWeek()), e);
            var i, d, n, o, r = a(this), u = (i = this.isoWeekYear(), d = this.$u, n = (d ? s.utc : s)().year(i).startOf("year"), o = 4 - n.isoWeekday(), n.isoWeekday() > 4 && (o += 7), n.add(o, e));
            return r.diff(u, "week") + 1;
        }, d.isoWeekday = function(e) {
            return this.$utils().u(e) ? this.day() || 7 : this.day(this.day() % 7 ? e : e - 7);
        };
        var n = d.startOf;
        d.startOf = function(e, t) {
            var i = this.$utils(), s = !!i.u(t) || t;
            return "isoweek" === i.p(e) ? s ? this.date(this.date() - (this.isoWeekday() - 1)).startOf("day") : this.date(this.date() - 1 - (this.isoWeekday() - 1) + 7).endOf("day") : n.bind(this)(e, t);
        };
    };
});


$1zDll.extend($5a116c1a8f4c9d55$exports);
$1zDll.locale('bg');
const $834f06b25d636945$var$getDays = ()=>{
    const today = $1zDll();
    const endOfMonth = today.endOf('month');
    let iterator = today.startOf('month').startOf('isoWeek');
    let days = [];
    while(iterator.valueOf() < endOfMonth.valueOf()){
        let weekdays = [];
        for(let i = 0; i < 7; i++){
            weekdays.push(iterator.date());
            iterator = iterator.add(1, 'day');
        }
        days.push(weekdays);
    }
    return days;
};

var $2Z6Kw = parcelRequire("2Z6Kw");
var $834f06b25d636945$require$section = $2Z6Kw.section;
var $834f06b25d636945$require$h1 = $2Z6Kw.h1;
var $834f06b25d636945$require$h2 = $2Z6Kw.h2;
var $834f06b25d636945$require$h3 = $2Z6Kw.h3;
var $834f06b25d636945$require$hr = $2Z6Kw.hr;
var $834f06b25d636945$require$header = $2Z6Kw.header;
var $834f06b25d636945$require$i = $2Z6Kw.i;
var $834f06b25d636945$require$ul = $2Z6Kw.ul;
var $834f06b25d636945$require$li = $2Z6Kw.li;
var $834f06b25d636945$require$table = $2Z6Kw.table;
var $834f06b25d636945$require$thead = $2Z6Kw.thead;
var $834f06b25d636945$require$tbody = $2Z6Kw.tbody;
var $834f06b25d636945$require$tr = $2Z6Kw.tr;
var $834f06b25d636945$require$td = $2Z6Kw.td;
var $834f06b25d636945$require$th = $2Z6Kw.th;
var $834f06b25d636945$require$button = $2Z6Kw.button;
$834f06b25d636945$exports = ({ state: state, actions: actions })=>$834f06b25d636945$require$section('.calendar', [
        $834f06b25d636945$require$table([
            $834f06b25d636945$require$thead([
                $834f06b25d636945$require$tr([
                    $834f06b25d636945$require$th([
                        $834f06b25d636945$require$button('.fa.fa-step-backward')
                    ]),
                    $834f06b25d636945$require$th([
                        $834f06b25d636945$require$button('.fa.fa-backward')
                    ]),
                    $834f06b25d636945$require$th({
                        attrs: {
                            colspan: 3
                        },
                        style: {
                            textTransform: 'capitalize'
                        }
                    }, $1zDll().format('MMMM YYYY')),
                    $834f06b25d636945$require$th([
                        $834f06b25d636945$require$button('.fa.fa-forward')
                    ]),
                    $834f06b25d636945$require$th([
                        $834f06b25d636945$require$button('.fa.fa-step-forward')
                    ])
                ]),
                $834f06b25d636945$require$tr([
                    "\u041F\u043E\u043D",
                    "\u0412\u0442\u043E",
                    "\u0421\u0440\u044F",
                    "\u0427\u0435\u0442",
                    "\u041F\u0435\u0442",
                    "\u0421\u044A\u0431",
                    "\u041D\u0435\u0434"
                ].map((wday)=>$834f06b25d636945$require$th(wday)))
            ]),
            $834f06b25d636945$require$tbody($834f06b25d636945$var$getDays().map((week)=>$834f06b25d636945$require$tr(week.map((day)=>$834f06b25d636945$require$td(day)))))
        ])
    ]);



var $6QkUD = parcelRequire("6QkUD");
var $502a9cf49c3e03ad$exports = {};
'use strict';

var $3QJuk = parcelRequire("3QJuk");
const { resolveLocalized: $502a9cf49c3e03ad$var$resolveLocalized, DEFAULT_LOCALE: $502a9cf49c3e03ad$var$DEFAULT_LOCALE } = $3QJuk.default || $3QJuk;
const $502a9cf49c3e03ad$var$pickNonEmpty = (obj, key)=>{
    if (!obj || obj[key] == null) return undefined;
    const v = obj[key];
    if (typeof v === 'string' && v.trim() === '') return undefined;
    if (typeof v === 'number' && Number.isNaN(v)) return undefined;
    return v;
};
const $502a9cf49c3e03ad$var$mergeAddress = (primary, fallback)=>{
    const a = primary || {};
    const b = fallback || {};
    const out = {};
    [
        'street',
        'city',
        'zip',
        'country'
    ].forEach((k)=>{
        const v = $502a9cf49c3e03ad$var$pickNonEmpty(a, k);
        out[k] = v !== undefined ? v : $502a9cf49c3e03ad$var$pickNonEmpty(b, k);
    });
    const pickGeo = (geo)=>{
        if (!geo) return undefined;
        const lat = $502a9cf49c3e03ad$var$pickNonEmpty(geo, 'lat');
        const lng = $502a9cf49c3e03ad$var$pickNonEmpty(geo, 'lng');
        if (lat === undefined && lng === undefined) return undefined;
        // (0, 0) is the form/API empty sentinel — fall through to profile coords
        if (Number(lat) === 0 && Number(lng) === 0) return undefined;
        return {
            lat: lat,
            lng: lng
        };
    };
    const geo = pickGeo(a.geo) || pickGeo(b && b.geo);
    if (geo) out.geo = geo;
    return out;
};
const $502a9cf49c3e03ad$var$resolveVenue = (event, lang)=>{
    const venue = event && event.venue || {};
    const profile = venue.profile && typeof venue.profile === 'object' ? venue.profile : null;
    const name = $502a9cf49c3e03ad$var$resolveLocalized(venue.name, lang) || (profile ? $502a9cf49c3e03ad$var$resolveLocalized(profile.fullName, lang) : '') || '';
    const address = $502a9cf49c3e03ad$var$mergeAddress(venue.address, profile && profile.address);
    return {
        name: name,
        address: address,
        profile: profile
    };
};
const $502a9cf49c3e03ad$var$formatAddressLine = (address)=>{
    if (!address) return '';
    const cityZip = [
        address.city,
        address.zip
    ].filter(Boolean).join(' ').trim();
    return [
        address.street,
        cityZip,
        address.country
    ].filter(Boolean).join(', ');
};
const $502a9cf49c3e03ad$var$formatLocation = (resolved)=>{
    if (!resolved) return '';
    const addr = $502a9cf49c3e03ad$var$formatAddressLine(resolved.address);
    return [
        resolved.name,
        addr
    ].filter(Boolean).join(', ');
};
const $502a9cf49c3e03ad$var$hasUsableGeo = (address)=>{
    const geo = address && address.geo;
    if (!geo || geo.lat == null || geo.lng == null) return false;
    const lat = Number(geo.lat);
    const lng = Number(geo.lng);
    if (Number.isNaN(lat) || Number.isNaN(lng)) return false;
    if (lat === 0 && lng === 0) return false;
    return true;
};
const $502a9cf49c3e03ad$var$addressHasContent = (address)=>{
    if (!address) return false;
    return Boolean(address.street || address.city || address.zip || address.country || $502a9cf49c3e03ad$var$hasUsableGeo(address));
};
$502a9cf49c3e03ad$exports = {
    mergeAddress: $502a9cf49c3e03ad$var$mergeAddress,
    resolveVenue: $502a9cf49c3e03ad$var$resolveVenue,
    formatAddressLine: $502a9cf49c3e03ad$var$formatAddressLine,
    formatLocation: $502a9cf49c3e03ad$var$formatLocation,
    addressHasContent: $502a9cf49c3e03ad$var$addressHasContent,
    DEFAULT_LOCALE: $502a9cf49c3e03ad$var$DEFAULT_LOCALE
};



var $cDQjg = parcelRequire("cDQjg");

var $3QJuk = parcelRequire("3QJuk");
const { resolveLocalized: $3f4aeb5dd4ac76fb$var$resolveLocalized, DEFAULT_LOCALE: $3f4aeb5dd4ac76fb$var$DEFAULT_LOCALE } = $3QJuk.default || $3QJuk;
const $3f4aeb5dd4ac76fb$var$profilePath = (profile)=>{
    if (!profile) return '';
    const id = profile.slug || profile._id;
    return id ? `/profiles/${id}` : '';
};
const $3f4aeb5dd4ac76fb$var$isEventDetail = (path)=>(path[0] === 'calendar' || path[0] === 'events') && Boolean(path[1]);
const $3f4aeb5dd4ac76fb$var$hydrateVenueProfile = (event, profiles)=>{
    const venue = event && event.venue;
    const ref = venue && venue.profile;
    if (!ref || typeof ref === 'object') return event;
    const id = String(ref);
    const found = (profiles || []).find((p)=>String(p._id) === id || p.slug === id);
    if (!found) return event;
    return Object.assign({}, event, {
        venue: Object.assign({}, venue, {
            profile: found
        })
    });
};
const $3f4aeb5dd4ac76fb$var$eventDetailPane = ({ state: state, i18n: i18n })=>{
    const lang = state.lang || $3f4aeb5dd4ac76fb$var$DEFAULT_LOCALE;
    const event = $3f4aeb5dd4ac76fb$var$hydrateVenueProfile(state.events && state.events.doc || {}, state.profiles && state.profiles.list || []);
    const title = $3f4aeb5dd4ac76fb$var$resolveLocalized(event.title, lang) || '';
    const venue = $502a9cf49c3e03ad$exports.resolveVenue(event, lang);
    const address = venue && venue.address;
    const showAddress = $502a9cf49c3e03ad$exports.addressHasContent(address);
    const profile = venue && venue.profile;
    const gravatarUtil = $cDQjg.default || $cDQjg;
    const avatar = profile && gravatarUtil.src ? gravatarUtil.src(profile, 112) : profile && profile.avatar || '';
    const profileUrl = $3f4aeb5dd4ac76fb$var$profilePath(profile);
    const description = profile ? $3f4aeb5dd4ac76fb$var$resolveLocalized(profile.about, lang) : '';
    return [
        event.poster ? $3f4aeb5dd4ac76fb$require$section('.poster', [
            $3f4aeb5dd4ac76fb$require$img({
                attrs: {
                    src: event.poster,
                    alt: title
                }
            })
        ]) : '',
        showAddress ? $6QkUD({
            address: address,
            title: venue.name || undefined,
            avatar: avatar || undefined,
            url: profileUrl || undefined,
            description: description || undefined,
            lang: lang,
            i18n: i18n
        }) : ''
    ];
};
const $3f4aeb5dd4ac76fb$var$defaultPane = ({ state: state, actions: actions })=>[
        $3f4aeb5dd4ac76fb$require$section([
            $3f4aeb5dd4ac76fb$require$ul([
                $3f4aeb5dd4ac76fb$require$li([
                    $3f4aeb5dd4ac76fb$require$a('[href="https://fb.com/musictech.bg"][target="_blank"]', [
                        $3f4aeb5dd4ac76fb$require$i('.fa.fa-facebook'),
                        'MusicTech.bg @ Facebook'
                    ])
                ]),
                $3f4aeb5dd4ac76fb$require$li([
                    $3f4aeb5dd4ac76fb$require$a('[href="https://fb.com/groups/musictechbg"][target="_blank"]', [
                        $3f4aeb5dd4ac76fb$require$i('.fa.fa-facebook-official'),
                        "Facebook \u0413\u0440\u0443\u043F\u0430 MusicTechBG"
                    ])
                ]),
                $3f4aeb5dd4ac76fb$require$li([
                    $3f4aeb5dd4ac76fb$require$a('[href="https://www.youtube.com/channel/UCphmUQ_1b0g9sIhmo505nAg"][target="_blank"]', [
                        $3f4aeb5dd4ac76fb$require$i('.fa.fa-youtube'),
                        "Youtube \u041A\u0430\u043D\u0430\u043B MusicTechBG"
                    ])
                ])
            ])
        ]),
        $834f06b25d636945$exports({
            state: state,
            actions: actions
        })
    ];
$3f4aeb5dd4ac76fb$exports = ({ state: state, actions: actions, i18n: i18n })=>{
    const path = state.router && state.router.path || [];
    return $3f4aeb5dd4ac76fb$require$section('.right-pane', $3f4aeb5dd4ac76fb$var$isEventDetail(path) ? $3f4aeb5dd4ac76fb$var$eventDetailPane({
        state: state,
        i18n: i18n
    }) : $3f4aeb5dd4ac76fb$var$defaultPane({
        state: state,
        actions: actions
    }));
};


const $17899ea4893f896b$var$BASE_LAYOUT_ID = 'base-layout';
/** Public static pages that fill `content` from YAML + i18n widgets. */ const $17899ea4893f896b$var$STATIC_LAYOUTS = {
    home: 'home-page-layout',
    about: 'about-page-layout'
};
const $17899ea4893f896b$var$tagFor = (node)=>{
    const name = (node.tag || 'div').toLowerCase();
    if (name === 'main') return 0, $2Z6Kw.main;
    if (name === 'aside') return 0, $2Z6Kw.aside;
    if (name === 'section') return 0, $2Z6Kw.section;
    return 0, $2Z6Kw.div;
};
const $17899ea4893f896b$var$classFor = (node)=>{
    const parts = [];
    if (node.id) parts.push(node.id);
    if (node.kind && node.type === 'panel') parts.push(`panel-${node.kind}`);
    return parts.length ? `.${parts.join('.')}` : '';
};
/**
 * Render a resolved panel tree. `slots[id]` replaces that node entirely
 * (return null/false/[] to omit). Widgets use the kind registry.
 */ const $17899ea4893f896b$var$renderNode = (node, ctx)=>{
    const { slots: slots = {} } = ctx;
    if (!node) return [];
    if (node.id && Object.prototype.hasOwnProperty.call(slots, node.id)) {
        const slotted = slots[node.id]({
            ...ctx,
            node: node
        });
        if (slotted == null || slotted === false) return [];
        return slotted;
    }
    if (node.type === 'widget') return (0, $5903ebdfedc1f2fa$export$2e2bcd8739ae039)(node, ctx);
    const tag = $17899ea4893f896b$var$tagFor(node);
    const sel = $17899ea4893f896b$var$classFor(node);
    const children = (node.children || []).map((child)=>$17899ea4893f896b$var$renderNode(child, ctx));
    const childrenFlat = [].concat(...children.map((c)=>[].concat(c)));
    return sel ? tag(sel, childrenFlat) : tag(childrenFlat);
};
const $17899ea4893f896b$var$isProfileDetail = (path = [])=>path[0] === 'profiles' && Boolean(path[1]);
const $17899ea4893f896b$var$isHome = (path = [], page)=>page === 'home' || !path[0] || path[0] === 'home';
const $17899ea4893f896b$var$layoutIdFor = (path = [])=>{
    const page = path[0] || 'home';
    if ($17899ea4893f896b$var$isProfileDetail(path)) return 'profile-detail-layout';
    return $17899ea4893f896b$var$STATIC_LAYOUTS[page] || $17899ea4893f896b$var$BASE_LAYOUT_ID;
};
var $17899ea4893f896b$export$2e2bcd8739ae039 = ({ state: state, actions: actions, i18n: i18n })=>{
    const entries = (0, (/*@__PURE__*/$parcel$interopDefault($167ae3265028d805$exports))) && (0, (/*@__PURE__*/$parcel$interopDefault($167ae3265028d805$exports))).layout || [];
    const path = state.router && state.router.path || [];
    const page = state.router && state.router.page || path[0] || 'home';
    const layoutId = $17899ea4893f896b$var$layoutIdFor(path);
    const tree = (0, $50ca37520d8c31ef$export$f7ad0328861e2f03)(entries, layoutId);
    const isAdmin = path[0] === 'admin';
    const hideRightPane = isAdmin || $17899ea4893f896b$var$isProfileDetail(path) || $17899ea4893f896b$var$isHome(path, page);
    const isStatic = Boolean($17899ea4893f896b$var$STATIC_LAYOUTS[path[0] || 'home']);
    const ctx = {
        state: state,
        actions: actions,
        i18n: i18n
    };
    const slots = {
        // Static pages: content comes from YAML widgets. Legacy pages: page switch.
        ...isStatic ? {} : {
            content: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($c7b45421880dd70e$exports)))({
                    state: state,
                    actions: actions,
                    i18n: i18n
                })
        },
        'right-pane': hideRightPane ? ()=>null : ()=>(0, (/*@__PURE__*/$parcel$interopDefault($3f4aeb5dd4ac76fb$exports)))({
                state: state,
                actions: actions,
                i18n: i18n
            })
    };
    if (!tree) return (0, $2Z6Kw.main)([].concat((0, (/*@__PURE__*/$parcel$interopDefault($c7b45421880dd70e$exports)))({
        state: state,
        actions: actions,
        i18n: i18n
    }), hideRightPane ? [] : (0, (/*@__PURE__*/$parcel$interopDefault($3f4aeb5dd4ac76fb$exports)))({
        state: state,
        actions: actions,
        i18n: i18n
    })));
    return $17899ea4893f896b$var$renderNode(tree, {
        ...ctx,
        slots: slots
    });
};


var $918388a15a1aa2ed$export$2e2bcd8739ae039 = ({ state: state, actions: actions, i18n: i18n })=>(0, $2Z6Kw.body)([
        (0, $232e760e39c9a25a$export$2e2bcd8739ae039)({
            state: state,
            actions: actions,
            i18n: i18n
        }),
        (0, $17899ea4893f896b$export$2e2bcd8739ae039)({
            state: state,
            actions: actions,
            i18n: i18n
        })
    ]);


var $611de703fc24c8b9$exports = {};
'use strict';

// Generated by `node bin/build-i18n.js` from config/i18n/**/*.json
$611de703fc24c8b9$exports = (parcelRequire("lsr9y"));


var $0f196eb47fbd0a67$exports = {};
'use strict';

var $hYEnO = parcelRequire("hYEnO");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $be7a6c25bf3d5e43$export$779c5fb865a0172e(comparator, keySelector) {
    if (keySelector === void 0) keySelector = (0, $hYEnO.identity);
    comparator = comparator !== null && comparator !== void 0 ? comparator : $be7a6c25bf3d5e43$var$defaultCompare;
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var previousKey;
        var first = true;
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            var currentKey = keySelector(value);
            if (first || !comparator(previousKey, currentKey)) {
                first = false;
                previousKey = currentKey;
                subscriber.next(value);
            }
        }));
    });
}
function $be7a6c25bf3d5e43$var$defaultCompare(a, b) {
    return a === b;
}


var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");
function $f8c2efb87b448d56$export$3dea766d36a8935f(predicate, thisArg) {
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}


var $0f196eb47fbd0a67$require$distinctUntilChanged = $be7a6c25bf3d5e43$export$779c5fb865a0172e;
var $0f196eb47fbd0a67$require$filter = $f8c2efb87b448d56$export$3dea766d36a8935f;

var $1i1BJ = parcelRequire("1i1BJ");
var $8f4c385e4fdea4ee$exports = {};
'use strict';
let $8f4c385e4fdea4ee$var$pocket = {};
const $8f4c385e4fdea4ee$var$set = (key, value)=>typeof window !== 'undefined' ? window.localStorage.setItem(key, JSON.stringify(value)) : Object.assign($8f4c385e4fdea4ee$var$pocket, {
        [key]: value
    });
const $8f4c385e4fdea4ee$var$get = (key, defaultValue)=>typeof window !== 'undefined' ? window.localStorage.getItem(key) && JSON.parse(window.localStorage.getItem(key)) || defaultValue : typeof $8f4c385e4fdea4ee$var$pocket[key] !== 'undefined' ? $8f4c385e4fdea4ee$var$pocket[key] : defaultValue;
$8f4c385e4fdea4ee$exports = {
    set: $8f4c385e4fdea4ee$var$set,
    get: $8f4c385e4fdea4ee$var$get
};



var $jjnZg = parcelRequire("jjnZg");
var $0f196eb47fbd0a67$require$obj = $jjnZg.obj;
const $0f196eb47fbd0a67$var$port = ''; // process.env.PORT && process.env.PORT !== '80' ? `:${process.env.PORT}` : '';
const $0f196eb47fbd0a67$var$url = `//${location.host || undefined || 'localhost'}${$0f196eb47fbd0a67$var$port}`;
const $0f196eb47fbd0a67$var$forceLogout = ()=>(state)=>{
        $8f4c385e4fdea4ee$exports.set('user', null);
        $8f4c385e4fdea4ee$exports.set('token', null);
        setTimeout(()=>{
            window.location = '#/';
        });
        return $0f196eb47fbd0a67$require$obj.patch(state, 'auth', {
            user: null,
            token: null
        });
    };
const $0f196eb47fbd0a67$var$login = (data)=>$1i1BJ.post(`${$0f196eb47fbd0a67$var$url}/api/auth/authorize`).send(data).set('Accept', 'application/json').then((res)=>res.body).then(({ msg: msg, user: user, token: token })=>user ? ($8f4c385e4fdea4ee$exports.set('user', user), $8f4c385e4fdea4ee$exports.set('token', token), (state)=>$0f196eb47fbd0a67$require$obj.patch(state, 'auth', {
                user: user,
                token: token
            })) : (state)=>state);
const $0f196eb47fbd0a67$var$register = (data)=>$1i1BJ.post(`${$0f196eb47fbd0a67$var$url}/api/auth/register`).send(data).set('Accept', 'application/json').then(({ status: status })=>status === 201 ? $0f196eb47fbd0a67$var$login(data) : (state)=>state);
const $0f196eb47fbd0a67$var$logout = (token)=>$1i1BJ.delete(`${$0f196eb47fbd0a67$var$url}/api/auth/token`).query({
        token: token
    }).set('Accept', 'application/json').then((res)=>res.body).then((data)=>data.success ? $0f196eb47fbd0a67$var$forceLogout() : (state)=>state);
const $0f196eb47fbd0a67$var$actions = {
    forceLogout: $0f196eb47fbd0a67$var$forceLogout,
    login: $0f196eb47fbd0a67$var$login,
    logout: $0f196eb47fbd0a67$var$forceLogout,
    register: $0f196eb47fbd0a67$var$register,
    initial: {
        user: $8f4c385e4fdea4ee$exports.get('user'),
        token: $8f4c385e4fdea4ee$exports.get('token')
    }
};
let $0f196eb47fbd0a67$var$unhook = ()=>{};
const $0f196eb47fbd0a67$var$hook = ({ state$: state$, actions: actions })=>{
    let subs = [];
    subs.push(state$.pipe($0f196eb47fbd0a67$require$distinctUntilChanged((a, b)=>a.auth.user === b.auth.user), $0f196eb47fbd0a67$require$filter((state)=>state.auth.user && state.auth.user.email)).subscribe((state)=>state.router.page === 'auth' && actions.router.go('home')));
    $0f196eb47fbd0a67$var$unhook = ()=>{
        subs.forEach((sub)=>sub.unsubscribe());
        subs = [];
    };
};
$0f196eb47fbd0a67$exports = {
    actions: $0f196eb47fbd0a67$var$actions,
    hook: $0f196eb47fbd0a67$var$hook,
    unhook: ()=>$0f196eb47fbd0a67$var$unhook()
};


var $9c4ac63f06d34bd2$exports = {};
'use strict';

var $gvBMK = parcelRequire("gvBMK");
var $6SBin = parcelRequire("6SBin");

var $kA4PZ = parcelRequire("kA4PZ");

var $gN3J6 = parcelRequire("gN3J6");
var $a0988bcdc56b56f1$export$ccb33e29d92c9a58 = new (0, $gN3J6.Observable)(function(subscriber) {
    return subscriber.complete();
});
function $a0988bcdc56b56f1$export$6e22c362a0406a2c(scheduler) {
    return scheduler ? $a0988bcdc56b56f1$var$emptyScheduled(scheduler) : $a0988bcdc56b56f1$export$ccb33e29d92c9a58;
}
function $a0988bcdc56b56f1$var$emptyScheduled(scheduler) {
    return new (0, $gN3J6.Observable)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}



var $6kN4i = parcelRequire("6kN4i");

var $aIPjU = parcelRequire("aIPjU");
function $68c08ddc84cf7ea4$export$4950aa0f605343fb() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $6kN4i.popScheduler)(args);
    var concurrent = (0, $6kN4i.popNumber)(args, Infinity);
    var sources = args;
    return !sources.length ? (0, $a0988bcdc56b56f1$export$ccb33e29d92c9a58) : sources.length === 1 ? (0, $kA4PZ.innerFrom)(sources[0]) : (0, $63523ba376002a40$export$18aef43295bbe906)(concurrent)((0, $aIPjU.from)(sources, scheduler));
}


var $a68Z4 = parcelRequire("a68Z4");
var $ceFTv = parcelRequire("ceFTv");

var $iZT3c = parcelRequire("iZT3c");

var $lo1Ce = parcelRequire("lo1Ce");

var $kA4PZ = parcelRequire("kA4PZ");

var $hYEnO = parcelRequire("hYEnO");

var $QfuEL = parcelRequire("QfuEL");

var $6kN4i = parcelRequire("6kN4i");
function $71621886b6c12a6a$export$d449030e5c10edf7() {
    var inputs = [];
    for(var _i = 0; _i < arguments.length; _i++)inputs[_i] = arguments[_i];
    var project = (0, $6kN4i.popResultSelector)(inputs);
    return (0, $iZT3c.operate)(function(source, subscriber) {
        var len = inputs.length;
        var otherValues = new Array(len);
        var hasValue = inputs.map(function() {
            return false;
        });
        var ready = false;
        var _loop_1 = function(i) {
            (0, $kA4PZ.innerFrom)(inputs[i]).subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
                otherValues[i] = value;
                if (!ready && !hasValue[i]) {
                    hasValue[i] = true;
                    (ready = hasValue.every((0, $hYEnO.identity))) && (hasValue = null);
                }
            }, (0, $QfuEL.noop)));
        };
        for(var i = 0; i < len; i++)_loop_1(i);
        source.subscribe((0, $lo1Ce.createOperatorSubscriber)(subscriber, function(value) {
            if (ready) {
                var values = (0, $ceFTv.__spreadArray)([
                    value
                ], (0, $ceFTv.__read)(otherValues));
                subscriber.next(project ? project.apply(void 0, (0, $ceFTv.__spreadArray)([], (0, $ceFTv.__read)(values))) : values);
            }
        }));
    });
}


var $9c4ac63f06d34bd2$require$fromEvent = $gvBMK.fromEvent;
var $9c4ac63f06d34bd2$require$merge = $68c08ddc84cf7ea4$export$4950aa0f605343fb;
var $9c4ac63f06d34bd2$require$of = $a68Z4.of;
var $9c4ac63f06d34bd2$require$map = $6SBin.map;
var $9c4ac63f06d34bd2$require$withLatestFrom = $71621886b6c12a6a$export$d449030e5c10edf7;
var $9c4ac63f06d34bd2$require$filter = $f8c2efb87b448d56$export$3dea766d36a8935f;

var $jjnZg = parcelRequire("jjnZg");
var $9c4ac63f06d34bd2$require$obj = $jjnZg.obj;
const $9c4ac63f06d34bd2$var$initial = {
    mode: 'history',
    page: 'home',
    path: [
        'home'
    ],
    admin: false,
    pageId: null
};
const $9c4ac63f06d34bd2$var$parsePageParams = (str)=>{
    const raw = String(str || '').split('/').filter(Boolean);
    // `/` and `` both resolve to home (production history mode)
    const path = raw.length ? raw : [
        'home'
    ];
    const admin = path[0] === 'admin';
    const pageId = path.length > (1 + admin ? 1 : 0) ? path.slice(admin ? 2 : 1).join('/') : null;
    const page = (admin ? path.slice(0, 2).join('.') : path[0]) || 'home';
    return {
        path: path,
        admin: admin,
        page: page,
        pageId: pageId
    };
};
let $9c4ac63f06d34bd2$var$change;
let $9c4ac63f06d34bd2$var$go;
$9c4ac63f06d34bd2$var$change = (page)=>(state)=>page.match('admin') && (!state.auth.user || [
            'admin',
            'editor'
        ].indexOf(state.auth.user.role) === -1) ? ($9c4ac63f06d34bd2$var$go('home'), state) : $9c4ac63f06d34bd2$require$obj.patch(state, 'router', $9c4ac63f06d34bd2$var$parsePageParams(page));
// go action, handled within the service hook
$9c4ac63f06d34bd2$var$go = (page)=>(state)=>state;
const $9c4ac63f06d34bd2$var$actions = {
    initial: $9c4ac63f06d34bd2$var$initial,
    change: $9c4ac63f06d34bd2$var$change,
    go: $9c4ac63f06d34bd2$var$go
};
const $9c4ac63f06d34bd2$var$clearSlashes = (path)=>path.toString().replace(/\/$/, '').replace(/^\//, '');
const $9c4ac63f06d34bd2$var$getFragment = ({ mode: mode, root: root = '/' })=>{
    let fragment = '';
    if (mode === 'history') {
        fragment = $9c4ac63f06d34bd2$var$clearSlashes(decodeURI(location.pathname + location.search));
        fragment = fragment.replace(/\?(.*)$/, '');
        fragment = root !== '/' ? fragment.replace(root, '') : fragment;
    } else {
        var match = window.location.href.match(/#(.*)$/);
        fragment = match ? match[1] : '';
    }
    return $9c4ac63f06d34bd2$var$clearSlashes(fragment);
};
let $9c4ac63f06d34bd2$var$unhook = ()=>{};
const $9c4ac63f06d34bd2$var$hook = ({ state$: state$, actions: actions })=>{
    let subs = [];
    const hashChange$ = $9c4ac63f06d34bd2$require$fromEvent(window, 'hashchange');
    const popState$ = $9c4ac63f06d34bd2$require$fromEvent(window, 'popstate');
    const locationChangeSub = $9c4ac63f06d34bd2$require$merge(hashChange$.pipe($9c4ac63f06d34bd2$require$map(()=>({
            type: 'hash'
        }))), popState$.pipe($9c4ac63f06d34bd2$require$map(()=>({
            type: 'history'
        }))), $9c4ac63f06d34bd2$require$of({
        type: 'initial'
    })).pipe($9c4ac63f06d34bd2$require$withLatestFrom(state$, (evt, state)=>({
            evt: evt,
            state: state
        }))).subscribe(({ state: state, evt: evt })=>{
        let mode = evt.type === 'initial' ? state.router.mode : evt.type;
        let url = $9c4ac63f06d34bd2$var$getFragment({
            mode: mode
        });
        if (mode !== state.router.mode) actions.router.go(url.split('/').join('.'));
        else actions.router.change(url);
    });
    subs.push(locationChangeSub);
    // Nested namespaces no longer have their own stream; filter root actions.stream
    const actionsHandlerSub = actions.stream.pipe($9c4ac63f06d34bd2$require$filter((action)=>action.path && action.path.join('.') === 'router.go'), $9c4ac63f06d34bd2$require$withLatestFrom(state$, (action, state)=>({
            action: action,
            state: state
        }))).subscribe(({ action: action, state: state })=>{
        let page = action.payload[0];
        let url = page !== 'home' ? page.split('.').join('/') : '';
        console.log(action.path, page, url, state.router);
        if (state.router.mode === 'hash') window.location.hash = `/${url}`;
        else {
            window.history.pushState({
                page: page
            }, `${page}`, `/${url}`);
            actions.router.change(url);
        }
    });
    subs.push(actionsHandlerSub);
    $9c4ac63f06d34bd2$var$unhook = ()=>{
        subs.forEach((sub)=>sub.unsubscribe());
        subs = [];
    };
    return $9c4ac63f06d34bd2$var$unhook;
};
$9c4ac63f06d34bd2$exports = {
    actions: $9c4ac63f06d34bd2$var$actions,
    hook: $9c4ac63f06d34bd2$var$hook,
    unhook: ()=>$9c4ac63f06d34bd2$var$unhook()
};


var $7bf98248e39b8900$exports = {};
'use strict';
var $64ea682042a624e2$exports = {};

$64ea682042a624e2$exports = (parcelRequire("9XpJf"));


const $7bf98248e39b8900$var$actions = {
    initial: {
        routes: {},
        collections: {}
    }
};
let $7bf98248e39b8900$var$unhook = ()=>{};
const $7bf98248e39b8900$var$hook = ({ state$: state$, actions: actions })=>{
    actions.set('rest', $64ea682042a624e2$exports);
};
$7bf98248e39b8900$exports = {
    actions: $7bf98248e39b8900$var$actions,
    config: $64ea682042a624e2$exports,
    hook: $7bf98248e39b8900$var$hook,
    unhook: $7bf98248e39b8900$var$unhook
};


var $9962d45754332879$exports = {};
'use strict';

var $9962d45754332879$require$distinctUntilChanged = $be7a6c25bf3d5e43$export$779c5fb865a0172e;
var $9962d45754332879$require$filter = $f8c2efb87b448d56$export$3dea766d36a8935f;
var $e615f5d44a43b294$exports = {};
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
var $371a3837fd81d701$exports = {};
// shim for using process in browser
var $371a3837fd81d701$var$process = $371a3837fd81d701$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $371a3837fd81d701$var$cachedSetTimeout;
var $371a3837fd81d701$var$cachedClearTimeout;
function $371a3837fd81d701$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $371a3837fd81d701$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        else $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    } catch (e) {
        $371a3837fd81d701$var$cachedSetTimeout = $371a3837fd81d701$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        else $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    } catch (e) {
        $371a3837fd81d701$var$cachedClearTimeout = $371a3837fd81d701$var$defaultClearTimeout;
    }
})();
function $371a3837fd81d701$var$runTimeout(fun) {
    if ($371a3837fd81d701$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedSetTimeout === $371a3837fd81d701$var$defaultSetTimout || !$371a3837fd81d701$var$cachedSetTimeout) && setTimeout) {
        $371a3837fd81d701$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $371a3837fd81d701$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $371a3837fd81d701$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $371a3837fd81d701$var$runClearTimeout(marker) {
    if ($371a3837fd81d701$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($371a3837fd81d701$var$cachedClearTimeout === $371a3837fd81d701$var$defaultClearTimeout || !$371a3837fd81d701$var$cachedClearTimeout) && clearTimeout) {
        $371a3837fd81d701$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $371a3837fd81d701$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $371a3837fd81d701$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $371a3837fd81d701$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $371a3837fd81d701$var$queue = [];
var $371a3837fd81d701$var$draining = false;
var $371a3837fd81d701$var$currentQueue;
var $371a3837fd81d701$var$queueIndex = -1;
function $371a3837fd81d701$var$cleanUpNextTick() {
    if (!$371a3837fd81d701$var$draining || !$371a3837fd81d701$var$currentQueue) return;
    $371a3837fd81d701$var$draining = false;
    if ($371a3837fd81d701$var$currentQueue.length) $371a3837fd81d701$var$queue = $371a3837fd81d701$var$currentQueue.concat($371a3837fd81d701$var$queue);
    else $371a3837fd81d701$var$queueIndex = -1;
    if ($371a3837fd81d701$var$queue.length) $371a3837fd81d701$var$drainQueue();
}
function $371a3837fd81d701$var$drainQueue() {
    if ($371a3837fd81d701$var$draining) return;
    var timeout = $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$cleanUpNextTick);
    $371a3837fd81d701$var$draining = true;
    var len = $371a3837fd81d701$var$queue.length;
    while(len){
        $371a3837fd81d701$var$currentQueue = $371a3837fd81d701$var$queue;
        $371a3837fd81d701$var$queue = [];
        while(++$371a3837fd81d701$var$queueIndex < len)if ($371a3837fd81d701$var$currentQueue) $371a3837fd81d701$var$currentQueue[$371a3837fd81d701$var$queueIndex].run();
        $371a3837fd81d701$var$queueIndex = -1;
        len = $371a3837fd81d701$var$queue.length;
    }
    $371a3837fd81d701$var$currentQueue = null;
    $371a3837fd81d701$var$draining = false;
    $371a3837fd81d701$var$runClearTimeout(timeout);
}
$371a3837fd81d701$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $371a3837fd81d701$var$queue.push(new $371a3837fd81d701$var$Item(fun, args));
    if ($371a3837fd81d701$var$queue.length === 1 && !$371a3837fd81d701$var$draining) $371a3837fd81d701$var$runTimeout($371a3837fd81d701$var$drainQueue);
};
// v8 likes predictible objects
function $371a3837fd81d701$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$371a3837fd81d701$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$371a3837fd81d701$var$process.title = 'browser';
$371a3837fd81d701$var$process.browser = true;
$371a3837fd81d701$var$process.env = {};
$371a3837fd81d701$var$process.argv = [];
$371a3837fd81d701$var$process.version = ''; // empty string to avoid regexp issues
$371a3837fd81d701$var$process.versions = {};
function $371a3837fd81d701$var$noop() {}
$371a3837fd81d701$var$process.on = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.addListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.once = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.off = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.removeAllListeners = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.emit = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.prependOnceListener = $371a3837fd81d701$var$noop;
$371a3837fd81d701$var$process.listeners = function(name) {
    return [];
};
$371a3837fd81d701$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$371a3837fd81d701$var$process.cwd = function() {
    return '/';
};
$371a3837fd81d701$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$371a3837fd81d701$var$process.umask = function() {
    return 0;
};


'use strict';
function $e615f5d44a43b294$var$assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $e615f5d44a43b294$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = '';
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf('/');
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = '';
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf('/');
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = '';
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += '/..';
                    else res = '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += '/' + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $e615f5d44a43b294$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || '') + (pathObject.ext || '');
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $e615f5d44a43b294$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = '';
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $371a3837fd81d701$exports.cwd();
                path = cwd;
            }
            $e615f5d44a43b294$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + '/' + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $e615f5d44a43b294$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return '/' + resolvedPath;
            else return '/';
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return '.';
    },
    normalize: function normalize(path) {
        $e615f5d44a43b294$var$assertPath(path);
        if (path.length === 0) return '.';
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $e615f5d44a43b294$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = '.';
        if (path.length > 0 && trailingSeparator) path += '/';
        if (isAbsolute) return '/' + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $e615f5d44a43b294$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return '.';
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $e615f5d44a43b294$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += '/' + arg;
            }
        }
        if (joined === undefined) return '.';
        return $e615f5d44a43b294$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $e615f5d44a43b294$var$assertPath(from);
        $e615f5d44a43b294$var$assertPath(to);
        if (from === to) return '';
        from = $e615f5d44a43b294$var$posix.resolve(from);
        to = $e615f5d44a43b294$var$posix.resolve(to);
        if (from === to) return '';
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = '';
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += '..';
            else out += '/..';
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $e615f5d44a43b294$var$assertPath(path);
        if (path.length === 0) return '.';
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? '/' : '.';
        if (hasRoot && end === 1) return '//';
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
        $e615f5d44a43b294$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return '';
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return '';
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $e615f5d44a43b294$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== 'object') throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $e615f5d44a43b294$var$_format('/', pathObject);
    },
    parse: function parse(path) {
        $e615f5d44a43b294$var$assertPath(path);
        var ret = {
            root: '',
            dir: '',
            base: '',
            ext: '',
            name: ''
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = '/';
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = '/';
        return ret;
    },
    sep: '/',
    delimiter: ':',
    win32: null,
    posix: null
};
$e615f5d44a43b294$var$posix.posix = $e615f5d44a43b294$var$posix;
$e615f5d44a43b294$exports = $e615f5d44a43b294$var$posix;



var $jjnZg = parcelRequire("jjnZg");
var $9962d45754332879$require$obj = $jjnZg.obj;

var $1i1BJ = parcelRequire("1i1BJ");

const $9962d45754332879$var$port = ''; // process.env.PORT && process.env.PORT !== '80' ? `:${process.env.PORT}` : '';
const $9962d45754332879$var$url = `//${location.host || undefined || 'localhost'}${$9962d45754332879$var$port}`;
const $9962d45754332879$var$initial = {
    query: {
        start: 0,
        limit: 10,
        search: ''
    },
    list: [],
    doc: {},
    focused: false,
    dirty: true
};
/** Public calendar/community lists need more than the admin page size. */ const $9962d45754332879$var$publicListLimit = {
    events: 200,
    profiles: 100
};
/** Admin events list: show a long newest-first window (no pagination UI yet). */ const $9962d45754332879$var$adminListLimit = {
    events: 200
};
const $9962d45754332879$var$reservedPageIds = [
    'new',
    'configure'
];
const $9962d45754332879$var$handleUnauthorized = (err)=>(console.log(err), [
        401,
        403
    ].indexOf(err.status) > -1 ? $0f196eb47fbd0a67$exports.actions.forceLogout() : (state)=>state);

const $9962d45754332879$var$scrubEmptyObjectIds = (ns, doc)=>{
    const schema = $64ea682042a624e2$exports.collections[ns] && $64ea682042a624e2$exports.collections[ns].schema || {};
    const out = Object.keys(doc || {}).reduce((acc, key)=>{
        const field = schema[key];
        const value = doc[key];
        if (field && field.type === 'ObjectId' && (value === '' || value === undefined || value === null)) return acc;
        acc[key] = value;
        return acc;
    }, {});
    // nested venue.profile on events
    if (out.venue && typeof out.venue === 'object') {
        const venue = Object.assign({}, out.venue);
        if (venue.profile === '' || venue.profile === undefined || venue.profile === null) delete venue.profile;
        out.venue = venue;
    }
    return out;
};
const $9962d45754332879$var$stripUploadMeta = (item)=>{
    if (!item || typeof item !== 'object') return item;
    const { _file: _file, _fileName: _fileName, _urlKind: _urlKind, ...rest } = item;
    return rest;
};
const $9962d45754332879$var$hasUploadFiles = (doc)=>!!(doc && (doc._avatarFile || doc._posterFile || [
        'tracks',
        'videos'
    ].some((kind)=>(doc[kind] || []).some((item)=>item && item._file))));
const $9962d45754332879$var$toFormData = (doc)=>{
    const fd = new FormData();
    const clean = Object.assign({}, doc);
    delete clean._avatarFile;
    delete clean._avatarFileName;
    delete clean._avatarKind;
    delete clean._posterFile;
    delete clean._posterFileName;
    delete clean._posterKind;
    clean.tracks = (doc.tracks || []).map($9962d45754332879$var$stripUploadMeta);
    clean.videos = (doc.videos || []).map($9962d45754332879$var$stripUploadMeta);
    fd.append('data', JSON.stringify(clean));
    if (doc._avatarFile) fd.append('avatar', doc._avatarFile);
    if (doc._posterFile) fd.append('poster', doc._posterFile);
    (doc.tracks || []).forEach((item, i)=>{
        if (item && item._file) fd.append(`tracks[${i}]`, item._file);
    });
    (doc.videos || []).forEach((item, i)=>{
        if (item && item._file) fd.append(`videos[${i}]`, item._file);
    });
    return fd;
};
// ns - namespace
const $9962d45754332879$var$list = (ns)=>(query = {}, ctrl = '', token)=>{
        const q = Object.assign({}, query);
        // legacy admin query used `length`; API expects `limit`
        if (q.length != null && q.limit == null) q.limit = q.length;
        delete q.length;
        return $1i1BJ.get(`${$9962d45754332879$var$url}/api/${$e615f5d44a43b294$exports.join(ns, ctrl)}`).query(q).set(token && {
            'x-access-token': token
        } || {}).then((res)=>res.body).then((data)=>(state)=>$9962d45754332879$require$obj.patch(state, ns, Object.assign({}, data, {
                    dirty: false
                }))).catch($9962d45754332879$var$handleUnauthorized);
    };
const $9962d45754332879$var$query = (ns)=>(keyValuePair)=>(state)=>$9962d45754332879$require$obj.patch(state, ns, {
                query: Object.assign({}, $9962d45754332879$require$obj.sub(state, [].concat(ns, 'query')), keyValuePair),
                dirty: true
            });
const $9962d45754332879$var$create = (ns)=>(doc, token, cb = ()=>{})=>{
        const payload = $9962d45754332879$var$scrubEmptyObjectIds(ns, doc);
        const req = $1i1BJ.post(`${$9962d45754332879$var$url}/api/${ns}`).set(token && {
            'x-access-token': token
        } || {});
        return ($9962d45754332879$var$hasUploadFiles(doc) ? req.send($9962d45754332879$var$toFormData(payload)) : req.send(payload)).then(()=>(cb(), (state)=>$9962d45754332879$require$obj.patch(state, ns, {
                    dirty: true,
                    doc: {}
                }))).catch($9962d45754332879$var$handleUnauthorized);
    };
const $9962d45754332879$var$read = (ns)=>(id, token)=>$1i1BJ.get(`${$9962d45754332879$var$url}/api/${ns}/${id}`).set(token && {
            'x-access-token': token
        } || {}).then((res)=>res.body).then((doc)=>(state)=>$9962d45754332879$require$obj.patch(state, ns, {
                    doc: doc
                })).catch($9962d45754332879$var$handleUnauthorized);
const $9962d45754332879$var$update = (ns)=>(id, doc, token, cb = ()=>{})=>{
        const payload = $9962d45754332879$var$scrubEmptyObjectIds(ns, doc);
        const req = $1i1BJ.put(`${$9962d45754332879$var$url}/api/${ns}/${id}`).set(token && {
            'x-access-token': token
        } || {});
        return ($9962d45754332879$var$hasUploadFiles(doc) ? req.send($9962d45754332879$var$toFormData(payload)) : req.send(payload)).then(()=>(cb(), (state)=>$9962d45754332879$require$obj.patch(state, ns, {
                    dirty: true,
                    doc: {}
                }))).catch($9962d45754332879$var$handleUnauthorized);
    };
const $9962d45754332879$var$save = (ns)=>(doc, token, cb = ()=>{})=>doc._id ? $9962d45754332879$var$update(ns)(doc._id, doc, token, cb) : $9962d45754332879$var$create(ns)(doc, token, cb);
const $9962d45754332879$var$_delete = (ns)=>(id, token)=>$1i1BJ.delete(`${$9962d45754332879$var$url}/api/${ns}/${id}`).set(token && {
            'x-access-token': token
        } || {}).then(()=>(state)=>$9962d45754332879$require$obj.patch(state, ns, {
                    dirty: true,
                    doc: {},
                    list: ($9962d45754332879$require$obj.sub(state, [
                        ns,
                        'list'
                    ]) || []).filter((doc)=>String(doc._id) !== String(id))
                })).catch($9962d45754332879$var$handleUnauthorized);
const $9962d45754332879$var$reset = (ns)=>()=>(state)=>$9962d45754332879$require$obj.patch(state, ns, {
                doc: {}
            });
const $9962d45754332879$var$filterFn = (ns)=>(query)=>(state)=>$9962d45754332879$require$obj.patch(state, [
                ns,
                'query'
            ], query);
const $9962d45754332879$var$actions = {
    initial: $9962d45754332879$var$initial,
    list: $9962d45754332879$var$list,
    query: $9962d45754332879$var$query,
    create: $9962d45754332879$var$create,
    update: $9962d45754332879$var$update,
    save: $9962d45754332879$var$save,
    delete: $9962d45754332879$var$_delete,
    read: $9962d45754332879$var$read,
    reset: $9962d45754332879$var$reset,
    filter: $9962d45754332879$var$filterFn
};
const $9962d45754332879$var$applyNs = (o, ns)=>$9962d45754332879$require$obj.map(o, (k, v)=>v instanceof Function ? v(ns) : v);
// Attach plain resource node into the tree before createState
const $9962d45754332879$var$attach = (tree, ns)=>Object.assign({}, tree, {
        [ns]: $9962d45754332879$var$applyNs($9962d45754332879$var$actions, ns)
    });
let $9962d45754332879$var$subs = [];
let $9962d45754332879$var$unhook = ()=>{
    $9962d45754332879$var$subs.forEach((sub)=>sub.unsubscribe());
    $9962d45754332879$var$subs = [];
};
const $9962d45754332879$var$publicListNs = [
    'profiles',
    'events'
];
// front menu uses /calendar for the public events list; home carousel also needs events.
// calendar/home also load profiles so venue.profile refs can resolve without populate.
const $9962d45754332879$var$publicPathForNs = (ns)=>ns === 'events' ? [
        'events',
        'calendar',
        'home',
        'contact',
        ''
    ] : ns === 'profiles' ? [
        'profiles',
        'calendar',
        'home',
        ''
    ] : [
        ns
    ];
const $9962d45754332879$var$hook = ({ state$: state$, actions: actions })=>(ns)=>{
        const isPublicNs = $9962d45754332879$var$publicListNs.indexOf(ns) > -1;
        const publicPaths = $9962d45754332879$var$publicPathForNs(ns);
        // load list on login (dirty), or whenever viewing a public collection page
        $9962d45754332879$var$subs.push(state$.pipe($9962d45754332879$require$distinctUntilChanged((a, b)=>[
                a[ns].dirty,
                !!(a.auth && a.auth.user),
                a.router.path[0],
                a.router.page
            ].join('|') === [
                b[ns].dirty,
                !!(b.auth && b.auth.user),
                b.router.path[0],
                b.router.page
            ].join('|')), $9962d45754332879$require$filter((state)=>{
            const authed = !!(state.auth && state.auth.user);
            const path0 = state.router.path[0];
            const onPublicPage = isPublicNs && (publicPaths.indexOf(path0) > -1 || ns === 'events' && state.router.page === 'home');
            return state[ns].dirty && authed || onPublicPage;
        })).subscribe((state)=>{
            const q = Object.assign({}, state[ns].query);
            const path0 = state.router.path[0];
            const page = state.router.page;
            const onPublicPage = isPublicNs && (publicPaths.indexOf(path0) > -1 || publicPaths.indexOf(page) > -1 || ns === 'events' && (page === 'home' || !path0));
            if (onPublicPage && $9962d45754332879$var$publicListLimit[ns]) // force public window (don't trust leftover admin/query limit)
            q.limit = $9962d45754332879$var$publicListLimit[ns];
            // public events: chronological so upcoming aren't buried on page 1 of defaults
            if (ns === 'events' && onPublicPage) q.sort = 'startDateTime';
            // admin events: newest first (recent on top, past toward the bottom)
            if (ns === 'events' && !onPublicPage) {
                if (!q.sort) q.sort = '-startDateTime';
                if ($9962d45754332879$var$adminListLimit.events) q.limit = Math.max(Number(q.limit) || 0, $9962d45754332879$var$adminListLimit.events);
            }
            const token = state.auth && state.auth.token;
            actions[ns].list(q, '', token);
        }));
        // on edit / public detail load doc
        $9962d45754332879$var$subs.push(state$.pipe($9962d45754332879$require$distinctUntilChanged((a, b)=>a.router.path.join('/') === b.router.path.join('/')), $9962d45754332879$require$filter((state)=>state.router.path[0] === 'admin' && state.router.path[1] === ns || publicPaths.indexOf(state.router.path[0]) > -1)).subscribe((state)=>{
            const isAdmin = state.router.path[0] === 'admin';
            const pageId = isAdmin ? state.router.pageId : state.router.path[1] || null;
            if ([
                null,
                ''
            ].indexOf(pageId) > -1 || $9962d45754332879$var$reservedPageIds.find((id)=>pageId && String(pageId).match(id))) {
                if ([
                    null,
                    ''
                ].indexOf(pageId) > -1 || pageId && pageId.split('/').length === 1 || pageId === 'new') {
                    if (isAdmin) actions.set([
                        ns
                    ], {
                        doc: {}
                    });
                }
                return;
            }
            actions[ns].read(isAdmin ? state.router.path.slice().pop() : pageId, state.auth.token);
        }));
    };
$9962d45754332879$exports = {
    actions: $9962d45754332879$var$actions,
    applyNs: $9962d45754332879$var$applyNs,
    attach: $9962d45754332879$var$attach,
    hook: $9962d45754332879$var$hook,
    unhook: ()=>$9962d45754332879$var$unhook()
};


const $70e01c01412cfa4e$var$resources = Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($7bf98248e39b8900$exports))).config.routes.api).filter((route)=>route !== '_meta');

// Compose full action tree before createState so initial includes all namespaces
let $70e01c01412cfa4e$var$tree = Object.assign({}, (parcelRequire("6gejJ")), {
    auth: (0, (/*@__PURE__*/$parcel$interopDefault($0f196eb47fbd0a67$exports))).actions,
    router: (0, (/*@__PURE__*/$parcel$interopDefault($9c4ac63f06d34bd2$exports))).actions
});
$70e01c01412cfa4e$var$tree.initial = Object.assign({}, $70e01c01412cfa4e$var$tree.initial, {
    themeMode: 'light'
});
$70e01c01412cfa4e$var$tree = $70e01c01412cfa4e$var$resources.reduce((t, ns)=>(0, (/*@__PURE__*/$parcel$interopDefault($9962d45754332879$exports))).attach(t, ns), $70e01c01412cfa4e$var$tree);
const $70e01c01412cfa4e$var$preserved = null && null.data && null.data.state;
let { actions: $70e01c01412cfa4e$var$actions, state$: $70e01c01412cfa4e$var$state$ } = (0, $0b23034ab663e0da$export$e6a0daad8304de)($70e01c01412cfa4e$var$tree);
if ($70e01c01412cfa4e$var$preserved) (0, $0dd1b25395c80137$export$635e15bbd66f01ea)(()=>$70e01c01412cfa4e$var$preserved);
var $373731c59342151e$exports = {};
'use strict';
const $373731c59342151e$var$applyDocumentTheme = (mode)=>{
    if (typeof document === 'undefined') return;
    const root = document.documentElement;
    const next = mode === 'dark' ? 'dark' : 'light';
    root.dataset.theme = next;
    root.style.colorScheme = next;
};
$373731c59342151e$exports = {
    applyDocumentTheme: $373731c59342151e$var$applyDocumentTheme
};


var $70e01c01412cfa4e$require$applyDocumentTheme = $373731c59342151e$exports.applyDocumentTheme;
$70e01c01412cfa4e$require$applyDocumentTheme($70e01c01412cfa4e$var$state$.getValue().themeMode || 'light');
const $70e01c01412cfa4e$var$hookServices = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($0f196eb47fbd0a67$exports))).hook({
        state$: $70e01c01412cfa4e$var$state$,
        actions: $70e01c01412cfa4e$var$actions
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($9c4ac63f06d34bd2$exports))).hook({
        state$: $70e01c01412cfa4e$var$state$,
        actions: $70e01c01412cfa4e$var$actions
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($7bf98248e39b8900$exports))).hook({
        state$: $70e01c01412cfa4e$var$state$,
        actions: $70e01c01412cfa4e$var$actions
    });
    $70e01c01412cfa4e$var$resources.forEach((0, (/*@__PURE__*/$parcel$interopDefault($9962d45754332879$exports))).hook({
        state$: $70e01c01412cfa4e$var$state$,
        actions: $70e01c01412cfa4e$var$actions
    }));
};
const $70e01c01412cfa4e$var$unhookServices = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($0f196eb47fbd0a67$exports))).unhook();
    (0, (/*@__PURE__*/$parcel$interopDefault($9c4ac63f06d34bd2$exports))).unhook();
    (0, (/*@__PURE__*/$parcel$interopDefault($7bf98248e39b8900$exports))).unhook();
    (0, (/*@__PURE__*/$parcel$interopDefault($9962d45754332879$exports))).unhook();
};
$70e01c01412cfa4e$var$hookServices();
let $70e01c01412cfa4e$var$vnode$ = $70e01c01412cfa4e$var$state$.pipe((0, $6SBin.map)((state)=>(0, $918388a15a1aa2ed$export$2e2bcd8739ae039)({
        state: state,
        actions: $70e01c01412cfa4e$var$actions,
        i18n: (0, (/*@__PURE__*/$parcel$interopDefault($611de703fc24c8b9$exports)))[state.lang] || (0, (/*@__PURE__*/$parcel$interopDefault($611de703fc24c8b9$exports))).bg
    })));
let $70e01c01412cfa4e$var$patchSubscription = (0, $2Z6Kw.patchStream)($70e01c01412cfa4e$var$vnode$, (0, $668ce3ab094152ac$export$cd5dd3c35a2a94c7)(document.body));
if (null) {
    null.dispose((data)=>{
        data.state = $70e01c01412cfa4e$var$state$.getValue();
        $70e01c01412cfa4e$var$unhookServices();
        $70e01c01412cfa4e$var$patchSubscription.unsubscribe();
        $70e01c01412cfa4e$var$state$.complete();
    });
    null.accept(()=>{
        if (null.data && null.data.state) (0, $0dd1b25395c80137$export$635e15bbd66f01ea)(()=>null.data.state);
        else (0, $0dd1b25395c80137$export$635e15bbd66f01ea)((state)=>state);
        $70e01c01412cfa4e$var$actions.ping();
    });
}


//# sourceMappingURL=pug.74e40151.js.map
